(function ()
{
    'use strict';

    angular
        .module('app.scrumboard', [])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        $stateProvider
            .state('app.scrumboard', {
                abstract : true,
                url      : '/scrumboard',
                resolve  : {
                    BoardList: function (apiResolver)
                    {
                        return apiResolver.resolve('scrumboard.boardList@get');
                    }
                },
                bodyClass: 'scrumboard'
            })

            // Home
            .state('app.scrumboard.boards', {
                url    : '/boards',
                views  : {
                    'content@app'                           : {
                        templateUrl: 'app/main/agile/scrumboard/views/boards/boards-view.html',
                        controller : 'BoardsViewController as vm'
                    }
                }
            })

            // Board
            .state('app.scrumboard.boards.board', {
                    url    : '/:id/:uri',
                    views  : {
                        'content@app'                           : {
                            templateUrl: 'app/main/agile/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.board': {
                            templateUrl: 'app/main/agile/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, apiResolver, BoardService)
                        {
                            return BoardService.getBoardData($stateParams.id);
                        }
                    }
                }
            )

            // Add board
            .state('app.scrumboard.boards.addBoard', {
                    url    : '/add',
                    views  : {
                        'content@app'                           : {
                            templateUrl: 'app/main/agile/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.addBoard': {
                            templateUrl: 'app/main/agile/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, apiResolver, BoardService)
                        {
                            return BoardService.addNewBoard();
                        }
                    }
                }
            );

        // Navigation
        // msNavigationServiceProvider.saveItem('AGILE.scrumboard', {
        //     title : 'Scrumboard',
        //     icon  : 'icon-trello',
        //     state : 'app.scrumboard.boards',
        //     weight: 5
        // });
    }

    /** @ngInject */
    function run(editableThemes)
    {
        /**
         * Inline Edit Configuration
         * @type {string}
         */
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardsViewController', BoardsViewController);

    /** @ngInject */
    function BoardsViewController(BoardList)
    {
        var vm = this;

        // Data
        vm.boardList = BoardList.data;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardViewController', BoardViewController);

    /** @ngInject */
    function BoardViewController($document,$mdSidenav, $mdDialog, msUtils, BoardList, BoardService, CardPreview, DialogService)
    {
        var vm = this;

        // Data
//        vm.previewCard = previewCard;
        vm.currentView = 'board';
        vm.board = BoardService.data;
        vm.boardList = BoardList.data;
        vm.cardPreview = CardPreview;
        vm.card = {};
        vm.cardOptions = {};
        vm.newListName = '';
        vm.sortableListOptions = {
            axis       : 'x',
            delay      : 75,
            distance   : 7,
            items      : '> .list-wrapper',
            handle     : '.list-header',
            placeholder: 'list-wrapper list-sortable-placeholder',
            tolerance  : 'pointer',
            start      : function (event, ui)
            {
                var width = ui.item[0].children[0].clientWidth;
                var height = ui.item[0].children[0].clientHeight;
                ui.placeholder.css({
                    'min-width': width + 'px',
                    'width'    : width + 'px',
                    'height'   : height + 'px'
                });
            }
        };
        vm.sortableCardOptions = {
            appendTo            : 'body',
            connectWith         : '.list-cards',
            delay               : 75,
            distance            : 7,
            forceHelperSize     : true,
            forcePlaceholderSize: true,
            handle              : msUtils.isMobile() ? '.list-card-sort-handle' : false,
            helper              : function (event, el)
            {
                return el.clone().addClass('list-card-sort-helper');
            },
            placeholder         : 'list-card card-sortable-placeholder',
            tolerance           : 'pointer',
            scroll              : true,
            sort                : function (event, ui)
            {
                var listContentEl = ui.placeholder.closest('.list-content');
                var boardContentEl = ui.placeholder.closest('#board');

                if ( listContentEl )
                {
                    var listContentElHeight = listContentEl[0].clientHeight,
                        listContentElScrollHeight = listContentEl[0].scrollHeight;

                    if ( listContentElHeight !== listContentElScrollHeight )
                    {
                        var itemTop = ui.position.top,
                            itemBottom = itemTop + ui.item.height(),
                            listTop = listContentEl.offset().top,
                            listBottom = listTop + listContentElHeight;

                        if ( itemTop < listTop + 25 )
                        {
                            listContentEl.scrollTop(listContentEl.scrollTop() - 25);
                        }

                        if ( itemBottom > listBottom - 25 )
                        {
                            listContentEl.scrollTop(listContentEl.scrollTop() + 25);
                        }
                    }
                }

                if ( boardContentEl )
                {
                    var boardContentElWidth = boardContentEl[0].clientWidth;
                    var boardContentElScrollWidth = boardContentEl[0].scrollWidth;

                    if ( boardContentElWidth !== boardContentElScrollWidth )
                    {
                        var itemLeft = ui.position.left,
                            itemRight = itemLeft + ui.item.width(),
                            boardLeft = boardContentEl.offset().left,
                            boardRight = boardLeft + boardContentElWidth;

                        if ( itemLeft < boardLeft + 25 )
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() - 25);
                        }

                        if ( itemRight > boardRight)
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() + 25);
                        }
                    }
                }
            }
        };

        // Methods
        vm.openCardDialog = DialogService.openCardDialog;
        vm.addNewList = addNewList;
        vm.removeList = removeList;
        vm.cardFilter = cardFilter;
        vm.isOverdue = isOverdue;
        vm.previewCard = CardPreview.previewCard;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
//        function previewCard(sidenavId, ev, cardId)
//        {
//            console.log('POKAZANIE DETALI TASKA');
//            vm.preview_card = vm.board.cards.getById(cardId);
//            console.log(vm.preview_card.code);
//            $mdSidenav(sidenavId).toggle();
//        }

        /**
         * Add new list
         */
        function addNewList()
        {
            if ( vm.newListName === '' )
            {
                return;
            }

            vm.board.lists.push({
                "id"     : msUtils.guidGenerator(),
                "name"   : vm.newListName,
                "idCards": []
            });

            vm.newListName = '';
        }

        /**
         * Remove list
         *
         * @param ev
         * @param list
         */
        function removeList(ev, list)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove List',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove list?',
                ariaLabel          : 'remove list',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });
            $mdDialog.show(confirm).then(function ()
            {
                vm.board.lists.splice(vm.board.lists.indexOf(list), 1);
            }, function ()
            {
                // Canceled
            });

        }

        /**
         * Card filter
         *
         * @param cardId
         * @returns {*}
         */
        function cardFilter(cardId)
        {
            var card = vm.board.cards.getById(cardId);

            try
            {
                if ( angular.lowercase(card.name).indexOf(angular.lowercase(vm.cardFilters.name)) < 0 )
                {
                    throw false;
                }

                angular.forEach(vm.cardFilters.labels, function (label)
                {
                    if ( !msUtils.exists(label, card.idLabels) )
                    {
                        throw false;
                    }
                });

                angular.forEach(vm.cardFilters.members, function (member)
                {
                    if ( !msUtils.exists(member, card.idMembers) )
                    {
                        throw false;
                    }
                });


            } catch ( err )
            {
                return err;
            }

            return true;
        }

        /**
         * Is the card overdue?
         *
         * @param cardDate
         * @returns {boolean}
         */
        function isOverdue(cardDate)
        {
            return moment() > moment(cardDate, 'x');
        }
        
        /**
         * Is the card overdue?
         *
         * @param cardDate
         * @returns {boolean}
         */
        function isOverWorked(remaining)
        {
            return remaining > 0;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('PreviewSidenavController', PreviewSidenavController);

    /** @ngInject */
    function PreviewSidenavController(msUtils, BoardService, CardPreview)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.cardFilters = CardPreview;
        vm.labels = vm.board.labels;
        vm.members = vm.board.members;
        vm.selectedMenu = 'Settings';
        vm.previewCard = vm.board.cards.getById("2837273da9b93dd84243s0f9");
        
        // Methods
        vm.exists = msUtils.exists;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.clearFilters = CardPreview.clear;
        vm.filteringIsOn = CardPreview.isOn;

        ////////
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('msSbAddCardController', msSbAddCardController)
        .directive('msSbAddCard', msSbAddCardDirective);

    /** @ngInject */
    function msSbAddCardController($scope, $timeout, BoardService, msUtils)
    {
        var vm = this;

        vm.newCardName = '';
        vm.listId = $scope.msListId;
        vm.board = BoardService.data;
        vm.cards = vm.board.cards;
        vm.list = vm.board.lists.getById(vm.listId);

        // Methods
        vm.addNewCard = addNewCard;

        /////

        /**
         * Add New Card
         */
        function addNewCard()
        {
            if ( vm.newCardName === '' )
            {
                return;
            }

            var newCardId = msUtils.guidGenerator();

            vm.cards.push({
                "id"               : newCardId,
                "name"             : vm.newCardName,
                "description"      : '',
                "idAttachmentCover": '',
                "idMembers"        : [],
                "idLabels"         : [],
                "attachments"      : [],
                "subscribed"       : false,
                "checklists"       : [],
                "checkItems"       : 0,
                "checkItemsChecked": 0,
                "comments"         : [],
                "activities"       : [],
                "due"              : null
            });

            vm.list.idCards.push(newCardId);

            $timeout(function ()
            {
                $scope.scrollListContentBottom();
            });

            vm.newCardName = '';
        }
    }

    /** @ngInject */
    function msSbAddCardDirective($document, $compile, $timeout)
    {
        return {
            restrict    : 'A',
            controller  : 'msSbAddCardController',
            controllerAs: 'vm',
            scope       : {
                msListId: '='
            },
            link        : function (scope, iElement)
            {
                scope.closeForm = closeForm;
                scope.scrollListContentBottom = scrollListContentBottom;

                var form = '<form ng-submit="vm.addNewCard()" class="ms-sb-add-card-form md-whiteframe-2dp" layout="column">\n\n    <md-input-container flex md-no-float>\n        <input placeholder="Card title" type="text" autocomplete="off"\n               ng-model="vm.newCardName" translate-attr-placeholder="SB.CARD_TITLE">\n    </md-input-container>\n\n    <div layout="row" layout-align="space-between center">\n        <md-button type="submit"\n                   class="add-button md-accent md-raised"\n                   aria-label="add" translate-attr-aria-label="SB.ADD">\n            <span translate="SB.ADD">Add</span>\n        </md-button>\n        <md-button ng-click="closeForm()" class="cancel-button md-icon-button"\n                   aria-label="cancel" translate-attr-aria-label="SB.CANCEL">\n            <md-icon md-font-icon="icon-close"></md-icon>\n        </md-button>\n    </div>\n\n</form>',
                    formEl = '',
                    listContent = iElement.prev();

                /**
                 * Click Event
                 */
                iElement.on('click', function (event)
                {
                    event.preventDefault();
                    openForm();
                });

                /**
                 * Open Form
                 */
                function openForm()
                {
                    iElement.hide();

                    formEl = $compile(form)(scope);

                    listContent.append(formEl);

                    scrollListContentBottom();

                    formEl.find('input').focus();

                    $timeout(function ()
                    {
                        $document.on('click', outSideClick);
                    });
                }

                /**
                 * Close Form
                 */
                function closeForm()
                {
                    formEl.remove();

                    iElement.next().remove();

                    iElement.show();

                    PerfectScrollbar.update(listContent[0]);

                    // Clean
                    $document.off('click', outSideClick);
                    scope.$on('$destroy', function ()
                    {
                        $document.off('click', outSideClick);
                    });
                }

                /**
                 * Scroll List to the Bottom
                 */
                function scrollListContentBottom()
                {
                    listContent[0].scrollTop = listContent[0].scrollHeight;
                }

                /**
                 * Click Outside Event Handler
                 * @param event
                 */
                var outSideClick = function (event)
                {
                    var isChild = formEl.has(event.target).length > 0;
                    var isSelf = formEl[0] == event.target;
                    var isInside = isChild || isSelf;

                    if ( !isInside )
                    {
                        closeForm();
                    }
                }

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardCardDialogController', ScrumboardCardDialogController);

    /** @ngInject */
    function ScrumboardCardDialogController($document, $mdDialog, fuseTheming, fuseGenerator, msUtils, BoardService, cardId)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.card = vm.board.cards.getById(cardId);
        vm.newLabelColor = 'red';
        vm.members = vm.board.members;
        vm.labels = vm.board.labels;

        // Methods
        vm.palettes = fuseTheming.getRegisteredPalettes();
        vm.rgba = fuseGenerator.rgba;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.closeDialog = closeDialog;
        vm.getCardList = getCardList;
        vm.removeCard = removeCard;
        
        /* Attachment */
        vm.toggleCoverImage = toggleCoverImage;
        vm.removeAttachment = removeAttachment;
        
        /* Labels */
        vm.labelQuerySearch = labelQuerySearch;
        vm.filterLabel = filterLabel;
        vm.addNewLabel = addNewLabel;
        vm.removeLabel = removeLabel;
        /* Members */
        vm.memberQuerySearch = memberQuerySearch;
        vm.filterMember = filterMember;
        /* Checklist */
        vm.updateCheckedCount = updateCheckedCount;
        vm.addCheckItem = addCheckItem;
        vm.removeChecklist = removeChecklist;
        vm.createCheckList = createCheckList;
        /* Comment */
        vm.addNewComment = addNewComment;

        //////////

        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Get Card List
         */
        function getCardList()
        {
            var response;
            for ( var i = 0, len = vm.board.lists.length; i < len; i++ )
            {
                if ( vm.board.lists[i].idCards.indexOf(vm.card.id) > -1 )
                {
                    response = vm.board.lists[i];
                    break;
                }
            }
            return response;
        }

        /**
         * Remove card
         *
         * @param ev
         */
        function removeCard(ev)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Card',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove card?',
                ariaLabel          : 'remove card',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var cardList = getCardList();

                cardList.idCards.splice(cardList.idCards.indexOf(vm.card.id), 1);

                vm.board.cards.splice(vm.board.cards.indexOf(vm.card), 1);

            }, function ()
            {
                // Canceled
            });
        }

        /**
         * Toggle cover image
         *
         * @param attachmentId
         */
        function toggleCoverImage(attachmentId)
        {
            if ( attachmentId === vm.card.idAttachmentCover )
            {
                vm.card.idAttachmentCover = null;
            }
            else
            {
                vm.card.idAttachmentCover = attachmentId;
            }
        }

        /**
         * Remove attachment
         *
         * @param item
         */
        function removeAttachment(item)
        {
            if ( vm.card.idAttachmentCover === item.id )
            {
                vm.card.idAttachmentCover = '';
            }
            vm.card.attachments.splice(vm.card.attachments.indexOf(item), 1);
        }

        /**
         * Add label chips
         *
         * @param query
         * @returns {filterFn}
         */
        function labelQuerySearch(query)
        {
            return query ? vm.labels.filter(createFilterFor(query)) : [];
        }

        /**
         * Label filter
         *
         * @param label
         * @returns {boolean}
         */
        function filterLabel(label)
        {
            if ( !vm.labelSearchText || vm.labelSearchText === '' )
            {
                return true;
            }

            return angular.lowercase(label.name).indexOf(angular.lowercase(vm.labelSearchText)) >= 0;
        }

        /**
         * Add new label
         */
        function addNewLabel()
        {
            vm.board.labels.push({
                "id"   : msUtils.guidGenerator(),
                "name" : vm.newLabelName,
                "color": vm.newLabelColor
            });

            vm.newLabelName = '';
        }

        /**
         * Remove label
         */
        function removeLabel()
        {
            var arr = vm.board.labels;
            arr.splice(arr.indexOf(arr.getById(vm.editLabelId)), 1);

            angular.forEach(vm.board.cards, function (card)
            {
                if ( card.idLabels && card.idLabels.indexOf(vm.editLabelId) > -1 )
                {
                    card.idLabels.splice(card.idLabels.indexOf(vm.editLabelId), 1);
                }
            });

            vm.newLabelName = '';
        }

        /**
         * Add member chips
         *
         * @param query
         * @returns {Array}
         */
        function memberQuerySearch(query)
        {
            return query ? vm.members.filter(createFilterFor(query)) : [];
        }

        /**
         * Member filter
         *
         * @param member
         * @returns {boolean}
         */
        function filterMember(member)
        {
            if ( !vm.memberSearchText || vm.memberSearchText === '' )
            {
                return true;
            }

            return angular.lowercase(member.name).indexOf(angular.lowercase(vm.memberSearchText)) >= 0;
        }

        /**
         * Update check list stats
         * @param list
         */
        function updateCheckedCount(list)
        {
            var checkItems = list.checkItems;
            var checkedItems = 0;
            var allCheckedItems = 0;
            var allCheckItems = 0;

            angular.forEach(checkItems, function (checkItem)
            {
                if ( checkItem.checked )
                {
                    checkedItems++;
                }
            });

            list.checkItemsChecked = checkedItems;

            angular.forEach(vm.card.checklists, function (item)
            {
                allCheckItems += item.checkItems.length;
                allCheckedItems += item.checkItemsChecked;
            });

            vm.card.checkItems = allCheckItems;
            vm.card.checkItemsChecked = allCheckedItems;
        }

        /**
         * Add checklist item
         *
         * @param text
         * @param checkList
         */
        function addCheckItem(text, checkList)
        {
            if ( !text || text === '' )
            {
                return;
            }

            var newCheckItem = {
                'name'   : text,
                'checked': false
            };

            checkList.checkItems.push(newCheckItem);

            updateCheckedCount(checkList);
        }

        /**
         * Remove checklist
         *
         * @param item
         */
        function removeChecklist(item)
        {
            vm.card.checklists.splice(vm.card.checklists.indexOf(item), 1);

            angular.forEach(vm.card.checklists, function (list)
            {
                updateCheckedCount(list);
            });
        }

        /**
         * Create checklist
         */
        function createCheckList()
        {
            vm.card.checklists.push({
                "id"               : msUtils.guidGenerator(),
                "name"             : vm.newCheckListTitle,
                "checkItemsChecked": 0,
                "checkItems"       : []
            });

            vm.newCheckListTitle = '';
        }

        /**
         * Add new comment
         *
         * @param newCommentText
         */
        function addNewComment(newCommentText)
        {
            var newComment = {
                "idMember": "36027j1930450d8bf7b10158",
                "message" : newCommentText,
                "time"    : "now"
            };

            vm.card.comments.unshift(newComment);
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query)
        {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item)
            {
                return angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0;
            };
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.backlog', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.backlog', {
            url      : '/backlog',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/agile/backlog/backlog.html',
                    controller : 'backlogController as vm'
                }
            },
            resolve  : {
                Tasks: function (apiResolver)
                {
                    return apiResolver.resolve('backlog.tasks@get');
                },
                Tags : function (apiResolver)
                {
                    return apiResolver.resolve('backlog.tags@get');
                }
            },
            bodyClass: 'backlog'
        });

        // Navigation
//         msNavigationServiceProvider.saveItem('AGILE.backlog', {
//             title : 'Backlog',
//             icon  : 'icon-checkbox-marked',
//             state : 'app.backlog',
// //            badge : {
// //                content: 3,
// //                color  : '#4CAF50'
// //            },
//             weight: 6
//         });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.backlog')
        .controller('TaskDialogController', TaskDialogController);

    /** @ngInject */
    function TaskDialogController($mdDialog, Task, Tasks, event)
    {
        var vm = this;

        // Data
        vm.title = 'Edit Task';
        vm.task = angular.copy(Task);
        vm.tasks = Tasks;
        vm.newTask = false;

        if ( !vm.task )
        {
            vm.task = {
                'id'                : '',
                'title'             : '',
                'notes'             : '',
                'startDate'         : new Date(),
                'startDateTimeStamp': new Date().getTime(),
                'dueDate'           : '',
                'dueDateTimeStamp'  : '',
                'completed'         : false,
                'starred'           : false,
                'important'         : false,
                'deleted'           : false,
                'tags'              : []
            };
            vm.title = 'New Task';
            vm.newTask = true;
            vm.task.tags = [];
        }

        // Methods
        vm.addNewTask = addNewTask;
        vm.saveTask = saveTask;
        vm.deleteTask = deleteTask;
        vm.newTag = newTag;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewTask()
        {
            vm.tasks.unshift(vm.task);

            closeDialog();
        }

        /**
         * Save task
         */
        function saveTask()
        {
            // Dummy save action
            for ( var i = 0; i < vm.tasks.length; i++ )
            {
                if ( vm.tasks[i].id === vm.task.id )
                {
                    vm.tasks[i] = angular.copy(vm.task);
                    break;
                }
            }

            closeDialog();
        }

        /**
         * Delete task
         */
        function deleteTask()
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure?')
                .content('The Task will be deleted.')
                .ariaLabel('Delete Task')
                .ok('Delete')
                .cancel('Cancel')
                .targetEvent(event);

            $mdDialog.show(confirm).then(function ()
            {
                // Dummy delete action
                for ( var i = 0; i < vm.tasks.length; i++ )
                {
                    if ( vm.tasks[i].id === vm.task.id )
                    {
                        vm.tasks[i].deleted = true;
                        break;
                    }
                }
            }, function ()
            {
                // Cancel Action
            });
        }


        /**
         * New tag
         *
         * @param chip
         * @returns {{label: *, color: string}}
         */
        function newTag(chip)
        {
            var tagColors = ['#388E3C', '#F44336', '#FF9800', '#0091EA', '#9C27B0'];

            return {
                name : chip,
                label: chip,
                color: tagColors[Math.floor(Math.random() * (tagColors.length))]
            };
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                // 'angular-chartist',
                // 'chart.js',
                // 'datatables',
                // 'gridshore.c3js.chart',
                // 'nvd3',
                'pascalprecht.translate',
                'timer',
                'ui.router',
                // 'uiGmapgoogle-maps',
                'textAngular',
                'ui.sortable',
                'ng-sortable',
                'xeditable',
                'moment-picker',
                'md.data.table'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('InvoicesZipPendingDialogController', InvoicesZipPendingDialogController);

    /** @ngInject */
    function InvoicesZipPendingDialogController($rootScope, $mdDialog, transService)
    {
        var vm = this;
        transService.loadFile('main/invoices/list/zip_pending_dialog');

        vm.accept = accept;
        vm.hide = hide;

        function accept() {
            $mdDialog.hide(true);
        }
        function hide() {
            $mdDialog.hide();
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('InvoicesZipDownloadDialogController', InvoicesZipDownloadDialogController);

    /** @ngInject */
    function InvoicesZipDownloadDialogController($rootScope, $mdDialog, transService, tableService, api, $window, $auth)
    {
        var vm = this;
        transService.loadFile('main/invoices/list/zip_download_dialog');
        vm.loading = false;
        vm.packages = [];
        vm.pagination = {};

        vm.getPackages = getPackages;
        vm.downloadPackage = downloadPackage;
        vm.hide = hide;

        init();
        function init() {
            getPackages();
            tableService.setVariables(vm);
        }

        function getPackages() {
            vm.loading = true;
            vm.promise = api.clipboard.get({}, function (response) {
                vm.packages = response.data;
                vm.pagination = response.meta.pagination;
                vm.loading = false;
            }, function (response) {
                vm.loading = false;
            }).$promise;
        }

        function downloadPackage(package_id) {
            $window.open(
                __env.apiUrl + 'clipboard/' + package_id +
                '?token=' + $window.localStorage.token +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        } 

        function hide() {
            $mdDialog.hide();
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('ProfileAlertDialogController', ProfileAlertDialogController);

    /** @ngInject */
    function ProfileAlertDialogController($mdDialog, $location)
    {
        var vm = this;

        vm.hide = hide;
        vm.goEdit = goEdit;

        function hide() {
            $mdDialog.hide();
        }

        function goEdit() {
            $mdDialog.hide();
            $location.url('/company/edit?first=true');
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.company-edit', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.company-edit', {
                url    : '/company/edit?first&user&package',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/company/edit/edit.html',
                        controller : 'CompanyEditController as vm'
                    }
                },
                resolve  : {
                    CurrentCompany: function (apiResolver)
                    {
                        return apiResolver.resolve('currentCompany@get');
                    },
                    Countries: function (apiResolver)
                    {
                        return apiResolver.resolve('company.countries@get');
                    },
                    InvoiceFormats: function (apiResolver)
                    {
                        return apiResolver.resolve('invoiceFormats@get');
                    },
                    PaymentsMethod: function (apiResolver)
                    {
                        return apiResolver.resolve('paymentsMethod.list@get');
                    },
                    VatReleaseReasons: function (apiResolver)
                    {
                        return apiResolver.resolve('vatReleaseReasons@get');
                    },
                    TaxOffices: function (apiResolver)
                    {
                        return apiResolver.resolve('taxOffices@get');
                    },
                    Roles: function (apiResolver)
                    {
                        return apiResolver.resolve('roles@get');
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.company-edit')
        .controller('AddEditUserDialogController', AddEditUserDialogController);

    /** @ngInject */
    function AddEditUserDialogController($auth, transService, $mdDialog, api, formService, apiErrorsService, user, role_id)
    {
        var vm = this;

        vm.create_user = false; //true create user; false only invite
        vm.msg_success = '';
        vm.msg_error = '';
        vm.request_sending = false;
        vm.roles = [];

        vm.edit = false;
        vm.form = {
            company_id: $auth.getCurrentCompany(),
            email: '',
            first_name: '',
            last_name: '',
            role_id: role_id,
            password: '',
            password_confirmation: '',
            url: 'http://' + api.url + 'guest/invitation/:token/:company'
        };

        vm.hide = hide;
        vm.create = create;
        vm.update = update;

        init();

        function init() {

            $auth.getSettings(function (settings) {
                vm.create_user = settings['general.invite.enabled'] == "0";
            });

            api.rolesCompany.get({}, function (response) {
                vm.roles = response.data;
            });
            if (user) {
                vm.edit = true;
                formService.generateForm(vm.form, user);
                vm.form.role_id = user.company_role_id;
                vm.form.id = user.id;
            }
        }

        function hide() {
            $mdDialog.hide();
        }

        /**
         * Create user
         */
        function create() {

            vm.request_sending = true;
            apiErrorsService.clear('#addEditUser', vm);

            api.company.invite.save(vm.form,
                // success
                function() {
                    $mdDialog.hide(true);
                    // vm.msg_error = '';
                    // vm.msg_success = transService.translate('COMPANY_EDIT.USER.ADD_SUCCESS');
                    // vm.request_sending = false;
                },
                // error
                function(response) {
                    apiErrorsService.show('#addEditUser', response, vm, []);
                    vm.request_sending = false;
                    vm.msg_error = transService.getErrorMassage(response);
                }
            );
        }

        /**
         * update user
         */
        function update() {

            vm.request_sending = true;
            apiErrorsService.clear('#addEditUser', vm);

            api.userUpdate.put(vm.form,
                // success
                function() {
                    vm.msg_error = '';
                    vm.msg_success = transService.translate('COMPANY_EDIT.USER.UPDATE_SUCCESS');
                    vm.request_sending = false;
                },
                // error
                function(response) {
                    apiErrorsService.show('#addEditUser', response, vm, []);
                    vm.request_sending = false;
                    vm.msg_error = transService.getErrorMassage(response);
                }
            );
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.calendar', [
            'ui.calendar'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.calendar', {
            url      : '/calendar',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/calendar/calendar.html',
                    controller : 'CalendarController as vm'
                }
            },
			resolve  : {
                Inbox: function (apiResolver)
                {
                    return apiResolver.resolve('mail.inbox@get');
                }
            }, 
            bodyClass: 'calendar'
        });
    }
})();

(function () {
    'use strict';

    angular.module('app.calendar')
        .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController($mdDialog, dialogData)
    {
        var vm = this;

        // Data
        vm.newEvents = [];
        vm.events = dialogData.currentEvents || [];
        vm.dialogData = dialogData;
        vm.action = checkAction();
        vm.reasons = ['holidays', 'sick_note', 'day_off'];
        vm.switch = '';
        vm.templateCounter = [];
        vm.moment = moment;
        vm.errors = dialogData.errors;
        vm.custom_desc = '';
        vm.def_desc = '';

        // Methods
        vm.saveEvent = saveEvent;
        vm.closeDialog = closeDialog;
        vm.incTemplate = incTemplate;
        vm.clearForm = clearForm;
        vm.setOfflineEvent = setOfflineEvent;
        vm.setOnlineEvent = setOnlineEvent;
        vm.switchAction = switchAction;
        vm.removeEvent = removeEvent;
        vm.removeNewEvent = removeNewEvent;
        init();

        /**
         * Initialize
         */
        function init() {
            switch(checkAction()) {
                case 'edit-offline':
                    vm.switch = false;
                    vm.newEvents.push(vm.events[0]);
                    break;
                case 'edit-online':
                    vm.switch = true;
                    break;
                case 'add-new':
                    vm.switch = true;
                    incTemplate();
                    break;
            }
        }

        /**
         * Save event
         */
        function saveEvent() {

            mergeToCurrentEvents(vm.newEvents)
            // clear empty events
            var events = vm.events.filter(function (e) { return e });
            events = formatEventsTime(events);

            var response = {
                day: dialogData.day,
                user: dialogData.user,
                events: events
            };

            $mdDialog.hide(response);
        }

        /**
         * Merge new events to old events
         *
         * @param array
         */
        function mergeToCurrentEvents(array) {
            if(checkAction() === 'edit-offline') {
                vm.events[0] = array[0];
                vm.events[0].description = vm.def_desc == null ? vm.custom_desc : vm.def_desc;
            } else {
                if (vm.switch) {
                    for (var i = 0; i < array.length; i++) {
                        vm.events.push(array[i]);
                    }
                } else {
                    vm.events[0] = array[0];
                    vm.events[0].description = vm.def_desc == null ? vm.custom_desc : vm.def_desc;
                }
            }
        }

        function setOfflineEvent() {
            vm.newEvents = [{
                day: dialogData.day,
                time_start: '00:00:00',
                time_stop: '00:00:00',
                available: 0
            }]
        }

        function setOnlineEvent(n) {
            vm.newEvents[n].day = dialogData.day;
            vm.newEvents[n].available = 1;
            vm.newEvents[n].description = '';
        }

        function switchAction() {
            clearForm();
        }

        /**
         * Close the dialog
         */
        function closeDialog() {
            $mdDialog.cancel();
        }

        /**
         * Increment template counter
         */
        function incTemplate(){
            vm.templateCounter.push(vm.templateCounter.length);
        }

        /**
         * Clear form
         */
        function clearForm() {
            vm.events = [];
            vm.newEvents = [];
            vm.templateCounter = [];

            incTemplate();
        }

        /**
         * Prepare modal depend on user action
         *
         * @returns {*}
         */
        function checkAction() {
            if(vm.events.length > 0 && vm.events[0].available == false) {
                return 'edit-offline';
            } else if(vm.events.length > 0 && vm.events[0].available == true) {
                return 'edit-online';
            } else if(vm.events.length == 0) {
                return 'add-new';
            }
        }

        function formatEventsTime(events)
        {
            for (var i = 0; i < events.length; i++) {
                events[i]['time_start'] = events[i]['time_start'] ? events[i]['time_start'].trim() : '00:00:00';
                events[i]['time_stop'] = events[i]['time_stop'] ? events[i]['time_stop'].trim() : '00:00:00';

                var pattern = ['0', '0', ':', '0', '0', ':', '0', '0'];
                var startLength  = events[i]['time_start'].length;
                var stopLength  = events[i]['time_stop'].length;

                for (var k = (startLength === 1 || startLength === 4) ? startLength + 1 : startLength; k < 8; k++) {
                    if (startLength === 7 && k === 7) {
                        events[i]['time_start'] = '0' + events[i]['time_start'];
                    } else {
                        events[i]['time_start'] += pattern[k];
                    }
                }

                for (var l = (stopLength === 1 || stopLength === 4) ? stopLength + 1 : stopLength; l < 8; l++) {
                    if (stopLength === 7 && l === 7) {
                        events[i]['time_stop'] = '0' + events[i]['time_stop'];
                    } else {
                        events[i]['time_stop'] += pattern[l];
                    }
                }
            }

            return events;
        }

        function removeEvent(index) {
            vm.events.splice(index, 1);
        }

        function removeNewEvent(index) {
            vm.newEvents.splice(index, 1);
            vm.templateCounter.pop();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('CardPreview', CardPreviewService);

    /** @ngInject */
    function CardPreviewService($mdSidenav)
    {
        var service = {
            name   : '',
            labels : [],
            members: [],
            clear  : clear,
            isOn   : isOn,
            previewCard: previewCard,
            cardId : null
        };

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function previewCard(sidenavId, ev, cardId)
        {
            console.log('POKAZANIE DETALI TASKA');
//            vm.preview_card = vm.board.cards.getById(cardId);
//            console.log(vm.preview_card.code);
            this.cardId = cardId;
            $mdSidenav(sidenavId).toggle();
        }
        
        /**
         * Clear
         */
        function clear()
        {
            service.name = '';
            service.labels = [];
            service.members = [];
        }

        /**
         * Is on
         *
         * @returns {boolean}
         */
        function isOn()
        {
            return (service.name === '' && service.labels.length === 0 && service.members.length === 0 ) ? false : true;
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('DialogService', DialogService);

    /** @ngInject */
    function DialogService($mdDialog, $document)
    {
        var service = {
            openCardDialog: openCardDialog
        };

        //////////

        /**
         * Open card dialog
         *
         * @param ev
         * @param cardId
         */
        function openCardDialog(ev, cardId)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/agile/scrumboard/dialogs/card/card-dialog.html',
                controller         : "ScrumboardCardDialogController",
                controllerAs       : "vm",
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                locals             : {
                    cardId: cardId
                }
            });
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('BoardService', BoardService);

    /** @ngInject */
    function BoardService($q, api)
    {
        var service = {
            data        : {},
            addNewBoard : addNewBoard,
            getBoardData: getBoardData
        };

        /**
         * Get board data from the server
         *
         * @param boardId
         * @returns {*}
         */
        function getBoardData(boardId)
        {
            // Create a new deferred object
            var deferred = $q.defer();

            api.scrumboard.board.get({id: boardId},

                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Create an empty board object and set it.
         *
         * For the demonstration purposes, we are creating the
         * empty object in the javascript which you wouldn't do
         * it in real life. Rather, you would make an API call
         * to your server to generate an empty object that fills
         * some of the areas for you like an ID, labels, members
         * or the default board settings.
         *
         * Then you would grab the response that comes from
         * the API call and attach it to the service.data object.
         */
        function addNewBoard()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Here you would make an API call to your server...
            _generateEmptyScrumboardObject().then(
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the response
                    deferred.resolve(response);
                },
                // ERROR
                function (response)
                {
                    // Reject the response
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Dummy function for generating an empty
         * scrumboard object for demonstration
         * purposes
         *
         * @private
         * returns {$promise}
         */
        function _generateEmptyScrumboardObject()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Fake id generator
            var id = parseInt(new Date().valueOf(), 16);

            // Prepare an empty scrumboard object
            var emptyObject = {
                data: {
                    name    : 'Untitled Board',
                    uri     : 'untitled-board',
                    id      : id,
                    settings: {
                        color          : '',
                        subscribed     : false,
                        cardCoverImages: true
                    },
                    lists   : [],
                    cards   : [],
                    members : [
                        {
                            id    : '56027c1930450d8bf7b10758',
                            name  : 'Alice Freeman',
                            avatar: 'assets/images/avatars/alice.jpg'
                        },
                        {
                            id    : '26027s1930450d8bf7b10828',
                            name  : 'Danielle Obrien',
                            avatar: 'assets/images/avatars/danielle.jpg'
                        },
                        {
                            id    : '76027g1930450d8bf7b10958',
                            name  : 'James Lewis',
                            avatar: 'assets/images/avatars/james.jpg'
                        },
                        {
                            id    : '36027j1930450d8bf7b10158',
                            name  : 'Vincent Munoz',
                            avatar: 'assets/images/avatars/vincent.jpg'
                        }
                    ],
                    labels  : [
                        {
                            id   : '26022e4129ad3a5sc28b36cd',
                            name : 'High Priority',
                            color: 'red'
                        },
                        {
                            id   : '56027e4119ad3a5dc28b36cd',
                            name : 'Design',
                            color: 'orange'
                        },
                        {
                            id   : '5640635e19ad3a5dc21416b2',
                            name : 'App',
                            color: 'blue'
                        },
                        {
                            id   : '6540635g19ad3s5dc31412b2',
                            name : 'Feature',
                            color: 'green'
                        }
                    ]
                }
            };

            // Resolve the promise
            deferred.resolve(emptyObject);

            return deferred.promise;
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        // $translatePartialLoaderProvider.addPart('app/quick-panel');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(api, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        // api.quickPanel.contacts.get({}, function (response)
        // {
        //     vm.contacts = response.data;
        // });

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.tokens-list', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.tokens-list', {
                url    : '/users/tokens/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/tokens/list/list.html',
                        controller : 'TokensListController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.tokens-list')
        .controller('TokensListController', TokensListController);

    /** @ngInject */
    function TokensListController(transService, api, tableService, dialogService, $stateParams)
    {
        var vm = this;
        transService.loadFile('main/tokens/list');

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.request_sending = false;
        vm.tokens = [];
        vm.id = $stateParams.id;

        vm.getTokens = getTokens;
        vm.deleteTokens = deleteTokens;

        init();

        function init() {
            tableService.setVariables(vm);
            vm.query.user_id = $stateParams.id;
            getTokens();
        }


        /**
         * get contractors
         */
        function getTokens() {
            vm.promise = api.company.tokens.get(vm.query, function (response) {
                vm.tokens = response.data;
                vm.pagination = response.pagination
            }).$promise;
        }

        /**
         * delete contractor
         * @param id
         */
        function deleteTokens(id) {
            dialogService.confirm(null, 'TOKENS_LIST.DELETE_QUESTION', function() {
                api.company.token.delete({id:id}, function () {
                    vm.msg_success = transService.translate('TOKENS_LIST.DELETE_SUCCESS');
                    vm.msg_error = '';
                    init();

                },function (response) {
                    vm.msg_error = transService.getErrorMassage(response);
                })
            });
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.tokens-form', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.tokens-form-new', {
                url    : '/users/tokens/form/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/tokens/form/form.html',
                        controller : 'TokensFormController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.tokens-form')
        .controller('TokensFormController', TokensFormController);

    /** @ngInject */
    function TokensFormController(transService, api, $stateParams, apiErrorsService, $location)
    {

        var vm = this;
        transService.loadFile('main/tokens/form');

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.request_sending = false;
        vm.roles = [];

        vm.form = {
            user_id: $stateParams.id,
            role_id: '',
            ip_from: '',
            ip_to: '',
            domain: '',
            ttl: ''
        };

        vm.send = send;

        init();

        function init() {

            api.roles.get({}, function (response) {

                for (var i in response.data) {
                    if (response.data[i].name.indexOf('api.') == 0) {
                        vm.roles.push(response.data[i]);
                    }
                }
            });
        }

        function send() {

            $location.hash('');
            vm.request_sending = true;
            apiErrorsService.clear('#formToken', vm);

            api.company.tokens.save(vm.form,
                // success
                function() {
                    vm.msg_error = '';
                    vm.msg_success = transService.translate('TOKENS_FORM.ADD_SUCCESS');
                    vm.request_sending = false;
                    formService.formUp();
                },
                // error
                function(response) {
                    apiErrorsService.show('#formToken', response, vm, []);
                    vm.msg_error = transService.getErrorMassage(response);
                    vm.msg_success = '';
                    vm.request_sending = false;
                    formService.formUp();
                }
            );

        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.registry-sales', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        var params = {limit:__env.table_limit_rows, year: moment().format('YYYY'), month: moment().format('M'), no_invoice: 1};
        // State
        $stateProvider
            .state('app.registry-sales', {
                url    : '/registry-sales/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/registry-sales/list/list.html',
                        controller : 'RegistrySalesController as vm'
                    }
                },
                bodyClass: 'registry-sales-page',
                resolve  : {
                    Currencies: function (apiResolver)
                    {
                        return apiResolver.resolve('currencies@get', { used: 1 });
                    },
                    InvoiceTypesList: function (apiResolver)
                    {
                        return apiResolver.resolve('invoiceTypes@get', {register: 1});
                    },
                    TaxesList: function (apiResolver)
                    {
                        return apiResolver.resolve('taxs@get');
                    },
                    UsersList: function (apiResolver)
                    {
                        return apiResolver.resolve('company.users@get');
                    },
                    PaymentMethodsList: function (apiResolver)
                    {
                        return apiResolver.resolve('paymentsMethod.list@get');
                    },
                    RegistryInvoicesList: function (apiResolver)
                    {
                        return apiResolver.resolve('registryInvoices@get', params);
                    },
                    RegistryInvoicesReportList: function (apiResolver)
                    {
                        return apiResolver.resolve('reports.registryInvoices@get', params);
                    },
                    OnlineSalesList: function (apiResolver)
                    {
                        return apiResolver.resolve('onlineSales@get', params);
                    },
                    OnlineSalesReportList: function (apiResolver)
                    {
                        return apiResolver.resolve('reports.onlineSales@get', params);
                    },
                    ReceiptsList: function (apiResolver)
                    {
                        return apiResolver.resolve('receipts@get', params);
                    },
                    ReceiptsReportList: function (apiResolver)
                    {
                        return apiResolver.resolve('reports.receipts@get', params);
                    }
                }
            });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.registry-sales')
        .controller('RegistrySalesController', RegistrySalesController);

    /** @ngInject */
    function RegistrySalesController(transService, api, tableService, dialogService, $window, __env, $httpParamSerializer, $auth, $rootScope, Currencies,
                                     InvoiceTypesList, TaxesList, UsersList, PaymentMethodsList, RegistryInvoicesList, RegistryInvoicesReportList, OnlineSalesList, OnlineSalesReportList, ReceiptsList, ReceiptsReportList)
    {
        var vm = this;
        transService.loadFile('main/registry-sales/list');

        vm.current_year = moment().format('YYYY');
        vm.receipts_active = false;
        vm.download_sales = false;

        vm.tab1 = {
            invoices: RegistryInvoicesList.data,
            pagination: RegistryInvoicesList.meta.pagination,
            invoice_types: InvoiceTypesList.data,
            reports: RegistryInvoicesReportList.data,
            currencies: Currencies.data,
            taxes: {},
            msg_error: '',
            enable_jpk: false,
            getInvoices: getInvoices,
            pdfInvoices: pdfInvoices,
            csvInvoices: csvInvoices,
            jpkFa: jpkFa,
            downloadSales: downloadSales
        };

        vm.tab2 = {
            online_sales: OnlineSalesList.data,
            pagination: OnlineSalesList.meta.pagination,
            reports: OnlineSalesReportList.data,
            msg_error: '',
            getOnlineSales: getOnlineSales,
            detailsOnlineSales: detailsOnlineSales,
            pdfOnlineSales: pdfOnlineSales
        };

        vm.tab3 = {
            receipts: ReceiptsList.data,
            pagination: ReceiptsList.meta.pagination,
            reports: ReceiptsReportList.data,
            msg_error: '',
            payments_method: [],
            payments_method2: PaymentMethodsList.data,
            users: UsersList.data,
            getReceipts: getReceipts,
            detailsReceipts: detailsReceipts,
            pdfReceipts: pdfReceipts
        };

        init();

        function init() {

            $auth.getSettings(function (settings) {
                vm.receipts_active = settings['receipts.active'] == "1";
                vm.tab1.enable_jpk = settings['invoices.jpk_export'] == "1";

                $auth.getMyRole(function (role) {
                    if (role == 'tax_office') {
                        vm.download_sales = settings['invoices.registry.export.name'] != "";
                    }
                })
            });

            angular.forEach(TaxesList.data, function (item) {
                vm.tab1.taxes[item.id] = item;
            });

            tableService.setVariables(vm.tab1);
            vm.tab1.query.year = moment().format('YYYY');
            vm.tab1.query.month = moment().format('M');
            vm.tab1.query.invoice_type_id = null;
            vm.tab1.query.vat_rate_id = null;
            vm.tab1.query.currency = null;

            tableService.setVariables(vm.tab2);
            vm.tab2.query.year = moment().format('YYYY');
            vm.tab2.query.month = moment().format('M');
            vm.tab2.query.no_invoice = 1;
            vm.tab2.query.transaction_number = '';
            vm.tab2.query.number = '';
            vm.tab2.query.email = '';

            for(var i in vm.tab3.payments_method2) {
                vm.tab3.payments_method[vm.tab3.payments_method2[i].id] = vm.tab3.payments_method2[i];
            }

            tableService.setVariables(vm.tab3);
            vm.tab3.query.year = moment().format('YYYY');
            vm.tab3.query.month = moment().format('M');
            vm.tab3.query.payment_method_id = '';
            vm.tab3.query.transaction_number = '';
            vm.tab3.query.number = '';
            vm.tab3.query.user_id = '';
            vm.tab3.query.no_invoice = 1;
        }

        //tab1
        function getInvoices() {
            vm.tab1.promise = api.registryInvoices.get(vm.tab1.query, function (response) {
                vm.tab1.invoices = response.data;
                vm.tab1.pagination = response.meta.pagination;

                api.reports.registryInvoices.get(vm.tab1.query, function (response) {
                    vm.tab1.reports = response.data;
                });
            }).$promise;
        }

        function pdfInvoices() {
            var params = $httpParamSerializer(vm.tab1.query);
            $window.open(
                __env.apiUrl + 'reports/invoices-registry-pdf?' + params +
                '&token=' + $window.localStorage.token +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }

        function csvInvoices() {
            var params = $httpParamSerializer(vm.tab1.query);
            $window.open(
                __env.apiUrl + 'reports/invoices-registry-xls?' + params +
                '&token=' + $window.localStorage.token +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }

        function jpkFa() {
            if (vm.tab1.enable_jpk) {
                api.company.jpk.get({}, function () {
                    dialogService.customDialog(null, 'JpkFaDialogController', 'app/main/registry-sales/jpk-fa/jpk-fa.html');
                }, function () {
                    dialogService.alert(null, 'REGISTRY_SALES.INVOICES_LIST.ALERT_DETAIL_JPK');
                });
            } else {
                $rootScope.packageAlert();
            }
        }

        function downloadSales() {
            var params = $httpParamSerializer(vm.tab1.query);
            $window.open(
                __env.apiUrl + 'reports/invoices-report-export?' + params +
                '&token=' + $window.localStorage.token +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }

        //tab2

        function getOnlineSales() {
            vm.tab2.promise = api.onlineSales.get(vm.tab2.query, function (response) {
                vm.tab2.online_sales = response.data;
                vm.tab2.pagination = response.meta.pagination;

                api.reports.onlineSales.get(vm.tab2.query, function (response) {
                    vm.tab2.reports = response.data;
                });

            }).$promise;
        }

        function detailsOnlineSales(id) {
            dialogService.customDialog(null, 'RegistrySalesTab2ItemsDialogController', 'app/main/registry-sales/items/items.html', {id:id});
        }

        function pdfOnlineSales() {
            var params = $httpParamSerializer(vm.tab2.query);
            $window.open(
                __env.apiUrl + 'online-sales/pdf?' + params +
                '&token=' + $window.localStorage.token +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }

        //tab3

        function getReceipts() {
            vm.promise = api.receipts.get(vm.tab3.query, function (response) {
                vm.tab3.receipts = response.data;
                vm.tab3.pagination = response.meta.pagination;

                api.reports.receipts.get(vm.tab3.query, function (response) {
                    vm.tab3.reports = response.data;
                });
            }).$promise;
        }

        function detailsReceipts(id) {
            dialogService.customDialog(null, 'ReceiptsTab3ItemsDialogController', 'app/main/registry-sales/items-receipts/items.html', {id:id});
        }

        function pdfReceipts() {
            var params = $httpParamSerializer(vm.tab3.query);
            $window.open(
                __env.apiUrl + 'receipts/pdf?' + params +
                '&token=' + $window.localStorage.token +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.registry-sales')
        .controller('JpkFaDialogController', JpkFaDialogController);

    /** @ngInject */
    function JpkFaDialogController($auth, transService, $mdDialog, $window, $httpParamSerializer)
    {
        var vm = this;

        vm.form = {
            start_date: moment().format('YYYY-MM') + '-01',
            end_date: moment().format('YYYY-MM-DD')
        };

        vm.hide = hide;
        vm.generate = generate;

        function hide() {
            $mdDialog.hide();
        }

        /**
         * Create user
         */
        function generate() {
            var params = $httpParamSerializer(vm.form);
            $window.open(
                __env.apiUrl + 'invoices/jpk/fa?' + params +
                '&token=' + $window.localStorage.token +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.registry-sales')
        .controller('ReceiptsTab3ItemsDialogController', ReceiptsTab3ItemsDialogController);

    /** @ngInject */
    function ReceiptsTab3ItemsDialogController($mdDialog, api, id)
    {
        var vm = this;
        vm.items = [];

        vm.hide = hide;

        init();

        function init() {

            api.receipt.get({id: id}, function (response) {
                vm.items = response.data.items.data;
            });
        }

        function hide() {
            $mdDialog.hide();
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.registry-sales')
        .controller('RegistrySalesTab2ItemsDialogController', RegistrySalesTab2ItemsDialogController);

    /** @ngInject */
    function RegistrySalesTab2ItemsDialogController($mdDialog, api, id)
    {
        var vm = this;
        vm.items = [];

        vm.hide = hide;

        init();

        function init() {

            api.onlineSale.get({id: id}, function (response) {
                vm.items = response.data.items.data;
            });
        }

        function hide() {
            $mdDialog.hide();
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.receipts-list', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.receipts-list', {
                url    : '/receipts/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/receipts/list/list.html',
                        controller : 'ReceiptsListController as vm'
                    }
                },
                resolve  : {
                    UsersList: function (apiResolver)
                    {
                        return apiResolver.resolve('company.users@get');
                    },
                    PaymentMethodsList: function (apiResolver)
                    {
                        return apiResolver.resolve('paymentsMethod.list@get');
                    },
                    ReceiptsList: function (apiResolver)
                    {
                        return apiResolver.resolve('receipts@get', {limit:__env.table_limit_rows});
                    },
                    ReceiptsReportList: function (apiResolver)
                    {
                        return apiResolver.resolve('reports.receipts@get');
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.receipts-list')
        .controller('ReceiptsListController', ReceiptsListController);

    /** @ngInject */
    function ReceiptsListController(transService, api, tableService, dialogService, $window, __env, $httpParamSerializer, $auth, $location, UsersList, PaymentMethodsList, ReceiptsList, ReceiptsReportList)
    {
        var vm = this;
        transService.loadFile('main/receipts/list');

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.request_sending = false;
        vm.receipts = ReceiptsList.data;
        vm.pagination = ReceiptsList.meta.pagination;
        vm.payments_method = [];
        vm.payments_method2 = PaymentMethodsList.data;
        vm.users = UsersList.data;
        vm.reports = ReceiptsReportList.data;
        vm.is_tax_office = false;

        vm.getReceipts = getReceipts;
        vm.details = details;
        vm.receiptsModal = receiptsModal;
        vm.pdf = pdf;
        vm.report = report;
        vm.invoices = invoices;
        vm.invoice = invoice;

        init();

        function init() {

            for(var i in vm.payments_method2) {
                vm.payments_method[vm.payments_method2[i].id] = vm.payments_method2[i];
            }

            tableService.setVariables(vm);
            vm.query.payment_method_id = '';
            vm.query.date_start = '';
            vm.query.date_end = '';
            vm.query.transaction_number = '';
            vm.query.number = '';
            vm.query.user_id = '';

            $auth.getMyRole(function (role) {
                vm.is_tax_office = role == 'tax_office';
            })
        }

        /**
         * get contractors
         */
        function getReceipts() {
            vm.promise = api.receipts.get(vm.query, function (response) {
                vm.receipts = response.data;
                vm.pagination = response.meta.pagination;
                
                api.reports.receipts.get(vm.query, function (response) {
                    vm.reports = response.data;
                });
            }).$promise;
        }

        function receiptsModal() {
            dialogService.customDialog(null, 'CreateInvoiceDialogController', 'app/main/receipts/crete-invoice/crete-invoice.html');
        }

        function details(id) {
            dialogService.customDialog(null, 'ReceiptsItemsDialogController', 'app/main/receipts/items/items.html', {id:id});
        }

        function invoices(index) {
            dialogService.customDialog(null, 'ReceiptsInvoicesDialogController', 'app/main/receipts/invoices/invoices.html', {invoices:vm.receipts[index].invoices.data});
        }


        function pdf() {
            var params = $httpParamSerializer(vm.query);
            $window.open(
                __env.apiUrl + 'receipts/pdf?' + params +
                '&token=' + $window.localStorage.token +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }

        function report() {
            var params = $httpParamSerializer(vm.query);
            $window.open(
                __env.apiUrl + 'receipts/report?' + params +
                '&token=' + $window.localStorage.token +
                '&report=1' +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }

        function invoice(id) {
            $location.path('/invoices/form/new/receipt/' + id);
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.receipts-list')
        .controller('ReceiptsItemsDialogController', ReceiptsItemsDialogController);

    /** @ngInject */
    function ReceiptsItemsDialogController($mdDialog, api, id)
    {
        var vm = this;
        vm.items = [];

        vm.hide = hide;

        init();

        function init() {

            api.receipt.get({id: id}, function (response) {
                vm.items = response.data.items.data;
            });
        }

        function hide() {
            $mdDialog.hide();
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.receipts-list')
        .controller('ReceiptsInvoicesDialogController', ReceiptsInvoicesDialogController);

    /** @ngInject */
    function ReceiptsInvoicesDialogController($mdDialog, $window, $httpParamSerializer, $auth, __env, invoices)
    {
        var vm = this;
        vm.invoices = invoices;

        vm.hide = hide;
        vm.pdf = pdf;

        function hide() {
            $mdDialog.hide();
        }

        function pdf(id, duplicate) {
            var params = $httpParamSerializer(vm.query);
            $window.open(
                __env.apiUrl + 'invoices/' + id + '/pdf?' + params +
                '&token=' + $window.localStorage.token +
                '&duplicate=' + duplicate +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.receipts-list')
        .controller('CreateInvoiceDialogController', CreateInvoiceDialogController);

    /** @ngInject */
    function CreateInvoiceDialogController($timeout, transService, $mdDialog, api, $location)
    {
        var vm = this;

        vm.msg_success = '';
        vm.msg_error = '';
        vm.request_sending = false;
        vm.search_text_receipt = [];
        vm.selected_item = [];

        vm.edit = false;

        vm.searchReceipt = searchReceipt;
        vm.hide = hide;
        vm.create = create;
        vm.add = add;

        add();

        function searchReceipt(number) {

            return api.receipts.get({
                    limit: 15,
                    page: 1,
                    no_inovice: 1,
                    number: number
                }
            ).$promise.then(function (response) {
                return response.data;
            });
        }

        function add() {

            vm.selected_item.push(null);

            var temp = angular.copy(vm.selected_item);
            vm.search_text_receipt.push('');
            $timeout(function (p) {
                vm.selected_item = p.temp;
            }, 500, true, {temp:temp});
        }

        function hide() {
            $mdDialog.hide();
        }

        /**
         * Create user
         */
        function create() {

            var ids = [];
            var ids_params = '';

            angular.forEach(vm.selected_item, function (item) {
                if (item) {
                    var found = false;
                    angular.forEach(ids, function (id) {
                        if (item.id == id) {
                            found = true;
                        }
                    });

                    if (!found) {
                        ids.push(item.id);

                        if (ids_params != '') {
                            ids_params += '&';
                        }
                        ids_params += 'ids=' + item.id;
                    }
                }
            });

            if (ids.length > 1) {
                $location.url('/invoices/form/new/receipts?'+ids_params);
                $mdDialog.hide();
            } else {
                vm.msg_error = transService.translate('RECEIPTS_LIST.CREATE_INVOICE_ERROR');
            }

        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.projects-show', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.projects-show', {
                url    : '/projects/show/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/projects/show/show.html',
                        controller : 'ProjectsShowController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.projects-show')
        .controller('ProjectsShowController', ProjectsShowController);

    /** @ngInject */
    function ProjectsShowController(transService, api, $stateParams, projectsService)
    {
        var vm = this;
        transService.loadFile('main/projects/show');

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.project = {};
        vm.users = {};


        init();

        function init() {

            api.project.get({id:$stateParams.id}, function (response) {
                vm.project = response.data;
                projectsService.addActive(vm.project);
            });
            api.projectUsers.get({id:$stateParams.id}, function (response) {
                vm.users = response.data;
            });
        }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.projects-list', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.projects-list', {
                url    : '/projects/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/projects/list/list.html',
                        controller : 'ProjectsListController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.projects-list')
        .controller('ProjectsListController', ProjectsListController);

    /** @ngInject */
    function ProjectsListController(transService, api, tableService, dialogService, $location, $auth)
    {
        var vm = this;
        transService.loadFile('main/projects/list');

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.request_sending = false;
        vm.projects = [];
        vm.role = '';
        vm.sum = null;

        vm.getProjects = getProjects;
        vm.deleteProjects = deleteProjects;
        vm.closeProjects = closeProjects;
        vm.openProjects = openProjects;
        vm.edit = edit;
        vm.show = show;

        init();

        function init() {

            $auth.getMyRole(function (role) {
               vm.role = role;
            });

            tableService.setVariables(vm);
            vm.query.status = 'all';
            vm.query.sort = 'id';
            getProjects();
        }

        /**
         * get contractors
         */
        function getProjects() {
            vm.promise = api.projects.get(vm.query, function (response) {
                vm.projects = response.data;
                vm.pagination = response.meta.pagination;
            }).$promise;
        }

        /**
         * delete contractor
         * @param id
         */
        function deleteProjects(id) {
            dialogService.confirm(null, 'PROJECTS_LIST.DELETE', function() {
                api.project.delete({id:id}, function () {
                    vm.msg_success = transService.translate('PROJECTS_LIST.DELETE_SUCCESS');
                    vm.msg_error = '';
                    init();

                },function (response) {
                    vm.msg_error = transService.getErrorMassage(response);
                })
            });
        }

        /**
         * delete contractor
         * @param id
         */
        function closeProjects(id) {
            dialogService.confirm(null, 'PROJECTS_LIST.CLOSE_QUESTION', function() {
                api.projectClose.put({id:id, status: 'close'}, function () {
                    vm.msg_success = transService.translate('PROJECTS_LIST.CLOSE_SUCCESS');
                    vm.msg_error = '';
                    init();

                },function (response) {
                    vm.msg_error = transService.getErrorMassage(response);
                })
            });
        }

        /**
         * delete contractor
         * @param id
         */
        function openProjects(id) {
            dialogService.confirm(null, 'PROJECTS_LIST.OPEN_QUESTION', function() {
                api.projectClose.put({id:id, status: 'open'}, function () {
                    vm.msg_success = transService.translate('PROJECTS_LIST.OPEN_SUCCESS');
                    vm.msg_error = '';
                    init();

                },function (response) {
                    vm.msg_error = transService.getErrorMassage(response);
                })
            });
        }

        function edit(id) {
            $location.path('/projects/form/edit/' + id);
        }

        function show(id) {
            $location.path('/projects/show/' + id);
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.projects-form', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.projects-form-new', {
                url    : '/projects/form/:type',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/projects/form/form.html',
                        controller : 'ProjectsFormController as vm'
                    }
                }
            })
            .state('app.projects-form-edit', {
            url    : '/projects/form/:type/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/projects/form/form.html',
                    controller : 'ProjectsFormController as vm'
                }
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.projects-form')
        .controller('ProjectsFormController', ProjectsFormController);

    /** @ngInject */
    function ProjectsFormController(transService, api, $stateParams, formService, apiErrorsService, $location, $auth)
    {
        var vm = this;
        transService.loadFile('main/projects/form');

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.request_sending = false;
        vm.edit = false;
        vm.roles = [];
        vm.users = [];
        vm.form_users = [];
        vm.selected_users = [];
        vm.creator_id = 0;
        vm.current_users = []; //for edit

        vm.form = {
            id: null,
            name: '',
            short_name: ''
        };

        vm.send = send;
        vm.generateShort = generateShort;
        vm.searchUser = searchUser;

        init();

        function init() {

            api.rolesCompany.get({}, function (response) {
                vm.roles = response.data;
                angular.forEach(vm.roles, function (value) {
                    vm.form_users[value.id] = [];
                });

                if ($stateParams.type == 'new') {
                    $auth.getUser(function (user) {
                        vm.form_users[user.selected_user_company.data.role_id].push({
                            id: user.id,
                            email: user.email,
                            name: user.first_name + ' ' + user.last_name,
                            avatar: 'assets/images/avatars/profile.jpg',
                        });

                        vm.creator_id = user.id;
                    });
                }

                api.company.users.get({company_status:1}, function (response) {
                    vm.users = response.data;

                    angular.forEach(vm.users, function (value, key) {
                        vm.users[key].name = value.first_name + ' ' + value.last_name;
                        vm.users[key]._lowername  = vm.users[key].name.toLowerCase();
                        vm.users[key].avatar = 'assets/images/avatars/profile.jpg';
                    });
                });

                //get edit data
                if ($stateParams.type == 'edit' && !isNaN(Number($stateParams.id)) ) {
                    vm.edit = true;

                    api.project.get({id:$stateParams.id}, function (response) {
                        formService.generateForm(vm.form, response.data);
                    });

                    api.projectUsers.get({id:$stateParams.id}, function (response) {
                        vm.current_users = response.data;
                        angular.forEach(response.data, function (user) {
                            vm.form_users[user.role_id].push({
                                id: user.user.data.id,
                                email: user.user.data.email,
                                name: user.user.data.first_name + ' ' + user.user.data.last_name,
                                avatar: 'assets/images/avatars/profile.jpg',
                            });
                        })

                    })
                }
                
            });
        }

        function generateShort() {
            var arr = vm.form.name.split(' ');
            vm.form.short_name = '';

            if (arr.length == 1) {
                vm.form.short_name = arr[0].substring(0,3);
            }

            if (arr.length == 2) {
                vm.form.short_name = (arr[0].substring(0,2) + arr[1].substring(0,2));
            }

            if (arr.length > 2) {
                angular.forEach(arr, function (value, key) {
                    vm.form.short_name += arr[key].substring(0,1);
                });
            }

            vm.form.short_name = vm.form.short_name.toUpperCase();

        }

        /**
         * searsh user for chips
         * @param query
         * @returns {Array}
         */
        function searchUser(query) {

            var list_users = angular.copy(vm.users);

            //filter selected users
            angular.forEach(vm.form_users, function (list) {
                angular.forEach(list, function (user) {
                    for(var i = list_users.length - 1; i >= 0; --i) {
                        if (list_users[i].id == user.id) {
                            list_users.splice(i, 1);
                            break;
                        }
                    }
                })
            });

            return query ? list_users.filter(createFilterFor(query)) : [];
        }

        /**
         * filter users
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(contact) {
                return (contact._lowername.indexOf(lowercaseQuery) != -1);;
            };
        }

        //show save error
        function showError(response) {
            apiErrorsService.show('#formProject', response, vm, []);
            vm.msg_error = transService.getErrorMassage(response);
            vm.msg_success = '';
            vm.request_sending = false;
            $location.hash('up');
        }


        function send() {

            angular.forEach(vm.form_users, function (list, role_id) {
                angular.forEach(list, function (user) {
                    vm.selected_users.push({
                        id: '',
                        user_id: user.id,
                        role_id: role_id
                    });
                })
            });

            $location.hash('');
            vm.request_sending = true;
            apiErrorsService.clear('#formProject', vm);

            if (vm.edit) {
                api.project.put(vm.form, updateUsers, showError);
            } else {

                //create project
                api.projects.save(vm.form,
                    // success
                    function(response) {

                        //add users
                        var users_count = 0;

                        angular.forEach(vm.selected_users, function (user) {

                            if (user.user_id != vm.creator_id) { //not creator
                                user.id = response.data.id;
                                api.projectUsers.save(user,
                                    // success
                                    function () {
                                        ++users_count;
                                        if (users_count == vm.selected_users.length) { //all added
                                            vm.msg_error = '';
                                            vm.msg_success = transService.translate('PROJECTS_FORM.ADD_SUCCESS');
                                            vm.request_sending = false;
                                            $location.hash('up');
                                        }
                                    }, showError);
                            } else {
                                ++users_count;
                            }
                        });
                    }, showError);
            }

        }

        function updateUsers(response) {
            //deleted users
            var deleted_users = [];
            var added_users = [];

            //search deleted/changed users
            angular.forEach(vm.current_users, function (user) {
                var found = false;
                angular.forEach(vm.selected_users, function (selected_user) {
                    if (user.user.data.id == selected_user.user_id) {

                        if (user.role_id == selected_user.role_id) {
                            found = true;
                        } else {
                            added_users.push({
                                id: response.data.id,
                                user_id: user.user.data.id,
                                role_id: selected_user.role_id
                            });
                        }
                    }
                });

                if (!found) {
                    deleted_users.push({
                        id: response.data.id,
                        user_id: user.user.data.id,
                        role_id: false
                    });
                }
            });

            //added users
            angular.forEach(vm.selected_users, function (selected_user) {
                var found = false;
                angular.forEach(vm.current_users, function (user) {
                    if (user.user.data.id == selected_user.user_id) {
                        found = true;
                    }
                });

                if (!found) {
                    added_users.push({
                        id: response.data.id,
                        user_id: selected_user.user_id,
                        role_id: selected_user.role_id
                    });
                }
            });

            var changed_users = deleted_users.concat(added_users);
            var users_count = 0;

            if (changed_users.length == 0) {
                vm.msg_error = '';
                vm.msg_success = transService.translate('PROJECTS_FORM.UPDATE_SUCCESS');
                vm.request_sending = false;
                $location.hash('up');
            } else {

                //update users
                angular.forEach(changed_users, function (user) {

                    if (user.role_id === false) {
                        api.projectUser.delete(user,
                            // success
                            function () {
                                ++users_count;
                                if (users_count == changed_users.length) { //all added
                                    vm.msg_error = '';
                                    vm.msg_success = transService.translate('PROJECTS_FORM.UPDATE_SUCCESS');
                                    vm.request_sending = false;
                                    $location.hash('up');
                                }
                            }, showError);
                    } else {
                        api.projectUsers.save(user,
                            // success
                            function () {
                                ++users_count;
                                if (users_count == changed_users.length) { //all added
                                    vm.msg_error = '';
                                    vm.msg_success = transService.translate('PROJECTS_FORM.UPDATE_SUCCESS');
                                    vm.request_sending = false;
                                    $location.hash('up');
                                }
                            }, showError);
                    }
                });
            }
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.products-list', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.products-list', {
                url    : '/products/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/products/list/list.html',
                        controller : 'ProductsListController as vm'
                    }
                },
                resolve  : {
                    ProductsList: function (apiResolver)
                    {
                        return apiResolver.resolve('products@get', {limit:__env.table_limit_rows});
                    },
                    TaxesList: function (apiResolver)
                    {
                        return apiResolver.resolve('taxs@get');
                    }
                },
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.products-list')
        .controller('ProductsListController', ProductsListController);

    /** @ngInject */
    function ProductsListController(transService, api, tableService, dialogService, ProductsList, $auth, TaxesList)
    {
        var vm = this;
        transService.loadFile('main/products/list');

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.request_sending = false;
        vm.products = ProductsList.data;
        vm.pagination = ProductsList.meta.pagination;
        vm.taxs = [];
        vm.is_tax_office = false;

        vm.getProducts = getProducts;
        // vm.deleteProducts = deleteProducts;

        init();

        function init() {

            for(var i in TaxesList.data) {
                vm.taxs[TaxesList.data[i].id] = TaxesList.data[i];
            }

            tableService.setVariables(vm);
            vm.query.name = '';
            vm.query.sort = 'id';

            $auth.getMyRole(function (role) {
                vm.is_tax_office = role == 'tax_office';
            })
        }

        /**
         * get contractors
         */
        function getProducts() {
            vm.promise = api.products.get(vm.query, function (response) {
                vm.products = response.data;
                vm.pagination = response.meta.pagination;
            }).$promise;
        }

        /**
         * delete contractor
         * @param id
         */
        // function deleteProducts(id) {
        //     dialogService.confirm(null, 'PRODUCTS_LIST.DELETE_QUESTION', function() {
        //         api.products.delete({id:id}, function () {
        //             vm.msg_success = transService.translate('PRODUCTS_LIST.DELETE_SUCCESS');
        //             vm.msg_error = '';
        //             getProducts();
        //
        //         },function (response) {
        //             vm.msg_error = transService.getErrorMassage(response);
        //         })
        //     });
        // }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.products-form', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.products-form-new', {
                url    : '/products/form/:type?success',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/products/form/form.html',
                        controller : 'ProductsFormController as vm'
                    }
                }
            })
            .state('app.products-form-edit', {
            url    : '/products/form/:type/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/products/form/form.html',
                    controller : 'ProductsFormController as vm'
                }
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.products-form')
        .controller('ProductsFormController', ProductsFormController);

    /** @ngInject */
    function ProductsFormController(transService, api, $stateParams, formService, apiErrorsService, $location, $state, $timeout, $mdDialog, $rootScope)
    {
        var vm = this;
        transService.loadFile('main/products/form');

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.request_sending = false;
        vm.edit = false;
        vm.taxes = {};
        vm.units = {};
        vm.root_scope = $rootScope;

        vm.form = {
            id: null,
            name: '',
            pkwiu: '',
            type: 'service',
            description: '',
            print_on_invoice: false,
            price_net: null,
            price_gross: null,
            service_unit_id: null,
            vat_rate_id: ''
        };

        vm.changePrice = changePrice;
        vm.send = send;

        init();

        function init() {

            if (typeof $stateParams.success != 'undefined') {
                vm.msg_success = transService.translate('PRODUCTS_FORM.ADD_SUCCESS');
            }

            api.units.get({}, function (response) {
                vm.units = response.data;
            });

            api.taxs.get({}, function (response) {
                angular.forEach(response.data, function (item) {
                    vm.taxes[item.id] = item;
                });

                if (response.data.length === 1) {
                    vm.form.vat_rate_id = response.data[0].id;
                }
            });

            if ($stateParams.type == 'edit' && !isNaN(Number($stateParams.id)) ) {
                vm.edit = true;

                api.product.get({id:$stateParams.id}, function (response) {
                    formService.generateForm(vm.form, response.data);
                    vm.form.print_on_invoice = vm.form.print_on_invoice == 1;

                    if (!vm.form.price_net) {
                        vm.form.price_net = null;
                        vm.form.price_gross = null;
                    }
                })
            }
        }

        function changePrice() {
            if (vm.form.price_net && vm.form.vat_rate_id != '') {
                vm.form.price_gross = vm.form.price_net * (1 + (vm.taxes[vm.form.vat_rate_id].rate / 100) );
                if (isNaN(vm.form.price_gross))
                    vm.form.price_gross = 0;
                vm.form.price_gross =  Math.round(vm.form.price_gross * 100) / 100;
            } else {
                vm.form.price_gross = null;
            }
        }

        function send(is_modal) {

            if (!is_modal) {
                $location.hash('');
            }

            vm.request_sending = true;
            apiErrorsService.clear('#formProduct', vm);

            if (vm.edit) {

                api.product.put(vm.form,
                    // success
                    function() {
                        vm.msg_error = '';
                        vm.msg_success = transService.translate('PRODUCTS_FORM.UPDATE_SUCCESS');
                        vm.request_sending = false;
                        if (is_modal) {
                            $mdDialog.hide();
                        } else {
                            formService.formUp();
                        }
                    },
                    // error
                    function(response) {
                        apiErrorsService.show('#formProduct', response, vm, []);
                        vm.msg_error = transService.getErrorMassage(response);
                        vm.msg_success = '';
                        vm.request_sending = false;
                        if (!is_modal) {
                            formService.formUp();
                        }
                    }
                );
            } else {

                api.product.save(vm.form,
                    // success
                    function(response) {
                        //reload
                        if (is_modal) {
                            $mdDialog.hide(response.data);
                        } else {
                            $location.url('/products/form/new?success=true');
                            $timeout(function () {
                                $state.reload();
                            }, 500);
                        }
                    },
                    // error
                    function(response) {
                        apiErrorsService.show('#formProduct', response, vm, []);
                        vm.msg_error = transService.getErrorMassage(response);
                        vm.msg_success = '';
                        vm.request_sending = false;
                        if (!is_modal) {
                            formService.formUp();
                        }
                    }
                );
            }
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.page.privacy-policy', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.page_privacy-policy', {
                url    : '/page/privacy-policy',
                views    : {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.page_privacy-policy': {
                        templateUrl: 'app/main/pages/privacy-policy/privacy-policy.html',
                        controller : 'PrivacyPolicyController as vm'
                    }
                },
                bodyClass: 'privacy-policy'
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.page.privacy-policy')
        .controller('PrivacyPolicyController', PrivacyPolicyController);

    /** @ngInject */
    function PrivacyPolicyController(transService, api)
    {
        var vm = this;
        transService.loadFile('main/pages/privacy-policy');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('PackageAlertDialogController', PackageAlertDialogController);

    /** @ngInject */
    function PackageAlertDialogController($mdDialog, $location)
    {
        var vm = this;

        vm.hide = hide;
        vm.goPremium = goPremium;

        function hide() {
            $mdDialog.hide();
        }

        function goPremium() {
            $mdDialog.hide();
            $location.url('/company/edit?package=premium');
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('NewVersionDialogController', NewVersionDialogController);

    /** @ngInject */
    function NewVersionDialogController($mdDialog, $window, transService, $auth)
    {
        var vm = this;
        vm.name = '';
        transService.loadFile('main/pages/new-version');

        vm.hide = hide;
        vm.refresh = refresh;

        $auth.getUser(function (user) {
            vm.name = user.first_name + ' ' + user.last_name;
        });

        function hide() {
            $mdDialog.hide();
        }

        function refresh() {
            $window.location.reload();
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('LanguageWebBrowserDialogController', LanguageWebBrowserDialogController);

    /** @ngInject */
    function LanguageWebBrowserDialogController($mdDialog, transService)
    {
        var vm = this;
        transService.loadFile('main/pages/language_webbrowser');

        vm.hide = hide;

        function hide() {
            $mdDialog.hide();
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('InviteTaxOfficeDialogController', InviteTaxOfficeDialogController);

    /** @ngInject */
    function InviteTaxOfficeDialogController($mdDialog, $location, $state)
    {
        var vm = this;

        vm.hide = hide;
        vm.goToInvite = goToInvite;

        function hide() {
            $mdDialog.hide();
        }

        function goToInvite() {
            $mdDialog.hide();
            if ($location.url() != '/company/edit?user=tax_office') {
                $location.url('/company/edit?user=tax_office');
            } else {
                $state.reload();
            }
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('GdprInfoDialogController', GdprInfoDialogController);

    /** @ngInject */
    function GdprInfoDialogController($rootScope, $mdDialog, transService, $location)
    {
        var vm = this;
        transService.loadFile('main/pages/gdpr_info');        

        vm.accept = accept;
        vm.hide = hide;
        vm.goToPrivacyPolicy = goToPrivacyPolicy;

        function accept() {
            $rootScope.closeGdprInfo();
            $mdDialog.hide();
        }
        function hide() {
            $mdDialog.hide();
        }

        function goToPrivacyPolicy() {
            $mdDialog.hide();
            $location.path('/page/privacy-policy');
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.page.cookie', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.page_cookie', {
                url    : '/page/cookie',
                views    : {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.page_cookie': {
                        templateUrl: 'app/main/pages/cookie/cookie.html',
                        controller : 'CookieController as vm'
                    }
                },
                bodyClass: 'cookie'
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.page.cookie')
        .controller('CookieController', CookieController);

    /** @ngInject */
    function CookieController(transService, api)
    {
        var vm = this;
        transService.loadFile('main/pages/cookie');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.online-sales-list', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.online-sales-list', {
                url    : '/online-sales/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/online-sales/list/list.html',
                        controller : 'OnlineSalesListController as vm'
                    }
                },
                resolve  : {
                    OnlineSalesList: function (apiResolver)
                    {
                        return apiResolver.resolve('onlineSales@get', {limit:__env.table_limit_rows});
                    },
                    OnlineSalesReportList: function (apiResolver)
                    {
                        return apiResolver.resolve('reports.onlineSales@get');
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.online-sales-list')
        .controller('OnlineSalesListController', OnlineSalesListController);

    /** @ngInject */
    function OnlineSalesListController(transService, api, tableService, dialogService, $window, __env, $httpParamSerializer, $auth, $location, OnlineSalesList, OnlineSalesReportList)
    {
        var vm = this;
        transService.loadFile('main/online-sales/list');

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.request_sending = false;
        vm.online_sales = OnlineSalesList.data;
        vm.pagination = OnlineSalesList.meta.pagination;
        vm.reports = OnlineSalesReportList.data;
        vm.is_tax_office = false;


        vm.getOnlineSales = getOnlineSales;
        vm.details = details;
        vm.pdf = pdf;
        vm.invoices = invoices;
        vm.invoice = invoice;

        init();

        function init() {
            tableService.setVariables(vm);
            vm.query.date_start = '';
            vm.query.date_end = '';
            vm.query.transaction_number = '';
            vm.query.number = '';
            vm.query.email = '';

            $auth.getMyRole(function (role) {
                vm.is_tax_office = role == 'tax_office';
            })
        }

        /**
         * get contractors
         */
        function getOnlineSales() {
            vm.promise = api.onlineSales.get(vm.query, function (response) {
                vm.online_sales = response.data;
                vm.pagination = response.meta.pagination;

                api.reports.onlineSales.get(vm.query, function (response) {
                    vm.reports = response.data;
                });
            }).$promise;
        }

        function details(id) {
            dialogService.customDialog(null, 'OnlineSalesItemsDialogController', 'app/main/online-sales/items/items.html', {id:id});
        }

        function invoices(index) {
            dialogService.customDialog(null, 'OnlineSalesDialogController', 'app/main/online-sales/invoices/invoices.html', {invoices:vm.online_sales[index].invoices.data});
        }

        function pdf() {
            var params = $httpParamSerializer(vm.query);
            $window.open(
                __env.apiUrl + 'online-sales/pdf?' + params +
                '&token=' + $window.localStorage.token +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }
        
        function invoice(id) {
            $location.path('/invoices/form/new/online-sales/' + id);
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.online-sales-list')
        .controller('OnlineSalesItemsDialogController', OnlineSalesItemsDialogController);

    /** @ngInject */
    function OnlineSalesItemsDialogController($mdDialog, api, id)
    {
        var vm = this;
        vm.items = [];

        vm.hide = hide;

        init();

        function init() {

            api.onlineSale.get({id: id}, function (response) {
                vm.items = response.data.items.data;
            });
        }

        function hide() {
            $mdDialog.hide();
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.online-sales-list')
        .controller('OnlineSalesDialogController', OnlineSalesDialogController);

    /** @ngInject */
    function OnlineSalesDialogController($mdDialog, $window, $httpParamSerializer, $auth, __env, invoices)
    {
        var vm = this;
        vm.invoices = invoices;

        vm.hide = hide;
        vm.pdf = pdf;

        function hide() {
            $mdDialog.hide();
        }

        function pdf(id, duplicate) {
            var params = $httpParamSerializer(vm.query);
            $window.open(
                __env.apiUrl + 'invoices/' + id + '/pdf?' + params +
                '&token=' + $window.localStorage.token +
                '&duplicate=' + duplicate +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('InvoicesSuccessSaveDialogController', InvoicesSuccessSaveDialogController);

    /** @ngInject */
    function InvoicesSuccessSaveDialogController(api, apiErrorsService, transService, $window, $mdDialog, $location, $auth, $state, invoice, type, page)
    {
        transService.loadFile('main/invoices/success_save');

        var vm = this;
        vm.msg_error = '';
        vm.msg_success = '';
        vm.invoice = invoice;
        vm.page = page;
        vm.form_email_anabled = false;
        vm.request_sending = false;
        vm.form = {
            id: invoice.id,
            email: ''
        },

        vm.pdf = pdf;
        vm.email = email;
        vm.cancelForm = cancelForm;
        vm.edit = edit;
        vm.copy = copy;
        vm.list = list;
        vm.add_new = add_new;

        init();

        function init() {
            if (!page) {
                vm.form_email_anabled = true;
            }

            if (typeof invoice.invoice_contractor != 'undefined') {
                vm.form.email = invoice.invoice_contractor.data.email;
            }
        }

        function pdf() {
            $window.open(
                __env.apiUrl + 'invoices/' + vm.invoice.id + '/pdf?' +
                'token=' + $window.localStorage.token +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }

        function email() {
            vm.request_sending = true;
            apiErrorsService.clear('#sendInvoiceEmail', vm);

            api.invoiceSendMail.save(vm.form,
                // success
                function() {
                    vm.request_sending = false;
                    vm.msg_success = transService.translate('INVOICES_SUCCESS_SAVE.SEND_SUCCESS');
                },
                // error
                function(response) {
                    apiErrorsService.show('#sendInvoiceEmail', response, vm, []);
                    vm.request_sending = false;
                    vm.msg_error = transService.getErrorMassage(response);
                }
            );
        }

        function cancelForm() {
            if (page) {
                vm.form_email_anabled = false
            } else {
                $mdDialog.hide();
            }
        }

        function edit() {
            if (page == 'edit') {
                $state.reload();
            } else {
                $location.path('/invoices/form/edit/' + vm.invoice.id);
            }

            $mdDialog.hide(true);
        }

        function copy() {
          $location.path('/invoices/form/new/invoice/' + vm.invoice.id);
          $mdDialog.hide(true);
        }

        function list() {
            $location.path('/invoices/list');
            $mdDialog.hide(true);
        }

        function add_new() {
            if (page == 'new') {
                $state.reload();
            } else {
                if (!type) {
                    api.invoiceTypes.get({}, function (response) {
                        angular.forEach(response.data, function (item) {
                            if (item.id == vm.invoice.invoice_type_id) {
                                type = item.slug;
                            }
                        });
                        $location.path('/invoices/form/new/type/' + type);
                    });

                } else {
                    $location.path('/invoices/form/new/type/' + type);
                }
            }

            $mdDialog.hide(true);
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.invoices-list', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.invoices-list', {
                url    : '/invoices/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/list/list.html',
                        controller : 'InvoicesListController as vm'
                    }
                },
                resolve  : {
                    Currencies: function (apiResolver)
                    {
                        return apiResolver.resolve('currencies@get', { used: 1 });
                    },
                    InvoicesList: function (apiResolver)
                    {
                        return apiResolver.resolve('invoices@get', {status: 'all', sort: '-id', limit:__env.table_limit_rows});
                    },
                    InvoiceTypesList: function (apiResolver)
                    {
                        return apiResolver.resolve('invoiceTypes@get');
                    },
                    InvoiceSettings: function (apiResolver)
                    {
                        return apiResolver.resolve('invoiceSettings@get');
                    },
                    InvoiceFormats: function (apiResolver)
                    {
                        return apiResolver.resolve('invoiceFormats@get');
                    },
                    InvoicesReportList: function (apiResolver)
                    {
                      return apiResolver.resolve('reports.invoices@get');
                    },
                    InvoiceFilters: function (apiResolver)
                    {
                      return apiResolver.resolve('invoiceFilters@get');
                    }
                }
            });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.invoices-list')
        .controller('InvoicesPaymentsDialogController', InvoicesPaymentsDialogController);

    /** @ngInject */
    function InvoicesPaymentsDialogController($mdDialog, api, id, is_tax_office)
    {
        var vm = this;
        vm.items = [];
        vm.payment_methods = [];
        vm.is_tax_office = is_tax_office;

        vm.hide = hide;
        vm.removePayment = removePayment;

        init();

        function init() {

            api.paymentsMethod.list.get({}, function (response) {
                angular.forEach(response.data, function (item) {
                    vm.payment_methods[item.id] = item;
                });
            });

            api.invoicePayments.get({invoice_id: id}, function (response) {
                vm.items = response.data;
            });
        }

        function hide() {
            $mdDialog.hide();
        }

        function removePayment(id) {
            $mdDialog.hide(id);
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.invoices-list')
        .controller('InvoicesListController', InvoicesListController);

    /** @ngInject */
    function InvoicesListController(transService, api, tableService, $httpParamSerializer, $window, $auth, $location,
                                    dialogService, $rootScope, InvoicesList, InvoiceTypesList, InvoicesReportList, $timeout,
                                    InvoiceFilters, InvoiceSettings, InvoiceFormats, Currencies, localStorageService, __env)
    {
        var vm = this;
        transService.loadFile('main/invoices/list');

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.request_sending = false;
        vm.invoices = InvoicesList.data;
        vm.pagination = InvoicesList.meta.pagination;
        vm.reports = InvoicesReportList.data;
        vm.filters = InvoiceFilters.data;
        vm.registries = InvoiceSettings.data.invoice_registries.data;
        vm.currencies = Currencies.data;
        vm.types = [];
        vm.type = null;
        vm.correction_ids = [];
        vm.id_type_correction = 0;
        vm.id_type_margin_correction = 0;
        vm.id_type_proforma = 0;
        vm.contractor = null;
        vm.is_proforma = false;
        vm.is_margin = false;
        vm.is_tax_office = false;
        vm.search_text = '';
        vm.is_loading = true;
        vm.invoice_formats = [];
        vm.save_filters = true;
        vm.ls_save_filters_key = 'fv_invoices_save_filters';
        vm.ls_filters_key = 'fv_invoices_filters';

        angular.forEach(InvoiceFormats.data, function (value) {
            vm.invoice_formats[value.id] = value;
        });

        vm.getInvoices = getInvoices;
        vm.filterInvoices = filterInvoices;
        vm.searchContractor = searchContractor;
        vm.selectAdd = selectAdd;
        vm.pdf = pdf;
        vm.pdfAll = pdfAll;
        vm.archiveAll = archiveAll;
        vm.invoicesZips = invoicesZips;
        vm.payments = payments;
        vm.paymentsAdd = paymentsAdd;
        vm.cancel = cancel;
        vm.mail = mail;
        vm.goTo = goTo;
        vm.isCorrection = isCorrection;
        vm.moment = moment;
        vm.onPaginationChanged = onPaginationChanged;
        vm.saveFilters = saveFilters;
        vm.resetFilters = resetFilters;

        init();

        function init() {
            $auth.getSettings(function (settings) {
                vm.is_proforma = settings['invoices.proforma.enabled'] == "1";
                vm.is_margin = settings['invoices.margin.enabled'] == "1";
                vm.reverse_charge = settings['invoices.reverse.charge.enabled'] == "1";

                vm.is_loading = false;
            });

            vm.correction_ids = [];

            //invoice types
            var data = InvoiceTypesList.data;
            for(var i in data) {
                vm.types[data[i].id] = data[i];

                if (data[i].slug == 'correction' ||
                    data[i].slug == 'margin_correction' ||
                    data[i].slug == 'reverse_charge_correction' ||
                    data[i].slug == 'currency_correction' ||
                    data[i].slug == 'currency_reverse_charge_correction' ||
                    data[i].slug == 'margin_proforma_correction'
                ) {
                    vm.correction_ids.push(data[i].id);
                }

                if (data[i].slug == 'proforma' || data[i].slug == 'margin_proforma') {
                    vm.id_type_proforma = data[i].id;
                }
            }

            tableService.setVariables(vm);
            vm.query.number = null;
            vm.query.contractor_id = null;
            vm.query.status = 'all';
            vm.query.invoice_registry_id = null;
            vm.query.date_start = '';
            vm.query.date_end = '';
            vm.query.sort = '-id';
            vm.query.currency = null;

            // load query params from LS:
            loadQueryFromLS();

            $auth.getMyRole(function (role) {
                vm.is_tax_office = role == 'tax_office';
            })
        }

        function getInvoices() {
            if (vm.query.number == '') {
                vm.query.number = null;
            }

            vm.promise = api.invoices.get(vm.query, function (response) {
                vm.invoices = response.data;
                vm.pagination = response.meta.pagination;
            }).$promise;

            api.reports.invoices.get(vm.query, function (response) {
                vm.reports = response.data;
            });
        }

        function searchContractor(name) {

            return api.contractors.get({
                    limit: 15,
                    page: 1,
                    search: name
                }
            ).$promise.then(function (response) {
                return response.data;
            });
        }

        function filterInvoices() {
            if (vm.contractor) {
                vm.query.contractor_id = vm.contractor.id;
            } else {
                vm.query.contractor_id = null;
            }
            localStorageService.save(vm.ls_filters_key, vm.query);
            getInvoices();
        }

        function selectAdd() {
            if (vm.type) {
                if (vm.type == 'proforma' && !vm.is_proforma) {
                    $rootScope.packageAlert();
                    vm.type = null;
                    return;
                }
                if (vm.type == 'margin' && !vm.is_margin) {
                    $rootScope.packageAlert();
                    vm.type = null;
                    return;
                }
                if (vm.type == 'reverse_charge' && !vm.reverse_charge) {
                    $rootScope.packageAlert();
                    vm.type = null;
                    return;
                }
                if (vm.type == 'margin_proforma' && !vm.is_margin) {
                    $rootScope.packageAlert();
                    vm.type = null;
                    return;
                }

                goTo('form/new/type/' + vm.type);
            }
        }

        function pdf(id, duplicate) {
            var params = $httpParamSerializer(vm.query);
            $window.open(
                __env.apiUrl + 'invoices/' + id + '/pdf?' + params +
                '&token=' + $window.localStorage.token +
                '&duplicate=' + duplicate +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }

        function pdfAll() {
            var params = $httpParamSerializer(vm.query);
            $window.open(
                __env.apiUrl + 'invoices/pdf?' + params +
                '&token=' + $window.localStorage.token +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }

        function archiveAll() {
            if (vm.pagination.total > 50) {
                dialogService.alert(null, 'INVOICES_LIST.INVOICES_ARCHIVE_EXCEEDED');
                return;
            }

            api.invoicesZip.get(vm.query, function () {
                dialogService.customDialog(null, 'InvoicesZipPendingDialogController', 'app/main/invoices/list/zip_pending_dialog/zip_pending_dialog.html', {}, function(go_to_zips) {
                    if (go_to_zips) {
                        invoicesZips();
                    }
                });
            }, function (response) {
                vm.msg_error = transService.getErrorMassage(response);
            })

        }

        function invoicesZips(e) {
            dialogService.customDialog(e, 'InvoicesZipDownloadDialogController', 'app/main/invoices/list/zip_download_dialog/zip_download_dialog.html', {});
        }

        function payments(id) {
            dialogService.customDialog(null, 'InvoicesPaymentsDialogController', 'app/main/invoices/payments/payments.html', {id:id, is_tax_office:vm.is_tax_office}, function (id) {
                if (id) {
                    dialogService.confirm(null, 'INVOICES_LIST.PAYMENTS.DELETE_QUESTION', function () {
                        api.invoicePayment.delete({id: id}, function () {
                            vm.msg_success = transService.translate('INVOICES_LIST.PAYMENTS.DELETE_SUCCESS');
                            vm.msg_error = '';
                            getInvoices();

                        }, function (response) {
                            vm.msg_error = transService.getErrorMassage(response);
                        })
                    });
                }
            });
        }

        function cancel(id) {
            dialogService.confirm(null, 'INVOICES_LIST.CANCEL_QUESTION', function() {
                api.invoice.delete({id:id},
                    // success
                    function(response) {
                        vm.msg_error = '';
                        vm.msg_success = transService.translate('INVOICES_LIST.CANCEL_SUCCESS');
                        getInvoices();
                    },
                    // error
                    function(response) {
                        vm.msg_error = transService.getErrorMassage(response);
                        vm.msg_success = '';
                    }
                );
            });
        }

        function paymentsAdd(id, amount, method) {
            dialogService.customDialog(null, 'InvoicesPaymentsAddDialogController', 'app/main/invoices/add-payment/add-payment.html',
              { id: id, amount: amount, method: method }, function (success) {
                if (success == true) {
                    vm.msg_error = '';
                    vm.msg_success = transService.translate('INVOICES_LIST.PAYMENTS.SUCCESS');
                    getInvoices();
                }
            });
        }

        function mail(invoice) {
            dialogService.customDialog(null, 'InvoicesSuccessSaveDialogController', 'app/main/invoices/success_save/success_save.html', {invoice:invoice, type:null, page: false});
        }

        function goTo(path) {
            $location.path('/invoices/' + path);
        }

        function isCorrection(id) {
            return vm.correction_ids.indexOf(id) != -1;
        }

        function onPaginationChanged() {
            getInvoices();
            tableService.scrollToTableTop();
        }

        function saveFilters() {
            $timeout(function () {
                localStorageService.save(vm.ls_save_filters_key, vm.save_filters);
                if (vm.save_filters) {
                    localStorageService.save(vm.ls_filters_key, vm.query);
                }
            });
        }

        function resetFilters() {
            vm.query.number = null;
            vm.query.contractor_id = null;
            vm.query.status = 'all';
            vm.query.invoice_registry_id = null;
            vm.query.date_start = '';
            vm.query.date_end = '';
            vm.query.currency = null;
            vm.contractor = null;
            vm.save_filters = false;
            saveFilters();
            localStorageService.save(vm.ls_filters_key, vm.query);
            getInvoices();
        }

        function loadQueryFromLS() {
            $timeout(function () {
                vm.save_filters = localStorageService.get(vm.ls_save_filters_key) || false;
                if (!vm.save_filters) {
                    return;
                }
                const ls_query = localStorageService.get(vm.ls_filters_key);
                if (!ls_query) {
                    return;
                }
                vm.query = ls_query;
                // Load contractor object if contractor_id specified
                if (vm.query.contractor_id) {
                    api.contractor.get({ id: vm.query.contractor_id }, function (response) {
                        console.log(response.data);
                        vm.contractor = response.data;
                    });
                }
                // get invoices list with LS query params
                getInvoices();
            }, 200);
        }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.invoices-form-edit', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.invoice-form-edit', {
                url    : '/invoices/form/edit/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/form-edit/form-edit.html',
                        controller : 'InvoicesFormEditController as vm'
                    }
                },
                resolve  : {
                    CurrentCompany: function (apiResolver)
                    {
                        return apiResolver.resolve('currentCompany@get');
                    },
                    TaxesList: function (apiResolver)
                    {
                        return apiResolver.resolve('taxs@get');
                    },
                    UnitsList: function (apiResolver)
                    {
                        return apiResolver.resolve('units@get');
                    },
                    PaymentMethodsList: function (apiResolver)
                    {
                        return apiResolver.resolve('paymentsMethod.list@get', {invoice_restrict:1});
                    },
                    Invoice: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('invoice@get', {id:$stateParams.id});
                    },
                    InvoiceTypesList: function (apiResolver)
                    {
                        return apiResolver.resolve('invoiceTypes@get');
                    },
                    ProductsListShortList: function (apiResolver)
                    {
                        return apiResolver.resolve('products@get', {limit: 3, sort:'-is_used'});
                    }
                }
            });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.invoices-form-edit')
        .controller('InvoicesFormEditController', InvoicesFormEditController);

    /** @ngInject */
    function InvoicesFormEditController(transService, api, dialogService, formService, apiErrorsService, $location, $scope,
                                        $auth, $timeout, invoiceService, TaxesList, UnitsList, PaymentMethodsList,
                                        Invoice, InvoiceTypesList, CurrentCompany, ProductsListShortList)
    {
        var vm = this;
        transService.loadFile('main/invoices/form');

        // Data
        vm.in_loading = true;
        vm.in_loading_contractor = true;
        vm.products_short_list = ProductsListShortList.data;

        vm.send = send;

        init();

        function init() {

            invoiceService.init(vm, $scope);
            vm.units = UnitsList.data;
            vm.payment_methods = PaymentMethodsList.data;
            vm.company = CurrentCompany.data;

            formService.generateForm(vm.form, Invoice.data);
            vm.form.id = Invoice.data.id;
            vm.form.default_delivery = vm.form.default_delivery == 1;
            vm.title = Invoice.data.number;
            vm.show_description = vm.form.description != '';

            //get slug type
            angular.forEach(InvoiceTypesList.data, function (item) {
                if (item.id == vm.form.invoice_type_id) {
                    vm.type = item.slug;
                }
            });

            // gtu items
            invoiceService.getGtuItems();

            //margin procedures
            if (vm.type == 'margin' || vm.type == 'margin_proforma' || vm.type == 'margin_correction') {
                invoiceService.getMarginProcedures();
            }
            //reverse charges
            if (vm.type == 'reverse_charge' || vm.type == 'currency_reverse_charge') {
                invoiceService.getReverseChanges();
            }
            //currency
            if (vm.type == 'currency' || vm.type == 'currency_reverse_charge') {
                invoiceService.getCurrencies();
            }

            invoiceService.setPaymentDate(vm.form.payment_term_days);

            // bank account
            invoiceService.setBankAccount(vm.company, Invoice.data.bank_account);

            //special payments
            if (Invoice.data.special_payments.data.length) {
                vm.special_payment = true;
                vm.form.special_payment = Invoice.data.special_payments.data[0];
            }

            //taxes
            angular.forEach(TaxesList.data, function (item) {
                vm.taxes[item.id] = item;

                if (item.name == 'np.') {
                    vm.tax_type_np_id = item.id;
                }
            });

            //invoice settings
            invoiceService.getInvoiceSettingAndFormats();

            //load items and set values
            angular.forEach(vm.form.items, function (item, key) {

                vm.form.items[key].service_unit = vm.form.items[key].service_unit.data;

                delete vm.form.items[key].paid;
                delete vm.form.items[key].invoice;

                (function (key) {
                    api.product.get({id:item.company_service_id}, function (response_product) {
                        vm.form.items[key].current_service = response_product.data;
                        vm.form.items[key].search_text = response_product.data.name;
                        vm.form.items[key].watch = vm.productWatch(key);

                        vm.form.items[key].custom_name_enable = vm.form.items[key].custom_name != null && vm.form.items[key].custom_name != '';
                        if (!vm.form.items[key].custom_name_enable) {
                            vm.form.items[key].custom_name = '';
                        }
                    })
                }(key));

            });

            //has receipts or online_sales
            if (Invoice.data.receipts.data.length || Invoice.data.online_sales.data.length) {
                vm.is_extra_item = true;
            }

            //get settings and data for edit
            $auth.getSettings(function (settings) {
                vm.custom_name_products_enable = settings['invoices.services.name.allow_customization'] == "1";
                vm.addresses_delivery_enabled = settings['invoices.addresses.delivery.enabled'] == "1";

                //set contractor delivery
                if (vm.addresses_delivery_enabled && Invoice.data.delivery_address.data) {
                    api.contractor.get({id: Invoice.data.delivery_address.data.contractor_id}, function (response) {
                        vm.delivery_contractor = response.data;
                    }, vm.responseError)
                }

                vm.in_loading = false;

                //get contractor
                api.contractor.get({id:vm.form.contractor_id}, function (response) {
                    vm.contractor = response.data;
                    $timeout(function () {
                        vm.in_loading_contractor = false;
                        //create invoice without delivery address and edit with
                        if (!vm.form.delivery_address_id && vm.addresses_delivery_enabled) {
                            vm.delivery_contractor = angular.copy(vm.contractor);
                            vm.changeContractorDelivery();
                        }
                    });
                }, vm.responseError)
            });


            /**
             * select contractor
             */
            $scope.$watch(function () {return vm.contractor;},function(value){
                // if (!vm.is_extra_item && value) {
                //
                //     //payment_method_id
                //     if (vm.contractor.default_payment_method_id && !vm.in_loading && !vm.special_payment) {
                //         vm.form.payment_method_id = vm.contractor.default_payment_method_id;
                //     }
                //
                //     invoiceService.setPaymentDateFull();
                // }

                //set contractor and address delivery
                if (!vm.in_loading_contractor && vm.addresses_delivery_enabled && value) {
                    vm.delivery_contractor = angular.copy(value);
                    if (!vm.form.default_delivery) {
                        vm.changeContractorDelivery();
                    }
                }
            });

            /**
             * change issue_date
             */
            $scope.$watch(function () {return vm.form.issue_date;},function(value){
                if (!vm.is_extra_item && value && !vm.in_loading) {
                    invoiceService.setPaymentDateFull();
                }
            });

            /**
             * change payment_method_id
             */
            $scope.$watch(function () {return vm.form.payment_method_id;},function(value){
                angular.forEach(vm.payment_methods, function (item) {
                    if (item.id == value) {
                        vm.current_method = item;
                        vm.disabled_payment_date = (item.slug == 'gotowka' || item.slug == 'karta' || item.slug == 'payu');
                        if (!vm.in_loading) {
                            invoiceService.setPaymentDateFull();
                        }
                    }
                })

            });

            /**
             * change products
             */
            $scope.$watchCollection(function () {return vm.form.items;},invoiceService.calculate);
        }

        function send() {
            //confirm action
            dialogService.confirm(null, 'INVOICES_FORM.UPDATE_QUESTION', function() {

                $location.hash('');
                vm.request_sending = true;
                apiErrorsService.clear('#invoiceProduct', vm);

                //clear unnecessary elements
                var form = angular.copy(vm.form);

                angular.forEach(form.items, function (item) {
                    delete item.current_service;
                    delete item.search_text;
                    delete item.watch;
                });

                form.contractor_id = vm.contractor.id; //set contractor id
                form.payment_term_days = moment(vm.payment_date).diff(vm.form.issue_date, 'days'); //calculate payment_term_days

                if (!vm.show_description) {
                    form.description = '';
                }

                api.invoice.put(form,
                    // success
                    function(response) {
                        //show modal with info success and actions for selected
                        dialogService.customDialog(null, 'InvoicesSuccessSaveDialogController', 'app/main/invoices/success_save/success_save.html',
                            {invoice:response.data, type:null, page: 'edit'},
                            undefined, function () {$location.path('/invoices/list');})
                    },
                    // error
                    function(response) {
                        apiErrorsService.show('#invoiceProduct', response, vm, []);
                        vm.msg_error = transService.getErrorMassage(response);
                        vm.msg_success = '';
                        vm.request_sending = false;
                        formService.formUp();
                    }
                );

            });
        }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.invoices-form-correction', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.invoice-form-correction', {
                url    : '/invoices/form-correction/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/form-correction/form-correction.html',
                        controller : 'InvoicesFormCorrectionController as vm'
                    }
                },
                resolve  : {
                    CurrentCompany: function (apiResolver)
                    {
                        return apiResolver.resolve('currentCompany@get');
                    },
                    InvoiceCorrectionTypesList: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('invoiceCorrectionTypes@get', {invoice_id:$stateParams.id});
                    },
                    TaxesList: function (apiResolver)
                    {
                        return apiResolver.resolve('taxs@get');
                    },
                    UnitsList: function (apiResolver)
                    {
                        return apiResolver.resolve('units@get');
                    },
                    PaymentMethodsList: function (apiResolver)
                    {
                        return apiResolver.resolve('paymentsMethod.list@get', {invoice_restrict:1});
                    },
                    Invoice: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('invoice@get', {id:$stateParams.id});
                    },
                    InvoiceTypesList: function (apiResolver)
                    {
                        return apiResolver.resolve('invoiceTypes@get');
                    },
                }
            })
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.invoices-form-correction')
        .controller('InvoicesFormCorrectionController', InvoicesFormCorrectionController);

    /** @ngInject */
    function InvoicesFormCorrectionController(transService, api, dialogService, formService, apiErrorsService, $location, $scope, invoiceService, InvoiceCorrectionTypesList, TaxesList, UnitsList, PaymentMethodsList, Invoice, InvoiceTypesList, CurrentCompany)
    {
        var vm = this;
        transService.loadFile('main/invoices/form-correction');

        // Data
        vm.correction_types = {};
        vm.taxes_old = [];
        vm.payment_method_slug = '';

        vm.send = send;
        vm.addProductCorrection = addProductCorrection;
        vm.deleteProductCorrection = deleteProductCorrection;

        init();

        function init() {

            invoiceService.init(vm);
            vm.units = UnitsList.data;
            vm.payment_methods = PaymentMethodsList.data;
            vm.company = CurrentCompany.data;
            vm.correction_types = InvoiceCorrectionTypesList.data;

            formService.generateForm(vm.form, Invoice.data);
            vm.form.issue_date = vm.today;
            vm.form.sale_date = vm.today;
            vm.form.corrected_invoice_id = Invoice.data.id;

            //taxes
            angular.forEach(TaxesList.data, function (item) {
                vm.taxes[item.id] = item;
            });

            //margin procedures
            invoiceService.getMarginProcedures();

            //set vm.type based on default invoice type

            // NOT SURE ABOUT THIS CODE
            vm.type = 'correction';
            angular.forEach(InvoiceTypesList.data, function (item) {
                if (vm.form.invoice_type_id == item.id) {
                    if (item.slug == 'margin') {
                        vm.type = 'margin_correction';
                    } else if (item.slug == 'reverse_charge') {
                        vm.type = 'reverse_charge_correction';
                    } else if (item.slug == 'margin_proforma') {
                        vm.type = 'margin_proforma_correction';
                    } else if (item.slug == 'currency') {
                        vm.type = 'currency_correction';
                    } else if (item.slug == 'currency_reverse_charge') {
                        vm.type = 'currency_reverse_charge_correction';
                    }
                }

            });

            //set vm.form.invoice_type_id based on vm.type
            angular.forEach(InvoiceTypesList.data, function (item) {
                if (item.slug == vm.type) {
                    vm.form.invoice_type_id = item.id;
                }
            });

            //set payment date
            invoiceService.setPaymentDate(vm.form.payment_term_days);

            // set bank account id
            invoiceService.setBankAccount(vm.company, Invoice.data.bank_account);

            //load items
            angular.forEach(vm.form.items, function (item, key) {

                vm.form.items[key].service_unit = vm.form.items[key].service_unit.data;

                delete vm.form.items[key].paid;
                delete vm.form.items[key].invoice;

                (function (key) {
                    api.product.get({id:item.company_service_id}, function (response_product) {
                        vm.form.items[key].new_obj = false;
                        vm.form.items[key].is_correction = false;
                        vm.form.items[key].current_service = response_product.data;

                        vm.form.items[key].custom_name_enable = vm.form.items[key].custom_name != null && vm.form.items[key].custom_name != '';
                        if (!vm.form.items[key].custom_name_enable) {
                            vm.form.items[key].custom_name = '';
                        }
                    })
                }(key));

            });

            //load contractor
            api.contractor.get({id:vm.form.contractor_id}, function (response) {
                vm.contractor = response.data;
            }, vm.responseError);

            /**
             * change issue_date
             */
            $scope.$watch(function () {return vm.form.issue_date;},function(value){
                if (value) {
                    if (['gotowka', 'karta', 'payu'].indexOf(vm.payment_method_slug) > -1) {
                        vm.payment_date = vm.form.issue_date;
                    }
                }
            });

            /**
             * change payment_method_id
             */
            $scope.$watch(function () {return vm.form.payment_method_id;},function(value){
                angular.forEach(vm.payment_methods, function (item) {
                    if (item.id == value) {
                        vm.payment_method_slug = item.slug;
                        if (item.slug == 'gotowka' || item.slug == 'karta' || item.slug == 'payu') {
                            vm.payment_date = vm.form.issue_date;
                            vm.disabled_payment_date = true;
                        } else {
                            vm.disabled_payment_date = false;
                        }
                    }
                })

            });

            /**
             * change gross_counted
             */
            $scope.$watch(function () {return vm.form.gross_counted;},calculateCorrection);

            /**
             * change products
             */
            $scope.$watchCollection(function () {return vm.form.items;},calculateCorrection);
        }

        /**
         * Create new invoice
         */
        function send() {

            //confirm action
            dialogService.confirm(null, 'INVOICES_FORM_CORRECTION.ADD_QUESTION', function() {

                $location.hash('');
                vm.request_sending = true;
                apiErrorsService.clear('#invoiceProduct', vm);

                //clear unnecessary elements
                var form = angular.copy(vm.form);

                var quantity_error = false;

                for(var i = form.items.length - 1; i >= 0; --i) {
                    if (!form.items[i].new_obj) {
                        //delete items from based invoice
                        form.items.splice(i, 1);
                    } else {
                        delete form.items[i].current_service;
                        delete form.items[i].search_text;
                        delete form.items[i].watch;
                        delete form.items[i].new_obj;
                        delete form.items[i].is_correction;

                        if (!form.items[i].quantity) {
                            quantity_error = true;
                            break;
                        }
                    }
                }

                //if any quantity is 0
                if (quantity_error) {
                    vm.msg_error = transService.translate('INVOICES_FORM_CORRECTION.QUANTITY_ERROR');
                    vm.msg_success = '';
                    formService.formUp();
                } else {

                    form.contractor_id = vm.contractor.id;//set contractor id
                    form.payment_term_days = moment(vm.payment_date).diff(vm.form.issue_date, 'days'); //calculate payment_term_days

                    if (!vm.show_description) {
                        form.description = '';
                    }

                    api.invoices.save(form,
                        // success
                        function (response) {
                            //show modal with info success and actions for selected
                            dialogService.customDialog(null, 'InvoicesSuccessSaveDialogController', 'app/main/invoices/success_save/success_save.html',
                                {invoice:response.data, type:null, page: 'new-correction'},
                                undefined, function () {$location.path('/invoices/list');});
                        },
                        // error
                        function (response) {
                            apiErrorsService.show('#invoiceProduct', response, vm, []);
                            vm.msg_error = transService.getErrorMassage(response);
                            vm.msg_success = '';
                            vm.request_sending = false;
                            formService.formUp();
                        }
                    );
                }

            });
        }

        /**
         * Add product for correction
         *
         * @param index
         * @returns {number}
         */
        function addProductCorrection(index) {

            //set default values
            ++index;
            vm.form.items.splice(index, 0, invoiceService.getNewObjItem());
            vm.form.items[index].current_service = vm.form.items[index - 1].current_service;
            vm.form.items[index].company_service_id = vm.form.items[index - 1].company_service_id;
            vm.form.items[index].custom_name = vm.form.items[index - 1].custom_name;
            vm.form.items[index].custom_name_enable = vm.form.items[index - 1].custom_name_enable;
            vm.form.items[index].vat_rate_id = vm.form.items[index - 1].vat_rate_id;
            vm.form.items[index].quantity = (vm.form.correction_type == 'quantity' ? -1 : 1) * vm.form.items[index - 1].quantity;
            vm.form.items[index].price_net = vm.form.items[index - 1].price_net;
            vm.form.items[index].price_net_old = vm.form.items[index - 1].price_net;
            vm.form.items[index].price_gross = vm.form.items[index - 1].price_gross;
            vm.form.items[index].price_gross_old = vm.form.items[index - 1].price_gross;
            vm.form.items[index].service_unit_id = vm.form.items[index - 1].service_unit_id;
            vm.form.items[index].service_unit = vm.form.items[index - 1].service_unit;
            vm.form.items[index].position_corrected_id = vm.form.items[index - 1].id;
            vm.form.items[index].new_obj = true;
            vm.form.items[index].is_correction = false;
            vm.form.items[index - 1].is_correction = true;


            /**
             * Run when product was changed
             */
            vm.form.items[index].watch = $scope.$watchCollection(function () {return vm.form.items[index];},function(new_obj, old_obj){

                if (typeof new_obj == 'undefined')
                    return;

                //find changed key
                var changed_key = null;
                angular.forEach(new_obj, function (value, key) {
                    if (value != old_obj[key] && !changed_key) {
                        //permitted keys
                        if (['price_net', 'price_gross', 'vat_rate_id', 'quantity'].indexOf(key) > -1) {
                            changed_key = key;
                        }
                    }
                });

                //set price_gross_sum, price_gross_sum, price_net, price_gross, vat_sum
                if (new_obj.current_service && typeof new_obj.quantity != 'undefined' && new_obj.vat_rate_id) {

                    var vat = vm.taxes[new_obj.vat_rate_id].rate;
                    //run only for selected variables
                    if (vm.form.gross_counted) {
                        var price_gross = vm.form.correction_type == 'price' ? new_obj.price_gross - new_obj.price_gross_old : new_obj.price_gross;

                        new_obj.price_gross_sum = vm.round(price_gross * new_obj.quantity);
                        new_obj.price_net = vat ? vm.round(price_gross / (1 + (vat / 100) )) : new_obj.price_gross;
                        new_obj.price_net_sum = vm.round(new_obj.price_gross_sum / (1 + (vat / 100) ));
                    } else {
                        var price_net = vm.form.correction_type == 'price' ? new_obj.price_net - new_obj.price_net_old : new_obj.price_net;

                        new_obj.price_net_sum = vm.round(price_net * new_obj.quantity);
                        new_obj.price_gross = vat ? vm.round(price_net * (1 + (vat / 100) )) : new_obj.price_net;
                        new_obj.price_gross_sum = vm.round(new_obj.price_net_sum * (1 + (vat / 100) ));
                    }

                    new_obj.vat_sum = vm.round(new_obj.price_gross_sum  - new_obj.price_net_sum );

                    calculateCorrection();
                }
            });

            return vm.form.items.length - 1;
        }

        /**
         * delete correction
         *
         * @param index
         */
        function deleteProductCorrection(index) {

            if (vm.form.items[index].new_obj) {
                vm.form.items[index - 1].is_correction = false;
            }

            vm.deleteProduct(index);
        }

        /**
         * Calculate global taxes, price_gross, price_net
         */
        function calculateCorrection() {

            //calculate all types taxes and price_gross/price_net in this types
            vm.form.taxes = [];

            angular.forEach(vm.form.items, function (item) {

                if (item.new_obj) {

                    //add value to tax
                    var found = false;
                    angular.forEach(vm.form.taxes, function (value, key) {
                        if (item.vat_rate_id != null && item.vat_rate_id == value.vat_rate_id) {
                            if (vm.form.gross_counted) {
                                value.price_gross += item.price_gross_sum;
                            } else {
                                value.price_net += item.price_net_sum;
                            }

                            found = true;
                        }
                    });

                    //new tax
                    if (!found && item.vat_rate_id != null) {

                        var new_tax = invoiceService.getNewObjTax();
                        new_tax.vat_rate_id = item.vat_rate_id;
                        if (vm.form.gross_counted) {
                            new_tax.price_gross = item.price_gross_sum;
                        } else {
                            new_tax.price_net = item.price_net_sum;
                        }

                        vm.form.taxes.push(new_tax);
                    }
                }
            });


            //tax correction
            if (vm.form.correction_type == 'tax') {

                //calculate all types taxes and price_gross/price_net in this types before changed taxes
                vm.taxes_old = [];

                angular.forEach(vm.form.items, function (item) {

                    if (!item.new_obj && item.is_correction) {

                        //add value to tax
                        var found = false;
                        angular.forEach(vm.taxes_old, function (value, key) {
                            if (item.vat_rate_id != null && item.vat_rate_id == value.vat_rate_id) {
                                value.price_gross += item.price_gross_sum;
                                value.price_net += item.price_net_sum;

                                found = true;
                            }
                        });

                        //new tax
                        if (!found && item.vat_rate_id != null) {

                            var new_tax = invoiceService.getNewObjTax();
                            new_tax.vat_rate_id = item.vat_rate_id;
                            new_tax.price_gross = item.price_gross_sum;
                            new_tax.price_net = item.price_net_sum;

                            vm.taxes_old.push(new_tax);
                        }
                    }
                });


                //sum after edited
                angular.forEach(vm.taxes_old, function (tax) {
                    var found = false;
                    for (var i = 0; i < vm.form.taxes.length; ++i) {
                        if (vm.form.taxes[i].vat_rate_id == tax.vat_rate_id) {
                            vm.form.taxes[i].price_gross -= tax.price_gross;
                            vm.form.taxes[i].price_net -= tax.price_net;
                            found = true;
                            break;
                        }
                    }

                    if (!found) {
                        var new_tax = invoiceService.getNewObjTax();
                        new_tax.vat_rate_id = tax.vat_rate_id;
                        new_tax.price_gross = -1 * tax.price_gross;
                        new_tax.price_net = -1 * tax.price_net;
                        vm.form.taxes.push(new_tax);
                    }
                });
            }

            //global sum price_net, price_gross, vat_sum
            vm.form.price_net = 0;
            vm.form.price_gross = 0;
            vm.form.vat_sum = 0;
            if (vm.form.gross_counted) {
                angular.forEach(vm.form.taxes, function (value) {
                    value.price_net = vm.round(value.price_gross / (1 + (vm.taxes[value.vat_rate_id].rate / 100) ));
                    vm.form.price_net += value.price_net;
                    vm.form.price_gross += value.price_gross;
                    vm.form.vat_sum += vm.round((value.price_gross - value.price_net));
                });
            } else {
                angular.forEach(vm.form.taxes, function (value) {
                    value.price_gross = vm.round(value.price_net * (1 + (vm.taxes[value.vat_rate_id].rate / 100) ));
                    vm.form.price_net += value.price_net;
                    vm.form.price_gross += value.price_gross;
                    vm.form.vat_sum += vm.round((value.price_gross - value.price_net));
                });
            }
        }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.invoices-form', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.invoice-form-new', {
                url    : '/invoices/form/new',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/form/form.html',
                        controller : 'InvoicesFormController as vm'
                    }
                },
                resolve: {
                    CurrentCompany: function (apiResolver)
                    {
                        return apiResolver.resolve('currentCompany@get');
                    },
                    TaxesList: function (apiResolver)
                    {
                        return apiResolver.resolve('taxs@get');
                    },
                    UnitsList: function (apiResolver)
                    {
                        return apiResolver.resolve('units@get');
                    },
                    PaymentMethodsList: function (apiResolver)
                    {
                        return apiResolver.resolve('paymentsMethod.list@get', {invoice_restrict:1});
                    },
                    InvoiceTypesList: function (apiResolver)
                    {
                        return apiResolver.resolve('invoiceTypes@get');
                    },
                    ProductsListShortList: function (apiResolver)
                    {
                        return apiResolver.resolve('products@get', {limit: 3, sort:'-is_used'});
                    }
                }
            })
            .state('app.invoices-form-new-receipts', {
                url    : '/invoices/form/new/receipts?ids',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/form/form.html',
                        controller : 'InvoicesFormController as vm'
                    }
                },
                resolve: {
                    CurrentCompany: function (apiResolver)
                    {
                        return apiResolver.resolve('currentCompany@get');
                    },
                    TaxesList: function (apiResolver)
                    {
                        return apiResolver.resolve('taxs@get');
                    },
                    UnitsList: function (apiResolver)
                    {
                        return apiResolver.resolve('units@get');
                    },
                    PaymentMethodsList: function (apiResolver)
                    {
                        return apiResolver.resolve('paymentsMethod.list@get', {invoice_restrict:1});
                    },
                    InvoiceTypesList: function (apiResolver)
                    {
                        return apiResolver.resolve('invoiceTypes@get');
                    },
                    ProductsListShortList: function (apiResolver)
                    {
                        return apiResolver.resolve('products@get', {limit: 3, sort:'-is_used'});
                    }
                }
            })
            .state('app.invoices-form-new-receipt', {
                url    : '/invoices/form/new/receipt/:receipt_id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/form/form.html',
                        controller : 'InvoicesFormController as vm'
                    }
                },
                resolve: {
                    CurrentCompany: function (apiResolver)
                    {
                        return apiResolver.resolve('currentCompany@get');
                    },
                    TaxesList: function (apiResolver)
                    {
                        return apiResolver.resolve('taxs@get');
                    },
                    UnitsList: function (apiResolver)
                    {
                        return apiResolver.resolve('units@get');
                    },
                    PaymentMethodsList: function (apiResolver)
                    {
                        return apiResolver.resolve('paymentsMethod.list@get', {invoice_restrict:1});
                    },
                    InvoiceTypesList: function (apiResolver)
                    {
                        return apiResolver.resolve('invoiceTypes@get');
                    },
                    ProductsListShortList: function (apiResolver)
                    {
                        return apiResolver.resolve('products@get', {limit: 3, sort:'-is_used'});
                    }
                }
            })
            .state('app.invoices-form-new-online-sales', {
                url    : '/invoices/form/new/online-sales/:online_sales_id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/form/form.html',
                        controller : 'InvoicesFormController as vm'
                    }
                },
                resolve: {
                    CurrentCompany: function (apiResolver)
                    {
                        return apiResolver.resolve('currentCompany@get');
                    },
                    TaxesList: function (apiResolver)
                    {
                        return apiResolver.resolve('taxs@get');
                    },
                    UnitsList: function (apiResolver)
                    {
                        return apiResolver.resolve('units@get');
                    },
                    PaymentMethodsList: function (apiResolver)
                    {
                        return apiResolver.resolve('paymentsMethod.list@get', {invoice_restrict:1});
                    },
                    InvoiceTypesList: function (apiResolver)
                    {
                        return apiResolver.resolve('invoiceTypes@get');
                    },
                    ProductsListShortList: function (apiResolver)
                    {
                        return apiResolver.resolve('products@get', {limit: 3, sort:'-is_used'});
                    }
                }
            })
            .state('app.invoices-form-new-type', {
                url    : '/invoices/form/new/type/:type',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/form/form.html',
                        controller : 'InvoicesFormController as vm'
                    }
                },
                resolve: {
                    CurrentCompany: function (apiResolver)
                    {
                        return apiResolver.resolve('currentCompany@get');
                    },
                    TaxesList: function (apiResolver)
                    {
                        return apiResolver.resolve('taxs@get');
                    },
                    UnitsList: function (apiResolver)
                    {
                        return apiResolver.resolve('units@get');
                    },
                    PaymentMethodsList: function (apiResolver)
                    {
                        return apiResolver.resolve('paymentsMethod.list@get', {invoice_restrict:1});
                    },
                    InvoiceTypesList: function (apiResolver)
                    {
                        return apiResolver.resolve('invoiceTypes@get');
                    },
                    ProductsListShortList: function (apiResolver)
                    {
                        return apiResolver.resolve('products@get', {limit: 3, sort:'-is_used'});
                    }
                }
            })
            .state('app.invoices-form-new-invoice', {
                url    : '/invoices/form/new/invoice/:invoice_id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/form/form.html',
                        controller : 'InvoicesFormController as vm'
                    }
                },
                resolve: {
                    CurrentCompany: function (apiResolver)
                    {
                        return apiResolver.resolve('currentCompany@get');
                    },
                    TaxesList: function (apiResolver)
                    {
                        return apiResolver.resolve('taxs@get');
                    },
                    UnitsList: function (apiResolver)
                    {
                        return apiResolver.resolve('units@get');
                    },
                    PaymentMethodsList: function (apiResolver)
                    {
                        return apiResolver.resolve('paymentsMethod.list@get', {invoice_restrict:1});
                    },
                    InvoiceTypesList: function (apiResolver)
                    {
                        return apiResolver.resolve('invoiceTypes@get');
                    },
                    ProductsListShortList: function (apiResolver)
                    {
                        return apiResolver.resolve('products@get', {limit: 3, sort:'-is_used'});
                    }
                }
            })
            .state('app.invoices-form-new-contractor', {
                url    : '/invoices/form/new/:contractor_id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/form/form.html',
                        controller : 'InvoicesFormController as vm'
                    }
                },
                resolve: {
                    CurrentCompany: function (apiResolver)
                    {
                        return apiResolver.resolve('currentCompany@get');
                    },
                    TaxesList: function (apiResolver)
                    {
                        return apiResolver.resolve('taxs@get');
                    },
                    UnitsList: function (apiResolver)
                    {
                        return apiResolver.resolve('units@get');
                    },
                    PaymentMethodsList: function (apiResolver)
                    {
                        return apiResolver.resolve('paymentsMethod.list@get', {invoice_restrict:1});
                    },
                    InvoiceTypesList: function (apiResolver)
                    {
                        return apiResolver.resolve('invoiceTypes@get');
                    },
                    ProductsListShortList: function (apiResolver)
                    {
                        return apiResolver.resolve('products@get', {limit: 3, sort:'-is_used'});
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.invoices-form')
        .controller('InvoicesFormController', InvoicesFormController);

    /** @ngInject */
    function InvoicesFormController(transService, api, $stateParams, dialogService, formService, apiErrorsService,
                                    $location, $scope, $auth, $timeout, invoiceService, CurrentCompany, TaxesList,
                                    UnitsList, PaymentMethodsList, InvoiceTypesList, ProductsListShortList)
    {
        var vm = this;
        transService.loadFile('main/invoices/form');

        // Data
        vm.for_contractor = false;
        vm.alert_profile_is_showing = false;
        vm.copy_invoice = false;
        vm.loading_gus = false;
        vm.products_short_list = ProductsListShortList.data;

        vm.checkClientData = checkClientData;
        vm.updateClientData = updateClientData;
        vm.send = send;

        init();

        function init() {

            invoiceService.init(vm, $scope);

            vm.units = UnitsList.data;
            vm.payment_methods = PaymentMethodsList.data;
            vm.company = CurrentCompany.data;

            //invoice_type_id
            vm.type = typeof $stateParams.type != 'undefined' ? $stateParams.type : 'vat';

            //settings
            $auth.getSettings(function (settings) {
                vm.custom_name_products_enable = settings['invoices.services.name.allow_customization'] == "1";
                vm.addresses_delivery_enabled = settings['invoices.addresses.delivery.enabled'] == "1";
            });

            // gtu items
            invoiceService.getGtuItems();

            //margin procedures
            if (vm.type == 'margin' || vm.type == 'margin_proforma' || vm.type == 'margin_correction') {
                invoiceService.getMarginProcedures();
            }
            //reverse charges
            if (vm.type == 'reverse_charge' || vm.type == 'currency_reverse_charge' ) {
                invoiceService.getReverseChanges();
            }
            //currency
            if (vm.type == 'currency' || vm.type == 'currency_reverse_charge') {
                invoiceService.getCurrencies();
            }

            //taxes
            angular.forEach(TaxesList.data, function (item) {
                vm.taxes[item.id] = item;

                if (item.name == 'np.') {
                    vm.tax_type_np_id = item.id;
                }
            });

            if (typeof $stateParams.invoice_id == 'undefined') {
                vm.addProduct();
            }

            // set values from selected invoice type
            angular.forEach(InvoiceTypesList.data, function (item) {
                if (item.slug == vm.type) {
                    vm.form.invoice_type_id = item.id;
                    vm.title = item.no_vat_description;
                }
            })

            //registry
            invoiceService.getInvoiceSettingAndFormats(function () {
                if (!vm.registries.length) {
                    profileAlert();
                }

                //set default registry
                angular.forEach(vm.registries, function (value) {
                    if (value.default) {
                        vm.form.invoice_registry_id = value.id;
                    }
                });
                if (!vm.form.invoice_registry_id && vm.registries.length) {
                    vm.form.invoice_registry_id = vm.registries[0].id;
                }
            });

            //payment_method_id
            if (!vm.company.default_payment_method_id || vm.company.vatin == '') {
                profileAlert()
            }
            vm.form.payment_method_id = vm.company.default_payment_method_id;

            //bank account
            invoiceService.setBankAccount(vm.company);

            //gross_counted
            vm.form.gross_counted =
                (vm.type == 'margin' || vm.type == 'reverse_charge' || vm.type == 'currency_reverse_charge' || vm.type == 'margin_proforma' ) ? 1 :
                vm.company.default_invoice_gross_counted;

            //get contractor
            if (typeof $stateParams.contractor_id != 'undefined') {

                vm.for_contractor = true;

                api.contractor.get({id:$stateParams.contractor_id}, function (response) {
                    vm.contractor = response.data;
                }, vm.responseError)
            }

            //load from invoice
            if (typeof $stateParams.invoice_id != 'undefined') {
                loadFromInvoice($stateParams.invoice_id);
            }

            //load from receipts
            if (typeof $stateParams.ids != 'undefined') {
                vm.is_extra_item = true;
                vm.form.gross_counted = 1;
                vm.form.extra_item_id = Array.isArray($stateParams.ids) ? $stateParams.ids : [$stateParams.ids];
                vm.form.extra_item_type = 'receipts';
                vm.form.items = [];

                angular.forEach(vm.payment_methods, function (method) {
                    if (method.slug == 'inne') {
                        vm.form.payment_method_id = method.id;
                    }
                });

                //load receipts and set values
                angular.forEach(vm.form.extra_item_id, function (id) {
                    api.receipt.get({id: id}, function (response) {

                        vm.form.sale_date = response.data.sale_date.split(' ')[0];
                        vm.payment_date = vm.form.sale_date;

                        angular.forEach(response.data.items.data, function (item, key) {

                            (function (item, id) {
                                //load product
                                api.product.get({id:item.company_service_id}, function (response_product) {

                                    vm.form.items.push(invoiceService.getNewObjItem());

                                    var index = vm.form.items.length - 1;
                                    formService.generateForm(vm.form.items[index], item);

                                    vm.form.items[index].current_service = response_product.data;
                                    vm.form.items[index].base_document_id = id;

                                    invoiceService.calculate();
                                })
                            }(item, id));

                        });

                    }, vm.responseError);
                });
            }

            //from receipt
            if (typeof $stateParams.receipt_id != 'undefined') {
                loadExtraItem('receipts', api.receipt, $stateParams.receipt_id);
            }

            //from online_sales
            if (typeof $stateParams.online_sales_id != 'undefined') {
                loadExtraItem('online_sales', api.onlineSale, $stateParams.online_sales_id);
            }

            /**
             * change contractor
             */
            $scope.$watch(function () {return vm.contractor;},function(value){
                if (!vm.is_extra_item && value) {

                    //payment_method_id
                    if (vm.contractor.default_payment_method_id && !vm.special_payment) {
                        vm.form.payment_method_id = vm.contractor.default_payment_method_id;
                    }

                    invoiceService.setPaymentDateFull();
                }

                //set contractor and address delivery
                if (vm.addresses_delivery_enabled && value) {
                    vm.delivery_contractor = angular.copy(value);
                    if (!vm.form.default_delivery) {
                        vm.changeContractorDelivery();
                    }
                }
            });

            /**
             * change issue_date
             */
            $scope.$watch(function () {return vm.form.issue_date;},function(value){
                if (!vm.is_extra_item && value) {
                    invoiceService.setPaymentDateFull();
                }
            });

            /**
             * change payment_method_id
             */
            $scope.$watch(function () {return vm.form.payment_method_id;},function(value){
                angular.forEach(vm.payment_methods, function (item) {
                    if (item.id == value) {
                        vm.current_method = item;
                        vm.disabled_payment_date = (item.slug == 'gotowka' || item.slug == 'karta' || item.slug == 'payu');
                        invoiceService.setPaymentDateFull();
                    }
                })

            });

            /**
             * change gross_counted
             */
            $scope.$watch(function () {return vm.form.gross_counted;},function(){
                if (!vm.is_extra_item) {
                    invoiceService.calculate();
                }
            });

            /**
             * change products
             */
            $scope.$watchCollection(function () {return vm.form.items;},invoiceService.calculate);
        }

        /**
         * Load other invoice to form
         * @param id
         */
        function loadFromInvoice(id) {

            //load invoice
            api.invoice.get({id:id}, function (response) {

                vm.copy_invoice = true;

                //load contractor
                api.contractor.get({id:response.data.contractor_id}, function (response_contractor) {

                    formService.generateForm(vm.form, response.data);

                    vm.contractor = response_contractor.data;
                    vm.form.sale_date = vm.today;
                    vm.form.issue_date = vm.today;
                    vm.form.default_delivery = vm.form.default_delivery == 1;


                    //set payment date in next tick
                    //todo check it is require
                    (function (payment_term_days) {
                        $timeout(function () {
                            invoiceService.setPaymentDate(payment_term_days);
                        });
                    })(vm.form.payment_term_days);


                    //get slug and title type
                    angular.forEach(InvoiceTypesList.data, function (item) {
                        if (item.id == vm.form.invoice_type_id) {
                            vm.type = item.slug;
                            vm.title = item.description;
                        }
                    });

                    //margin procedures
                    if (vm.type == 'margin' || vm.type == 'margin_proforma' || vm.type == 'margin_correction') {
                        invoiceService.getMarginProcedures();
                    }
                    //reverse charges
                    if (vm.type == 'reverse_charge' || vm.type == 'currency_reverse_charge') {
                        invoiceService.getReverseChanges();
                    }
                    //currency
                    if (vm.type == 'currency' || vm.type == 'currency_reverse_charge') {
                        invoiceService.getCurrencies();
                    }

                    //special payments
                    if (response.data.special_payments.data.length) {
                        vm.special_payment = true;
                        vm.form.special_payment = response.data.special_payments.data[0];
                    }

                    // Show/hide "description"
                    if (vm.form.description) {
                      vm.show_description = true;
                    }

                    //load items
                    angular.forEach(vm.form.items, function (item, key) {

                        (function (key) {
                            api.product.get({id:item.company_service_id}, function (response_product) {
                                vm.form.items[key].current_service = response_product.data;
                                vm.form.items[key].search_text = response_product.data.name;
                                vm.form.items[key].watch = vm.productWatch(key);

                                vm.form.items[key].custom_name_enable = vm.form.items[key].custom_name != null && vm.form.items[key].custom_name != '';
                                if (!vm.form.items[key].custom_name_enable) {
                                    vm.form.items[key].custom_name = '';
                                }
                            })
                        }(key));

                    });

                }, vm.responseError)

            }, vm.responseError)
        }

        /**
         * Load items from receipt or online sales for generate invoice
         *
         * @param name
         * @param endpoint
         * @param id
         */
        function loadExtraItem(name, endpoint, id) {
            vm.is_extra_item = true;
            vm.form.gross_counted = 1;
            vm.form.extra_item_id = [id];
            vm.form.extra_item_type = name;

            //load receipt or online sales and set values
            endpoint.get({id: id}, function (response) {

                formService.generateForm(vm.form, response.data);

                vm.form.sale_date = vm.form.sale_date.split(' ')[0];
                vm.payment_date = vm.form.sale_date;

                angular.forEach(vm.form.items, function (item, key) {

                    (function (key) {
                        //load product
                        api.product.get({id:item.company_service_id}, function (response_product) {
                            vm.form.items[key].current_service = response_product.data;
                            vm.form.items[key].custom_name = '';
                            vm.form.items[key].custom_name_enable = false;
                        })
                    }(key));

                });

            }, vm.responseError);
        }

        /**
         * Alert company setting is empty
         * @param e
         */
        function profileAlert(e) {
            if (!vm.alert_profile_is_showing) {
                vm.alert_profile_is_showing = true;
                dialogService.customDialog(e, 'ProfileAlertDialogController', 'app/main/invoices/form/profile-alert/profile-alert.html');
            }
        }


        /**
         * Check CLient data that is valid with current GUS data
         */
        function checkClientData() {
            vm.loading_gus = true;
            api.gusCompany.get({ vatin: vm.contractor.vatin }, function (response) {
                vm.loading_gus = false;
                if (response.data.length && response.data[0].name != '') {
                    vm.contractor.gus_data = {
                        name: response.data[0].name,
                        main_address_city: response.data[0].main_address_city,
                        main_address_zip_code: response.data[0].main_address_zip_code,
                        main_address_street: response.data[0].main_address_street,
                        main_address_number: response.data[0].main_address_number
                    }
                    if (
                        vm.contractor.name == vm.contractor.gus_data.name &&
                        vm.contractor.main_address_city == vm.contractor.gus_data.main_address_city &&
                        vm.contractor.main_address_zip_code == vm.contractor.gus_data.main_address_zip_code &&
                        vm.contractor.main_address_street == vm.contractor.gus_data.main_address_street &&
                        vm.contractor.main_address_number == vm.contractor.gus_data.main_address_number
                    ) {
                        vm.contractor.gus_ok = true;
                        vm.contractor.gus_diff = false;
                    } else {
                        vm.contractor.gus_ok = false;
                        vm.contractor.gus_diff = true;
                    }
                }
            }, function () {
                vm.loading_gus = false;
            });
        }

        function updateClientData(e) {
            dialogService.confirm(e, 'INVOICES_FORM.UPDATE_CONTRACTOR_DATA_QUESTION', function() {
                var data = Object.assign(vm.contractor, vm.contractor.gus_data);
                delete data.default_payment_term_days;
                delete data.default_payment_method_id;
                data.addresses = vm.contractor.addresses.data;
                api.contractor.put(data, function () {
                    Object.assign(vm.contractor, vm.contractor.gus_data);
                    vm.checkClientData();
                }, function (error) {
                    console.log(error);
                });
            });
        }

        /**
         * Create new invoice
         */
        function send() {

            //confirm action
            dialogService.confirm(null, 'INVOICES_FORM.ADD_QUESTION', function() {

                $location.hash('');
                vm.request_sending = true;
                apiErrorsService.clear('#invoiceProduct', vm);

                //clear unnecessary elements
                var form =  angular.copy(vm.form);

                angular.forEach(form.items, function (item) {
                    delete item.current_service;
                    delete item.search_text;
                    delete item.watch;
                });

                form.contractor_id = vm.contractor.id; //set contractor id
                form.payment_term_days = moment(vm.payment_date).diff(vm.form.issue_date, 'days'); //calculate payment_term_days

                if (!vm.show_description) {
                    form.description = '';
                }

                api.invoices.save(form,
                    // success
                    function(response) {
                        //show modal with info success and actions for selected
                        dialogService.customDialog(null, 'InvoicesSuccessSaveDialogController', 'app/main/invoices/success_save/success_save.html',
                            {invoice:response.data, type:vm.type, page: 'new'},
                            undefined, function () {$location.path('/invoices/list');});
                    },
                    // error
                    function(response) {
                        apiErrorsService.show('#invoiceProduct', response, vm, []);
                        vm.msg_error = transService.getErrorMassage(response);
                        vm.msg_success = '';
                        vm.request_sending = false;
                        formService.formUp();
                    }
                );

            });
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.invoices-list')
        .controller('InvoicesPaymentsAddDialogController', InvoicesPaymentsAddDialogController);

    /** @ngInject */
    function InvoicesPaymentsAddDialogController(transService, $mdDialog, api, apiErrorsService, id, amount, method)
    {
        var vm = this;

        vm.msg_success = '';
        vm.msg_error = '';
        vm.request_sending = false;
        vm.payment_methods = [];
        vm.max_payment = amount;

        vm.form = {
            invoice_id: id,
            amount: amount,
            payment_method_id: method
        };

        vm.hide = hide;
        vm.create = create;

        init();

        function init() {
            api.paymentsMethod.list.get({}, function (response) {
              vm.payment_methods = response.data;
            });
        }

        function hide() {
            $mdDialog.hide();
        }

        /**
         * Create user
         */
        function create() {

            vm.request_sending = true;
            apiErrorsService.clear('#addPyment', vm);

            api.invoicePayments.save(vm.form,
                // success
                function() {
                    $mdDialog.hide(true);
                },
                // error
                function(response) {
                    apiErrorsService.show('#addPyment', response, vm, []);
                    vm.request_sending = false;
                    vm.msg_error = transService.getErrorMassage(response);
                }
            );
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller(transService, $window)
    {
        var vm = this;
        vm.back = back;

        transService.loadFile('main/errors/500');

        function back() {
            $window.history.back();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller(transService, $window)
    {
        var vm = this;
        vm.back = back;

        transService.loadFile('main/errors/404');

        function back() {
            $window.history.back();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-403', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-403', {
            url      : '/error-403',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-403': {
                    templateUrl: 'app/main/errors/403/error-403.html',
                    controller : 'Error403Controller as vm'
                }
            },
            bodyClass: 'error-403'
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-403')
        .controller('Error403Controller', Error403Controller);

    /** @ngInject */
    function Error403Controller(transService, $window)
    {
        var vm = this;
        vm.back = back;

        transService.loadFile('main/errors/403');

        function back() {
            $window.history.back();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contractors-list', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.contractors-list', {
                url    : '/contractors/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/contractors/list/list.html',
                        controller : 'ContractorsListController as vm'
                    }
                },
                resolve  : {
                    ContractorsList: function (apiResolver)
                    {
                        return apiResolver.resolve('contractors@get', {limit:__env.table_limit_rows});
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contractors-list')
        .controller('ContractorsListController', ContractorsListController);

    /** @ngInject */
    function ContractorsListController(transService, api, tableService, dialogService, $location, $auth, ContractorsList)
    {
        var vm = this;
        transService.loadFile('main/contractors/list');

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.request_sending = false;
        vm.contractors = ContractorsList.data;
        vm.pagination = ContractorsList.meta.pagination;
        vm.is_tax_office = false;

        vm.getContractors = getContractors;
        vm.deleteContractor = deleteContractor;
        vm.edit = edit;
        vm.invoice_add = invoice_add;

        init();

        function init() {
            tableService.setVariables(vm);
            vm.query.search = '';
            vm.query.sort = 'id';

            $auth.getMyRole(function (role) {
                vm.is_tax_office = role == 'tax_office';
            })
        }

        /**
         * get contractors
         */
        function getContractors() {
            vm.promise = api.contractors.get(vm.query, function (response) {
                vm.contractors = response.data;
                vm.pagination = response.meta.pagination;
            }).$promise;
        }

        /**
         * delete contractor
         * @param id
         */
        function deleteContractor(id) {
            dialogService.confirm(null, 'CONTRACTORS_LIST.DELETE_QUESTION', function() {
                api.contractor.delete({id:id}, function () {
                    vm.msg_success = transService.translate('CONTRACTORS_LIST.DELETE_SUCCESS');
                    vm.msg_error = '';
                    getContractors();

                },function (response) {
                    vm.msg_error = transService.getErrorMassage(response);
                })
            });
        }

        function edit(id) {
            $location.path('/contractors/form/edit/' + id);
        }

        function invoice_add(id) {
            $location.path('/invoices/form/new/' + id);
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.contractors-form', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.contractors-form-new', {
                url    : '/contractors/form/:type?success',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/contractors/form/form.html',
                        controller : 'ContractorsFormController as vm'
                    }
                }
            })
            .state('app.contractors-form-edit', {
            url    : '/contractors/form/:type/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/contractors/form/form.html',
                    controller : 'ContractorsFormController as vm'
                }
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contractors-form')
        .controller('ContractorsFormController', ContractorsFormController);

    /** @ngInject */
    function ContractorsFormController(transService, api, $stateParams, formService, apiErrorsService, $location, $auth, $timeout, $state, $mdDialog, $scope, $window)
    {
        var vm = this;
        transService.loadFile('main/contractors/form');

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.request_sending = false;
        vm.edit = false;
        vm.methods = [];
        vm.days = '';
        vm.term = '';
        vm.addresses_delivery_enabled = false;
        vm.other_contact_address = false;
        vm.other_delivery_address = false;
        vm.show_full = false;
        vm.from_gus = false;
        vm.countries = [];
        vm.pl_id = 0;
        vm.copy_nip = false;

        vm.form = {
            id: null,
            name: '',
            vatin: '',
            country_vatin_prefix_id: null,
            email: '',
            phone: '',
            company: true,
            bank_account_number: '',
            bank_name: '',
            main_address_zip_code: '',
            main_address_city: '',
            main_address_street: '',
            main_address_number: '',
            main_address_country: 'POLSKA',
            contact_address_zip_code: '',
            contact_address_city: '',
            contact_address_street: '',
            contact_address_number: '',
            contact_address_country: 'POLSKA',
            default_payment_term_days: null,
            default_payment_method_id: null,
            addresses: [{
                id: null,
                type: 'delivery',
                street: '',
                number: '',
                zip_code: '',
                city: '',
                default: true,
                country: 'POLSKA'
            }]
        };

        vm.copyToContact = copyToContact;
        vm.addDeliveryAddress = addDeliveryAddress;
        vm.delDeliveryAddress = delDeliveryAddress;
        vm.copyMainToDeliver = copyMainToDeliver;
        vm.copyContactToDeliver = copyContactToDeliver;
        vm.changeDefaultDeliver = changeDefaultDeliver;
        vm.checkErrors = checkErrors;
        vm.getGus = getGus;
        vm.skip = skip;
        vm.send = send;

        init();

        function init() {

            if (typeof $stateParams.success != 'undefined') {
                vm.msg_success = transService.translate('CONTRACTORS_FORM.ADD_SUCCESS');
            }
            if (typeof $window.localStorage.nip_new_contractor != 'undefined') {
                vm.form.vatin = $window.localStorage.nip_new_contractor;
                delete $window.localStorage.nip_new_contractor;
                vm.copy_nip = true;
            }

            $auth.getSettings(function (settings) {
                vm.addresses_delivery_enabled = settings['invoices.addresses.delivery.enabled'] == "1";
            });

            //countries
            api.company.countries.get({}, function (response) {
                vm.countries = response.data;
                var pl_key = -1;
                angular.forEach(vm.countries, function (value, key) {
                    if (value.key == 'PL') {
                        vm.pl_id = value.id;
                        pl_key = key;

                        if ($stateParams.type != 'edit') {
                            vm.form.country_vatin_prefix_id = vm.pl_id;
                        }
                    }
                });
                if (pl_key > -1) {
                    var pl = vm.countries[pl_key];
                    vm.countries.splice(pl_key, 1);
                    vm.countries.unshift(pl);
                }
            });

            api.paymentsMethod.list.get({}, function (response) {
                vm.methods = response.data;
            });

            if ($stateParams.type == 'edit' && !isNaN(Number($stateParams.id)) ) {
                vm.edit = true;
                vm.show_full = true;
                vm.other_contact_address = true;
                vm.other_delivery_address = true;

                api.contractor.get({id:$stateParams.id}, function (response) {
                    formService.generateForm(vm.form, response.data, true);

                    //set default delivery address
                    var is_default = false;
                    angular.forEach(vm.form.addresses, function (value) {
                        value.default = value.default == 1;
                        if (value.default) {
                            is_default = true;
                        }
                    });

                    if (!is_default && vm.form.addresses.length) {
                        vm.form.addresses[0].default = true;
                    }

                    vm.form.company = vm.form.vatin != '';

                    vm.form.default_payment_term_days = vm.form.default_payment_term_days == 0 ? null : vm.form.default_payment_term_days;
                    if (vm.form.default_payment_term_days && [7, 14, 30, 90].indexOf(vm.form.default_payment_term_days) == -1) {
                        vm.days = vm.form.default_payment_term_days;
                        vm.term = 'd';
                    } else {
                        vm.term = vm.form.default_payment_term_days;
                    }

                    if (!vm.form.default_payment_method_id) {
                        vm.form.default_payment_method_id = null;
                    }
                })
            } else {
                $scope.$watch(function () {return vm.form.company;},function(value){
                    if (!vm.from_gus) {
                        if (value) {
                            vm.show_full = false;
                        } else {
                            vm.show_full = true;
                        }
                    }
                });
            }
        }

        function copyToContact() {
            vm.form.contact_address_street = vm.form.main_address_street;
            vm.form.contact_address_number = vm.form.main_address_number;
            vm.form.contact_address_city = vm.form.main_address_city;
            vm.form.contact_address_zip_code = vm.form.main_address_zip_code;
            vm.form.contact_address_country = vm.form.main_address_country;
        }

        function copyMainToDeliver() {
            vm.form.addresses[0].street = vm.form.main_address_street;
            vm.form.addresses[0].number = vm.form.main_address_number;
            vm.form.addresses[0].city = vm.form.main_address_city;
            vm.form.addresses[0].zip_code = vm.form.main_address_zip_code;
            vm.form.addresses[0].country = vm.form.main_address_country;
        }

        function copyContactToDeliver() {
            vm.form.addresses[0].street = vm.form.contact_address_street;
            vm.form.addresses[0].number = vm.form.contact_address_number;
            vm.form.addresses[0].city = vm.form.contact_address_city;
            vm.form.addresses[0].zip_code = vm.form.contact_address_zip_code;
            vm.form.addresses[0].country = vm.form.contact_address_country;
        }

        /**
         * add new delivery address
         */
        function addDeliveryAddress() {
            if (vm.form.addresses.length < 9) {
                vm.form.addresses.push({
                    type: 'delivery',
                    street: '',
                    number: '',
                    zip_code: '',
                    city: '',
                    default: false,
                    country: 'POLSKA'
                });
            }
        }

        /**
         * delete last inputs delivery address
         */
        function delDeliveryAddress() {
            if (vm.form.addresses.length > 1) {
                vm.form.addresses.pop();
            }
        }

        function changeDefaultDeliver(current_index) {
            if (vm.form.addresses[current_index].default != false) {
                angular.forEach(vm.form.addresses, function (sddress, index) {
                    if (index != current_index && vm.form.addresses[index].default != false) {
                        vm.form.addresses[index].default = false;
                    }
                })
            } else {
                vm.form.addresses[0].default = true;
            }
        }

        function checkErrors(name) {

            $timeout(function () {
                angular.forEach($scope.formContractor.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        if (name == errorField.$name) {
                            errorField.$setUntouched();
                            (function (errorField) {
                                $timeout(function () {
                                    errorField.$setTouched();
                                }, 100);
                            })(errorField);
                        }
                    })
                });
            });
        }
        
        function getGus() {

            vm.request_sending = true;
            vm.msg_error = '';
            vm.msg_success = '';

            var vatin = vm.form.vatin.toString().split('-').join('');

            api.gusCompany.get({vatin:vatin}, function (response) {
                if (response.data.length) {
                    vm.form.name = response.data[0].name;
                    vm.form.phone = response.data[0].phone;
                    vm.form.email = response.data[0].email;
                    vm.form.main_address_street = response.data[0].main_address_street;
                    vm.form.main_address_number = response.data[0].main_address_number;
                    vm.form.main_address_city = response.data[0].main_address_city;
                    vm.form.main_address_zip_code = response.data[0].main_address_zip_code;

                    if (response.data.length > 1) {
                        vm.other_delivery_address = true;
                        vm.form.addresses = [];
                        angular.forEach(response.data, function (address) {
                            vm.form.addresses.push({
                                type: 'delivery',
                                street: address.main_address_street,
                                number: address.main_address_number,
                                zip_code: address.main_address_zip_code,
                                city: address.main_address_city,
                                default: false,
                                country: 'POLSKA'
                            });
                        });
                        vm.form.addresses[0].default = true;
                    }
                    vm.show_full = true;
                    vm.from_gus = true;
                } else {
                    vm.msg_error = transService.translate('CONTRACTORS_FORM.GUS_ERROR');
                }
                vm.request_sending = false;
            }, function (response) {
                vm.msg_error = transService.getErrorMassage(response);
                vm.request_sending = false;
            });
        }

        function skip() {
            vm.show_full = true;
            vm.copy_nip = false;
        }

        function send(is_modal, create_invoice) {

            if (!vm.show_full) {
                getGus();
                return;
            }

            if (!is_modal) {
                $location.hash('');
            }

            vm.request_sending = true;
            apiErrorsService.clear('#formContractor', vm);

            //set term
            if (vm.term == 'd') {
                vm.form.default_payment_term_days = vm.days;
            } else {
                vm.form.default_payment_term_days = vm.term;
            }

            if (!vm.edit) {
                if (!vm.other_contact_address) {
                    copyToContact()
                }

                if (!vm.other_delivery_address) {
                    vm.form.addresses = [vm.form.addresses[0]];
                    copyMainToDeliver();
                }
            }

            var form = angular.copy(vm.form);
            if (form.default_payment_term_days === null) {
                delete form.default_payment_term_days;
            }
            if (form.default_payment_method_id === null) {
                delete form.default_payment_method_id;
            }

            if (vm.edit) {

                api.contractor.put(form,
                    // success
                    function(response) {
                        vm.msg_error = '';
                        vm.msg_success = transService.translate('CONTRACTORS_FORM.UPDATE_SUCCESS');
                        vm.request_sending = false;
                        if (is_modal) {
                            $mdDialog.hide();
                        } else {
                            if (create_invoice) {
                                $location.path('/invoices/form/new/' + response.data.id);
                            } else {
                                formService.formUp();
                                init();
                            }
                        }
                    },
                    // error
                    function(response) {
                        apiErrorsService.show('#formContractor', response, vm, {default_payment_term_days: 'term'});
                        vm.msg_error = transService.getErrorMassage(response);
                        vm.msg_success = '';
                        vm.request_sending = false;
                        if (!is_modal) {
                            formService.formUp();
                        }
                    }
                );
            } else {

                api.contractor.save(form,
                    // success
                    function(response) {
                        if (is_modal) {
                            api.contractor.get({id:response.data.id}, function (response_full) {
                                $mdDialog.hide(response_full.data);
                            });
                        } else {
                            //reload
                            if (create_invoice) {
                                $location.path('/invoices/form/new/' + response.data.id);
                            } else {
                                $location.url('/contractors/form/new?success=true');
                                $timeout(function () {
                                    $state.reload();
                                }, 500);
                            }
                        }
                    },
                    // error
                    function(response) {
                        apiErrorsService.show('#formContractor', response, vm, {default_payment_term_days: 'term'});
                        vm.msg_error = transService.getErrorMassage(response);
                        vm.msg_success = '';
                        vm.request_sending = false;
                        if (!is_modal) {
                            formService.formUp();
                        }
                    }
                );
            }
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.company-payment-back', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.company-payment-back', {
                url    : '/company/payment/back',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/company/payment-back/payment-back.html',
                        controller : 'CompanyPaymentBackController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.company-payment-back')
        .controller('CompanyPaymentBackController', CompanyPaymentBackController);

    /** @ngInject */
    function CompanyPaymentBackController(transService)
    {
        var vm = this;
        transService.loadFile('main/company/payment-back');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.company-new', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.company-new', {
                url    : '/company/new',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/company/new/new.html',
                        controller : 'CompanyNewController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.company-new')
        .controller('CompanyNewController', CompanyNewController);

    /** @ngInject */
    function CompanyNewController(transService, api, $location, $auth, $window, $timeout, paymentService)
    {
        var vm = this;
        transService.loadFile('main/company/new');

        vm.form = {
            name: '',
            vat_payer: true,
            vat_release_reason_id: null,
            vat_release_reason_note: ''
        };

        vm.form_full = {
            vatin: '',
            name: '',
            email: '',
            phone: '',
            bank_account_number: '',
            bank_name: '',
            main_address_zip_code: '',
            main_address_city: '',
            main_address_street: '',
            main_address_number: '',
            main_address_country: 'POLSKA',
            contact_address_zip_code: '',
            contact_address_city: '',
            contact_address_street: '',
            contact_address_number: '',
            contact_address_country: 'POLSKA'
        };

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.request_sending = false;
        vm.show_full = false;
        vm.vat_release_reasons = {};

        vm.create = create;
        vm.getGus = getGus;
        vm.skip = skip;

        init();

        function init() {
            api.vatReleaseReasons.get({}, function (response) {
                angular.forEach(response.data, function (value) {
                    vm.vat_release_reasons[value.id] = value;
                })
            })
        }

        function getGus() {
            vm.request_sending = true;
            vm.msg_error = '';
            var vatin = vm.form_full.vatin.toString().split('-').join('');
            api.gusCompany.get({vatin:vatin}, function (response) {
                if (response.data.length && response.data[0].name != '') {
                    vm.form.name = response.data[0].name;
                    vm.form_full.name = response.data[0].name;
                    vm.form_full.phone = response.data[0].phone;
                    vm.form_full.email = response.data[0].email;
                    vm.form_full.main_address_street = response.data[0].main_address_street;
                    vm.form_full.main_address_number = response.data[0].main_address_number;
                    vm.form_full.main_address_city = response.data[0].main_address_city;
                    vm.form_full.main_address_zip_code = response.data[0].main_address_zip_code;
                    vm.form_full.contact_address_street = response.data[0].main_address_street;
                    vm.form_full.contact_address_number = response.data[0].main_address_number;
                    vm.form_full.contact_address_city = response.data[0].main_address_city;
                    vm.form_full.contact_address_zip_code = response.data[0].main_address_zip_code;

                    create(true);
                    
                } else {
                    vm.msg_error = transService.translate('COMPANY_NEW.GUS_ERROR');
                    vm.request_sending = false;
                }
            }, function (response) {
                vm.msg_error = transService.getErrorMassage(response);
                vm.request_sending = false;
            });

        }

        function skip() {
            vm.show_full = true;
        }

        function endCreate(from_gus) {
            $auth.refreshUser(function () {

                if (from_gus) {
                    api.company.company.put(vm.form_full,
                        // success
                        function () {
                            vm.request_sending = false;
                            $location.url('/company/edit?first=true');
                        },
                        // error
                        function () {
                            $window.localStorage.company_data = JSON.stringify(vm.form_full);
                            vm.request_sending = false;
                            $location.url('/company/edit?first=true');
                        }
                    );
                }
                else {
                    vm.request_sending = false;
                    $location.url('/company/edit?first=true');
                }
            })
        }

        function create(from_gus) {
            vm.request_sending = true;

            api.company.company.save(vm.form,
                // success
                function(response) {
                    vm.msg_error = '';
                    //vm.msg_success = transService.translate('COMPANY_NEW.SUCCESS');
                    
                    $auth.setCurrentCompany(response.data.id, function () {

                        if (typeof $window.localStorage.package != 'undefined') {

                            var package_slug = null;
                            switch ($window.localStorage.package) {
                                case 'premium':
                                    package_slug = 'premium';
                                    break;
                                case 'classic':
                                    package_slug = 'cep_classic';
                                    break;
                                case 'business':
                                    package_slug = 'cep_business';
                                    break;
                            }

                            if (package_slug) {
                                paymentService.forceTest(package_slug, function (is_success) {
                                    delete $window.localStorage.package;
                                    if (is_success === true) {
                                        $timeout($auth.refreshCurrentPackage, 10000);
                                        endCreate(from_gus);
                                    } else {
                                        delete $window.localStorage.package;
                                        endCreate(from_gus);
                                    }
                                })
                            }
                        } else {
                            endCreate(from_gus);
                        }

                    });
                },
                // error
                function(response) {
                    vm.msg_error = transService.getErrorMassage(response);
                    vm.msg_success = '';
                    vm.request_sending = false;
                }
            );
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.my-list', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.my-list', {
                url    : '/company/my-list?open',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/company/my-list/my-list.html',
                        controller : 'MyListController as vm'
                    }
                }
            })
            .state('app.my-list-open', {
                url    : '/company/my-list/:open',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/company/my-list/my-list.html',
                        controller : 'MyListController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.my-list')
        .controller('MyListController', MyListController);

    /** @ngInject */
    function MyListController(transService, api, $auth, dialogService, $location, $stateParams)
    {
        var vm = this;
        transService.loadFile('main/company/my-list');

        // Data
        vm.companies = [];
        vm.invitations = [];
        vm.msg_error = '';
        vm.is_pending = false;
        vm.num_owners = 0;

        vm.selectCompany = selectCompany;
        vm.accept = accept;
        vm.reject = reject;

        init();

        // Methods
        function init() {
            $auth.refreshCompanies(function (companies) {
                vm.companies = companies;

                angular.forEach(vm.companies, function (value) {
                    if (value.role.data.name == 'owner') {
                        ++vm.num_owners;
                    }
                });

                api.company.myInvitations.get({active:1}, function (response) {
                    vm.invitations = response.data;

                    for (var i = 0; i < vm.invitations.length; ++i) {
                        if (vm.invitations[i].status == 0) {
                            vm.is_pending = true;
                            break;
                        }
                    }

                    if ($stateParams.open != 'open' && vm.companies.length == 1 && !vm.is_pending) {
                        $auth.redirectToDashboard();
                    } else if (vm.companies.length == 0 && vm.invitations.length == 0) {
                        $location.path('company/new');
                    }
                });

            });

        }
        
        function selectCompany(id, enabled) {
            if (enabled == '1') {
                $auth.setCurrentCompany(id, function () {
                    $auth.refreshUser(function (user) {
                        $auth.redirectToDashboard();
                    })
                });
            }
        }

        /**
         * accept invitation
         * @param token
         */
        function accept(token) {
            dialogService.confirm(null, 'COMPANY_MY_LIST.ACCEPT_QUESTION', function() {
                api.company.acceptInvitation.put({token:token}, function () {

                    vm.msg_error = '';
                    init();

                },function (response) {
                    vm.msg_error = transService.getErrorMassage(response);
                })
            });
        }

        /**
         * reject invitation
         * @param token
         */
        function reject(token) {
            dialogService.confirm(null, 'COMPANY_MY_LIST.REJECT_QUESTION', function() {
                api.company.rejectInvitation.put({token:token}, function () {

                    vm.msg_error = '';
                    init();

                },function (response) {
                    vm.msg_error = transService.getErrorMassage(response);
                })
            });
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('paymentService', paymentService);

    /** @ngInject */
    function paymentService(tableService, api, dialogService, transService, $location)
    {
        var vm = {};

        var service = {
            setVariables: setVariables,
            getPayments: getPayments,
            forceTest:forceTest,
        };

        return service;

        function setVariables(t_vm, role) {
            vm = t_vm;

            vm.tab11 = {
                msg_error: '',
                msg_success: '',
                currency: 'PLN',
                packages: {},
                packages_current: {},
                additional_modules: {},
                isFreeMod:isFreeMod,
                isActiveInOtherPackage:isActiveInOtherPackage,
                isInactiveInOtherPackage:isInactiveInOtherPackage,
                getMods:getMods,
                getModule:getModule,
                getCountMods:getCountMods,
                getPriceChangeModule:getPriceChangeModule,
                togglePackage:togglePackage,
                toggleModules:toggleModules,
                cancelSubscription:cancelSubscription,
                replaceModuleSlug:replaceModuleSlug,
                disableModule:disableModule,
                renewPackage:renewPackage,
                changePackage:changePackage,
                testPackage:testPackage,
                calculate:calculate,
                canTest:canTest,
                canChange:canChange,
                canRenew:canRenew,
                canTestModule:canTestModule,
                canChangeModule:canChangeModule,
                canRenewModule:canRenewModule,
                enableDaysRenewModule:enableDaysRenewModule,
                modHasError:modHasError,
                gePriceMod:gePriceMod,
                testModule:testModule,
                renewModule:renewModule,
                changeModule:changeModule,
            };


            vm.tab13 = {
                msg_error: '',
                msg_success: '',
                status: null,
                payments: [],
                pagination:null,
                cancel: cancel,
                again: again,
                getPayments: getPayments
            };

            tableService.setVariables(vm.tab13);

            getPayments();

            if (role == 'owner') {

                api.packagesCurrent.get({}, function (response) {
                    vm.tab11.packages_current = response.data;
                    vm.tab11.packages_current.selected_days = 30
                })

                api.packages.get({}, function (response) {
                    vm.tab11.packages = response.data;
                    angular.forEach(vm.tab11.packages, function (item) {
                        item.selected_days = 30;
                    });
                })
            }
        }

        function replaceModuleSlug(slug) {
            return slug.replace(/\./g, '-');
        }

        function isFreeMod(module) {
            var free = false;
            angular.forEach(module.mods.data, function (item) {
                if (module.selected_mod == item.id && ['0', '', 0].indexOf(item.value) != -1) {
                    free = true
                }
            });

            return free
        }

        function isActiveInOtherPackage(module) {
            var active = false;
            angular.forEach(module.mods.data, function (item) {
                if ((item.error == 'module_mod_currently_used' || item.error == 'module_mod_currently_used_can_extend') &&
                    ['0', '', 0].indexOf(item.value) == -1) {
                    active = true
                }
            });
            return active;
        }

        function isInactiveInOtherPackage(module) {

            if (isActiveInOtherPackage(module)) {
                return false;
            }

            var inactive = true;
            angular.forEach(module.mods.data, function (item) {
                if (item.error && item.error != 'module_mod_currently_used' && item.error != 'module_mod_currently_used_can_extend') {
                    inactive = false
                }
            });

            return inactive;
        }

        function getMods(module) {
            var mods = [];
            angular.forEach(vm.tab11.packages_current.modules_list, function (item) {
                if (item.slug == module.slug) {
                    mods = item.mods.data;
                }
            })
            return mods;
        }

        function getModule(module) {
            var selected_module = null;
            angular.forEach(vm.tab11.packages_current.modules_list, function (item) {
                if (item.slug == module.slug) {
                    selected_module = item;
                }
            })
            return selected_module;
        }

        function getCountMods(module) {
            var count = null;
            angular.forEach(module.mods.data, function (item) {
                if (!item.test) {
                    ++count
                }
            })
            return count;
        }

        function getPriceChangeModule(module, id) {
            var price = 0;
            if (module.hasOwnProperty('mods')) {
              var full_module = module;
            } else {
              var full_module = getModule(module);
            }

            angular.forEach(full_module.mods.data, function (mod) {
                if (mod.id == id) {
                    angular.forEach(mod.mod_prices.data, function (mod_price) {
                        if (mod_price.days == vm.tab11.packages_current.selected_days) {
                            price = mod_price.price_change;
                        }
                    });
                }
            });

            return price;
        }

        function togglePackage(selected_package, with_switch) {
            if (with_switch) {
                selected_package.togglePackage = !selected_package.togglePackage
            }

            if (selected_package.togglePackage) {
                api.package.get({id: selected_package.id}, function (response) {
                    selected_package.modules_list = response.data;

                    //selected mod default
                    angular.forEach(selected_package.modules_list, function (module) {
                        module.selected_mod = null;
                        //preliminary select
                        angular.forEach(module.mods.data, function (mod) {
                            if (!mod.test && !module.selected_mod) {
                                module.selected_mod = mod.id;
                            }
                        })
                        //select if is used
                        angular.forEach(module.mods.data, function (mod) {
                            if (!mod.test && (mod.error == 'module_mod_currently_used' || mod.error == 'module_mod_currently_used_can_extend')) {
                                module.selected_mod = mod.id;
                            }
                        })
                    })

                    calculate(selected_package);
                })
            }
        }

        function toggleModules(with_switch) {
            if (with_switch) {
                vm.tab11.additional_modules.toggled = !vm.tab11.additional_modules.toggled;
            }

            if (vm.tab11.additional_modules.toggled) {
                vm.tab11.additional_modules.current = null
                vm.tab11.additional_modules.available = null
                api.modulesCurrent.get({}, function (response) {
                    vm.tab11.additional_modules.current = response.data;
                    prepareModules();
                });
                api.modulesAvailable.get({}, function (response) {
                    vm.tab11.additional_modules.available = response.data;

                    angular.forEach(vm.tab11.additional_modules.available, function (module) {
                        module.selected_days = 30;
                        module.selected_mod = module.mods.data[0].id;
                        angular.forEach(module.mods.data, function (mod) {
                            if (mod.error == 'module_mod_currently_used' || mod.error == 'module_mod_currently_used_can_extend') {
                                module.selected_mod = mod.id;
                            }
                        })
                    });
                    prepareModules();
                });
            }
        }

        function prepareModules() {
            if (vm.tab11.additional_modules.current && vm.tab11.additional_modules.available) {
                angular.forEach(vm.tab11.additional_modules.current, function (current) {
                    angular.forEach(vm.tab11.additional_modules.available, function (available) {
                        if (current.module_id == available.id) {
                            current.module.data = available;
                            available.hide = true;
                        }
                    });
                })
            }
        }

        function cancelSubscription(id, selected_package) {
            dialogService.confirm(null, 'COMPANY_EDIT.PACKAGES.CANCEL_SUBSCRIPTION_QUESTION', function() {
                api.subscription.delete({subscription_id:id}, function () {
                    vm.tab11.msg_success = transService.translate('COMPANY_EDIT.PACKAGES.CANCEL_SUBSCRIPTION_SUCCESS');
                    vm.tab11.msg_error = '';
                    if (selected_package) {
                        togglePackage(selected_package, false)
                    } else {
                        toggleModules(false);
                    }
                },function (response) {
                    vm.tab11.msg_success = '';
                    vm.tab11.msg_error = transService.getErrorMassage(response);
                })
            });
        }

        function renewPackage(selected_package) {
            var params = {
                package_id: selected_package.id,
                days: selected_package.selected_days,
                is_test: 0,
                currency: vm.tab11.currency,
                mod_price: [],
            };

            angular.forEach(selected_package.modules_list, function (module) {
                var found = false;

                angular.forEach(module.mods.data, function (mod) {
                    if (module.selected_mod == mod.id) {
                        angular.forEach(mod.mod_prices.data, function (price) {
                            if (price.checksum && price.days == selected_package.selected_days) {
                                params.mod_price.push({
                                    id: price.id,
                                    checksum: price.checksum
                                })
                                found = true;
                            }
                        });
                    }
                });
            });

            postPackage(params);
        }


        function changePackage(selected_package) {
            var params = {
                package_id: selected_package.id,
                days: 0,
                is_test: false,
                currency: vm.tab11.currency,
                mod_price: [],
            };

            angular.forEach(selected_package.modules_list, function (module) {
                var found = false;

                angular.forEach(module.mods.data, function (mod) {
                    if (module.selected_mod == mod.id) {
                        angular.forEach(mod.mod_prices.data, function (price) {
                            if (price.checksum_change && price.days == selected_package.selected_days) {
                                params.mod_price.push({
                                    id: price.id,
                                    checksum: price.checksum_change
                                })
                                found = true;
                            }
                        });
                    }
                });
            });

            postPackage(params);
        }

        function testPackage(selected_package) {
            var params = {
                package_id: selected_package.id,
                days: 30,
                is_test: true,
                currency: 'PLN',
                mod_price: [],
            };

            angular.forEach(selected_package.modules_list, function (module) {
                var found = false;

                angular.forEach(module.mods.data, function (mod) {
                    if (!found && mod.test && mod.mod_prices.data.length && mod.mod_prices.data[0].checksum) {
                        params.mod_price.push({
                            id: mod.mod_prices.data[0].id,
                            checksum: mod.mod_prices.data[0].checksum
                        })
                        found = true;
                    }
                });
            });

            postPackage(params);
        }

        function calculate(selected_package) {
            selected_package.current_price = 0;
            angular.forEach(selected_package.modules_list, function (module) {
                angular.forEach(module.mods.data, function (mod) {
                    if (module.selected_mod == mod.id) {
                        angular.forEach(mod.mod_prices.data, function (price) {
                            if (selected_package.selected_days == price.days) {
                                selected_package.current_price += price.price;
                            }
                        });
                    }
                });
            });
        }

        function testModule(module) {
            var params = {
                days: 30,
                is_test: true,
                currency: vm.tab11.currency,
                mod_price_id: null,
                checksum: null,
            };

            var found = false;

            angular.forEach(module.mods.data, function (mod) {
                if (!found && mod.test && mod.mod_prices.data.length && mod.mod_prices.data[0].checksum) {
                    params.mod_price_id = mod.mod_prices.data[0].id
                    params.checksum = mod.mod_prices.data[0].checksum
                    found = true;
                }
            });

            postModule(params);
        }

        function renewModule(module) {
            var params = {
                days: module.selected_days,
                is_test: 0,
                currency: vm.tab11.currency,
                mod_price_id: null,
                checksum: null,
            };

            var found = false;

            angular.forEach(module.mods.data, function (mod) {
                if (module.selected_mod == mod.id) {
                    angular.forEach(mod.mod_prices.data, function (price) {
                        if (price.days == module.selected_days && price.checksum) {
                            params.mod_price_id = price.id;
                            params.checksum = price.checksum;
                            found = true;
                        }
                    })
                }
            });

            postModule(params);
        }

        function changeModule(module) {
            var params = {
                days: 0,
                is_test: 0,
                currency: vm.tab11.currency,
                mod_price_id: null,
                checksum: null,
            };

            var found = false;

            angular.forEach(module.mods.data, function (mod) {
                if (module.selected_mod == mod.id) {
                    angular.forEach(mod.mod_prices.data, function (price) {
                        if (price.checksum_change) {
                            params.mod_price_id = price.id;
                            params.checksum = price.checksum_change;
                            found = true;
                        }
                    })
                }
            });

            postModule(params);
        }

        function canTest(selected_package) {
            var can_test = true;
            angular.forEach(selected_package.modules_list, function (module) {
                var is_test = false;

                angular.forEach(module.mods.data, function (mod) {
                    if (mod.test && mod.mod_prices.data.length && mod.mod_prices.data[0].checksum) {
                        is_test = true;
                    }
                });

                if (!is_test) {
                    can_test = false;
                }
            });

            return can_test;
        }

        function canChange(selected_package) {
            var can_change = true;
            angular.forEach(selected_package.modules_list, function (module) {
                var is_checksum = false;

                angular.forEach(module.mods.data, function (mod) {
                    if (module.selected_mod == mod.id) {
                        angular.forEach(mod.mod_prices.data, function (price) {
                            if (price.checksum_change) {
                                is_checksum = true;
                            }
                        });
                    }
                });

                if (!is_checksum) {
                    can_change = false;
                }
            });

            return can_change;
        }

        function canRenew(selected_package, days) {
            var can_renew = true;
            angular.forEach(selected_package.modules_list, function (module) {
                var is_checksum = false;

                angular.forEach(module.mods.data, function (mod) {
                    if (module.selected_mod == mod.id) {
                        angular.forEach(mod.mod_prices.data, function (price) {
                            if (price.checksum && price.days == days) {
                                is_checksum = true;
                            }
                        });
                    }
                });

                if (!is_checksum) {
                    can_renew = false;
                }
            });

            return can_renew;
        }

        function canTestModule(module) {
            var is_test = false;

            angular.forEach(module.mods.data, function (mod) {
                if (mod.test && mod.mod_prices.data.length && mod.mod_prices.data[0].checksum) {
                    is_test = true;
                }
            });

            return is_test
        }

        function canChangeModule(module) {
            var is_checksum = false;

            if (module && module.mods) {
                angular.forEach(module.mods.data, function (mod) {
                    if (module.selected_mod == mod.id) {
                        angular.forEach(mod.mod_prices.data, function (price) {
                            if (price.checksum_change) {
                                is_checksum = true;
                            }
                        })
                    }
                });
            }
            return is_checksum
        }

        function canRenewModule(module) {
            var is_checksum = false;

            if (module.mods) {
                angular.forEach(module.mods.data, function (mod) {
                    if (module.selected_mod == mod.id) {
                        angular.forEach(mod.mod_prices.data, function (price) {
                            if (price.days == module.selected_days && price.checksum) {
                                is_checksum = true;
                            }
                        })
                    }
                });
            }
            return is_checksum
        }

        function enableDaysRenewModule(module, days) {
            var is_checksum = false;

            if (module.mods) {
                angular.forEach(module.mods.data, function (mod) {
                    if (module.selected_mod == mod.id) {
                        angular.forEach(mod.mod_prices.data, function (price) {
                            if (price.days == days && price.checksum) {
                                is_checksum = true;
                            }
                        })
                    }
                });
            }
            return is_checksum
        }

        function modHasError(module, error) {
            var has = false;

            if (module.mods) {
                angular.forEach(module.mods.data, function (mod) {
                    if (mod.error == error) {
                        has = true;
                    }
                });
            }
            return has
        }

        function gePriceMod(module, days) {
            var text = '';

            if (module.mods) {
                angular.forEach(module.mods.data, function (mod) {
                    if (module.selected_mod == mod.id) {
                        angular.forEach(mod.mod_prices.data, function (price) {
                            if (price.days == days && price.checksum) {
                                text = (price.price / 100).toFixed(2) + ' ' + price.currency;
                            }
                        })
                    }
                });
            }
            return text
        }

        function postPackage(params) {
            api.package.save(params, function (response) {
                if (response.data.payments.data.length) {
                    $location.url('/company/buy/' + response.data.payments.data[0].id);
                } else {
                    api.packages.get({}, function (res) {
                        vm.tab11.packages = res.data;
                        angular.forEach(vm.tab11.packages, function (item) {
                            item.selected_days = 30;
                        });
                    })
                    api.packagesCurrent.get({}, function (res) {
                        vm.tab11.packages_current = res.data;
                        vm.tab11.packages_current.selected_days = 30
                    })
                }
            },function (response) {
                vm.tab11.msg_success = '';
                vm.tab11.msg_error = transService.getErrorMassage(response);
            });
        }

        function postModule(params) {
            api.modules.save(params, function (response) {
                if (response.data.payments.data.length) {
                    $location.url('/company/buy/' + response.data.payments.data[0].id);
                } else {
                    api.modulesCurrent.get({}, function (response) {
                        vm.tab11.additional_modules.current = response.data;
                    });
                    api.modulesAvailable.get({}, function (response) {
                        vm.tab11.additional_modules.available = response.data;
                    });
                }
            },function (response) {
                vm.tab11.msg_success = '';
                vm.tab11.msg_error = transService.getErrorMassage(response);
            });
        }

        function disableModule(id) {
            dialogService.confirm(null, 'COMPANY_EDIT.PACKAGES.DISABLE_MODULE_QUESTION', function() {
                api.module.delete({id:id}, function () {
                    vm.tab11.msg_success = transService.translate('COMPANY_EDIT.PACKAGES.DISABLE_MODULE_SUCCESS');
                    vm.tab11.msg_error = '';
                    toggleModules(false);
                },function (response) {
                    vm.tab11.msg_success = '';
                    vm.tab11.msg_error = transService.getErrorMassage(response);
                })
            });
        }

        function getPayments() {
            api.payments.get({status:vm.tab13.status}, function (response) {
                vm.tab13.payments = response.data;
                vm.tab13.pagination = response.meta.pagination;
            })
        }

        function cancel(id) {
            dialogService.confirm(null, 'COMPANY_EDIT.PAYMENTS.CANCEL_QUESTION', function() {
                api.payment.delete({id:id},
                    // success
                    function(response) {
                        vm.tab13.msg_error = '';
                        vm.tab13.msg_success = transService.translate('COMPANY_EDIT.PAYMENTS.CANCEL_SUCCESS');
                        getPayments();
                    },
                    // error
                    function(response) {
                        vm.tab13.msg_error = transService.getErrorMassage(response);
                        vm.tab13.msg_success = '';
                    }
                );
            });
        }

        function again(transaction_id) {
            api.paymentAgain.save({transaction_id: transaction_id},
                // success
                function(response) {
                    $location.path('/company/buy/' . response.data.id);
                },
                // error
                function(response) {
                    vm.tab13.msg_error = transService.getErrorMassage(response);
                    vm.tab13.msg_success = '';
                }
            );
        }

        function forceTest(name, callback) {
            api.packages.get({}, function (response) {
                //search package_id
                var package_id = null;
                angular.forEach(response.data, function (item) {
                    if (item.slug == name) {
                        package_id = item.id;
                    }
                });

                if (!package_id) {
                    callback(false);
                    return;
                }

                api.package.get({id: package_id}, function (response) {
                    var params = {
                        package_id: package_id,
                        days: 30,
                        is_test: true,
                        currency: 'PLN',
                        mod_price: [],
                    };

                    angular.forEach(response.data, function (module) {
                        var found = false;

                        angular.forEach(module.mods.data, function (mod) {
                            if (!found && mod.test && mod.mod_prices.data.length && mod.mod_prices.data[0].checksum) {
                                params.mod_price.push({
                                    id: mod.mod_prices.data[0].id,
                                    checksum: mod.mod_prices.data[0].checksum
                                })
                                found = true;
                            }
                        });
                    });

                    api.package.save(params, function () {
                        callback(true)
                    }, function () {
                        callback(false);
                    });
                }, function () {
                    callback(false);
                });

            }, function () {
                callback(false);
            })
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.company-edit')
        .controller('CompanyEditController', CompanyEditController);

    /** @ngInject */
    function CompanyEditController(transService, api, $stateParams, formService, apiErrorsService, dialogService, tableService, paymentService,
                                   $auth, $location, $rootScope, $window, $scope, $timeout,
                                   CurrentCompany, Countries, InvoiceFormats, PaymentsMethod, VatReleaseReasons, TaxOffices, Roles)
    {
        var vm = this;
        transService.loadFile('main/company/edit');

        vm.msg_error = ''; //for apiErrorsService
        vm.user = {};
        vm.user_role = null;
        vm.tab_selected = 0;
        vm.is_profile_completed = false;

        vm.tab1 = {
            msg_error: '',
            msg_success: '',
            other_contact_address: false,
            edit: false,
            first: false,
            countries: Countries.data,
            pl_id: 0,
            scope_form: {},
            logotype: null,
            logotype_loaded: false,
            vat_settings_is_editable: false,
            vat_release_reasons: {},
            progress: 0,

            form: {
                vatin: '',
                vat_payer: true,
                bdo: '',
                vat_release_reason_id: null,
                vat_release_reason_note: '',
                country_vatin_prefix_id: null,
                name: '',
                email: '',
                phone: '',
                logotype: null,
                remove_logotype: false,
                website: '',
                main_address_zip_code: '',
                main_address_city: '',
                main_address_street: '',
                main_address_number: '',
                main_address_country: '',
                contact_address_zip_code: '',
                contact_address_city: '',
                contact_address_street: '',
                contact_address_number: '',
                contact_address_country: '',
                bank_accounts:  [
                    {
                        id: null,
                        bank_name: '',
                        number: '',
                        swift: null,
                        default: true
                    }
                ]
            }
        };

        vm.tab2 = {
            msg_error: '',
            msg_success: '',
            methods: PaymentsMethod.data,
            default: 0
        };

        vm.tab3 = {
            msg_error: '',
            msg_success: '',
            num_example: '',
            term_days: 7,
            term_custom: '',
            invoice_formats: [],
            invoice_formats_2: InvoiceFormats.data,
            invoice_registries: [],
            year_registry_id: 0,
            vat_settings_is_editable: true,
            form: {
                default_payment_term_days: '',
                default_invoice_gross_counted: 0,
                invoice_registries: [{
                    invoice_format_id: '',
                    name: 'Default',
                    prefix: '',
                    start_number: 1,
                    default: 1,
                    is_used: 0,
                }]
            }
        };

        vm.tab4 = {
            msg_error: '',
            msg_success: '',
            users: [],
            roles: [],
            pagination:null
        };

        vm.tab5 = {
            msg_error: '',
            msg_success: ''
        };

        vm.tab10 = {
            msg_error: '',
            msg_success: '',
            edit: false,
            tax_offices: TaxOffices.data,
            scope_form: {},

            form: {
                regon: '',
                state: '',
                county: '',
                community: '',
                street: '',
                building_number: '',
                flat_number: '',
                city: '',
                zip_code: '',
                postal: '',
                tax_office_id: null
            }
        };

        vm.request_sending = false;

        init();


        vm.checkErrors = checkErrors;
        vm.addLogo = addLogo;
        vm.sendTab1 = sendTab1;
        vm.sendTab3 = sendTab3;
        vm.sendTab10 = sendTab10;
        vm.changeNumbering = changeNumbering;
        vm.copyToContact = copyToContact;
        vm.setDefaultMethod = setDefaultMethod;
        vm.addRegister = addRegister;
        vm.delRegister = delRegister;
        vm.changeDefaultRegister = changeDefaultRegister;
        vm.getUsers = getUsers;
        vm.newUser = newUser;
        vm.deleteUser = deleteUser;
        vm.editUser = editUser;
        vm.getPayments = paymentService.getPayments;
        vm.addBankAccount = addBankAccount;
        vm.deleteBankAccount = deleteBankAccount;
        vm.changeDefaultBankAccount = changeDefaultBankAccount;

        function init() {

            //countries
            var pl_key = -1;
            angular.forEach(vm.tab1.countries, function (value, key) {
                if (value.key == 'PL') {
                    vm.tab1.pl_id = value.id;
                    pl_key = key;
                }
            })
            if (pl_key > -1) {
                var pl = vm.tab1.countries[pl_key];
                vm.tab1.countries.splice(pl_key, 1);
                vm.tab1.countries.unshift(pl);
            }

            //invoice format
            angular.forEach(vm.tab3.invoice_formats_2, function (value) {
                vm.tab3.invoice_formats[value.id] = value;

                if (value.format == '{%nr}/{%Y}') {
                    vm.tab3.year_registry_id = value.id;
                }
            });

            getInvoiceSettings();

            //current company
            formService.generateForm(vm.tab1.form, CurrentCompany.data, true);
            if (vm.tab1.form.main_address_country == '') {
                vm.tab1.form.main_address_country = 'POLSKA';
                vm.tab1.form.contact_address_country = 'POLSKA';
            }
            vm.tab1.vat_settings_is_editable = CurrentCompany.data.vat_settings_is_editable;
            vm.tab3.vat_settings_is_editable = CurrentCompany.data.vat_settings_is_editable;
            if (!vm.is_profile_completed) {
                vm.is_profile_completed = vm.tab1.form.email ? true : false;
            }

            //default payment method
            vm.tab2.default = CurrentCompany.data.default_payment_method_id;

            if (typeof $window.localStorage.company_data != 'undefined') {
                formService.generateForm(vm.tab1.form, JSON.parse($window.localStorage.company_data));
                delete $window.localStorage.company_data;
            }

            if (vm.tab1.form.vatin != '') {
                vm.tab1.other_contact_address = true;
                vm.tab1.edit = true
            } else {
                vm.tab1.other_contact_address = false;
                vm.tab1.edit = false
            }

            initLogotype(CurrentCompany.data);

            tableService.setVariables(vm.tab4);

            //roles
            for (var i in Roles.data) {
                vm.tab4.roles[Roles.data[i].id] = Roles.data[i];
            }
            getUsers();

            //open add user
            if (typeof $stateParams.user != 'undefined' ) {
                angular.forEach(Roles.data, function (value) {
                    if (value.name == $stateParams.user) {
                        vm.tab_selected = 3;
                        newUser(undefined, value.id);
                    }
                });
            }

            $auth.getUser(function (user) {
                vm.user = user;
            });

            $auth.getMyRole(function (role) {
                paymentService.setVariables(vm, role);
                vm.user_role = role;
            });

            //vatReleaseReasons
            angular.forEach(VatReleaseReasons.data, function (value) {
                vm.tab1.vat_release_reasons[value.id] = value;
            })

            api.company.jpk.get({}, function (response) {
                formService.generateForm(vm.tab10.form, response.data);
            });

            //add new package
            if (typeof $stateParams.package != 'undefined' ) {
                vm.tab_selected = 5;
            }

            if ($stateParams.first) {
                vm.tab1.first = true;
            }
        }

        function initLogotype(response) {
            if (response.logotype && response.logotype != ' ') {
                vm.tab1.logotype = __env.apiUrl + 'companies/get-logotype?selected_company_id=' + $auth.getCurrentCompany() + '&token=' + $window.localStorage.token;
                vm.tab1.logotype_loaded = true;
            } else {
                vm.tab1.logotype = '';
                vm.tab1.logotype_loaded = false;
            }
            vm.tab1.form.logotype = null;
        }

        function responseError() {
            vm.tab1.msg_error = transService.translate('ERRORS.RESPONSE');
            vm.tab2.msg_error = transService.translate('ERRORS.RESPONSE');
            vm.tab3.msg_error = transService.translate('ERRORS.RESPONSE');
            vm.tab4.msg_error = transService.translate('ERRORS.RESPONSE');
            vm.tab5.msg_error = transService.translate('ERRORS.RESPONSE');
        }

        function addLogo() {
            $timeout(function() {
                angular.element('#file-to-upload').trigger('click');
            }, 100);
        }

        function getInvoiceSettings() {
            api.invoiceSettings.get({}, function (response) {

                if (response.data.invoice_registries.data.length) {
                    vm.tab3.invoice_registries = response.data.invoice_registries.data;

                    //add default if not exist
                    var has_default = false;
                    angular.forEach(vm.tab3.invoice_registries, function (value) {
                        if (value.default) {
                            has_default = true;
                        }
                    });

                    if (!has_default) {
                        vm.tab3.invoice_registries[0].default = 1;
                    }

                } else {
                    vm.tab3.invoice_registries = [{
                        invoice_format_id: '',
                        name: 'Default',
                        prefix: '',
                        start_number: 1,
                        default: 1,
                        is_used: 0,
                    }]
                }

                vm.tab3.form.default_invoice_gross_counted = response.data.default_invoice_gross_counted;

                //default_payment_term_days
                vm.tab3.term_days = response.data.default_payment_term_days ? response.data.default_payment_term_days : 7;
                if ([7, 14, 30, 90].indexOf(vm.tab3.term_days) == -1) {
                    vm.tab3.term_custom = vm.tab3.term_days;
                    vm.tab3.term_days = 'd';
                }

                angular.forEach(vm.tab3.invoice_registries, function (value) {
                    value.default = value.default == 1;
                });

            }, responseError)
        }

        function copyToContact() {
            vm.tab1.form.contact_address_street = vm.tab1.form.main_address_street;
            vm.tab1.form.contact_address_number = vm.tab1.form.main_address_number;
            vm.tab1.form.contact_address_city = vm.tab1.form.main_address_city;
            vm.tab1.form.contact_address_zip_code = vm.tab1.form.main_address_zip_code;
            vm.tab1.form.contact_address_country = vm.tab1.form.main_address_country;
        }

        function checkErrors(name) {
            $timeout(function () {
                angular.forEach(vm.tab1.scope_form.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        if (name == errorField.$name) {
                            errorField.$setUntouched();
                            (function (errorField) {
                                $timeout(function () {
                                    errorField.$setTouched();
                                }, 100);
                            })(errorField);
                        }
                    })
                });
            });
        }

        function changeNumbering(index) {
            if (vm.tab3.year_registry_id != vm.tab3.invoice_registries[index].invoice_format_id) {
                vm.tab3.invoice_registries[index].start_number = null;
            }
        }

        function sendTab1() {
            vm.request_sending = true;
            apiErrorsService.clear('#editCompanyTab1', vm);
            $location.hash('');

            if (!vm.tab1.edit && !vm.tab1.other_contact_address) {
                copyToContact();
            }

            if (vm.tab1.form.website == null) {
                vm.tab1.form.website = '';
            }

            if (vm.tab1.form.website != '' && vm.tab1.form.website.indexOf('http://') != 0 && vm.tab1.form.website.indexOf('https://') != 0) {
                vm.tab1.form.website = 'http://' + vm.tab1.form.website;
            }
            var form = angular.copy(vm.tab1.form);
            form.logotype = vm.tab1.form.logotype;

            if (!form.logotype) {
                delete form.logotype;
            }

            api.company.company.put(form,
                // success
                function(response) {
                    vm.is_profile_completed = true;

                    getInvoiceSettings();
                    vm.tab1.msg_error = '';
                    vm.tab1.msg_success = transService.translate('COMPANY_EDIT.SUCCESS');
                    vm.request_sending = false;
                    vm.tab1.edit = true;
                    vm.tab1.other_contact_address = true;

                    initLogotype(response.data);

                    $rootScope.current_company_nip = response.data.vatin;
                    $rootScope.vat_payer = response.data.vat_payer;

                    if ($stateParams.first) {
                        vm.tab_selected = 1;
                    }

                    formService.formUp();
                },
                // error
                function(response) {
                    apiErrorsService.show('#editCompanyTab1', response, vm, []);
                    vm.tab1.msg_error = transService.getErrorMassage(response);
                    vm.tab1.msg_success = '';
                    vm.request_sending = false;
                    formService.formUp();
                },
                // progress
                function(progress) {
                    vm.tab1.progress = progress;
                }
            );
        }

        function sendTab3() {
            vm.request_sending = true;
            apiErrorsService.clear('#editCompanyTab3', vm);
            $location.hash('');

            //set term
            if (vm.tab3.term_days == 'd') {
                vm.tab3.form.default_payment_term_days = vm.tab3.term_custom;
            } else {
                vm.tab3.form.default_payment_term_days = vm.tab3.term_days;
            }

            var is_repeating = false;
            var is_reserved = false;
            vm.tab3.form.invoice_registries = angular.copy(vm.tab3.invoice_registries);
            angular.forEach(vm.tab3.invoice_registries, function (item, key) {
                if (['PRO', 'ZAL', 'KOR', 'KOR/ZAL'].indexOf(item.prefix.toUpperCase()) > -1) {
                    is_reserved = true;
                }

                angular.forEach(vm.tab3.invoice_registries, function (item2, key2) {
                    if (key != key2 && item.prefix == item2.prefix) {
                        is_repeating = true;
                    }
                });

                if (item.is_used || !item.invoice_format_id || vm.tab3.year_registry_id !== item.invoice_format_id) {
                    vm.tab3.form.invoice_registries[key].start_number = null;
                }
            });

            if (is_reserved) {
                vm.tab3.msg_error = transService.translate('COMPANY_EDIT.RESERVED_ERROR');
                vm.tab3.msg_success = '';
                formService.formUp();
                vm.request_sending = false;
            } else if (is_repeating) {
                vm.tab3.msg_error = transService.translate('COMPANY_EDIT.PREFIX_ERROR');
                vm.tab3.msg_success = '';
                formService.formUp();
                vm.request_sending = false;
            } else {
                api.invoiceSettings.put(vm.tab3.form,
                    // success
                    function () {
                        vm.tab3.msg_error = '';
                        vm.tab3.msg_success = transService.translate('COMPANY_EDIT.SUCCESS');
                        vm.request_sending = false;
                        getInvoiceSettings();
                        if ($stateParams.first) {
                            vm.tab_selected = 5;
                        } else {
                            formService.formUp();
                        }
                    },
                    // error
                    function (response) {
                        apiErrorsService.show('#editCompanyTab3', response, vm, []);
                        vm.tab3.msg_error = transService.getErrorMassage(response);
                        vm.tab3.msg_success = '';
                        vm.request_sending = false;
                        formService.formUp();
                    }
                );
            }
        }

        function sendTab10() {
            vm.request_sending = true;
            apiErrorsService.clear('#editCompanyTab10', vm);
            $location.hash('');

            if (vm.tab10.form.building_number === '') {
                vm.tab10.form.building_number = null;
            }

            if (vm.tab10.form.flat_number === '') {
                vm.tab10.form.flat_number = null;
            }

            api.company.jpk.put(vm.tab10.form,
                // success
                function(response) {
                    vm.tab10.msg_error = '';
                    vm.tab10.msg_success = transService.translate('COMPANY_EDIT.SUCCESS');
                    vm.request_sending = false;

                    if ($stateParams.first) {
                        vm.tab_selected = 4;
                    } else {
                        formService.formUp();
                    }
                },
                // error
                function(response) {
                    apiErrorsService.show('#editCompanyTab10', response, vm, []);
                    vm.tab10.msg_error = transService.getErrorMassage(response);
                    vm.tab10.msg_success = '';
                    vm.request_sending = false;
                    formService.formUp();
                }
            );
        }

        function setDefaultMethod(id) {
            dialogService.confirm(null, 'COMPANY_EDIT.DEFAULT_METHOD_QUESTION', function() {
                api.paymentsMethod.setDefault.put({default_payment_method_id:id}, function () {
                    vm.tab2.msg_success = transService.translate('COMPANY_EDIT.DEFAULT_METHOD_SUCCESS');
                    vm.tab2.msg_error = '';
                    init();
                    if ($stateParams.first) {
                        vm.tab_selected = 2;
                    }

                },function (response) {
                    vm.tab2.msg_error = transService.getErrorMassage(response);
                })
            });
        }

        function addRegister() {
            if (vm.tab3.invoice_registries.length < 9) {
                vm.tab3.invoice_registries.push({
                    invoice_format_id: '',
                    name: 'register ' + (vm.tab3.invoice_registries.length + 1),
                    prefix: '',
                    start_number: 1,
                    default: false,
                    is_used: 0,
                });
            }
        }

        function delRegister(index) {
            if (vm.tab3.invoice_registries.length > 1) {
                if (vm.tab3.invoice_registries[index].default) {
                    vm.changeDefaultRegister(index ? 0 : 1);
                }
                vm.tab3.invoice_registries.splice(index, 1);
            }
        }

        function changeDefaultRegister(current_index) {
            if (vm.tab3.invoice_registries[current_index].default != false) {
                angular.forEach(vm.tab3.invoice_registries, function (address, index) {
                    if (index != current_index && vm.tab3.invoice_registries[index].default != false) {
                        vm.tab3.invoice_registries[index].default = false;
                    }
                })
            } else {
                vm.tab3.invoice_registries[current_index].default = true;
            }
        }

        function getUsers(add_success) {

            if (typeof add_success != 'undefined') {
                vm.tab4.msg_success = transService.translate(vm.create_user ? 'COMPANY_EDIT.USER.ADD_SUCCESS' : 'COMPANY_EDIT.USER.INVITE_SUCCESS');
            }

            vm.tab4.promise = api.company.users.get({company_status:1}, function (response) {
                vm.tab4.users = response.data;
                // vm.tab4.pagination = response.meta.pagination;
            }).$promise;
        }

        function newUser(e, role_id) {

            $auth.getSettings(function (settings) {
                if (settings['general.multiple_users'] == "0") {
                    $rootScope.packageAlert();
                } else {
                    var values = {
                        user: null,
                        role_id: typeof role_id != 'undefined' ? role_id : 0
                    };
                    dialogService.customDialog(e, 'AddEditUserDialogController', 'app/main/company/edit/add-edit-user/add-edit-user.html', values, getUsers, getUsers);
                }
            });
        }

        function deleteUser(id) {
            dialogService.confirm(null, 'COMPANY_EDIT.USER.DELETE_QUESTION', function() {
                api.company.userDelete.delete({id:id}, function () {
                    vm.tab4.msg_success = transService.translate('COMPANY_EDIT.USER.DELETE_SUCCESS');
                    vm.tab4.msg_error = '';
                    getUsers();

                },function (response) {
                    vm.tab4.msg_error = transService.getErrorMassage(response);
                })
            });
        }

        function editUser(index,e) {
            var values = {
                user: vm.tab4.users[index],
                role_id: 0
            };
            dialogService.customDialog(e, 'AddEditUserDialogController', 'app/main/company/edit/add-edit-user/add-edit-user.html', values, getUsers, getUsers);
        }

        function addBankAccount() {
            vm.tab1.form.bank_accounts.push({
                id: null,
                number: '',
                bank_name: '',
                swift: null,
                default: false
            });
        }

        function deleteBankAccount() {
            if (vm.tab1.form.bank_accounts.length <= 1) {
                return;
            }
            // if already deleting item is default, set first on list as default
            if (vm.tab1.form.bank_accounts[vm.tab1.form.bank_accounts.length-1].default == true) {
                vm.tab1.form.bank_accounts[0].default = true;
            }
            vm.tab1.form.bank_accounts.pop();
        }

        function changeDefaultBankAccount(current_index) {
            if (vm.tab1.form.bank_accounts[current_index].default == false) {
                angular.forEach(vm.tab1.form.bank_accounts, function (bank_account, index) {
                    vm.tab1.form.bank_accounts[index].default = index == current_index ? true : false;
                });
            }
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.company-buy-wizard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.company-buy-wizard', {
                url    : '/company/buy/:id',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/company/buy-wizard/buy-wizard.html',
                        controller : 'CompanyBuyWizardController as vm'
                    }
                },
                resolve  : {
                    CardList: function (apiResolver) {
                        //disable subscriptions
                        return {data:[]};
                        // return apiResolver.resolve('payuCardList@get');
                    },
                    Payment: function (apiResolver, $stateParams) {
                        return apiResolver.resolve('payment@get', {id: $stateParams.id});
                    },
                    PackagesCurrent: function (apiResolver)
                    {
                        return apiResolver.resolve('packagesCurrent@get');
                    },
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.company-buy-wizard')
        .controller('CompanyBuyWizardController', CompanyBuyWizardController);

    /** @ngInject */
    function CompanyBuyWizardController(transService, api, CardList, Payment, PackagesCurrent, apiErrorsService, $window, $location)
    {
        var vm = this;
        transService.loadFile('main/company/buy-wizard');

        // Data
        vm.card_list = CardList.data;
        vm.payment = Payment.data;
        vm.package_current = PackagesCurrent.data;
        vm.first_module = vm.payment.transaction.data.company_modules_history.data[0];
        vm.request_sending = false;
        vm.enable_card_pay = false; //disable subscriptions

        vm.form = {
            id: vm.payment.id,
            subscription: false,
            type: false,
            token: null,
            card_exp_month: '',
            card_exp_year: '',
            card_cvv: '',
            card_number: ''
        };


        // Methods
        vm.sendForm = sendForm;

        function sendForm() {
            vm.request_sending = true;

            api.payment.save(vm.form,
                // success
                function(response) {
                    if (response.data.redirect_url) {
                        $window.location.href = response.data.redirect_url;
                    } else {
                        $location.path('/company/payment/back');
                    }
                },
                // error
                function(response) {
                    if (response.date.code == 'payu.warning_continue_3ds') {
                        $window.location.href = response.data.redirect_url;
                    } else {
                        vm.msg_error = transService.getErrorMassage(response);
                        vm.msg_success = '';
                        vm.request_sending = false;
                    }
                }
            );
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cash-operations-list', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.cash-operations-list', {
                url    : '/cash-operations/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cash-operations/list/list.html',
                        controller : 'CashOperationsListController as vm'
                    }
                },
                resolve  : {
                    UsersList: function (apiResolver) {
                        return apiResolver.resolve('company.users@get');
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cash-operations-list')
        .controller('CashOperationsListController', CashOperationsListController);

    /** @ngInject */
    function CashOperationsListController(transService, api, tableService, $scope, $window, __env, $httpParamSerializer, $auth, dialogService, UsersList)
    {
        var vm = this;
        transService.loadFile('main/cash-operations/list');

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.request_sending = false;
        vm.cash_operations = [];
        vm.users = UsersList.data;
        vm.reports = {};
        vm.is_tax_office = false;

        vm.tab1 = {
            cash_operations: [],
            reports: {},
            edit_access:false,
        };

        vm.tab2 = {
            cash_operations: [],
            reports: {},
            edit_access:false,
        };

        vm.getCashOperations = getCashOperations;
        vm.getNonCashOperations = getNonCashOperations;
        // vm.deleteCashOperations = deleteCashOperations;
        vm.pdf = pdf;
        vm.nonCashPdf = nonCashPdf;
        vm.changeTo = changeTo;

        init();

        function init() {

            tableService.setVariables(vm.tab1);
            vm.tab1.query.cashless = '0';
            vm.tab1.query.user_id = '';
            vm.tab1.query.balanced_tmp = 0;
            vm.tab1.query.date = moment().format('YYYY-MM-DD');

            if (typeof $window.localStorage.cash_operations_tab1_user_id != 'undefined') {
                vm.tab1.query.user_id = $window.localStorage.cash_operations_tab1_user_id;
            } else if (vm.users.length) {
                vm.tab1.query.user_id = vm.users[0].id;
            }

            tableService.setVariables(vm.tab2);
            vm.tab2.query.cashless = '1';
            vm.tab2.query.user_id = '';
            vm.tab1.query.balanced_tmp = 0;
            vm.tab2.query.date = moment().format('YYYY-MM-DD');

            if (typeof $window.localStorage.cash_operations_tab2_user_id != 'undefined') {
                vm.tab2.query.user_id = $window.localStorage.cash_operations_tab2_user_id;
            } else if (vm.users.length) {
                vm.tab2.query.user_id = vm.users[0].id;
            }

            getCashOperations();
            getNonCashOperations();

            $scope.$watch(function () {return vm.tab1.query.user_id;},function(value){
                $window.localStorage.cash_operations_tab1_user_id = value;
            });

            $scope.$watch(function () {return vm.tab2.query.user_id;},function(value){
                $window.localStorage.cash_operations_tab2_user_id = value;
            });

            $auth.getMyRole(function (role) {
                vm.is_tax_office = role == 'tax_office';
            })
        }

        /**
         * get contractors
         */
        function getCashOperations() {
            $auth.getUser(function (user) {
                vm.tab1.edit_access = user.id == vm.tab1.query.user_id;

                vm.tab1.query.balanced = Number(vm.tab1.query.balanced_tmp);
                vm.tab1.promise = api.cashOperations.get(vm.tab1.query, function (response) {
                    vm.tab1.cash_operations = response.data;
                    vm.tab1.pagination = response.meta.pagination;

                    api.reports.cashOperations.get(vm.tab1.query, function (response) {
                        vm.tab1.reports = response.data;
                    });

                }).$promise;
            });
        }

        /**
         * get contractors
         */
        function getNonCashOperations() {
            $auth.getUser(function (user) {
                vm.tab2.edit_access = user.id == vm.tab2.query.user_id;

                vm.tab2.query.balanced = Number(vm.tab2.query.balanced_tmp);
                vm.tab2.promise = api.cashOperations.get(vm.tab2.query, function (response) {
                    vm.tab2.cash_operations = response.data;
                    vm.tab2.pagination = response.meta.pagination;

                    api.reports.cashOperations.get(vm.tab2.query, function (response) {
                        vm.tab2.reports = response.data;
                    });

                }).$promise;
            });
        }

        /**
         * delete contractor
         * @param id
         */
        // function deleteCashOperations(id) {
        //     dialogService.confirm(null, 'CASH_OPERATIONS_LIST.DELETE_QUESTION', function() {
        //         api.cashOperations.delete({id:id}, function () {
        //             vm.msg_success = transService.translate('CASH_OPERATIONS_LIST.DELETE_SUCCESS');
        //             vm.msg_error = '';
        //             init();
        //
        //         },function (response) {
        //             vm.msg_error = transService.getErrorMassage(response);
        //         })
        //     });
        // }


        /**
         *
         * @param id
         * @param cashless
         */
        function changeTo(id, cashless) {
                dialogService.confirm(null, 'CASH_OPERATIONS_LIST.CHANGE_QUESTION_' + cashless, function() {
                    api.cashOperation.put({id:id, cashless:cashless}, function () {
                        vm.msg_success = transService.translate('CASH_OPERATIONS_LIST.CHANGE_SUCCESS');
                        
                        vm.msg_error = '';
                        init();

                    },function (response) {
                        vm.msg_error = transService.getErrorMassage(response);
                    })
                });
        }

        function pdf(id) {

            if (typeof id == 'undefined') {
                var params = $httpParamSerializer(vm.tab1.query);
                $window.open(
                    __env.apiUrl + 'cash-flows/pdf?' + params +
                    '&token=' + $window.localStorage.token +
                    '&balanced=' + Number(vm.tab1.query.balanced_tmp) +
                    '&selected_company_id=' + $auth.getCurrentCompany(),
                    '_blank');
            } else {
                $window.open(
                    __env.apiUrl + 'cash-flows/'+id+'/pdf?' +
                    'token=' + $window.localStorage.token +
                    '&selected_company_id=' + $auth.getCurrentCompany(),
                    '_blank');
            }
        }


        function nonCashPdf(id) {

            if (typeof id == 'undefined') {
                var params = $httpParamSerializer(vm.tab2.query);
                $window.open(
                    __env.apiUrl + 'cash-flows/pdf?' + params +
                    '&token=' + $window.localStorage.token +
                    '&balanced=' + Number(vm.tab2.query.balanced_tmp) +
                    '&selected_company_id=' + $auth.getCurrentCompany(),
                    '_blank');
            } else {
                $window.open(
                    __env.apiUrl + 'cash-flows/'+id+'/pdf?' +
                    'token=' + $window.localStorage.token +
                    '&selected_company_id=' + $auth.getCurrentCompany(),
                    '_blank');
            }
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cash-operations-form', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.cash-operations-form-new', {
                url    : '/cash-operations/form/:type/cashless/:cashless',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/cash-operations/form/form.html',
                        controller : 'CashOperationsFormController as vm'
                    }
                }
            })
            .state('app.cash-operations-form-edit', {
            url    : '/cash-operations/form/:type/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/cash-operations/form/form.html',
                    controller : 'CashOperationsFormController as vm'
                }
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.cash-operations-form')
        .controller('CashOperationsFormController', CashOperationsFormController);

    /** @ngInject */
    function CashOperationsFormController(transService, api, $location, $window, apiErrorsService, __env, $auth, $stateParams, formService)
    {
        var vm = this;
        transService.loadFile('main/cash-operations/form');

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.request_sending = false;
        vm.edit = false;
        vm.search_text_receipt = '';
        vm.search_text_invoice = '';
        vm.last_added = null;
        vm.form = {
            document_id: null,
            document_type: 'receipt',
            cashless: $stateParams.cashless,
            amount: '',
            direction: '',
            flow_date: moment().format('YYYY-MM-DD'),
            description: ''
        };
        vm.receipt = {
            selected_item: null
        };

        vm.invoice = {
            selected_item: null
        };

        vm.send = send;
        vm.pdf = pdf;
        vm.searchReceipt = searchReceipt;
        vm.searchInvoice = searchInvoice;

        function searchReceipt(number) {

            return api.receipts.get({
                    limit: 15,
                    page: 1,
                    number: number
                }
            ).$promise.then(function (response) {
                return response.data;
            });
        }

        function searchInvoice(number) {

            return api.invoices.get({
                    limit: 15,
                    page: 1,
                    number: number,
                    status: 'not_deleted'
                }
            ).$promise.then(function (response) {
                return response.data;
            });
        }

        function pdf() {
            $window.open(
                __env.apiUrl + 'cash-flows/'+vm.last_added+'/pdf?' +
                'token=' + $window.localStorage.token +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }

        function send() {
            
            $location.hash('');
            vm.request_sending = true;
            apiErrorsService.clear('#cashOperations', vm);


            if ((vm.form.document_type == 'receipt' && !vm.receipt.selected_item && vm.search_text_receipt != '')
                || (vm.form.document_type == 'invoice' && !vm.invoice.selected_item && vm.search_text_invoice != '')) {
                vm.msg_error = transService.translate('CASH_OPERATIONS_FORM.WRONG_SELECTED');
                vm.msg_success = '';
            } else {
                if (vm.form.document_type == 'receipt' && vm.receipt.selected_item) {
                    vm.form.document_id = vm.receipt.selected_item.id;
                }
                if (vm.form.document_type == 'invoice' && vm.invoice.selected_item) {
                    vm.form.document_id = vm.invoice.selected_item.id;
                }
                api.cashOperations.save(vm.form,
                    // success
                    function (response) {
                        vm.last_added = response.data.id;
                        vm.msg_error = '';
                        vm.msg_success = transService.translate('CASH_OPERATIONS_FORM.ADD_SUCCESS');
                        vm.request_sending = false;
                        formService.formUp();
                    },
                    // error
                    function (response) {
                        apiErrorsService.show('#cashOperations', response, vm, []);
                        vm.msg_error = transService.getErrorMassage(response);
                        vm.msg_success = '';
                        vm.request_sending = false;
                        formService.formUp();
                    }
                );
            }
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.user-edit', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.user-edit', {
                url    : '/user-edit',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/auth/user-edit/user-edit.html',
                        controller : 'UserEditController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.user-edit')
        .controller('UserEditController', UserEditController);

    /** @ngInject */
    function UserEditController(transService, api, $auth)
    {
        var vm = this;
        transService.loadFile('main/auth/user-edit');

        vm.form = {
            id: 0,
            password: '',
            first_name: '',
            last_name: '',
            password_confirmation: '',
            old_password: '',
        };

        // Data
        vm.msg_error = '';
        vm.msg_success = '';
        vm.request_sending = false;

        vm.send = send;
        vm.passwordRequired = passwordRequired;
        vm.changeLanguage = transService.changeLanguage;

        init();

        function init() {
            $auth.getUser(function (user) {
                vm.form.id = user.id;
                vm.form.first_name = user.first_name;
                vm.form.last_name = user.last_name;
            });
        }

        function passwordRequired() {
            return (vm.form.password != '' && typeof vm.form.password != 'undefined')
                || (vm.form.password_confirmation != '' && typeof vm.form.password_confirmation != 'undefined')
                || (vm.form.old_password != '' && typeof vm.form.old_password != 'undefined')
        }

        function send() {
            vm.request_sending = true;

            api.userUpdate.put(vm.form,
                // success
                function() {
                    vm.msg_error = '';
                    vm.msg_success = transService.translate('USER_EDIT.SUCCESS');
                    vm.request_sending = false;

                    vm.form.password = '';
                    vm.form.password_confirmation = '';
                    vm.form.old_password = '';
                },
                // error
                function(response) {
                    vm.msg_error = transService.getErrorMassage(response);
                    vm.msg_success = '';
                    vm.request_sending = false;
                }
            );
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.reset-password', {
            url      : '/guest/reset-password/:token',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.reset-password': {
                    templateUrl: 'app/main/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController($stateParams, $window, api, $auth, transService, $location)
    {
        var vm = this;
        transService.loadFile('main/auth/reset-password');

        // Data
        vm.form = {
            email: '',
            password: '',
            password_confirmation: '',
            token: $stateParams.token
        }
        vm.msg_success = '';
        vm.msg_error = '';
        vm.not_reset_link = '';
        vm.request_sending = false;

        // Methods
        vm.reset = reset;
        vm.changeLanguage = transService.changeLanguage;

        //////////
        function reset()
        {
            vm.request_sending = true;

            api.auth.passwordReset.put(vm.form,
                //success
                function(response) {
                    if ($auth.check()) {
                        vm.msg_success = transService.translate('RESETPASSWORD.SUCCESS_2');
                    } else {
                        vm.msg_success = transService.translate('RESETPASSWORD.SUCCESS');
                        $window.sessionStorage.passwordChangedEmail = vm.form.email;
                        $location.path('/guest/login');

                    }
                    vm.request_sending = false;
                },
                //error
                function(response) {
                    if (response.data.code == 'password.invalid_token') {
                        vm.not_reset_link = '/guest/forgot-password';
                    } else {
                        vm.msg_error = transService.getErrorMassage(response);
                    }
                    vm.request_sending = false;
                }
            );
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.
            state('app.register', {
                url      : '/guest/register', //and register
                views    : {
                    'main@'                          : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.register': {
                        templateUrl: 'app/main/auth/register/register.html',
                        controller : 'RegisterController as vm'
                    }
                },
                bodyClass: 'register'
            }).
            state('app.register-plan', {
                url      : '/guest/register/plan/:plan',
                views    : {
                    'main@'                          : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.register-plan': {
                        templateUrl: 'app/main/auth/register/register.html',
                        controller : 'RegisterController as vm'
                    }
                },
                bodyClass: 'register'
            }).
            state('app.register-plan-key', {
                url      : '/guest/register/plan/:plan/:key',
                views    : {
                    'main@'                          : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.register-plan-key': {
                        templateUrl: 'app/main/auth/register/register.html',
                        controller : 'RegisterController as vm'
                    }
                },
                bodyClass: 'register'
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController(api, transService, $scope, $timeout, $stateParams, $window, apiErrorsService, dialogService, $location)
    {
        var vm = this;
        transService.loadFile('main/auth/register');

        // Data
        vm.form = {
            first_name: '',
            last_name: '',
            email: '',
            regulations: false,
            discount_code: typeof $stateParams.key != 'undefined' ? $stateParams.key : '',
            password: '',
            password_confirmation: '',
            url: 'http://' + api.url + 'guest/activation/:token'
        };
        vm.msg_success = '';
        vm.msg_error = '';
        vm.request_sending = false;

        // Methods
        vm.create = create;
        vm.changeLanguage = transService.changeLanguage;

        //////////

        function create()
        {
            vm.request_sending = true;
            apiErrorsService.clear('#registerForm', vm);

            api.auth.create.save(vm.form,
                //success
                function(response) {
                    vm.msg_error = '';
                    vm.msg_success = transService.translate('REGISTER.SUCCESS');
                    vm.request_sending = false;

                    if (typeof $stateParams.plan != 'undefined') {
                        $window.localStorage.package = $stateParams.plan;
                    }

                    vm.form = {
                        first_name: '',
                        last_name: '',
                        email: '',
                        regulations: false,
                        password: '',
                        password_confirmation: '',
                        url: 'http://' + api.url + 'guest/activation/:token'
                    };
                    $timeout(function () {
                        $scope.registerForm.$setPristine();
                        $scope.registerForm.$setValidity();
                        $scope.registerForm.$setUntouched();
                        $scope.$apply();
                        $scope.registerForm = {};
                    });
                },
                //error
                function(response) {
                    apiErrorsService.show('#registerForm', response, vm);
                    vm.msg_success = '';
                    vm.request_sending = false;

                    if (response.data.code == 'general.validation_failed' && response.data.fields.email 
                            && (response.data.fields.email[0].indexOf('unikalne') !== -1 || response.data.fields.email[0].indexOf('unique') !== -1)) {
                        accountArleadyExistsInfo();
                    }

                }
            );
        }

        function accountArleadyExistsInfo() {
            dialogService.confirm(null, 'REGISTER.ACCOUNT_EXISTS', function() {
                $timeout(function() {
                    $location.path('/guest/login');
                }, 100);
            }, null, 'REGISTER.LOGIN', 'OTHER.CLOSE');
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.login-quick', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.login-quick', {
            url      : '/guest/login/:token',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.login-quick': {
                    templateUrl: 'app/main/auth/login-quick/login-quick.html',
                    controller : 'LoginQuickController as vm'
                }
            },
            bodyClass: 'login-quick'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.login-quick')
        .controller('LoginQuickController', LoginQuickController);

    /** @ngInject */
    function LoginQuickController($stateParams, api, $auth, transService)
    {

        var vm = this;
        transService.loadFile('main/auth/login-quick');

        vm.changeLanguage = transService.changeLanguage;

        vm.msg_success = '';
        vm.msg_error = '';

        //send activation
        api.auth.quick.save({
                token: $stateParams.token
            },
            //success
            function (response) {
                $auth.login(response.data.token);
            },
            //error
            function (response) {

                switch (response.data.code) {
                    case 'auth.user_already_logged':
                        $auth.redirectTo('/');
                        break;
                    default:
                        vm.msg_error = transService.getErrorMassage(response);
                }
            }
        );
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.login', {
            url      : '/guest/login', //and login
            views    : {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($auth, api, $window, transService, $location)
    {
        var vm = this;
        transService.loadFile('main/auth/login');

        // Data
        vm.form = {
            email: '',
            password: ''
        };
        vm.msg_error = '';
        vm.msg_success = '';
        vm.not_active_link = '';

        // Methods
        vm.submitLoginForm = submitLoginForm;
        vm.changeLanguage = transService.changeLanguage;
        //////////

        init();

        function init()
        {
            if ($auth.check()) {
                $auth.redirectToDashboard();
            }
            
            if(typeof $window.sessionStorage.passwordChangedEmail != 'undefined') {
                vm.successMessage = $window.sessionStorage.passwordChangedEmail;
                delete $window.sessionStorage.passwordChangedEmail;
            }

            if(typeof $window.sessionStorage.login_info != 'undefined') {
                vm.msg_success = $window.sessionStorage.login_info;
                delete $window.sessionStorage.login_info;
            }
        }

        function submitLoginForm()
        {
            if (vm.form.email != undefined) {

                api.auth.authenticate.save(vm.form,
                    // Success
                    function (response) {
                        if (response.data.token) {
                            $auth.login(response.data.token);
                        }
                    },
                    // Error
                    function (response) {
                        if (response.data.code == 'auth.user_not_activated') {
                            vm.not_active_link = '/guest/activation/false';
                        } else if (response.data.code == 'auth.user_already_logged') {
                            $auth.redirectToDashboard();
                        } else {
                            vm.msg_error = transService.getErrorMassage(response.data);
                        }
                    }
                );
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.invitation', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.invitation', {
            url      : '/guest/invitation/:token/:company',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.invitation': {
                    templateUrl: 'app/main/auth/invitation/invitation.html',
                    controller : 'InvitationController as vm'
                }
            },
            bodyClass: 'invitation'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.invitation')
        .controller('InvitationController', InvitationController);

    /** @ngInject */
    function InvitationController($stateParams, $window, api, transService, $location, $timeout)
    {
        var vm = this;
        transService.loadFile('main/auth/invitation');

        // Data
        vm.form = {
            password: '',
            password_confirmation: '',
            regulations: false,
            token: $stateParams.token
        };
        vm.msg_success = '';
        vm.msg_error = '';
        vm.request_sending = false;
        vm.company_name = decodeURIComponent($stateParams.company).replace(/\+/g, ' ');
        vm.form_enabled = false;

        // Methods
        vm.send = send;
        vm.changeLanguage = transService.changeLanguage;

        init();

        function init() {
            api.company.acceptInvitation.put(vm.form, function () {

                $location.path('/guest/login');

            }, function (response) {
                vm.form_enabled = true;
            });
        }


        //////////
        function send()
        {
            vm.request_sending = true;

            api.company.acceptInvitation.put(vm.form, function () {

                $location.path('/guest/login');

            },function (response) {
                vm.msg_error = transService.getErrorMassage(response);
                vm.request_sending = false;
                $timeout(function () {
                    try {
                        var list = [
                            'company_invitation.not_pending',
                            'company_invitation.already_assigned_to_company',
                            'company_invitation.expired',
                            'company_invitation.invalid_email_given'
                        ];

                        if (list.indexOf(response.data.code) > -1) {
                            $location.path('/guest/login');
                        }
                    } catch (e) {}
                }, 5000);
            })
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.forgot-password', {
            url      : '/guest/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.forgot-password': {
                    templateUrl: 'app/main/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController(api, $window, $auth, transService)
    {
        var vm = this;
        transService.loadFile('main/auth/forgot-password');

        // Data
        vm.form = {
            email: '',
            url: 'http://' + api.url + 'guest/reset-password/:token'
        };
        vm.msg_success = '';
        vm.msg_error = '';

        // Methods
        vm.forgotPassword = forgotPassword;
        vm.changeLanguage = transService.changeLanguage;

        //////////

        function forgotPassword()
        {
            vm.request_sending = true;

            api.auth.passwordReset.save(vm.form,
                // success
                function() {
                    vm.msg_error = '';
                    vm.msg_success = transService.translate('FORGOTPASSWORD.SUCCESS');
                    vm.request_sending = false;
                },
                // error
                function(response) {
                    vm.msg_error = transService.getErrorMassage(response);
                    vm.msg_success = '';
                    vm.request_sending = false;
                }
            );
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.activation', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.activation', {
            url      : '/guest/activation/:token',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.activation': {
                    templateUrl: 'app/main/auth/activation/activation.html',
                    controller : 'ActivationController as vm'
                }
            },
            bodyClass: 'activation'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.activation')
        .controller('ActivationController', ActivationController);

    /** @ngInject */
    function ActivationController($stateParams, $window, $timeout, api, $auth, transService)
    {

        var vm = this;
        transService.loadFile('main/auth/activation');

        vm.msg_success = '';
        vm.msg_error = '';
        vm.error_code = '';
        // vm.form = {email : $stateParams.email};
        vm.form = {
            email : '',
            url: 'http://' + api.url + 'guest/activation/:token'
        };
        vm.recreate_form = false;
        vm.request_sending = false;

        // Methods
        vm.recreate = recreate;
        vm.changeLanguage = transService.changeLanguage;

        //open only reactivate
        if ($stateParams.token == 'false') {

            vm.recreate_form = true;

        } else {

            //send activation
            api.activation.activation.put({
                    // email: $stateParams.email,
                    activation_token: $stateParams.token
                },
                //success
                function (response) {

                    if ($auth.check()) {
                        vm.msg_success = transService.translate('ACTIVATION.ACCOUNT.ACTIVE_2');
                    } else {
                        vm.msg_success = transService.translate('ACTIVATION.ACCOUNT.ACTIVE');
                        $timeout(function () {
                            if (response.data.token) {
                                $auth.login(response.data.token);
                            }
                        }, 5000);
                    }
                },
                //error
                function (response) {

                    switch (response.data.code) {
                        case 'general.validation_failed':
                            vm.error_code = 'broken-link';
                            break;
                        case 'general.user_not_found':
                            vm.error_code = 'user-not-found';
                            break;
                        case 'activation.user_already_activated':
                            $window.sessionStorage.login_info = transService.translate('ACTIVATION.ACCOUNT.ACTIVE_BEFORE');
                            $auth.redirectTo('/guest/login');
                            break;
                        default:
                            vm.msg_error = transService.getErrorMassage(response);
                    }
                }
            );
        }
        /**
         * resend the activation e-mail
         */
        function recreate()
        {
            vm.request_sending = true;
            vm.msg_success = '';
            vm.msg_error = '';
            vm.error_code = '';

            api.activation.recreate.put(vm.form,
                //success
                function() {
                    vm.msg_success = transService.translate('ACTIVATION.RECREATE.OK');
                    vm.request_sending = false;
                },
                //error
                function() {
                    vm.msg_error = transService.translate('ACTIVATION.RECREATE.ERROR');
                    vm.request_sending = false;
                }
            );
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardController', ScrumboardController);

    /** @ngInject */
    function ScrumboardController($window, $mdSidenav, BoardService, BoardList, CardPreview, transService)
    {
        var vm = this;
        transService.loadFile('main/agile/scrumboard');

        // Data
        vm.currentView = 'board';
        vm.board = BoardService.data;
        vm.boardList = BoardList.data;
        vm.boardSelectorVisible = false;

        // Methods
        vm.updateBoardUri = updateBoardUri;

        ////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // IE list-content max-height hack
            if ( angular.element('html').hasClass('explorer') )
            {
                // Calculate the height for the first time
                calculateListContentHeight();

                // Attach calculateListContentHeight function to window resize
                $window.onresize = function ()
                {
                    calculateListContentHeight();
                }
            }
        }

        /**
         * IE ONLY
         * Calculate the list-content height
         * IE ONLY
         */
        function calculateListContentHeight()
        {
            // Get the required heights for calculations
            var listWrapperEl = angular.element('#board .list-wrapper').first(),
                listWrapperElHeight = listWrapperEl.height(),
                listHeaderElHeight = listWrapperEl.find('.list-header').height(),
                listFooterElHeight = listWrapperEl.find('.list-footer').height();

            // Calculate the max height
            var maxHeight = listWrapperElHeight - listHeaderElHeight - listFooterElHeight;

            // Add the max height
            angular.element('#board .list-content').css({'max-height': maxHeight});
        }

        /**
         * Update Board Uri
         *
         * Once you connect your app to your server,
         * you would do this on your API server.
         */
        function updateBoardUri()
        {
            if ( vm.boardList.getById(vm.board.id) )
            {
                vm.boardList.getById(vm.board.id).name = vm.board.name;
                vm.boardList.getById(vm.board.id).uri = vm.board.uri = encodeURIComponent(vm.board.name).replace(/%20/g, '-').toLowerCase();
            }
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.backlog')
        .controller('backlogController', backlogController);

    /** @ngInject */
    function backlogController($document, $mdDialog, msUtils, $mdSidenav, Tasks, Tags, transService)
    {
        var vm = this;
        transService.loadFile('main/agile/backlog');

        // Data
        vm.tasks = Tasks.data;
        vm.tags = Tags.data;
        vm.completed = [];
        vm.colors = ['blue', 'blue-grey', 'orange', 'pink', 'purple'];
        vm.projects = {
            'creapond'    : 'Project Creapond',
            'withinpixels': 'Project Withinpixels'
        };
        vm.selectedFilter = {
            filter : 'Start Date',
            dueDate: 'Next 3 days'
        };
        vm.selectedProject = 'creapond';

        // Tasks will be filtered against these models
        vm.taskFilters = {
            search   : '',
            tags     : [],
            completed: '',
            deleted  : false,
            important: '',
            starred  : '',
            startDate: '',
            dueDate  : ''
        };
        vm.taskFiltersDefaults = angular.copy(vm.taskFilters);
        vm.showAllTasks = true;

        vm.taskOrder = '';
        vm.taskOrderDescending = false;

        vm.sortableOptions2 = {
            handle        : '.handle',
            forceFallback : true,
            ghostClass    : 'backlog-item-placeholder',
            fallbackClass : 'backlog-item-ghost',
            fallbackOnBody: true,
            sort          : true
        };
        
        vm.sortableOptions = {
            appendTo      : 'body',
            connectWith   : '.backlog-items',
            items      : '> .backlog-item',
            forceFallback : true,
//            placeholder: 'backlog-item-placeholder',
            ghostClass    : 'backlog-item-placeholder',
            fallbackClass : 'backlog-item-ghost',
            fallbackOnBody: true,
            handle              : msUtils.isMobile() ? '.handle' : false,
            scroll              : true
        };
        vm.msScrollOptions = {
            suppressScrollX: true
        };
        
        vm.sortableSprintOptions = {
            axis       : 'y',
            delay      : 75,
            distance   : 7,
            items      : '> .sprint',
            handle     : '.sprint-handle',
            placeholder: 'sprint sprint-sortable-placeholder',
            tolerance  : 'pointer',
            start      : function (event, ui)
            {
                var width = ui.item[0].children[0].clientWidth;
                var height = ui.item[0].children[0].clientHeight;
                ui.placeholder.css({
                    'min-width': width + 'px',
                    'width'    : width + 'px',
                    'height'   : height + 'px'
                });
            }
        };

        // Methods
        vm.preventDefault = preventDefault;
        vm.openTaskDialog = openTaskDialog;
        vm.toggleCompleted = toggleCompleted;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleFilter = toggleFilter;
        vm.toggleFilterWithEmpty = toggleFilterWithEmpty;
        vm.filterByStartDate = filterByStartDate;
        vm.filterByDueDate = filterByDueDate;
        vm.resetFilters = resetFilters;
        vm.toggleTagFilter = toggleTagFilter;
        vm.isTagFilterExists = isTagFilterExists;

        init();

        //////////

        /**
         * Initialize the controller
         */
        function init()
        {
            angular.forEach(vm.tasks, function (task)
            {
                if ( task.startDate )
                {
                    task.startDate = new Date(task.startDate);
                    task.startDateTimestamp = task.startDate.getTime();
                }

                if ( task.dueDate )
                {
                    task.dueDate = new Date(task.dueDate);
                    task.dueDateTimestamp = task.dueDate.getTime();
                }
            });
        }

        /**
         * Prevent default
         *
         * @param e
         */
        function preventDefault(e)
        {
            e.preventDefault();
            e.stopPropagation();
        }

        /**
         * Open new task dialog
         *
         * @param ev
         * @param task
         */
        function openTaskDialog(ev, task)
        {
            $mdDialog.show({
                controller         : 'TaskDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/agile/backlog/dialogs/task/task-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Task : task,
                    Tasks: vm.tasks,
                    event: ev
                }
            });
        }

        /**
         * Toggle completed status of the task
         *
         * @param task
         * @param event
         */
        function toggleCompleted(task, event)
        {
            event.stopPropagation();
            task.completed = !task.completed;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggles filter with true or false
         *
         * @param filter
         */
        function toggleFilter(filter)
        {
            vm.taskFilters[filter] = !vm.taskFilters[filter];

            checkFilters();
        }

        /**
         * Toggles filter with true or empty string
         * @param filter
         */
        function toggleFilterWithEmpty(filter)
        {
            if ( vm.taskFilters[filter] === '' )
            {
                vm.taskFilters[filter] = true;
            }
            else
            {
                vm.taskFilters[filter] = '';
            }

            checkFilters();
        }

        /**
         * Reset filters
         */
        function resetFilters()
        {
            vm.showAllTasks = true;
            vm.taskFilters = angular.copy(vm.taskFiltersDefaults);
        }

        /**
         * Check filters and mark showAllTasks
         * as true if no filters selected
         */
        function checkFilters()
        {
            vm.showAllTasks = !!angular.equals(vm.taskFiltersDefaults, vm.taskFilters);
        }

        /**
         * Filter by startDate
         *
         * @param item
         * @returns {boolean}
         */
        function filterByStartDate(item)
        {
            if ( vm.taskFilters.startDate === true )
            {
                return item.startDate === new Date();
            }

            return true;
        }

        /**
         * Filter Due Date
         *
         * @param item
         * @returns {boolean}
         */
        function filterByDueDate(item)
        {
            if ( vm.taskFilters.dueDate === true )
            {
                return !(item.dueDate === null || item.dueDate.length === 0);
            }

            return true;
        }

        /**
         * Toggles tag filter
         *
         * @param tag
         */
        function toggleTagFilter(tag)
        {
            var i = vm.taskFilters.tags.indexOf(tag);

            if ( i > -1 )
            {
                vm.taskFilters.tags.splice(i, 1);
            }
            else
            {
                vm.taskFilters.tags.push(tag);
            }

            checkFilters();
        }

        /**
         * Returns if tag exists in the tagsFilter
         *
         * @param tag
         * @returns {boolean}
         */
        function isTagFilterExists(tag)
        {
            return vm.taskFilters.tags.indexOf(tag) > -1;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                deleteItem         : deleteItem,
                sort               : sortByWeight,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if ( msNavigationService.getFolded() )
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep(num)
        {
            if (angular.isUndefined(num)) {
                vm.selectedIndex--;
            } else {
                vm.selectedIndex -= num;
            }
        }

        /**
         * Go to next step
         */
        function nextStep(num)
        {
            if (angular.isUndefined(num)) {
                vm.selectedIndex++;
            } else {
                vm.selectedIndex += num;
            }
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === vm.forms.length - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean|*}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sample', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.sample', {
                url    : '/sample',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/sample/sample.html',
                        controller : 'SampleController as vm'
                    }
                },
                resolve: {
                    SampleData: function (apiResolver)
                    {
                        return apiResolver.resolve('sample@get');
                    }
                }
            });

        // // Navigation
        // msNavigationServiceProvider.saveItem('CEP', {
        //     title : 'SAMPLE',
        //     group : true,
        //     weight: 1
        // });
        //
        // msNavigationServiceProvider.saveItem('CEP.sample', {
        //     title    : 'Sample',
        //     icon     : 'icon-tile-four',
        //     state    : 'app.sample',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     translate: 'SAMPLE.SAMPLE_NAV',
        //     weight   : 1
        // });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sample')
        .controller('SampleController', SampleController);

    /** @ngInject */
    function SampleController(SampleData, transService)
    {
        var vm = this;
        transService.loadFile('main/sample');

        // Data
        vm.helloText = SampleData.data.helloText;

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('invoiceService', invoiceService);

    /** @ngInject */
    function invoiceService(transService, api, dialogService, $window, $timeout, $rootScope)
    {
        var vm = null;
        var scope = null;
        var add_product_id = 0;
        var add_contractor_id = 0;

        var service = {
            init:init,
            getNewObjItem:getNewObjItem,
            getNewObjTax:getNewObjTax,
            getMarginProcedures:getMarginProcedures,
            getReverseChanges:getReverseChanges,
            getCurrencies:getCurrencies,
            getInvoiceSettingAndFormats:getInvoiceSettingAndFormats,
            setPaymentDate:setPaymentDate,
            setPaymentDateFull:setPaymentDateFull,
            calculate:calculate,
            setBankAccount: setBankAccount,
            getGtuItems: getGtuItems
        };

        return service;

        function init(tmp_vm, tmp_scope) {
            vm = tmp_vm;
            scope = tmp_scope;

            vm.msg_error = '';
            vm.msg_success = '';
            vm.request_sending = false;
            vm.type = '';
            vm.contractor = null;
            vm.search_text_contractor = '';
            vm.payment_methods = {};
            vm.payment_date = '';
            vm.taxes = {};
            vm.units = {};
            vm.services = {};
            vm.margin_procedures = {};
            vm.reverse_changes = {};
            vm.currencies = [];
            vm.gtu_procedure_items = [];
            vm.gtu_product_items = [];
            vm.disabled_payment_date = false;
            vm.today = moment().format('YYYY-MM-DD');
            vm.start_callendar = moment().add(-180, 'days').format('YYYY-MM-DD');
            vm.stop_callendar = moment().add(180, 'days').format('YYYY-MM-DD');
            vm.show_description = false;

            //data only for edit/add
            vm.company = {};
            vm.registries = [];
            vm.current_method = null;
            vm.title = '';
            vm.invoice_formats = {};
            vm.is_extra_item = false;
            vm.custom_name_products_enable = false;
            vm.addresses_delivery_enabled = false;
            vm.delivery_contractor = null;
            vm.search_text_delivery_contractor = '';
            vm.tax_type_np_id = 0; //id tax type "np."
            vm.special_payment = false;

            //form
            vm.form = {
                correction_type: '',
                sale_date: vm.today,
                issue_date: vm.today,
                price_net: '',
                price_gross: '',
                vat_sum: '',
                payment_term_days: '',
                contractor_id: null,
                payment_method_id: '',
                bank_account_id: '',
                invoice_type_id: '',
                gross_counted: true,
                corrected_invoice_id: '',
                delivery_address_id: -1,
                default_delivery: false,
                mpp: false,
                gtu: [],
                currency: '',
                invoice_registry_id: 0,
                description: '',
                invoice_margin_procedure_id: 0,
                invoice_reverse_charge_id: 0,
                invoice_margin: 0,
                invoice_margin_proforma: 0,
                invoice_margin_correction: 0,
                items: [],
                taxes: []
            };

            vm.round = round;
            vm.responseError = responseError;
            vm.searchContractor = searchContractor;
            vm.searchProducts = searchProducts;
            vm.clearCustomName = clearCustomName;
            vm.changeContractorDelivery = changeContractorDelivery;
            vm.changeSpecialPayment = changeSpecialPayment;
            vm.selectedAutocompleteProduct = selectedAutocompleteProduct;
            vm.addNewProduct = addNewProduct;
            vm.selectedAutocompleteContractor = selectedAutocompleteContractor;
            vm.addNewContractor = addNewContractor;
            vm.addProduct = addProduct;
            vm.deleteProduct = deleteProduct;
            vm.productWatch = productWatch;
            vm.getGtuProductLabel = getGtuProductLabel;
            vm.getGtuProcedureLabel = getGtuProcedureLabel;
        }

        /**
         * return new item object
         */
        function getNewObjItem() {
            return {
                current_service: null,
                search_text: '',
                watch: null,
                company_service_id: '',
                service_unit: null,
                service_unit_id: '',
                custom_name: '',
                custom_name_enable: false,
                price_net: 0,
                price_net_sum: 0,
                price_gross: 0,
                price_gross_sum: 0,
                vat_rate_id: null,
                vat_sum: '',
                quantity: 1
            };
        }

        /**
         * return new tax object
         */
        function getNewObjTax() {
            return {
                price_net: 0,
                price_gross: 0,
                vat_rate_id: ''
            }
        }

        /**
         * Round to 2 decimal places
         *
         * @param number
         * @returns {number}
         */
        function round(number) {
            if (isNaN(number))
                return 0;
            return Math.round(number * 100) / 100;
        }

        /**
         * show response error
         */
        function responseError() {
            vm.msg_error = transService.translate('ERRORS.RESPONSE');
        }

        /**
         * get contractors list for autocomplete
         *
         * @param name
         */
        function searchContractor(name) {
            return api.contractors.get({
                    limit: 15,
                    page: 1,
                    search: name
                }
            ).$promise.then(function (response) {
                return response.data;
            });
        }

        /**
         * get products list for autocomplete
         *
         * @param name
         */
        function searchProducts(name) {
            return api.products.get({
                    limit: 15,
                    page: 1,
                    name: name
                }
            ).$promise.then(function (response) {
                return response.data;
            });
        }

        /**
         * Clear custom item name
         *
         * @param item
         */
        function clearCustomName(item) {
            item.custom_name = '';
            item.custom_name_enable = false;
        }

        /**
         * load margin procedures
         */
        function getMarginProcedures() {
            api.invoiceMarginProcedures.get({}, function (response) {
                vm.margin_procedures = response.data;
            }, responseError);
        }

        /**
         * load reverse changes
         */
        function getReverseChanges() {
            api.invoiceReverseCharges.get({}, function (response) {
                vm.reverse_changes = response.data;
            }, responseError);
        }

        /**
         * load all currencies
         */
        function getCurrencies() {
            api.currencies.get({}, function (response) {
                vm.currencies = response.data.filter(function(currency) {
                    return currency.code !== 'PLN';
                });
            }, responseError);
        }

        /**
         * load invoice formats and invoice registry with callback
         *
         * @param callback
         */
        function getInvoiceSettingAndFormats(callback) {
            //registry
            api.invoiceFormats.get({}, function (response) {

                angular.forEach(response.data, function (value) {
                    vm.invoice_formats[value.id] = value;
                });

                api.invoiceSettings.get({}, function (response) {
                    vm.registries = response.data.invoice_registries.data;

                    if (typeof callback != 'undefined') {
                        callback();
                    }

                }, responseError);

            }, responseError);
        }

        /**
         * run before change contractor delivery - set default delivery address
         */
        function changeContractorDelivery() {
            if (vm.delivery_contractor && vm.delivery_contractor.addresses.data && vm.delivery_contractor.addresses.data.length > 0) {
                vm.form.delivery_address_id = -1;
                angular.forEach(vm.delivery_contractor.addresses.data, function (obj) {
                    if (obj.default) {
                        vm.form.delivery_address_id = obj.id;
                    }
                });
                if (vm.form.delivery_address_id == -1) {
                    vm.form.delivery_address_id = vm.delivery_contractor.addresses.data[0].id;
                }
            }
        }

        /**
         * run before change special payment - clear or add structure for partial payments
         */
        function changeSpecialPayment() {
            if (vm.special_payment) {
                vm.form.special_payment = {
                    amount: '',
                    payment_method_id: null
                }
            } else {
                delete vm.form.special_payment;
            }
        }

        /**
         * select field item autocomplete (onclick)
         * save id for adding new product
         *
         * @param index
         */
        function selectedAutocompleteProduct(index) {
            add_product_id = index;
        }

        /**
         * Open modal for add new product from field autocomplete
         * if product added then set current_service for selected field
         */
        function addNewProduct() {
            dialogService.customDialog(null, 'ProductsFormController', 'app/main/products/form/modal.html', null, function (data) {
                vm.form.items[add_product_id].current_service = data;
            });
        }

        /**
         * select field contractor autocomplete (onclick)
         * save id for adding new contractor
         *
         * @param index
         */
        function selectedAutocompleteContractor(index) {
            add_contractor_id = index;
        }

        /**
         * Open modal for add new product from field autocomplete
         * if contractor added then set contractor or delivery_contractor
         */
        function addNewContractor() {

            //get search text and if this is nip then save to local storage for use in form adding contractor
            var text = vm.search_text_delivery_contractor;
            if (add_contractor_id == 'contractor') {
                text = vm.search_text_contractor;
            }

            var re = /^((\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3})|([0-9]{10}))$/;
            var found = text.match(re);

            if (found) {
                $window.localStorage.nip_new_contractor = text;
            }

            dialogService.customDialog(null, 'ContractorsFormController', 'app/main/contractors/form/modal.html', null, function (data) {
                if (add_contractor_id == 'contractor') {
                    vm.contractor = data;
                } else {
                    vm.delivery_contractor = data;
                }
            });
        }

        /**
         * set payment date
         *
         * @param payment_term_days
         */
        function setPaymentDate(payment_term_days) {
            vm.payment_date = moment(vm.form.issue_date).add(payment_term_days, 'days').format('YYYY-MM-DD');
        }

        /**
         * set payment date according to conditions
         */
        function setPaymentDateFull() {
            if (vm.current_method && vm.contractor && vm.company) {
                if (['gotowka', 'karta', 'payu'].indexOf(vm.current_method.slug) == -1) {
                    if (vm.contractor.default_payment_term_days) {
                        setPaymentDate(vm.contractor.default_payment_term_days);
                    } else {
                        setPaymentDate(vm.company.default_payment_term_days);
                    }
                } else {
                    setPaymentDate(0);
                }
            }
        }

        /**
         * Add new empty product to items list
         *
         * @returns {number}
         */
        function addProduct() {
            vm.form.items.push(getNewObjItem());

            var index = vm.form.items.length - 1;

            if (vm.type == 'margin' || vm.type == 'reverse_charge' || vm.type == 'currency_reverse_charge' || vm.type == 'margin_proforma' || !$rootScope.vat_payer) {
                vm.form.items[index].vat_rate_id = vm.tax_type_np_id;
            }

            /**
             * change product
             */
            vm.form.items[index].watch = productWatch(index);

            return vm.form.items.length - 1;
        }

        /**
         * Delete selected product
         *
         * @param index
         */
        function deleteProduct(index) {
            //stop watching
            angular.forEach(vm.form.items, function (item) {
                if (item.watch) {
                    item.watch();
                }
            });

            vm.form.items.splice(index, 1);

            $timeout(function () {
                angular.forEach(vm.form.items, function (item, key) {
                    item.watch = vm.productWatch(key);
                });
            });
        }

        /**
         * Run when selected product was changed
         *
         * @param index
         */
        function productWatch(index) {
            return scope.$watchCollection(function () {return vm.form.items[index];},function(new_obj, old_obj){

                if (!vm.is_extra_item && typeof new_obj != 'undefined') {
                    //find changed key
                    var changed_key = null;
                    angular.forEach(new_obj, function (value, key) {
                        if (value != old_obj[key] && !changed_key) {
                            //permitted keys
                            if (['current_service', 'price_net', 'price_gross', 'vat_rate_id', 'quantity', 'service_unit_id'].indexOf(key) > -1) {
                                changed_key = key;
                            }
                        }
                    });


                    //change service
                    //set company_service_id, vat_rate_id, service_unit_id, service_unit, price_gross/price_net
                    if (new_obj.current_service && changed_key == 'current_service') {
                        //change service
                        new_obj.company_service_id = new_obj.current_service.id;

                        if (!old_obj.current_service || new_obj.current_service.id != old_obj.current_service.id) {

                            //service_unit_id, service_unit
                            new_obj.service_unit_id = new_obj.current_service.service_unit_id;
                            angular.forEach(vm.units, function (item) {
                                if (item.id == new_obj.service_unit_id)
                                    new_obj.service_unit = item;
                            });

                            //vat_rate_id, price_gross, price_net
                            if (vm.type != 'margin' && vm.type != 'reverse_charge' && vm.type != 'currency_reverse_charge' && vm.type != 'margin_proforma') {

                                if ($rootScope.vat_payer) {
                                    new_obj.vat_rate_id = new_obj.current_service.vat_rate_id;
                                }

                                if (vm.form.gross_counted) {
                                    new_obj.price_gross = new_obj.current_service.price_gross;
                                } else {
                                    new_obj.price_net = new_obj.current_service.price_net;
                                }
                            } else {
                                if (vm.form.gross_counted) {
                                    new_obj.price_gross = new_obj.current_service.price_net;
                                } else {
                                    new_obj.price_net = new_obj.current_service.price_net;
                                }
                            }
                        }
                    }

                    //set service_unit when changed service_unit_id
                    if (changed_key == 'service_unit_id') {
                        angular.forEach(vm.units, function (item) {
                            if (item.id == new_obj.service_unit_id)
                                new_obj.service_unit = item;
                        });
                    }

                    //set price_gross_sum, price_gross_sum, price_net, price_gross, vat_sum
                    if (new_obj.current_service && typeof new_obj.quantity != 'undefined' && new_obj.quantity > 0 && new_obj.vat_rate_id) {

                        var vat = vm.taxes[new_obj.vat_rate_id].rate;

                        //run only for selected variables
                        if (vm.form.gross_counted) {
                            new_obj.price_gross_sum = vm.round(new_obj.price_gross * new_obj.quantity);
                            new_obj.price_net = vm.round(new_obj.price_gross / (1 + (vat / 100) ));
                            new_obj.price_net_sum = vm.round(new_obj.price_gross_sum / (1 + (vat / 100) ));
                        } else {
                            new_obj.price_net_sum = vm.round(new_obj.price_net * new_obj.quantity);
                            new_obj.price_gross = vm.round(new_obj.price_net * (1 + (vat / 100) ));
                            new_obj.price_gross_sum = vm.round(new_obj.price_net_sum * (1 + (vat / 100) ));
                        }

                        new_obj.vat_sum = vm.round(new_obj.price_gross_sum - new_obj.price_net_sum);

                        calculate();
                    }
                }
            });
        }

        /**
         * Calculate global taxes, price_gross, price_net
         */
        function calculate() {

            //calculate all types taxes and price_gross/price_net in this types
            vm.form.taxes = [];

            angular.forEach(vm.form.items, function (item) {

                //add value to tax
                var found = false;
                angular.forEach(vm.form.taxes, function (value, key) {
                    if (item.vat_rate_id != null && item.vat_rate_id == value.vat_rate_id) {
                        if (vm.form.gross_counted) {
                            value.price_gross += item.price_gross_sum;
                        } else {
                            value.price_net += item.price_net_sum;
                        }

                        found = true;
                    }
                });

                //new tax
                if (!found && item.vat_rate_id != null) {

                    var new_tax = getNewObjTax();
                    new_tax.vat_rate_id = item.vat_rate_id;
                    if (vm.form.gross_counted) {
                        new_tax.price_gross = item.price_gross_sum;
                    } else {
                        new_tax.price_net = item.price_net_sum;
                    }

                    vm.form.taxes.push(new_tax);
                }
            });

            //global sum price_net, price_gross, vat_sum
            vm.form.price_net = 0;
            vm.form.price_gross = 0;
            vm.form.vat_sum = 0;
            if (vm.form.gross_counted) {
                angular.forEach(vm.form.taxes, function (value) {
                    value.price_net = vm.round(value.price_gross / (1 + (vm.taxes[value.vat_rate_id].rate / 100) ));
                    vm.form.price_net += value.price_net;
                    vm.form.price_gross += value.price_gross;
                    vm.form.vat_sum += vm.round((value.price_gross - value.price_net));
                });
            } else {
                angular.forEach(vm.form.taxes, function (value) {
                    value.price_gross = vm.round(value.price_net * (1 + (vm.taxes[value.vat_rate_id].rate / 100) ));
                    vm.form.price_net += value.price_net;
                    vm.form.price_gross += value.price_gross;
                    vm.form.vat_sum += vm.round((value.price_gross - value.price_net));
                });
            }
        }

        /**
         * @param {object} company
         * @param {int} bank account id
         */
        function setBankAccount(company, bank_account) {
            if (bank_account && bank_account.data) {
                vm.form.bank_account_id = bank_account.data.id;
            } else if (company.bank_accounts) {
                // set default bank account
                angular.forEach(company.bank_accounts.data, function (bank_account) {
                    if (bank_account.default == true) {
                        vm.form.bank_account_id = bank_account.id;
                    }
                });
            }
        }

        function getGtuItems() {
            vm.gtu_product_items = [];
            vm.gtu_procedure_items = [];
            api.gtu.get({}, function (response) {
                angular.forEach(response.data, function (item) {
                    if (item.id.indexOf('gtu-') !== -1) {
                        vm.gtu_product_items.push(item);
                    } else {
                        vm.gtu_procedure_items.push(item);
                    }
                });
                vm.gtu_procedure_items.sort(function (a, b) {
                    return a.id === 'mpp' ? -1 : 1;
                });
            });
        }

        function getGtuProductLabel() {
            return getGtuLabel(vm.form.gtu, vm.gtu_product_items, 'INVOICES_FORM.GTU_PRODUCT');
        }

        function getGtuProcedureLabel() {
            return getGtuLabel(vm.form.gtu, vm.gtu_procedure_items, 'INVOICES_FORM.GTU_PROCEDURE');
        }

        function getGtuLabel(selected, list, label) {
            if (!selected || !list) {
                return transService.translate(label);
            }
            var result = '';
            list.forEach(function (gtu) {
                if (selected.indexOf(gtu.id) !== -1) {
                    if (result.length > 1) {
                        result += ', '
                    }
                    result += gtu.name;
                }
            });
            return result.length ? result : transService.translate(label);
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.home', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.home', {
            url      : '/',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/home/home.html',
                    controller : 'HomeController as vm'
                }
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.home')
        .controller('HomeController', HomeController);

    /** @ngInject */
    function HomeController()
    {

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.dashboard', {
            url      : '/dashboard',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/dashboard/dashboard.html',
                    controller : 'DashboardController as vm'
                }
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController(transService, $auth, $location, $window, $httpParamSerializer)
    {
        var vm = this;
        transService.loadFile('main/dashboard');

        vm.role = '';
        vm.open = open;
        vm.csvInvoices = csvInvoices;

        function open(url) {
            $location.url('url');
        }

        $auth.getMyRole(function (role) {
            vm.role = role;
        })


        function csvInvoices() {

            var month =  moment().format('M');
            var params = $httpParamSerializer({
                year: month == 1 ? moment().format('YYYY') - 1 : moment().format('YYYY'),
                month: month == 1 ? 12 : month - 1
            });
            $window.open(
                __env.apiUrl + 'reports/invoices-registry-pdf?' + params +
                '&token=' + $window.localStorage.token +
                '&selected_company_id=' + $auth.getCurrentCompany(),
                '_blank');
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.calendar')
        .directive('dragDropCalendar', dragDropCalendarDirective);

    /** @ngInject */
    function dragDropCalendarDirective($parse, $filter)
    {
        return {
            scope: { drop: '&' },
            link:function(scope,element){
                element.attr("draggable", "true");
                element.on('dragover', function(event) {
                    event.preventDefault();
                });
                element.on('drop', function(event) {
                    event.preventDefault();
                    var data = event.originalEvent.dataTransfer.getData("id");
                    var arr = data.split('-"');
                    var from = {
                        id: arr[0],
                        date: $filter('date')(arr[1].split('"')[0], 'yyyy-MM-dd')
                    };

                    arr = event.target.id.split('-"');
                    var to = {
                        id: arr[0],
                        date: $filter('date')(arr[1].split('"')[0], 'yyyy-MM-dd')
                    };

                    scope.drop({from: from, to: to});
                });
                element.on('dragstart', function(event) {
                    event.originalEvent.dataTransfer.setData("id",event.target.id);
                    scope.$apply();
                });
            }

        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.calendar')
        .factory('calendarService', calendarService);

    /** @ngInject */
    function calendarService($filter)
    {
        var service = {
            getDates: getDates,
            isFutureDate: isFutureDate,
            makeFormatedDate: makeFormatedDate,
            getEvents: getEvents
        };

        return service;

        /**
         * Prepare dates for calendar
         * It get start and end dates from backend and prepare array with dates for view
         *
         * @param apiData {object} data from api
         * @param toString {boolean} describe if array item must be string or object
         * @returns {Array}
         */
        function getDates(apiData) {
            var startDay = apiData.date_start.split('-');
            var firstDate = new Date(apiData.date_start)
            var secondDate = new Date(apiData.date_end)
            var days = datesCount(firstDate, secondDate);
            var dates = [];

            for (var i = 0; i < days; i++) {
                // create start date from first day
                // - 1 must exists to set correct month
                var newDate = new Date(startDay[0], startDay[1] - 1, startDay[2]);
                newDate.setDate(newDate.getDate() + i);
                dates.push(newDate);
            }

            return dates;
        }

        function isFutureDate(date) {
            var currentDate = makeFormatedDate();
            var pickedDate =  $filter('date')(date, 'yyyy-MM-dd');

            // console.log(currentDate);
            // console.log(pickedDate);



            return pickedDate >= currentDate;
        }

        function makeFormatedDate(date)
        {
            var dateObject =  date ? new Date(date) : new Date();

            return dateObject.toISOString().slice(0, 10);
        }

        function datesCount(startDate, endDate) {
            var count = 0;
            var curDate = startDate;
            while (curDate <= endDate) {
                count++;
                curDate.setDate(curDate.getDate() + 1);
            }

            return count;
        }


        /**
         * Get current user availabilities from selected day
         *
         * @param  user
         * @param day
         * @return {array|*}
         */
        function getEvents(dataArray, user, day) {
            var user = dataArray.filter(function (el) {
                return el.id === user.id;
            });

            var availabilities = user[0].availabilities.data.filter(function (el) {
                return el.day === day;
            });

            return availabilities;
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.calendar')
        .controller('CalendarController', CalendarController);

    /** @ngInject */
    function CalendarController($mdDialog, $document, $filter, api, calendarService, transService, $auth)
    {
        var vm = this;
        transService.loadFile('main/calendar');

        // assign data from resource users
        vm.currentUser = {};
        vm.users = [];
        vm.dates = null;
        vm.errorsBag = [];
        vm.temp = {};
        vm.currentDate = '';
        vm.reasons = ['holidays', 'sick_note', 'day_off'];

        // Methods
        vm.showEventsModal = showEventsModal;
        vm.getPrev = getPrev;
        vm.getNext = getNext;
        vm.getToday = getToday;
        vm.drop = drop;
        vm.moment = moment;

        init();

        function init() {
            $auth.getUser(function (user) {
                vm.currentUser = user;

                if (vm.currentDate != '') {
                    getEvents(vm.currentDate);
                } else {
                    getEvents(moment().format('YYYY-MM-DD'));
                }
            });
        }

        function getEvents(start_date) {
            
            vm.currentDate = start_date;
            var date = calendarService.makeFormatedDate(start_date);
            api.calendar.users.get({from: date}, function (response) {
                vm.users = response.data;
                vm.dates = calendarService.getDates(response);
            });
        }

        function getPrev() {
            getEvents(moment(vm.currentDate, 'YYYY-MM-DD').add(-7, 'days').format('YYYY-MM-DD'));
        }

        function getNext() {
            getEvents(moment(vm.currentDate, 'YYYY-MM-DD').add(7, 'days').format('YYYY-MM-DD'));
        }

        function getToday() {
            getEvents(moment().toString());
        }

        function drop(from, to) {

            //access admin
            if (parseInt(to.id) != vm.currentUser.id && -1 == ["admin", "owner"].indexOf(vm.currentUser.selected_user_company.data.role.data.name)) return;

            angular.forEach(vm.users, function (user) {
                if (user.id == from.id) {

                    var events = [];

                    angular.forEach(user.availabilities.data, function (date) {
                        if (date.day == from.date) {
                            var temp_date = {};
                            angular.copy(date, temp_date);
                            temp_date['day'] = to.date;
                            events.push(temp_date);
                        }
                    });

                    api.calendar.userAvailabilities.save(
                        {
                            user: to.id,
                            day: to.date,
                            availabilities: events
                        },
                        // success
                        function () {
                            init();
                        }
                    );

                }
            });
        }

        /**
         * Show add event modal
         *
         * @param e
         * @param  user user object
         * @param  day day object
         */
        function showEventsModal(e, user, day, errors) {

            // Can't modify other users unless you are admin
            // Can't modify past days
            if (user.id != vm.currentUser.id && -1 == ["admin", "owner"].indexOf(vm.currentUser.selected_user_company.data.role.data.name)) return;
            if(! calendarService.isFutureDate(day)) return;

            day = $filter('date')(day, 'yyyy-MM-dd');

            var data = {
                user: user,
                day: day,
                currentEvents: calendarService.getEvents(vm.users, user, day),
                errors: errors
            };

            vm.temp = {
                event: e,
                user: user,
                day: day
            }

            showEventFormDialog(e, data);
        }

        /**
         * Show event add/edit form dialog
         *
         * @param e
         * @param data
         */
        function showEventFormDialog(e, data)
        {

            var modalData = {
                controller         : 'EventFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/calendar/dialogs/event-form/event-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: angular.copy(data)
                }
            };

            $mdDialog
                .show(modalData)
                .then(function (response) {
                    addEvent(response);
                });
        }

        /**
         * Add new event to the array
         *
         * @param  data
         */
        function addEvent(responseData) {

            api.calendar.userAvailabilities.save(
                {
                    user: responseData.user.id,
                    day: responseData.day,
                    availabilities: responseData.events,
                },
                // success
                function () {
                    // update view
                    init();
                },
                // error
                function (response) {
                    var object = response.data.fields;

                    for (var property in object) {
                        if (object.hasOwnProperty(property)) {
                            for (var i = 0; i < object[property].length; i++) {
                                vm.errorsBag.push(object[property][i]);
                            }
                        }
                    }

                    showEventsModal(vm.temp.event, vm.temp.user, vm.temp.day, vm.errorsBag);
                }
            );
        }



    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('zipCode', zipCodeDirective);

    /** @ngInject */
    function zipCodeDirective()
    {
        return {
            require: 'ngModel',
            link: function (scope, element) {
                element.on('keyup', function(event) {
                    if (event.which != 8) {

                        if (element.val().length == 3 && event.keyCode != 173 && event.keyCode != 109) {
                            scope.$apply(function () {
                                element.val(element.val()[0] + element.val()[1] + '-' + element.val()[2]);
                            });
                        }
                    }
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('$multipartForm', function () {
            var MultipartForm = function (url, $http) {
                this.url = url;
                this.http = $http;

                this.save = function (form, success, error, progress) {
                    request('POST', form, success, error, progress);
                };

                this.put = function (form, success, error, progress) {
                    request('PUT', form, success, error, progress);
                };

                function request(method, form, success, error, progress) {
                    var new_url = url;
                    angular.forEach(form, function (value, key) {
                        new_url = new_url.replace(':' + key, value);
                    });

                    form._method = method;
                    var fd = objectToFormData(form, new FormData());

                    $http({
                        method: "POST",
                        url: new_url,
                        data: fd,
                        transformRequest: angular.identity,
                        headers: {'Content-Type': undefined},
                        uploadEventHandlers: {
                            progress: function (e) {
                                if (progress != undefined) {
                                    progress((e.loaded / e.total) * 100);
                                }
                            }
                        }
                    }).then(
                        function (response) {
                            success(response.data, response.status);
                        },
                        function (response) {
                            error(response.data, response.status);
                        }
                    );
                }

                function objectToFormData(obj, form, namespace) {

                    var fd = form || new FormData();
                    var formKey;

                    for (var property in obj) {
                        if (obj.hasOwnProperty(property) && property != '$$hashKey') {

                            if (namespace) {
                                formKey = namespace + '[' + property + ']';
                            } else {
                                formKey = property;
                            }

                            if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {

                                objectToFormData(obj[property], fd, formKey);

                            } else {

                                var val = obj[property];

                                if (obj[property] === true) {
                                    val = 1;
                                } else if (obj[property] === false) {
                                    val = 0;
                                }

                                fd.append(formKey, val);
                            }
                        }
                    }

                    return fd;
                }
            };

            return {
                getInstance: function (url, $http) {
                    return new MultipartForm(url, $http);
                }
            };
        });
})();

(function ()
{
    'use strict';
    angular
        .module('app.core')
        .directive('fileread', msFilereadDirective);

    /** @ngInject */
    function msFilereadDirective()
    {
        return {
            scope: {
                fileread: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = loadEvent.target.result;
                        });
                    }
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        }
    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.core')
        .directive('fileModel', fileModelDirective);

    /** @ngInject */
    function fileModelDirective($parse)
    {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;

                element.bind('change', function(){
                    scope.$apply(function(){
                        modelSetter(scope, element[0].files[0]);
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msConfirm', msConfirmDirective);

    /** @ngInject */
    function msConfirmDirective()
    {
        return {
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                var firstInput = '#' + attrs.msConfirm;
                elem.add(firstInput).on('keyup', function () {
                    scope.$apply(function () {
                        var v = elem.val() === $(firstInput).val();
                        ctrl.$setValidity('confirm', v);
                    });
                });
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('logoSqr', logoSqrDirective);

    /** @ngInject */
    function logoSqrDirective(__env)
    {
        return {
            require: 'E',
            template: __env.logo == '' ?
                '<div ng-click="openHome()" class="logo md-accent-bg"><span>F</span></div>' :
                "<div ng-click='openHome()' class='logo-sqr' style='background-image: url(\"/assets/logos/" + __env.logo + "/logo_sqr_t.png\")'></div>"
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('inputClear', inputClearDirective);

    /** @ngInject */
    function inputClearDirective()
    {
        return {
            restrict: 'A',
            compile: function (element, attrs) {
                var action = attrs.ngModel + " = ''";
                element.after(
                    '<md-button class="animate-show md-icon-button"' +
                    'ng-show="' + attrs.ngModel + '" ng-click="' + action + '"' +
                    'style="position: absolute; top: 0px; right: -6px; font-weight: 100">' +
                    '<div >x</div>' +
                    '</md-button>');
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('autocompleteRequired', autocompleteRequiredDirective);

    /** @ngInject */
    function autocompleteRequiredDirective($timeout)
    {
        return {
            restrict: 'A',
            require: '^form',
            link: function (scope, element, attr, ctrl) {
                $timeout(function () {
                    var realModel,
                        elemCtrl = ctrl[attr.mdInputName],
                        realValidation = function (model) {
                            elemCtrl.$setValidity('selectedItem', !!realModel);
                            return model;
                        };
                    if (!!attr.mdSelectedItem && !!attr.mdInputName) {
                        scope.$watchCollection(attr.mdSelectedItem, function (obj) {
                            realModel = obj;
                            realValidation()
                        });
                        elemCtrl.$parsers.push(realValidation);
                    }
                })
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Edge",
                    versionSearch: "Edge",
                    identity     : "Edge"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Chrome",
                    identity : "Chrome"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "OmniWeb",
                    versionSearch: "OmniWeb/",
                    identity     : "OmniWeb"
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : "Apple",
                    versionSearch: "Version",
                    identity     : "Safari"
                },
                {
                    prop    : $window.opera,
                    identity: "Opera"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "iCab",
                    identity : "iCab"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "KDE",
                    identity : "Konqueror"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Firefox",
                    identity : "Firefox"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "Camino",
                    identity : "Camino"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Netscape",
                    identity : "Netscape"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "MSIE",
                    identity     : "Explorer",
                    versionSearch: "MSIE"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Trident/7",
                    identity     : "Explorer",
                    versionSearch: "rv"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Gecko",
                    identity     : "Mozilla",
                    versionSearch: "rv"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Mozilla",
                    identity     : "Netscape",
                    versionSearch: "Mozilla"
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: "Win",
                    identity : "Windows"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Mac",
                    identity : "Mac"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Linux",
                    identity : "Linux"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPhone",
                    identity : "iPhone"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPod",
                    identity : "iPod"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPad",
                    identity : "iPad"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Android",
                    identity : "Android"
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) != -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index == -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || "unknown-browser";
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || "unknown-version";
            var os = searchString(osData) || "unknown-os";

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) == -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter)
        .filter('slice', slice)
        .filter('availability', availability);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

    /** @ngInject */
    function slice()
    {
        return function (arr, start, end)
        {
            return (arr || []).slice(start, end);
        };
    }

    /** @ngInject */
    function availability($filter)
    {
        return function (arr, date)
        {
            var date = $filter('date')(date, 'yyyy-MM-dd');

            return arr.filter(function(el) {
                return el.day == date;
            })
        };
    }

})();
/*
disabled for security (Expression Sandbox Removal)
*/


// (function ()
// {
//     'use strict';
//
//     angular
//         .module('app.core')
//         .directive('hljs', hljsDirective);
//
//     /** @ngInject */
//     function hljsDirective($timeout, $q, $interpolate)
//     {
//         return {
//             restrict: 'EA',
//             compile : function (tElement, tAttrs)
//             {
//                 var code;
//                 //No attribute? code is the content
//                 if ( !tAttrs.code )
//                 {
//                     code = tElement.html();
//                     tElement.empty();
//                 }
//
//                 return function (scope, iElement, iAttrs)
//                 {
//                     if ( iAttrs.code )
//                     {
//                         // Attribute? code is the evaluation
//                         code = scope.$eval(iAttrs.code);
//                     }
//                     var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);
//
//                     $q.when(code).then(function (code)
//                     {
//                         if ( code )
//                         {
//                             if ( shouldInterpolate )
//                             {
//                                 code = $interpolate(code)(scope);
//                             }
//
//                             var contentParent = angular.element(
//                                 '<pre><code class="highlight" ng-non-bindable></code></pre>'
//                             );
//
//                             iElement.append(contentParent);
//
//                             // Defer highlighting 1-frame to prevent GA interference...
//                             $timeout(function ()
//                             {
//                                 render(code, contentParent);
//                             }, 34, false);
//                         }
//                     });
//
//                     function render(contents, parent)
//                     {
//                         var codeElement = parent.find('code');
//                         var lines = contents.split('\n');
//
//                         // Remove empty lines
//                         lines = lines.filter(function (line)
//                         {
//                             return line.trim().length;
//                         });
//
//                         // Make it so each line starts at 0 whitespace
//                         var firstLineWhitespace = lines[0].match(/^\s*/)[0];
//                         var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
//
//                         lines = lines.map(function (line)
//                         {
//                             return line
//                                 .replace(startingWhitespaceRegex, '')
//                                 .replace(/\s+$/, '');
//                         });
//
//                         var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
//                         highlightedCode.value = highlightedCode.value
//                             .replace(/=<span class="hljs-value">""<\/span>/gi, '')
//                             .replace('<head>', '')
//                             .replace('<head/>', '');
//                         codeElement.append(highlightedCode.value).addClass('highlight');
//                     }
//                 };
//             }
//         };
//     }
// })();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $mdSidenav, $translate, $mdToast, $timeout, $auth, $window)
    {
        var vm = this;

        // Data
        // $rootScope.global = {
        //     search: ''
        // };

        vm.bodyEl = angular.element('body');
        // vm.userStatusOptions = [
        //     {
        //         'title': 'Online',
        //         'icon' : 'icon-checkbox-marked-circle',
        //         'color': '#4CAF50'
        //     },
        //     {
        //         'title': 'Away',
        //         'icon' : 'icon-clock',
        //         'color': '#FFC107'
        //     },
        //     {
        //         'title': 'Do not Disturb',
        //         'icon' : 'icon-minus-circle',
        //         'color': '#F44336'
        //     },
        //     {
        //         'title': 'Invisible',
        //         'icon' : 'icon-checkbox-blank-circle-outline',
        //         'color': '#BDBDBD'
        //     },
        //     {
        //         'title': 'Offline',
        //         'icon' : 'icon-checkbox-blank-circle-outline',
        //         'color': '#616161'
        //     }
        // ];
        vm.languages = {
            pl: {
                'title'      : 'Polish',
                'translation': 'TOOLBAR.POLISH',
                'code'       : 'pl',
                'flag'       : 'pl'
            },
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            // es: {
            //     'title'      : 'Spanish',
            //     'translation': 'TOOLBAR.SPANISH',
            //     'code'       : 'es',
            //     'flag'       : 'es'
            // },
            // tr: {
            //     'title'      : 'Turkish',
            //     'translation': 'TOOLBAR.TURKISH',
            //     'code'       : 'tr',
            //     'flag'       : 'tr'
            // }
        };
        vm.currentUser = {};

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            // vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            if (typeof $window.localStorage.language != 'undefined') {
                vm.selectedLanguage = vm.languages[$window.localStorage.language];
            } else {
                vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
            }

            moment.locale(vm.selectedLanguage.code);

            $auth.getUser(function (user) {
                vm.currentUser = user;
            });
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            // if ( lang.code !== 'en' )
            // {
            //     var message = 'CEP supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';
            //
            //     $mdToast.show({
            //         template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
            //         hideDelay: 7000,
            //         position : 'top right',
            //         parent   : '#content'
            //     });
            //
            //     return;
            // }

            // Change the language
            $timeout(function () {
                $translate.use(lang.code);
                moment.locale(vm.selectedLanguage.code);
            });

            $window.localStorage.language = lang.code;
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('transService', transService);

    /** @ngInject */
    function transService($translate, $translatePartialLoader, $window, $timeout, $document, $rootScope)
    {
        var service = {
            getErrorMassage: getErrorMassage,
            loadFile: loadFile,
            translate: translate,
            changeLanguage: changeLanguage
        };


        $rootScope.$on('$translateLoadingStart',function(event) {
            $rootScope.translate_loading = true;
        });

        $rootScope.$on('$translateLoadingEnd',function(event) {
            $rootScope.translate_loading = false;
        });

        return service;

        /**
         * Load translate file
         *
         * @param path
         */
        function loadFile(path) {
            $translatePartialLoader.addPart('app/' +path);
            $translate.refresh();

            $timeout(function () {
                $translate.refresh();
            }, 1000);

            $timeout(function () {
                $translate.refresh();
            }, 3000);

            $timeout(function () {
                $translate.refresh();
            }, 10000);

            //for first load
            $window.onload = function(e) {
                $translate.refresh();
            };

            $document.ready = function(e) {
                $translate.refresh();
            };
        }

        /**
         * return message error from api
         *
         * @param response
         * @returns {string|Object}
         */
        function getErrorMassage(response) {

            try {
                var data = {};
                if (response.hasOwnProperty('data')) {
                    data = response.data;
                } else {
                    data = response;
                }

                var msg = $translate.instant('ERRORS.' + data.code);

                if (msg == 'ERRORS.' + data.code) {
                    return $translate.instant('ERRORS.DEFAULT');
                }

                return msg;

            } catch(e) {
                return $translate.instant('ERRORS.DEFAULT');
            }
        }

        /**
         * return translate string or ''
         *
         * @param name
         * @returns {*}
         */
        function translate(name) {

            var msg = $translate.instant(name);

            if (msg == name) {
                return '';
            }

            return msg;
        }

        /**
         * change language
         * @param code
         */
        function changeLanguage(code) {
            $translate.use(code);
            $window.localStorage.language = code;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('tableService', tableService);

    /** @ngInject */
    function tableService(transService, $timeout)
    {
        var service = {
            setVariables: setVariables,
            scrollToTableTop: scrollToTableTop
        };

        return service;

        function setVariables(vm) {
            vm.promise = null;
            vm.query = {
                sort: '',
                limit: __env.table_limit_rows,
                page: 1
            };
            vm.table_translate = {
                page :transService.translate("PAGINATION.PAGE"),
                rowsPerPage :transService.translate("PAGINATION.ROWS"),
                of :transService.translate("PAGINATION.OF")
            };
        }

        function scrollToTableTop() {
            var contentElement = angular.element('#content');
            var tableElement = angular.element('.md-table');
            if (!tableElement || !tableElement[0] || !contentElement || !contentElement[0]) {
                return;
            }
            // if user arleady see the top of the table
            if (contentElement[0].scrollTop < tableElement[0].offsetTop) {
            return;
            }
            // if table header is not visible - scroll to the top
            $timeout(function () {
                contentElement.animate({
                    scrollTop: tableElement[0].offsetTop - 50
                }, 300);
            }, 100);
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('projectsService', projectsService);

    /** @ngInject */
    function projectsService(msNavigationService, $window)
    {
        var limit = 3;

        var service = {
            addActive: addActive,
            setList: setList,
            deleteListFromMenu: deleteListFromMenu
        };

        return service;

        function addActive(project) {

            var arr_name = 'company_' + $window.localStorage.current_company;

            var projects = [];
            var recentProjects = {data: {}};
            if (typeof $window.localStorage.recentProjects != 'undefined') {
                recentProjects = angular.fromJson($window.localStorage.recentProjects);
                if (typeof recentProjects.data != 'undefined' && typeof recentProjects.data[arr_name] != 'undefined') {
                    projects = recentProjects.data[arr_name];
                }
            }

            //remove if is in recent
            for (var i = projects.length -1; i >= 0; --i) {
                if (projects[i].id == project.id) {
                    projects.splice(i);
                }
            }

            //remove last
            if (projects.length == limit) {
                projects.pop();
            }

            //add
            projects.unshift({id: project.id, name: project.name});
            recentProjects.data[arr_name] = projects;
            $window.localStorage.recentProjects = angular.toJson(recentProjects);

            setList();
        }
        
        function setList() {

            var arr_name = 'company_' + $window.localStorage.current_company;

            deleteListFromMenu();

            if (typeof $window.localStorage.recentProjects != 'undefined') {
                var recentProjects = angular.fromJson($window.localStorage.recentProjects);
                if (typeof recentProjects.data != 'undefined' && typeof recentProjects.data[arr_name] != 'undefined') {
                    var projects = recentProjects.data[arr_name];
                    angular.forEach(projects, function (value, key) {
                        msNavigationService.saveItem('projects.last_' + (key + 1), {
                            title    : value.name,
                            state    : 'app.projects-show',
                            stateParams: {id: value.id},
                            weight   : (key + 1)
                        });
                    });
                }
            }

            msNavigationService.saveItem('projects.all', {
                title    : 'Wszystkie',
                state    : 'app.projects-list',
                translate: 'NAV.PROJECTS.ALL',
                weight   : 10
            });
        }

        function deleteListFromMenu() {
            msNavigationService.deleteItem('projects.all');

            for(var i = 1; i <= limit; ++i) {
                msNavigationService.deleteItem('projects.last_' + i);
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('menu', menu);

    /** @ngInject */
    function menu(msNavigationService, projectsService)
    {

        var service = {
            projects:projects,
            invoices:invoices,
            manageCompany:manageCompany,
    	};

    	return service;

        function projects(show) {
            if (show == "1") {
                msNavigationService.saveItem('projects', {
                    title : 'Projekty',
                    state: '',
                    weight: 1,
                    icon     : 'icon-puzzle',
                    translate: 'NAV.PROJECTS.TITLE'
                });
                msNavigationService.saveItem('calendar', {
                    title : 'Calendar',
                    icon  : 'icon-calendar-today',
                    state : 'app.calendar',
                    translate: 'NAV.CALENDAR',
                    weight: 2
                });
                projectsService.setList();
            } else {
                msNavigationService.deleteItem('projects');
                msNavigationService.deleteItem('calendar');
                projectsService.deleteListFromMenu();
            }
        }

        function invoices(show, receipts) {
            if (show == "1") {
                msNavigationService.saveItem('contractors', {
                    title    : 'Lista kontrchentów',
                    icon     : 'icon-account-multiple',
                    state    : 'app.contractors-list',
                    translate: 'NAV.CONTRACTORS.LIST',
                    weight   : 1
                });
                msNavigationService.saveItem('products', {
                    title    : 'Lista produktów',
                    icon     : 'icon-cube-outline',
                    state    : 'app.products-list',
                    translate: 'NAV.PRODUCTS.LIST',
                    weight   : 2
                });
                msNavigationService.saveItem('invoices', {
                    title    : 'Lista Faktur',
                    icon     : 'icon-file-document',
                    state    : 'app.invoices-list',
                    translate: 'NAV.INVOICES.LIST',
                    weight   : 3
                });
                if (receipts == "1") {
                    msNavigationService.saveItem('receipts-list', {
                        title: 'Lista operacji kasowych',
                        icon: 'icon-receipt',
                        state: 'app.receipts-list',
                        translate: 'NAV.RECEIPTS.LIST',
                        weight: 4
                    });
                }
                msNavigationService.saveItem('online-sales-list', {
                    title    : 'Lista operacji kasowych',
                    icon     : 'icon-web',
                    state    : 'app.online-sales-list',
                    translate: 'NAV.ONLINE_SALES.LIST',
                    weight   : 5
                });
                msNavigationService.saveItem('cash-operations', {
                    title    : 'Lista operacji kasowych',
                    icon     : 'icon-cash-multiple',
                    state    : 'app.cash-operations-list',
                    translate: 'NAV.CACHE_OPERATIONS.LIST',
                    weight   : 6
                });
                msNavigationService.saveItem('registry-sales', {
                    title    : 'Rejestr',
                    icon     : 'icon-cash-usd',
                    state    : 'app.registry-sales',
                    translate: 'NAV.REGISTRY_SALES.LIST',
                    weight   : 7
                });
            } else {
                msNavigationService.deleteItem('contractors');
                msNavigationService.deleteItem('products');
                msNavigationService.deleteItem('invoices');
                msNavigationService.deleteItem('receipts-list');
                msNavigationService.deleteItem('online-sales-list');
                msNavigationService.deleteItem('cash-operations');
                msNavigationService.deleteItem('registry-sales');
            }
        }

        function manageCompany(is_admin) {
            if (is_admin) {
                msNavigationService.saveItem('company', {
                    title    : 'Zarzadzaj firmą',
                    icon     : 'icon-pencil',
                    state    : 'app.company-edit',
                    translate: 'NAV.COMPANY.TITLE',
                    weight   : 1
                });
            } else {
                msNavigationService.deleteItem('company');
            }
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('localStorageService', localStorageService);

    /** @ngInject */
    function localStorageService($window, $timeout)
    {
        return {
            save: save,
            get: get
        };

        function save(key, data) {
            $window.localStorage.setItem(key, JSON.stringify(data));
        }

        function get(key) {
            return JSON.parse($window.localStorage.getItem(key));
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('formService', formService);

    /** @ngInject */
    function formService($timeout, $location)
    {
        var service = {
            formUp: formUp,
            generateForm: generateForm
        };

        return service;

        function formUp() {
            $timeout(function () {
                $location.hash('up');
            });
        }

        function generateForm(form, data, accept_null) {

            if (typeof accept_null == 'undefined') {
                accept_null = false;
            }

            //add fields
            angular.forEach(data, function(value, key) {

                if (form.hasOwnProperty(key)) {

                    if (value == null && !accept_null) {
                        value = '';
                    }

                    //remove data
                    if (value !== null && value.hasOwnProperty('data')) {

                        if (value.data != null && value.data.length != 0) {
                            form[key] = value.data;
                        }

                    } else {
                        form[key] = value;
                    }
                }

            });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('dialogService', dialogService);

    /** @ngInject */
    function dialogService($mdDialog, transService)
    {
        var service = {
            alert: alert,
            confirm: confirm,
            customDialog: customDialog
        };

        return service;

        /**
         *  show alert dialog
         *
         * @param e
         * @param message
         */
        function alert(e, message) {
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(transService.translate(message))
                    .ariaLabel('Alert dialog')
                    .ok('OK')
                    // .targetEvent(e)
            );
        }

        /**
         * show confirm dialog
         *
         * @param e
         * @param question
         * @param ok
         * @param cancel
         * @param translate_yes
         * @param translate_no
         */
        function confirm(e, question, ok, cancel, translate_yes, translate_no) {

            var yes = translate_yes == undefined ? 'OTHER.OK' : translate_yes;
            var no = translate_no == undefined ? 'OTHER.CANCEL' : translate_no;

            var confirm = $mdDialog.confirm()
                .title(transService.translate(question))
                .ariaLabel('Confirm dialog')
                .ok(transService.translate(yes))
                .cancel(transService.translate(no));

            if (e != null) {
                confirm.targetEvent(e)
            }

            $mdDialog.show(confirm).then(
                function() {
                    if (ok != undefined && ok != null)
                        ok()
                },
                function() {
                    if (cancel != undefined && cancel != null)
                        cancel()
                }
            );
        }

        /**
         * show custom dialog
         *
         * @param e
         * @param name_controller
         * @param html_file
         * @param items
         * @param closure_with_response
         * @param closure_without_response
         * @param closure_finally
         */
        function customDialog(e, name_controller, html_file, items, closure_with_response, closure_without_response, closure_finally) {

            if (items == undefined) {
                items = null;
            }

            $mdDialog.show({
                controller: name_controller,
                controllerAs: 'vm',
                templateUrl: html_file,
                parent: angular.element(document.body),
                targetEvent: e,
                clickOutsideToClose:true,
                fullscreen: true,
                locals: items
            }).then(
                function(response) {
                    if (closure_with_response != undefined && closure_with_response != null)
                        closure_with_response(response);
                },
                function() {
                    if (closure_without_response != undefined && closure_without_response != null)
                        closure_without_response()
                }
            ).finally(function() {
                if (closure_finally != undefined && closure_finally != null)
                    closure_finally();
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('$auth', auth);

    /** @ngInject */
    function auth($location, api, $window, $timeout, $rootScope, $state, menu)
    {
        var user = null;
        var settings = {};
        var companies = [];
        var current_company = 0;
        var current_package = null;

        $rootScope.logout = logout;

        var service = {
            check: check,
            login: login,
            redirectToDashboard: redirectToDashboard,
            redirectTo: redirectTo,
            refreshUser: refreshUser,
            getUser: getUser,
            getMyRole: getMyRole,
            refreshCurrentPackage: refreshCurrentPackage,
            getCurrentPackage: getCurrentPackage,
            getSettings: getSettings,
            refreshSettings: refreshSettings,
            refreshCompanies: refreshCompanies,
            getCompanies: getCompanies,
            setCurrentCompany: setCurrentCompany,
            getCurrentCompany: getCurrentCompany,
            checkAccess : checkAccess,
    	};

    	return service;

        /**
         * Check if user is logged in
         *
         * @return boolean
         */
        function check() {
            return typeof $window.localStorage.token !== 'undefined';
        }

        /**
         * login and get user data, and redirect to dashboard
         *
         * @param token
         */
        function login(token)
        {
            $window.localStorage.token = token;
            return redirectTo('/company/my-list');
        }

        /**
         * logout
         */
        function logout(without_request)
        {
            delete $window.localStorage.current_company;

            if (without_request === true) {
                delete $window.localStorage.token;
                user = null;
                $window.location.reload();
            } else {
                api.auth.authenticate.delete($window.localStorage.token,
                    // success
                    function () {
                        delete $window.localStorage.token;
                        user = null;
                        $window.location.reload();
                    },
                    // error
                    function () {
                        delete $window.localStorage.token;
                        user = null;
                        $window.location.reload();
                    }
                );
            }
        }

        /**
         * Redirect to dashboard
         */
        function redirectToDashboard() {
            getSettings(function (settings) {
                redirectTo($state.href(settings['general.welcome_url']));
            });
        }

        /**
         * Redirect User to given path
         *
         * @param  string path
         * @return Redirect
         */
    	function redirectTo(path) {
    		return $location.path(path);
    	}

        /**
         * refresh data user
         *
         * @param closure
         */
        function refreshUser(closure) {

            if (check()) {
                api.auth.currentUser.get({}, function (response) {
                    user = response.data;
                    closure(user);
                });
            }
        }

        /**
         * get data user
         *
         * @param closure
         */
        function getUser(closure) {
            if (user == null) {
                refreshUser(closure);
            } else {
                closure(user);
            }
        }

        /**
         * get current user role
         *
         * @param calback
         */
        function getMyRole(calback) {
            getUser(function (user) {
                if (user.selected_user_company.data) {
                    calback(user.selected_user_company.data.role.data.name)
                } else {
                    calback('');
                }
            });
        }

        /**
         * refresh current package
         *
         * @param closure
         */
        function refreshCurrentPackage(closure) {
            api.currentCompany.get({}, function (response) {

                $rootScope.packageExpires = null;

                var real_package = response.data.real_package.data;
                var diff = moment(real_package.expires_at, "YYYY-MM-DD HH:mm:ss").diff(moment(), 'seconds');
                if (real_package.expires_at == null || diff > 0) {
                    $rootScope.packageName = real_package.slug;
                    $rootScope.packageExpires = real_package.expires_at;
                    if (real_package.expires_at) {
                        $rootScope.packageExpires = real_package.expires_at.split(' ')[0];
                    }
                }

                if (real_package.slug == null) {
                    $rootScope.packageName = 'start';
                }

                if (typeof closure != 'undefined') {
                    closure($rootScope.packageName);
                }
            });
        }

        /**
         * get current package
         *
         * @param closure
         */
        function getCurrentPackage(closure) {
            if (!current_package) {
                refreshCurrentPackage(closure);
            } else {
                closure(current_package);
            }
        }
        /**
         * refresh data company
         *
         * @param closure
         */
        function refreshCompanies(closure) {
            if (check()) {
                api.companyMyList.get({}, function (response) {
                    companies = response.data;
                    closure(companies);
                });
            }
        }

        /**
         * get data company
         *
         * @param closure
         */
        function getCompanies(closure) {
            if (!companies.length) {
                refreshCompanies(closure);
            } else {
                closure(companies);
            }
        }

        /**
         * refresh data settings
         *
         * @param closure
         */
        function refreshSettings(closure) {
            api.currentCompany.get({}, function (response) {
                settings = {};
                angular.forEach(response.data.app_settings, function (value) {
                    settings[value.slug] = value.value;
                });

                closure(settings);
            });
        }

        /**
         * get data settings
         *
         * @param closure
         */
        function getSettings(closure) {
            if (!settings.length) {
                refreshSettings(closure);
            } else {
                closure(settings);
            }
        }

        /**
         * set current company
         * @param id
         * @param closure
         */
        function setCurrentCompany(id, closure) {
            current_company = id;
            $window.localStorage.current_company = id;
            current_package = null;
            refreshCurrentPackage(function () {});
            $rootScope.button_change_packet = false;

            refreshUser(function (user) {

                menu.manageCompany(-1 < ["admin", "owner"].indexOf(user.selected_user_company.data.role.data.name));
                menu.projects(false);
                menu.invoices(false, false);

                refreshSettings(function (settings) {
                    $rootScope.show_companies_list = settings['general.companies.visible'] == "1";
                    menu.projects(settings['projects.active']);
                    menu.invoices(settings['invoices.active'], settings['receipts.active']);
                });

                //show invite  tax office button
                if (["admin", "owner"].indexOf(user.selected_user_company.data.role.data.name) > -1) {
                    $rootScope.show_tax_office_button = false;
                    $rootScope.button_change_packet = true;
                    api.roles.get({}, function (response) {
                        var tax_office_id = -1;
                        angular.forEach(response.data, function (value) {
                            if (value.name == 'tax_office') {
                                tax_office_id = value.id;
                            }
                        });
                        api.company.users.get(function (response) {
                            $rootScope.show_tax_office_button = true;
                            angular.forEach(response.data, function (value) {
                                if (value.company_role_id == tax_office_id) {
                                    $rootScope.show_tax_office_button = false;
                                }
                            })
                        })
                    });
                }
                
                if (typeof closure != 'undefined') {
                    closure();
                }
            });
        }

        /**
         * get current company
         * @param id
         */
        function getCurrentCompany() {
            return current_company;
        }

        /**
         * check access to page and redirect
         *
         * @param url
         */
        function checkAccess(url) {

            if (url.indexOf('error') > -1 || url.indexOf('page') > -1 ) {
                return;
            }

            // redirect user to login page if not logged
            if(url.indexOf('guest') === -1) {

                if (!check()) {
                    if (url == '/register') {
                        $timeout(function () {
                            redirectTo('/guest/register');
                        });
                    } else {
                        $timeout(function () {
                            redirectTo('/guest/login');
                        });
                    }
                } else if (url == '/') {
                    $timeout(function () {
                        redirectToDashboard();
                    });
                } else {
                    //user is in companies
                    getCompanies(function (companies) {

                        //set companies
                        if (current_company == 0) {
                            if ($window.localStorage.current_company != undefined){
                                setCurrentCompany($window.localStorage.current_company);
                            } else if (companies.length == 1) {
                                setCurrentCompany(companies[0].id);
                            }
                        }

                        $rootScope.show_projects_buttons = (url.indexOf('projects') == 1 && url.indexOf('/projects/list') != 0);

                        if ((url.indexOf('company') != 1 ) && url.indexOf('user-edit') != 1 && current_company == 0) {
                            $timeout(function () {
                                redirectTo('/company/my-list');
                            });
                        }
                        if ((url.indexOf('company/edit') == 1 ) && current_company == 0) {
                            $timeout(function () {
                                redirectTo('/company/my-list');
                            });
                        }
                        getUser(function (user) {
                            //for employee
                            if (url.indexOf('company/edit') == 1  && user.selected_user_company.data.role.data.name == 'employee') {
                                redirectTo('/error-403');
                            }
                        });

                        angular.forEach(companies, function (value) {
                            if (value.id == current_company) {
                                if ($rootScope.current_company_nip !== value.vatin) {
                                    $rootScope.current_company_nip = value.vatin;

                                    api.invoiceSettings.get({}, function (response) {
                                        $rootScope.vat_payer = response.data.vat_payer;
                                    });
                                }
                            }
                        })

                    });
                }

            } else if (url.indexOf('guest') > -1 && check()) {
                $timeout(function () {
                    redirectToDashboard();
                });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('authInterceptor', authInterceptor);

    /** @ngInject */
    function authInterceptor($rootScope, $q, $window, $location) {
        var service = {
            request: request,
            response: response,
            responseError: responseError
        };

        return service;

        function request(config) {
            config.headers = config.headers || {};
            if ($window.localStorage.token) {
                if (config.headers.Authorization != false) {
                    config.headers.Authorization = 'Bearer ' + $window.localStorage.token;
                }

                //params - selected_company_id if is not file and has current_company
                var parts = config.url.split('/');
                if (parts.length && parts[parts.length - 1].indexOf('.') == -1 && $window.localStorage.current_company != undefined){
                    config.params = config.params || {};
                    config.params.selected_company_id = $window.localStorage.current_company;
                }
            }

            return config;
        }

        function response(response) {
            if (response.headers('Authorization') != null) {
                $window.localStorage.token = response.headers('Authorization').replace('Bearer ', '');
            }

            return response || $q.when(response);
        }

        function responseError(response) {

            //logout
            try {
                if (($location.path().indexOf('guest') === -1 && typeof $window.localStorage.token === 'undefined') || (response.status === 400 && response.data.code.indexOf('auth.expired_token') != -1)) {
                    $rootScope.logout(true);
                }
            } catch (e) {
                $rootScope.logout(true);
            }

            if (response.status === 401 && typeof $window.localStorage.token !== 'undefined') {
                try {
                    if (response.data.code.toUpperCase().indexOf('NO_PERMISSION') == -1 && response.data.code.indexOf('no_action_permission') == -1) {
                        $rootScope.logout(true);
                    }
                } catch (e) {
                    $rootScope.logout(true);
                }
            }

            //error 5xx
            if (response.status / 500 == 1) {
                window.location.href = '/error-500';
            }

            return $q.reject(response);
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiErrorsService', apiErrorsService);

    /** @ngInject */
    function apiErrorsService(transService)
    {
        var service = {
            show: show,
            clear: clear,
            isError: isError
        };

        return service;


        /**
         * show errors
         *
         * @param form_id
         * @param response
         * @param vm
         * @param custom_names
         */
        function show(form_id, response, vm, custom_names) {

            var data = {};
            if (response.hasOwnProperty('data')) {
                data = response.data;
            } else {
                data = response;
            }

            vm.msg_error = transService.getErrorMassage(data);

            angular.forEach(data.fields, function(value, key) {
                if (value.length > 0 && typeof value[0] == 'string') {
                    try {
                        var errors = value.join(' ');

                        if (custom_names) {
                            angular.forEach(custom_names, function(new_name, old_name) {
                                if (old_name == key) {
                                    key = new_name;
                                }
                            });
                        }

                        key = key.split('.').join('_');

                        var elem = $(form_id + " [name=" + key + "]");
                        elem.addClass('is-error');
                        elem.after("<span class='api-error'>" + errors + "</span>");
                    } catch (e) {}
                }
            });
        }

        /**
         * clear errors
         *
         * @param form_id
         */
        function clear(form_id, vm) {

            vm.msg_error = '';

            try {
                $( form_id + " .api-error" ).remove();
                $( form_id + " .is-error" ).removeClass('is-error');
            } catch (e) {}
        }

        /**
         * is error
         *
         * @param response
         * @param field
         * @returns {boolean}
         */
        function isError(response, field) {
            return typeof response.fields[field] !== 'undefined';
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(api)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        // api.quickPanel.activities.get({}, function (response)
        // {
        //     vm.activities = response.data;
        // });
        //
        // api.quickPanel.events.get({}, function (response)
        // {
        //     vm.events = response.data;
        // });
        //
        // api.quickPanel.notes.get({}, function (response)
        // {
        //     vm.notes = response.data;
        // });

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController( $scope, __env, $auth)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.logo = __env.logo;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.redirectToDashboard = $auth.redirectToDashboard;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function () {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active')
        });
    }

})();
// moment.js locale configuration
// locale : polish (pl)
// author : Rafal Hirsz : https://github.com/evoL

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(['moment'], factory); // AMD
    } else if (typeof exports === 'object') {
        module.exports = factory(require('../moment')); // Node
    } else {
        factory((typeof global !== 'undefined' ? global : this).moment); // node or other global
    }
}(function (moment) {
    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');

    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    return moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
        weekdaysMin : 'N_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'LT:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY LT',
            LLLL : 'dddd, D MMMM YYYY LT'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: '[W] dddd [o] LT',
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate,
            y : 'rok',
            yy : translate
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });
}));

(function ()
{
    'use strict';

    /**
     * Main module of the CEP
     */
    angular
        .module('CEP', [

            // Core
            'app.core',

            // Home
            'app.home',

            // Dashboard
            'app.dashboard',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick panel
            'app.quick-panel',

            // Sample
            'app.sample',

            //pages
            'app.pages.error-500',
            'app.pages.error-404',
            'app.pages.error-403',

            //regulations
            'app.page.cookie',
            'app.page.privacy-policy',

            // Apps
            'app.calendar',
            // 'app.scrumboard', disable
            // 'app.backlog', disable

            // Auth
            'app.login',
            'app.login-quick',
            'app.forgot-password',
            'app.reset-password',
            'app.register',
            'app.activation',
            'app.invitation',
            'app.user-edit',

            //company
            'app.my-list',
            'app.company-new',
            'app.company-edit',
            'app.company-buy-wizard',
            'app.company-payment-back',
            'app.tokens-list',
            'app.tokens-form',

            //contractors
            'app.contractors-list',
            'app.contractors-form',

            //products
            'app.products-list',
            'app.products-form',

            //cash-operations
            'app.cash-operations-list',
            'app.cash-operations-form',

            //receipts
            'app.receipts-list',

            //registry-sales
            'app.registry-sales',

            //online-sales
            'app.online-sales-list',

            //invoice
            'app.invoices-list',
            'app.invoices-form',
            'app.invoices-form-edit',
            'app.invoices-form-correction',

            //projects
            'app.projects-list',
            'app.projects-form',
            'app.projects-show',
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('CEP')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('CEP')
        .filter('no', no)
        .filter('n2br', n2br)
        .filter('firstLetterUpper', firstLetterUpper)
        .filter('numFormat', numFormat);

    function no() {
        return function (pagination, index) {
            return pagination.per_page * (pagination.current_page - 1) + index +1;
        };
    }

    function n2br() {
    	return function(text) {
    		if (text) {
		        return text.replace(/\n/g, '<br/>');
    		}

    		return;
	    };
    }

    function firstLetterUpper() {
        return function(text) {
            if (text.length) {
                return text[0].toUpperCase() + text.substr(0+1);
            }
            return '';
        };
    }

    function numFormat() {
        return function(number) {
            if (typeof number == 'undefined') {
                return ''
            }

            return number.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$1 ');
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('CEP')
        .filter('utcToLocal', utcToLocal)
        .filter('localToUtc', localToUtc)
        .filter('toTimestamp', toTimestamp);

    /**
     * convert utc time to localtime
     *
     * @param $filter
     * @returns {Function}
     */
    function utcToLocal($filter) {
        return function (utcDateString, format) {

            if (!utcDateString) {
                return;
            }

            utcDateString = utcDateString.replace(' ', 'T') + 'Z';

            if (format == undefined) {
                format = "yyyy-MM-dd HH:mm:ss";
            }

            return $filter('date')(utcDateString, format);
        };
    }

    /**
     * convert local time to utc time
     *
     * @param $filter
     * @returns {Function}
     */
    function localToUtc($filter) {
        return function (dateString, format) {

            if (!dateString) {
                return;
            }

            dateString = dateString.replace(/-/g, '/');

            dateString = (new Date(dateString)).toUTCString();
            dateString = (new Date(dateString)).toISOString();
            dateString = dateString.replace('T', ' ');
            dateString = dateString.replace('Z', '');
            dateString = dateString.split('.')[0];

            if (format == undefined) {
                format = "yyyy-MM-dd HH:mm:ss";
            }

            return $filter('date')(dateString, format);
        };
    }

    /**
     * conver time to timestamp
     *
     * @returns {Function}
     */
    function toTimestamp() {
        return function (dateString) {
            return (new Date(dateString.replace(/-/g, '/'))).getTime();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig, $window)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }


        /**
         * Google Analytics
         */
        if (__env.ga) {
            $window.ga('create', __env.ga, 'auto');
        }
    }
})();
(function ()
{
    'use strict';

    var __env = {
        apiUrl: '',
        googleMapKey: '',
        enableDebug: false
    };

    // Import variables if present (from env.js)
    if(window){
        __env = window.__env; //ie ...
    }

    angular
        .module('app.core')
        .config(config)
        .constant('__env', __env);

    /** @ngInject */
    // uiGmapGoogleMapApiProvider
    function config($ariaProvider, $mdAriaProvider, $logProvider, msScrollConfigProvider, $translateProvider, $provide, fuseConfigProvider, __env)
    {
        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Globally disables all ARIA warnings.
        $mdAriaProvider.disableWarnings();

        // Enable debug logging
        $logProvider.debugEnabled(__env.enableDebug);

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // uiGmapgoogle-maps configuration
        // uiGmapGoogleMapApiProvider.configure({
        //     //    key: 'your api key',
        //     v        : '3.exp',
        //     libraries: 'weather,geometry,visualization'
        // });

        var last_build_angular = 0;
        if (typeof window.localStorage.last_build_angular != 'undefined') {
            last_build_angular = window.localStorage.last_build_angular;
        }

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json?t=' + last_build_angular
        });

        if (localStorage.getItem('language')) {
            $translateProvider.preferredLanguage(localStorage.getItem('language'));
        } else {
            $translateProvider.preferredLanguage('pl');
        }
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.quote.iconclass = 'icon-format-quote';

                return taTools;
            }
        ]);

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('CEP')
        .factory('$resourceJson', function ($resource) {
            var ResourceJson = function (url) {
                this.url = url;
                this.resource = $resource;

                this.get = function(form, success, error){

                    return $resource(url).get(
                        form,
                        function (response) {if (success != undefined) success(response)},
                        function (response) {if (error != undefined) error(response)}
                    );
                };

                this.save = function(form, success, error){
                    form = {};
                    return this.get(form, success, error);
                };

                this.put = function(form, success, error){
                    form = {};
                    return this.get(form, success, error);
                };

                this.delete = function(form, success, error){
                    return this.get(form, success, error);
                };
            };

            return {
                getInstance: function (url, $resource) {
                    return new ResourceJson(url, $resource);
                }
            };
        });
})();

(function ()
{
    'use strict';

    angular
        .module('CEP')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $auth, $location, $window, dialogService, api)
    {
        $rootScope.page_title = __env.title;
        $rootScope.is_fv = __env.is_fv;
        $rootScope.show_tax_office_button = false;
        $rootScope.show_projects_buttons = false;
        $rootScope.button_change_packet  = false;
        $rootScope.show_companies_list = true;
        $rootScope.close_gdpr_info = false;

        if (angular.isUndefined($window.localStorage.last_build_angular)) {
            $window.localStorage.last_build_angular = 0;
        }

        // onload actions
        (function() {
            //favicon
            var link = document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = __env.logo == '' ? 'favicon.ico' : '/assets/logos/' + __env.logo + '/favicon.ico';
            document.getElementsByTagName('head')[0].appendChild(link);
            // GDPR information            
            $(window).on('load', function() {
                if (typeof $window.localStorage.gdprInfo != 'undefined') {
                    $rootScope.close_gdpr_info = true;
                } else {
                    showGdprInfo();
                }
            });
        }());

        $rootScope.closeGdprInfo = function() {
            $window.localStorage.gdprInfo = true;
            $rootScope.close_gdpr_info = true;
        }

        // redirect user if hasn`t access
        $auth.checkAccess($location.path());

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState)
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $auth.checkAccess($location.path());

            $timeout(function ()
            {
                $rootScope.loadingProgress = false;

                if (__env.ga) {
                    //remove hash
                    var hash = $location.hash();
                    var url = $location.url().replace('#' + hash, '');
                    var url_parts = url.split('?');
                    url = url_parts[0];
                    if (url_parts.length > 1) {
                        url += url_parts[1];
                    }

                    /**
                     * Google Analytics
                     */
                    $auth.getUser(function (user) {
                        ga('set', 'userId', user.id);
                    });
                    $window.ga('send', 'pageview', url);
                }
            });
        });

        $($window).bind('hashchange', function () {

            if (__env.ga && !$rootScope.loadingProgress) {

                var hash = $location.hash();
                if (hash != '' && hash != 'up' && hash != 'down') {

                    $auth.getUser(function (user) {
                        ga('set', 'userId', user.id);
                    });

                    if (hash == '1') {
                        $window.ga('send', 'pageview', $location.url().replace('#1', ''));
                    } else {
                        var url = $location.url().replace('#' + hash, '');
                        var url_parts = url.split('?');
                        url = url_parts[0] + '/' + hash.replace('-wrap', '-page');
                        if (url_parts.length > 1) {
                            url += url_parts[1];
                        }
                        $window.ga('send', 'pageview', url);
                    }
                }
            }
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

        /**
         * range method
         *
         * @param min
         * @param max
         * @param step
         * @returns {Array}
         */
        $rootScope.range = function(min, max, step) {
            step = step || 1;
            min = Math.ceil(min);
            max = Math.ceil(max);
            var input = [];
            for (var i = min; i <= max; i += step) {
                input.push(i);
            }
            return input;
        };

        $rootScope.range_r = function(min, max, step) {
            step = step || 1;
            min = Math.ceil(min);
            max = Math.ceil(max);
            var input = [];
            for (var i = max; i >= min; i -= step) {
                input.push(i);
            }
            return input;
        };

        /**
         * new version
         */
        api.version.get({t:(new Date()).getTime()}, function (response) {

            if ($window.localStorage.last_build_angular == 0) {
                $window.localStorage.last_build_angular = response.data.timestamp;
            }
            else if (response.data.timestamp != $window.localStorage.last_build_angular) {
                $window.localStorage.last_build_angular = response.data.timestamp;
                $window.location.reload();
            }

            checkVersion();
        });

        function checkVersion() {
            $timeout(function () {
                api.version.get({t:(new Date()).getTime()}, function (response) {
                    if (response.data.timestamp != $window.localStorage.last_build_angular) {
                        $window.localStorage.last_build_angular = response.data.timestamp;
                        dialogService.customDialog(undefined, 'NewVersionDialogController', 'app/main/pages/new-version/new-version.html');
                    } else {
                        checkVersion();
                    }
                }, function () {
                    checkVersion();
                })
            }, 1800 * 1000); //30min
        }

        /**
         * Language information
         */
        if ((typeof $window.navigator.language !== 'undefined' && ['pl', 'pl-PL'].indexOf($window.navigator.language) == -1 ) ||
            (typeof $window.navigator.userLanguage !== 'undefined' && ['pl', 'pl-PL'].indexOf($window.navigator.userLanguage) == -1 )) {
            dialogService.customDialog(undefined, 'LanguageWebBrowserDialogController', 'app/main/pages/language_webbrowser/language_webbrowser.html');
        }

        /**
         * invite tax office modal
         */
        $rootScope.inviteTaxOffice = inviteTaxOffice;
        $rootScope.packageAlert = packageAlert;
        $rootScope.openHome = openHome;

        function inviteTaxOffice(e) {
            dialogService.customDialog(e, 'InviteTaxOfficeDialogController', 'app/main/pages/invite_tax_office/invite_tax_office.html');
        }

        function packageAlert(e) {
            dialogService.customDialog(e, 'PackageAlertDialogController', 'app/main/pages/package-alert/package-alert.html');
        }

        function openHome() {
            window.location.href = __env.homeUrl;
        }

        function showGdprInfo() {
            dialogService.customDialog(null, 'GdprInfoDialogController', 'app/main/pages/gdpr_info/gdpr_info.html', null, null, null, null, false);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('CEP')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/error-404');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        // var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';
        var layoutStyle = 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            // horizontalNavigation: {
            //     main      : 'app/core/layouts/horizontal-navigation.html',
            //     toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
            //     navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            // },
            // contentOnly         : {
            //     main      : 'app/core/layouts/content-only.html',
            //     toolbar   : '',
            //     navigation: ''
            // },
            // contentWithToolbar  : {
            //     main      : 'app/core/layouts/content-with-toolbar.html',
            //     toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
            //     navigation: ''
            // }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('CEP')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('CEP');
})();

(function ()
{
    'use strict';

    angular
        .module('CEP')
        .config(config);

    /** @ngInject */
    function config($httpProvider, apiProvider, $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app');

        var config = {
            "url": {
                "mail": window.location.hostname + "/"
            },
            "dataSource": "http",
            "interceptor": "authInterceptor",
            "modulesJSON": [ //if dataSource == http
            ]
        };

        // set config values
  		$httpProvider.interceptors.push(config.interceptor);
        apiProvider.setDriver(config.dataSource);
        apiProvider.setUrl(config.url.mail);
        apiProvider.setModulesJson(config.modulesJSON);

    }

})();
(function ()
{
    'use strict';

    angular
        .module('CEP')
        .provider('api', api);

    /** @ngInject */
    function api()
    {
        this.driver = '';
        this.url = '';
        this.modulesJson = [];

        this.setDriver = function(driver) {
            this.driver = driver;
        };

        this.setUrl = function(url) {
            this.url = url;
        };

        this.setModulesJson = function(modulesJson) {
            this.modulesJson = modulesJson;
        };

        this.$get = function(apiJson, apiHttp) {
            var api = {};

            if (this.driver == 'http') {
                api = apiHttp;
                for (var i = 0; i < this.modulesJson.length; ++i) {
                    api[this.modulesJson[i]] = apiJson[this.modulesJson[i]];
                }
            } else {
                api = apiJson;
            }

            api['url'] = this.url;
            return api;
        }
    }
})();

(function() {
	'use strict';

	angular
		.module('CEP')
		.factory('apiJson', apiJson);

	/** @ngInject */
	function apiJson($resourceJson)
	{
		var baseUrl =  'app/data/';

		return {

	        quickPanel: {
	            activities: $resourceJson.getInstance(baseUrl + 'quick-panel/activities.json'),
	            contacts  : $resourceJson.getInstance(baseUrl + 'quick-panel/contacts.json'),
	            events    : $resourceJson.getInstance(baseUrl + 'quick-panel/events.json'),
	            notes     : $resourceJson.getInstance(baseUrl + 'quick-panel/notes.json')
	        },

	        scrumboard: {
	            boardList: $resourceJson.getInstance(baseUrl + 'scrumboard/boardList.json'),
	            board    : $resourceJson.getInstance(baseUrl + 'scrumboard/boards/:id.json')
	        },

	        backlog: {
	            tasks: $resourceJson.getInstance(baseUrl + 'backlog/tasks.json'),
	            tags : $resourceJson.getInstance(baseUrl + 'backlog/tags.json')
	        },

	        mail: {
	            inbox: $resourceJson.getInstance(baseUrl + 'mail/inbox.json')
	        },

	        calendar: {
	            users: $resourceJson.getInstance(baseUrl + 'calendar/users.json')
	        },

	        auth: {
	            authenticate: $resourceJson.getInstance(baseUrl + 'auth/login.json')
	        },

			companyMyList: $resourceJson.getInstance(baseUrl + 'company/my-list.json'),
			numbering: $resourceJson.getInstance(baseUrl + 'numbering/index.json'),
			currentCompany: $resourceJson.getInstance(baseUrl + 'company/current.json'),

            payments: $resourceJson.getInstance(baseUrl + 'company/payments.json'),

			termNumber: $resourceJson.getInstance(baseUrl + 'numbering/current.json'),
			paymentsMethod: {
				current: $resourceJson.getInstance(baseUrl + 'payments-method/current.json'),
				list: $resourceJson.getInstance(baseUrl + 'payments-method/list.json'),
				deleteMethod: $resourceJson.getInstance(baseUrl + ''),
				setDefault: $resourceJson.getInstance(baseUrl + '', {}, {
					'put': {method: 'PUT'}
				}),
				update: $resourceJson.getInstance(baseUrl + '', {}, {
					'put': {method: 'PUT'}
				}),
				create: $resourceJson.getInstance(baseUrl + ''),
			},

			users: $resourceJson.getInstance(baseUrl + 'users/list.json'),
			contractor: $resourceJson.getInstance(baseUrl + 'contractors/get.json'),
			contractors: $resourceJson.getInstance(baseUrl + 'contractors/list.json'),
			products: $resourceJson.getInstance(baseUrl + 'products/list.json'),
			product: $resourceJson.getInstance(baseUrl + 'products/get.json'),
			taxs: $resourceJson.getInstance(baseUrl + 'products/taxs.json'),
			cashOperations: $resourceJson.getInstance(baseUrl + 'cash-operations/list.json'),
			receipts: $resourceJson.getInstance(baseUrl + 'receipts/list.json'),
			onlineSales: $resourceJson.getInstance(baseUrl + 'online-sales/list.json'),

			projectUsers: $resourceJson.getInstance(baseUrl + 'projects/show.json'),
		}
	}

})();
(function() {
	'use strict';

	angular
		.module('CEP')
		.factory('apiHttp', apiHttp);

	/** @ngInject */
	function apiHttp($resource, __env, $multipartForm, $http)
	{
   	    var baseUrl =  __env.apiUrl;

		return {
			version: $resource('/app/data/version/index.json'),

	        quickPanel: {
	            activities: $resource('/app/data/quick-panel/activities.json'),
	            contacts  : $resource('/app/data/quick-panel/contacts.json'),
	            events    : $resource('/app/data/quick-panel/events.json'),
	            notes     : $resource('/app/data/quick-panel/notes.json')
	        },

	        scrumboard: {
	            boardList: $resource(baseUrl + 'scrumboard/boardList.json'),
	            board    : $resource(baseUrl + 'scrumboard/boards/:id.json')
	        },

	        backlog: {
	            tasks: $resource(baseUrl + 'backlog/tasks.json'),
	            tags : $resource(baseUrl + 'backlog/tags.json')
	        },

	        mail: {
	            inbox: $resource('app/data/mail/inbox.json')
	        },

	        calendar: {
                users: $resource(baseUrl + 'users/availabilities'),
				userAvailabilities: $resource(baseUrl + 'users/:user/availabilities/:day', {
					user: '@user',
					day: '@day'
				})
	        },

	        auth: {
				authenticate: $resource(baseUrl + 'auth'),
				quick: $resource(baseUrl + 'auth/quick'),
	            passwordReset: $resource(baseUrl + 'password/reset', {}, {
					'put': {method: 'PUT'}
				}),
                create: $resource(baseUrl + 'users'),
				currentUser: $resource(baseUrl + 'users/current')
	        },

			activation: {
				activation: $resource(baseUrl + 'activation', {}, {
					'put': {method: 'PUT', headers: { 'Authorization': false }}
				}),
			recreate: $resource(baseUrl + 'activation/resend', {}, {
					'put': {method: 'PUT'}
				})
			},

			roles: $resource(baseUrl + 'roles'),
			rolesCompany: $resource(baseUrl + 'roles/company'),

			companyMyList: $resource(baseUrl + 'users/current/companies'),
			invoiceFormats: $resource(baseUrl + 'invoice-formats'),
			currentCompany: $resource(baseUrl + 'companies/current'),
			gusCompany: $resource(baseUrl + 'companies/get-gus-data'),
            vatReleaseReasons: $resource(baseUrl + 'vat-release-reasons'),

			company: {
				myInvitations: $resource(baseUrl + 'users/current/invitations'),
				acceptInvitation: $resource(baseUrl + 'companies/invitations/accept', {}, {
					'put': {method: 'PUT', headers: { 'Authorization': false }}
				}),
				rejectInvitation: $resource(baseUrl + 'companies/invitations/reject', {}, {
					'put': {method: 'PUT', headers: { 'Authorization': false }}
				}),
				invite: $resource(baseUrl + 'companies/:company_id/invitations', {company_id:'@company_id'}),
				users: $resource(baseUrl + 'companies/current/users'),
				userDelete: $resource(baseUrl + '/companies/current/users/:id', {id:'@id'}),
				myList: $resource(baseUrl + 'users/current/companies'),
				countries: $resource(baseUrl + 'companies/country-vatin-prefixes'),
                company: $multipartForm.getInstance(baseUrl + 'companies', $http),
				tokens: $resource(baseUrl + 'companies/tokens'),
				token: $resource(baseUrl + 'companies/tokens/:id', {id:'@id'}),
                jpk: $resource(baseUrl + 'companies/jpk_details', {}, {'put': {method: 'PUT'}}),
			},

			currencies: $resource(baseUrl + 'currencies'),
			gtu: $resource(baseUrl + 'gtu'),
			invoiceSettings: $resource(baseUrl + 'companies/invoice-settings', {}, {'put': {method: 'PUT'}}),
			invoiceTypes: $resource(baseUrl + 'invoice-types'),
			invoiceFilters: $resource(baseUrl + 'invoice-filters'),
			invoiceMarginProcedures: $resource(baseUrl + 'invoice-margin-procedures'),
			invoiceReverseCharges: $resource(baseUrl + 'invoice-reverse-charges'),
			invoiceCorrectionTypes: $resource(baseUrl + 'invoice-correction-types'),
			invoicePayments: $resource(baseUrl + 'invoice-payments'),
			invoicePayment: $resource(baseUrl + 'invoice-payments/:id', {id:'@id'}),
			invoices: $resource(baseUrl + 'invoices'),
			invoice: $resource(baseUrl + 'invoices/:id', {id:'@id'}, {'put': {method: 'PUT'}}),
			invoiceSendMail: $resource(baseUrl + 'invoices/:id/send', {id:'@id'}),
			invoiceJpkFa: $resource(baseUrl + 'invoices/jpk/fa'),
			invoicesZip: $resource(baseUrl + 'invoices/zip', {}),
			clipboard: $resource(baseUrl + 'clipboard', {}),

			packages: $resource(baseUrl + 'packages'),
            packagesCurrent: $resource(baseUrl + 'packages/current'),
            package: $resource(baseUrl + 'packages/:id', {id:'@id'}),
            modules: $resource(baseUrl + 'modules'),
            module: $resource(baseUrl + 'modules/:id', {id:'@id'}),
            modulesCurrent: $resource(baseUrl + 'modules/current'),
            modulesAvailable: $resource(baseUrl + 'modules/available'),

			payments: $resource(baseUrl + 'companies/payments'),
			payuCardList: $resource(baseUrl + 'companies/payments/cards'),
            payment: $resource(baseUrl + 'companies/payments/:id', {id:'@id'}),
            paymentAgain: $resource(baseUrl + 'companies/payments/again/:transaction_id', {transaction_id:'@transaction_id'}),
            subscription: $resource(baseUrl + 'companies/payments/subscription/:subscription_id', {subscription_id:'@subscription_id'}),

            taxOffices: $resource(baseUrl + 'tax-offices'),

			paymentsMethod: {
				list: $resource(baseUrl + 'payment-methods'),
				// deleteMethod: $resource(baseUrl + ''),
				setDefault: $resource(baseUrl + 'companies/default-payment-method', {}, {
					'put': {method: 'PUT'}
				}),
				// update: $resource(baseUrl + '', {}, {
				// 	'put': {method: 'PUT'}
				// }),
				// create: $resource(baseUrl + ''),
			},
			users: $resource(baseUrl + 'users'),
			userUpdate: $resource(baseUrl + 'users/:id', {id:'@id'}, {'put': {method: 'PUT'}}),

			contractor: $resource(baseUrl + 'contractors/:id', {id:'@id'}, {'put': {method: 'PUT'}}),
			contractors: $resource(baseUrl + 'contractors'),
			products: $resource(baseUrl + 'companies/services'),
			product: $resource(baseUrl + 'companies/services/:id', {id:'@id'}, {'put': {method: 'PUT'}}),
			units: $resource(baseUrl + 'companies/service-units'),
			taxs: $resource(baseUrl + 'vat-rates'),

			cashOperations: $resource(baseUrl + 'cash-flows'),
			cashOperation: $resource(baseUrl + 'cash-flows/:id', {id:'@id'}, {'put': {method: 'PUT'}}),
			receipts: $resource(baseUrl + 'receipts'),
			receipt: $resource(baseUrl + 'receipts/:id', {id:'@id'}),
			onlineSales: $resource(baseUrl + 'online-sales'),
			onlineSale: $resource(baseUrl + 'online-sales/:id', {id:'@id'}),
			registryInvoices: $resource(baseUrl + '/reports/invoices-registry'),

			reports: {
				invoices: $resource(baseUrl + 'reports/company-invoices'),
				receipts: $resource(baseUrl + 'reports/receipts'),
				onlineSales: $resource(baseUrl + 'reports/online-sales'),
				cashOperations: $resource(baseUrl + 'reports/cash-flows'),
				registryInvoices: $resource(baseUrl + '/reports/invoices-registry-report'),
			},

			projects: $resource(baseUrl + 'projects'),
			project: $resource(baseUrl + 'projects/:id', {id:'@id'}, {'put': {method: 'PUT'}}),
			projectClose: $resource(baseUrl + 'projects/:id/close', {id:'@id'}, {'put': {method: 'PUT'}}),
			projectUsers: $resource(baseUrl + 'projects/:id/users', {id:'@id'}),
			projectUser: $resource(baseUrl + 'projects/:id/users/:user_id', {id:'@id', user_id:'@user_id'}),
		}
	}

})();

 /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allows you to
         * add hardcoded parameters to your API calls that you want them to be sent every
         * time you make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *          list     : $resource('http://api.example.com/blog);
         *          getById  : $resource('http://api.example.com/blog/:id', {id: '@id'});
         *          getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'},
         *              'get': {method: 'GET', params: {getByDate: true}}
         *          );
         *      }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource servive, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

angular.module("CEP").run(["$templateCache", function($templateCache) {$templateCache.put("app/layouts/footer.html","<span class=\"copyright\">Copyright © fvonline.pl</span> | <a href=\"https://fvonline.pl/regulamin\" target=\"_blank\" translate=\"LAYOUT.REGULATIONS\">Regulamin</a> | <a href=\"/page/privacy-policy\" translate=\"LAYOUT.PRIVACY_POLICY\">Polityka prywatności</a> | <a href=\"/page/cookie\" translate=\"LAYOUT.COOKIE\">Pliki cookie</a>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination=\"\" md-swipe-content=\"\" md-stretch-tabs=\"always\"><md-tab><md-tab-label translate=\"QUICKPANEL.TODAY\">TODAY</md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" ms-scroll=\"\" ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.CHAT\">CHAT</md-tab-label><md-tab-body><md-content class=\"chat-tab scrollable\" ms-scroll=\"\" ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" ng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" ms-scroll=\"\" ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex=\"\"></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex=\"\"></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" ui-view=\"navigation\"></div><div id=\"content-container\" flex=\"\" layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll=\"\" ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/main/calendar/calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\"><div class=\"ms-widget ng-isolate-scope layout-row flex-100\"><div flex=\"100\" layout=\"row\"><div flex=\"33\"><div layout=\"row\" layout-align=\"start none\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"PREVIOUS\" translate=\"CALENDAR.PREVIOUS\" ng-click=\"vm.getPrev()\"></md-button></div></div><div flex=\"33\"><div layout=\"row\" layout-align=\"center none\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"TODAY\" translate=\"CALENDAR.TODAY\" ng-click=\"vm.getToday()\"></md-button></div></div><div flex=\"33\"><div layout=\"row\" layout-align=\"end none\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"NEXT\" translate=\"CALENDAR.NEXT\" ng-click=\"vm.getNext()\"></md-button></div></div></div></div><div class=\"ms-widget ng-isolate-scope layout-row flex-100\"><table id=\"availability-callendar\" class=\"dataTable row-border hover ng-scope ng-isolate-scope no-footer dtr-inline\"><thead><tr role=\"row\"><th class=\"sorting_disabled avatar-col\"></th><th class=\"sorting_asc person\" translate=\"CALENDAR.PERSON\">Person</th><th class=\"sorting_disabled\" ng-repeat=\"day in vm.dates\"><div class=\"date\">{{ day | date: \'yyyy-MM-dd\' }}</div><div class=\"day-in-week\">{{ vm.moment(day).format(\'dddd\'); }}</div></th></tr></thead><tbody><tr role=\"row\" ng-class=\"{selected: currentUser.id == user.id}\" ng-repeat=\"user in vm.users\"><td class=\"avatar-col\"><img alt=\"{{ user.first_name + \' \' + user.last_name }}\" class=\"avatar ng-scope\" ng-src=\"{{ user.avatar !== \'\' && user.avatar || \'/assets/images/avatars/profile.jpg\' }}\"></td><td class=\"person\">{{ user.first_name }}<br>{{ user.last_name }}</td><td ng-repeat=\"day in vm.dates\" drag-drop-calendar=\"\" id=\"{{user.id}}-{{day}}\" drop=\"vm.drop(from, to)\" ng-click=\"vm.showEventsModal($event, user, day)\"><div ng-repeat=\"availability in user.availabilities.data | availability:day\" ng-class=\"availability.available ? \'online\' : \'offline\'\"><span ng-show=\"availability.available\">{{ availability.time_start | slice:0:5 }} - {{ availability.time_stop | slice:0:5 }}<div class=\"desc\">{{availability.description}}</div></span> <span ng-show=\"! availability.available\"><span ng-if=\"-1 == vm.reasons.indexOf(availability.description)\">{{ availability.description }}</span> <span ng-if=\"-1 != vm.reasons.indexOf(availability.description)\" translate=\"CALENDAR.REASON.{{availability.description}}\"></span></span></div></td></tr></tbody></table></div></div><pre>\n        \n        \n    </pre></div>");
$templateCache.put("app/main/dashboard/dashboard.html","<div id=\"contractors-list\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div id=\"dashboard\" layout=\"column\" flex=\"\"><div id=\"board-selector\" layout=\"column\" layout-align=\"start center\" flex=\"\"><div class=\"board-list\" ng-if=\"vm.role != \'tax_office\'\"><div layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><a class=\"board-list-item rounded-element\" layout=\"column\" layout-align=\"center center\" href=\"/company/edit\" ng-if=\"vm.role == \'admin\' || vm.role == \'owner\'\"><md-icon md-font-icon=\"icon-pencil\" class=\"icon s64\"></md-icon><div class=\"board-name\" translate=\"DASHBOARD.EDIT_COMPANY\"></div></a> <a class=\"board-list-item rounded-element disabled\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.role != \'admin\' && vm.role != \'owner\'\"><md-icon md-font-icon=\"icon-pencil\" class=\"icon s64\"></md-icon><div class=\"board-name\" translate=\"DASHBOARD.EDIT_COMPANY\"></div></a> <a class=\"board-list-item rounded-element\" layout=\"column\" layout-align=\"center center\" href=\"/invoices/form/new\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"icon s64\"></md-icon><div class=\"board-name\" translate=\"DASHBOARD.NEW_INVOICE\"></div></a></div><div layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><a class=\"board-list-item rounded-element\" layout=\"column\" layout-align=\"center center\" href=\"/contractors/form/new\"><md-icon md-font-icon=\"icon-account\" class=\"icon s64\"></md-icon><div class=\"board-name\" translate=\"DASHBOARD.NEW_CONTRACTOR\"></div></a> <a class=\"board-list-item rounded-element\" layout=\"column\" layout-align=\"center center\" href=\"/products/form/new\"><md-icon md-font-icon=\"icon-cube-outline\" class=\"icon s64\"></md-icon><div class=\"board-name\" translate=\"DASHBOARD.NEW_PRODUCT\"></div></a></div></div><div class=\"board-list\" ng-if=\"vm.role == \'tax_office\'\"><div layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><a class=\"board-list-item rounded-element\" layout=\"column\" layout-align=\"center center\" href=\"/invoices/list\"><md-icon md-font-icon=\"icon-file-document\" class=\"icon s64\"></md-icon><div class=\"board-name\" translate=\"DASHBOARD.INVOICE_LIST\"></div></a><div class=\"board-list-item rounded-element\" layout=\"column\" layout-align=\"center center\" ng-click=\"vm.csvInvoices()\"><md-icon md-font-icon=\"icon-download\" class=\"icon s64\"></md-icon><div class=\"board-name\" translate=\"DASHBOARD.DOWNLOAD_REGISTRY\"></div></div></div></div></div></div></div>");
$templateCache.put("app/main/home/home.html","");
$templateCache.put("app/main/sample/sample.html","<h1>{{vm.helloText}}<br><div class=\"col-xs-12 text-center\"><h1 style=\"color: orange;\">CEP - Company Managemet Project</h1><div class=\"col-xs-6 text-left\" style=\"font-size: 12px\">Fazy budowy projektu<ul><li>1. Kalendarz dostępności</li><li>2. AGILE - scrumboard + backlog list (z podziałem na sprinty)</li><li>3. Integracja z UPWORK, SLACK</li><li>4. Raporty czasu pracy</li><li>5. Zarządznie mailami</li><li>6. Zarządzanie plikami</li><li>7. Pozostałe statystyki i plan dalszego rozwoju aplikacji</li></ul></div></div></h1>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex=\"\" layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon id=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon id=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label> <input id=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate=\"\" translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex=\"\"></div>");
$templateCache.put("app/main/agile/backlog/backlog.html","<div id=\"backlog\" class=\"page-layout\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content center\"><md-content id=\"sprints-list\" class=\"backlog-list-pane\" flex=\"\" ng-include=\"\'app/main/agile/backlog/views/list/list-view.html\'\" ui-sortable=\"vm.sortableSprintOptions\"></md-content></md-content></div></div>");
$templateCache.put("app/main/agile/scrumboard/scrumboard.html","<div id=\"scrumboard\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" layout=\"column\"><div class=\"header-content\" layout=\"row\" layout-align=\"space-between\" layout-wrap=\"\" flex=\"\"><div layout=\"row\" layout-align=\"center center\" flex-order=\"1\" flex-order-xs=\"2\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" ng-class=\"\'md-\'+vm.board.settings.color+\'-700-bg\'\" ng-click=\"vm.boardSelectorVisible = !vm.boardSelectorVisible\" aria-label=\"boards button\" translate=\"\" translate-attr-aria-label=\"SB.BOARDS_BUTTON\"><md-icon md-font-icon=\"icon-trello\" class=\"icon\"></md-icon><span translate=\"SB.BOARDS\">BOARDS</span></md-button></div><div class=\"header-board-name\" layout=\"row\" layout-align=\"center center\" flex-order=\"2\" flex-order-xs=\"1\" flex-xs=\"100\"><i ng-if=\"vm.board.settings.subscribed\" class=\"board-subscribe s16 icon-eye\"></i> <span editable-text=\"vm.board.name\" onaftersave=\"vm.updateBoardUri()\">{{vm.board.name}}</span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" flex-order=\"3\"><md-button ui-sref-active-eq=\"ng-hide\" class=\"md-icon-button\" ui-sref=\"app.scrumboard.boards.board\" aria-label=\"Board\" translate=\"\" translate-attr-aria-label=\"SB.BOARD\"><md-icon md-font-icon=\"icon-trello\"></md-icon><md-tooltip><span translate=\"SB.BOARD\">Board</span></md-tooltip></md-button></div></div></div><div ng-show=\"vm.boardSelectorVisible\" id=\"board-selector\" class=\"md-accent-bg animate-slide-down board-list md-whiteframe-3dp\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" layout=\"row\" layout-align=\"start center\"><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" ui-sref=\"app.scrumboard.boards.board({id:board.id, uri:board.uri})\" layout=\"column\" layout-align=\"space-between center\"><div class=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex=\"\" class=\"board-name\">{{board.name}}</div><div class=\"board-options\"><i class=\"icon-dots-horizontal\"></i></div><div ng-if=\"board.id === vm.board.id\" class=\"selected-icon green-bg\"><i class=\"icon-check s24\"></i></div></div><div class=\"board-list-item add-new-board\" ui-sref=\"app.scrumboard.boards.addBoard\" ui-sref-active=\"hidden\" layout=\"column\" layout-align=\"space-between center\"><div class=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex=\"\" class=\"board-name\" translate=\"SB.ADD_NEW_BOARD\">Add New Board</div></div></div><md-content class=\"content\" flex=\"\" layout=\"column\" ui-view=\"scrumboardContent\"></md-content><md-sidenav class=\"preview-sidenav md-sidenav-right\" md-component-id=\"preview-sidenav\" ng-include=\"\'app/main/agile/scrumboard/sidenavs/preview/preview-sidenav.html\'\" ng-controller=\"PreviewSidenavController as vm\" ms-sidenav-helper=\"\"></md-sidenav></div>");
$templateCache.put("app/main/auth/activation/activation.html","<div id=\"login\" class=\"flex-scrollable guest-layout\" layout=\"column\" ms-scroll=\"\"><div id=\"login-form-wrapper\" class=\"guest-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"login-form\" class=\"rounded-container guest-form\"><logo-sqr></logo-sqr><div class=\"title\" translate=\"ACTIVATION.TITLE\"></div><div class=\"success\">{{vm.msg_success}}</div><div class=\"error\">{{vm.msg_error}}</div><div class=\"error\" ng-if=\"vm.error_code == \'broken-link\'\"><span translate=\"ACTIVATION.ACCOUNT.BROKEN_LINK_1\"></span> <a ng-click=\"vm.recreate_form = true\" translate=\"ACTIVATION.ACCOUNT.BROKEN_LINK_2\"></a></div><div class=\"error\" ng-if=\"vm.error_code == \'user-not-found\'\"><span translate=\"ACTIVATION.ACCOUNT.BROKEN_ACTIVATION_1\"></span> <a href=\"/contact\" translate=\"ACTIVATION.ACCOUNT.BROKEN_ACTIVATION_2\"></a> <span translate=\"ACTIVATION.ACCOUNT.BROKEN_ACTIVATION_3\"></span></div><form name=\"reactivateForm\" ng-if=\"vm.recreate_form\"><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"ACTIVATION.RECREATE.EMAIL\"></span></label> <input ng-model=\"vm.form.email\" required=\"\" ng-maxlength=\"255\" name=\"email\" type=\"email\"><div ng-messages=\"reactivateForm.email.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"email\"><span translate=\"ERRORS.FORM.EMAIL\"></span></div></div></md-input-container><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-click=\"vm.recreate()\" ng-disabled=\"reactivateForm.$invalid || vm.request_sending\" translate=\"OTHER.SEND\" translate-attr-aria-label=\"OTHER.SEND\"></md-button></form><div class=\"languages-no-login\" layout=\"row\" layout-align=\"end center\"><div ng-click=\"vm.changeLanguage(\'pl\')\" class=\"mr-5\"><span><img class=\"flag\" ng-src=\"assets/images/flags/pl.png\"></span></div><div ng-click=\"vm.changeLanguage(\'en\')\"><span><img class=\"flag\" ng-src=\"assets/images/flags/us.png\"></span></div></div></div></div><footer ng-include=\"\'app/layouts/footer.html\'\"></footer></div>");
$templateCache.put("app/main/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable guest-layout\" layout=\"column\" ms-scroll=\"\"><div id=\"forgot-password-form-wrapper\" class=\"guest-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"rounded-container guest-form\"><logo-sqr></logo-sqr><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Recover your password</div><div class=\"success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><form name=\"forgotPasswordForm\" novalidate=\"\" ng-submit=\"vm.forgotPassword()\"><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"FORGOTPASSWORD.EMAIL_ADRESS\"></span></label> <input ng-model=\"vm.form.email\" required=\"\" ng-maxlength=\"255\" name=\"email\" type=\"email\"><div ng-messages=\"forgotPasswordForm.email.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"email\"><span translate=\"ERRORS.FORM.EMAIL\"></span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"RESET MY PASSWORD\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine || vm.request_sending\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" translate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\">SEND RESET LINK</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.login\" translate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div><div class=\"languages-no-login\" layout=\"row\" layout-align=\"end center\"><div ng-click=\"vm.changeLanguage(\'pl\')\" class=\"mr-5\"><span><img class=\"flag\" ng-src=\"assets/images/flags/pl.png\"></span></div><div ng-click=\"vm.changeLanguage(\'en\')\"><span><img class=\"flag\" ng-src=\"assets/images/flags/us.png\"></span></div></div></div></div><footer ng-include=\"\'app/layouts/footer.html\'\"></footer></div>");
$templateCache.put("app/main/auth/invitation/invitation.html","<div id=\"invitation\" class=\"flex-scrollable guest-layout\" layout=\"column\" ms-scroll=\"\"><div id=\"invitation-form-wrapper\" class=\"guest-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"invitation-form\" class=\"rounded-container guest-form\"><logo-sqr></logo-sqr><div class=\"title\"><span translate=\"INVITATION.TITLE\"></span> {{vm.company_name}}</div><div class=\"success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><form name=\"invitationForm\" novalidate=\"\" ng-submit=\"vm.send()\" ng-if=\"vm.form_enabled\"><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"INVITATION.PASSWORD\"></span></label> <input type=\"password\" ng-model=\"vm.form.password\" required=\"\" pattern=\".{6,}\" name=\"password\" id=\"password\"><div ng-messages=\"invitationForm.password.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.PASSWORD\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"INVITATION.PASSWORD_CONFIRM\"></span></label> <input type=\"password\" ng-model=\"vm.form.password_confirmation\" required=\"\" name=\"password_confirmation\" ms-confirm=\"password\"><div ng-messages=\"invitationForm.password_confirmation.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"confirm\"><span translate=\"ERRORS.FORM.CONFIRM\"></span></div></div></md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"vm.form.regulations\" aria-label=\"I read and accept\" required=\"\"></md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><span translate=\"INVITATION.READ_ACCEPT\">I read and accept</span> <a ng-href=\"https://fvonline.pl/regulamin\" target=\"_blank\" class=\"md-accent-color\" translate=\"INVITATION.TERMS_COND\">terms and conditions</a></div></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"invitationForm.$invalid || invitationForm.$pristine || vm.request_sending\" translate=\"INVITATION.SEND\" translate-attr-aria-label=\"INVITATION.SEND\"></md-button></form><div class=\"languages-no-login\" layout=\"row\" layout-align=\"end center\"><div ng-click=\"vm.changeLanguage(\'pl\')\" class=\"mr-5\"><span><img class=\"flag\" ng-src=\"assets/images/flags/pl.png\"></span></div><div ng-click=\"vm.changeLanguage(\'en\')\"><span><img class=\"flag\" ng-src=\"assets/images/flags/us.png\"></span></div></div></div></div><footer ng-include=\"\'app/layouts/footer.html\'\"></footer></div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable guest-layout\" layout=\"column\" ms-scroll=\"\"><div id=\"login-form-wrapper\" class=\"guest-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"login-form\" class=\"rounded-container guest-form\"><logo-sqr></logo-sqr><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><div class=\"error\">{{ vm.msg_error }}</div><div class=\"success\">{{ vm.msg_success }}</div><div class=\"error\" ng-if=\"vm.not_active_link != \'\'\"><span translate=\"ERRORS.ACTIVE_1\"></span> <a href=\"{{vm.not_active_link}}\" translate=\"ERRORS.ACTIVE_2\"></a></div><form name=\"loginForm\" novalidate=\"\" ng-submit=\"vm.submitLoginForm()\"><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"LOGIN.EMAIL\"></span></label> <input ng-model=\"vm.form.email\" required=\"\" ng-maxlength=\"255\" name=\"login\" type=\"email\"><div ng-messages=\"loginForm.login.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"email\"><span translate=\"ERRORS.FORM.EMAIL\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"LOGIN.PASSWORD\"></span></label> <input type=\"password\" ng-model=\"vm.form.password\" required=\"\" name=\"password_login\" id=\"password\"><div ng-messages=\"loginForm.password_login.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"end\"><a ui-sref=\"app.forgot-password\" class=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"register\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">Don\'t have an account?</span> <a class=\"link\" ui-sref=\"app.register\" translate=\"LOGIN.CREATE_ACCOUNT\">Create an account</a></div><div class=\"languages-no-login\" layout=\"row\" layout\"column\"=\"\" layout-align=\"end center\"><div ng-click=\"vm.changeLanguage(\'pl\')\" class=\"mr-5\"><span><img class=\"flag\" ng-src=\"assets/images/flags/pl.png\"></span></div><div ng-click=\"vm.changeLanguage(\'en\')\"><span><img class=\"flag\" ng-src=\"assets/images/flags/us.png\"></span></div></div></div></div><footer ng-include=\"\'app/layouts/footer.html\'\"></footer></div>");
$templateCache.put("app/main/auth/login-quick/login-quick.html","<div id=\"login\" class=\"flex-scrollable guest-layout\" layout=\"column\" ms-scroll=\"\"><div id=\"login-form-wrapper\" class=\"guest-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"login-form\" class=\"rounded-container guest-form\"><logo-sqr></logo-sqr><div class=\"title\" translate=\"LOGIN-QUICK.TITLE\"></div><div>{{vm.msg_success}}</div><div class=\"error\">{{vm.msg_error}}</div><div class=\"languages-no-login\" layout=\"row\" layout-align=\"end center\"><div ng-click=\"vm.changeLanguage(\'pl\')\" class=\"mr-5\"><span><img class=\"flag\" ng-src=\"assets/images/flags/pl.png\"></span></div><div ng-click=\"vm.changeLanguage(\'en\')\"><span><img class=\"flag\" ng-src=\"assets/images/flags/us.png\"></span></div></div></div></div><footer ng-include=\"\'app/layouts/footer.html\'\"></footer></div>");
$templateCache.put("app/main/auth/register/register.html","<div id=\"register\" class=\"flex-scrollable guest-layout\" layout=\"column\" ms-scroll=\"\"><div id=\"register-form-wrapper\" class=\"guest-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"register-form\" class=\"rounded-container guest-form\"><logo-sqr></logo-sqr><div class=\"title\" translate=\"REGISTER.TITLE\">Create an account</div><div class=\"success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><form id=\"registerForm\" name=\"registerForm\" novalidate=\"\" ng-submit=\"vm.create()\"><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"REGISTER.FIRST_NAME\"></span></label> <input ng-model=\"vm.form.first_name\" required=\"\" ng-maxlength=\"100\" name=\"first_name\" type=\"text\"><div ng-messages=\"registerForm.first_name.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_100\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"REGISTER.LAST_NAME\"></span></label> <input ng-model=\"vm.form.last_name\" required=\"\" ng-maxlength=\"100\" name=\"last_name\" type=\"text\"><div ng-messages=\"registerForm.last_name.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_100\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"REGISTER.EMAIL\"></span></label> <input ng-model=\"vm.form.email\" required=\"\" ng-maxlength=\"255\" name=\"email\" type=\"email\"><div ng-messages=\"registerForm.email.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"email\"><span translate=\"ERRORS.FORM.EMAIL\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"REGISTER.KEY\"></span></label> <input ng-model=\"vm.form.discount_code\" ng-maxlength=\"255\" name=\"discount_code\" type=\"text\"><div ng-messages=\"registerForm.discount_code.$error\"><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"REGISTER.PASSWORD\"></span></label> <input type=\"password\" ng-model=\"vm.form.password\" required=\"\" pattern=\".{6,}\" name=\"password\" id=\"password\"><div ng-messages=\"registerForm.password.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.PASSWORD\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"REGISTER.PASSWORD_CONFIRM\"></span></label> <input type=\"password\" ng-model=\"vm.form.password_confirmation\" required=\"\" name=\"password_confirmation\" ms-confirm=\"password\"><div ng-messages=\"registerForm.password_confirmation.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"confirm\"><span translate=\"ERRORS.FORM.CONFIRM\"></span></div></div></md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"vm.form.regulations\" aria-label=\"I read and accept\" required=\"\"></md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><span translate=\"REGISTER.READ_ACCEPT\">I read and accept</span> <a href=\"https://fvonline.pl/regulamin\" target=\"_blank\" class=\"md-accent-color\" translate=\"REGISTER.TERMS_COND\">terms and conditions</a></div></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"CREATE MY ACCOUNT\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" translate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER.ALREADY_HAVE\">Already have an account?</span> <a class=\"link\" ui-sref=\"app.login\" translate=\"REGISTER.LOGIN\">Log in</a></div><div class=\"languages-no-login\" layout=\"row\" layout-align=\"end center\"><div ng-click=\"vm.changeLanguage(\'pl\')\" class=\"mr-5\"><span><img class=\"flag\" ng-src=\"assets/images/flags/pl.png\"></span></div><div ng-click=\"vm.changeLanguage(\'en\')\"><span><img class=\"flag\" ng-src=\"assets/images/flags/us.png\"></span></div></div></div></div><footer ng-include=\"\'app/layouts/footer.html\'\"></footer></div>");
$templateCache.put("app/main/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable guest-layout\" layout=\"column\" ms-scroll=\"\"><div id=\"reset-password-form-wrapper\" class=\"guest-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"rounded-container guest-form\"><logo-sqr></logo-sqr><div class=\"title\" translate=\"RESETPASSWORD.TITLE\">Reset your password</div><div class=\"success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div class=\"error\" ng-if=\"vm.not_reset_link != \'\'\"><span translate=\"RESETPASSWORD.RESET_1\"></span> <a href=\"{{vm.not_reset_link}}\" translate=\"RESETPASSWORD.RESET_2\"></a></div><form name=\"resetPasswordForm\" novalidate=\"\" ng-submit=\"vm.reset()\"><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"RESETPASSWORD.EMAIL_ADRESS\"></span></label> <input ng-model=\"vm.form.email\" required=\"\" ng-maxlength=\"255\" name=\"email\" type=\"email\"><div ng-messages=\"resetPasswordForm.email.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"email\"><span translate=\"ERRORS.FORM.EMAIL\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"RESETPASSWORD.PASSWORD\"></span></label> <input type=\"password\" ng-model=\"vm.form.password\" required=\"\" pattern=\".{6,}\" name=\"password\" id=\"password\"><div ng-messages=\"resetPasswordForm.password.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.PASSWORD\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"RESETPASSWORD.PASSWORD_CONFIRM\"></span></label> <input type=\"password\" ng-model=\"vm.form.password_confirmation\" required=\"\" name=\"password_confirmation\" ms-confirm=\"password\"><div ng-messages=\"resetPasswordForm.password_confirmation.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"confirm\"><span translate=\"ERRORS.FORM.CONFIRM\"></span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine || vm.request_sending\" translate=\"RESETPASSWORD.UPDATE_PASSWORD\" translate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\">RESET MY PASSWORD</md-button></form><div class=\"languages-no-login\" layout=\"row\" layout-align=\"end center\"><div ng-click=\"vm.changeLanguage(\'pl\')\" class=\"mr-5\"><span><img class=\"flag\" ng-src=\"assets/images/flags/pl.png\"></span></div><div ng-click=\"vm.changeLanguage(\'en\')\"><span><img class=\"flag\" ng-src=\"assets/images/flags/us.png\"></span></div></div></div></div><footer ng-include=\"\'app/layouts/footer.html\'\"></footer></div>");
$templateCache.put("app/main/auth/user-edit/user-edit.html","<div id=\"profile-edit\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"title\" translate=\"USER_EDIT.TITLE\"></div></div></div><div class=\"content\" layout=\"column\"><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container max-1000\" flex=\"\"><form name=\"editUser\" novalidate=\"\" ng-submit=\"vm.send()\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label><span translate=\"USER_EDIT.NAME\"></span></label> <input ng-model=\"vm.form.first_name\" required=\"\" ng-maxlength=\"100\" name=\"first_name\"><div ng-messages=\"editUser.first_name.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_100\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label><span translate=\"USER_EDIT.SURNAME\"></span></label> <input ng-model=\"vm.form.last_name\" required=\"\" ng-maxlength=\"100\" name=\"last_name\"><div ng-messages=\"editUser.last_name.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_100\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label><span translate=\"USER_EDIT.PASSWORD_OLD\"></span></label> <input type=\"password\" ng-model=\"vm.form.old_password\" ng-required=\"vm.passwordRequired()\" name=\"old_password\" id=\"old_password\"><div ng-messages=\"editUser.old_password.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.PASSWORD\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label><span translate=\"USER_EDIT.PASSWORD\"></span></label> <input type=\"password\" ng-model=\"vm.form.password\" ng-required=\"vm.passwordRequired()\" pattern=\".{6,}\" name=\"password\" id=\"password\"><div ng-messages=\"editUser.password.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.PASSWORD\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label><span translate=\"USER_EDIT.PASSWORD_CONFIRM\"></span></label> <input type=\"password\" ng-model=\"vm.form.password_confirmation\" ng-required=\"vm.passwordRequired()\" ms-confirm=\"password\" name=\"password_confirmation\"><div ng-messages=\"editUser.password_confirmation.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"confirm\"><span translate=\"ERRORS.FORM.CONFIRM\"></span></div></div></md-input-container></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"CREATE\" ng-disabled=\"editUser.$invalid || editUser.$pristine || vm.request_sending\" translate=\"OTHER.SAVE\" translate-attr-aria-label=\"OTHER.SAVE\"></md-button></form></div></div></div></div>");
$templateCache.put("app/main/cash-operations/form/form.html","<div id=\"cash-operations-form\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\" flex=\"100\"><div layout=\"row\"><div ng-if=\"!vm.edit && vm.form.cashless == 0\" class=\"title\" translate=\"CASH_OPERATIONS_FORM.TITLE_ADD_1\" flex=\"70\"></div><div ng-if=\"!vm.edit && vm.form.cashless == 1\" class=\"title\" translate=\"CASH_OPERATIONS_FORM.TITLE_ADD_2\" flex=\"70\"></div><div ng-if=\"vm.edit && vm.form.cashless == 0\" class=\"title\" translate=\"CASH_OPERATIONS_FORM.TITLE_EDIT_1\" flex=\"70\"></div><div ng-if=\"vm.edit && vm.form.cashless == 1\" class=\"title\" translate=\"CASH_OPERATIONS_FORM.TITLE_EDIT_2\" flex=\"70\"></div><div flex=\"30\" layout=\"row\" layout-align=\"end center\"><md-button href=\"/cash-operations/list\" class=\"md-raised\" aria-label=\"Go Back\" translate=\"OTHER.GO_BACK\" translate-attr-aria-label=\"OTHER.GO_BACK\">Go Back</md-button></div></div></div></div><div class=\"content\" layout=\"column\"><a name=\"up\"></a><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><form id=\"cashOperations\" name=\"cashOperations\" novalidate=\"\" ng-submit=\"vm.send()\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block autocomplete-container\" flex-gt-sm=\"\" ng-if=\"vm.form.document_type == \'receipt\'\"><label><span translate=\"CASH_OPERATIONS_FORM.RECEIPT\"></span></label><md-autocomplete md-input-name=\"receipt_id\" ng-model-options=\"{debounce:200}\" md-selected-item=\"vm.receipt.selected_item\" md-search-text=\"vm.search_text_receipt\" md-items=\"item in vm.searchReceipt(vm.search_text_receipt)\" md-item-text=\"item.number\"><md-item-template><span md-highlight-text=\"vm.search_text_receipt\">{{item.number}}</span></md-item-template><md-not-found><span translate=\"OTHER.NOT_FOUND\"></span></md-not-found></md-autocomplete></md-input-container><md-input-container class=\"md-block autocomplete-container\" flex-gt-sm=\"\" ng-if=\"vm.form.document_type == \'invoice\'\"><label><span translate=\"CASH_OPERATIONS_FORM.INVOICE\"></span></label><md-autocomplete md-input-name=\"invoice_id\" ng-model-options=\"{debounce:200}\" md-selected-item=\"vm.invoice.selected_item\" md-search-text=\"vm.search_text_invoice\" md-items=\"item in vm.searchInvoice(vm.search_text_invoice)\" md-item-text=\"item.number\"><md-item-template><span md-highlight-text=\"vm.search_text_invoice\">{{item.number}}</span></md-item-template><md-not-found><span translate=\"OTHER.NOT_FOUND\"></span></md-not-found></md-autocomplete></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-radio-group ng-model=\"vm.form.document_type\"><md-radio-button value=\"receipt\"><span translate=\"CASH_OPERATIONS_FORM.RECEIPT_2\"></span></md-radio-button><md-radio-button value=\"invoice\"><span translate=\"CASH_OPERATIONS_FORM.INVOICE_2\"></span></md-radio-button></md-radio-group></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CASH_OPERATIONS_FORM.DIRECTION\"></span></label><md-select ng-model=\"vm.form.direction\" required=\"\" name=\"direction\" ng-if=\"!translate_loading\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"\'initial\'\"><span translate=\"CASH_OPERATIONS_FORM.DIRECTION_LIST.initial\"></span></md-option><md-option ng-value=\"\'in\'\"><span translate=\"CASH_OPERATIONS_FORM.DIRECTION_LIST.in\"></span></md-option><md-option ng-value=\"\'out\'\"><span translate=\"CASH_OPERATIONS_FORM.DIRECTION_LIST.out\"></span></md-option><md-option ng-value=\"\'final\'\"><span translate=\"CASH_OPERATIONS_FORM.DIRECTION_LIST.final\"></span></md-option></md-select><div ng-messages=\"cashOperations.payment_method_id.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CASH_OPERATIONS_FORM.AMOUNT\"></span></label> <input ng-model=\"vm.form.amount\" name=\"amount\" required=\"\" type=\"number\" step=\"0.01\" min=\"0\" max=\"9999999\"><div ng-messages=\"cashOperations.amount.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"number\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"max\"><span translate=\"ERRORS.FORM.MAX_9999999\"></span></div><div ng-message=\"step\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CASH_OPERATIONS_FORM.DATE\"></span></label> <input ng-model=\"vm.form.flow_date\" name=\"flow_date\" moment-picker=\"vm.form.flow_date\" required=\"\" format=\"YYYY-MM-DD\" start-view=\"decade\" locale=\"pl\"><div ng-messages=\"cashOperations.flow_date.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CASH_OPERATIONS_FORM.DESCRIPTION\"></span></label> <textarea name=\"description\" ng-model=\"vm.form.description\" md-maxlength=\"500\"></textarea><div ng-messages=\"cashOperations.description.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span translate=\"ERRORS.FORM.MAX_500\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><span class=\"require\">*</span> <span translate=\"INFO.REQUIRE_INFO\"></span></md-input-container></div><div layout=\"row\" layout-align=\"end none\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"PDF\" ng-if=\"vm.last_added\" ng-click=\"vm.pdf()\" translate=\"CASH_OPERATIONS_FORM.PDF\" translate-attr-aria-label=\"CASH_OPERATIONS_FORM.PDF\"></md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-if=\"!vm.last_added\" ng-disabled=\"cashOperations.$invalid || cashOperations.$pristine || vm.request_sending\" translate=\"OTHER.SAVE\" translate-attr-aria-label=\"OTHER.SAVE\"></md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/cash-operations/list/list.html","<div id=\"cash-operations-list\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"title\" translate=\"CASH_OPERATIONS_LIST.TITLE\"></div></div></div><div class=\"content\" layout=\"column\"><md-tabs md-dynamic-height=\"\"><md-tab><md-tab-label><span translate=\"CASH_OPERATIONS_LIST.TAB1\"></span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/cash-operations/list/tab/tab1.html\'\"></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"CASH_OPERATIONS_LIST.TAB2\"></span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/cash-operations/list/tab/tab2.html\'\"></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/company/buy-wizard/buy-wizard.html","<div id=\"company-new\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"title\" translate=\"BUY_WIZARD.TITLE\"></div></div></div><div class=\"content\" layout=\"column\"><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\" translate=\"BUY_WIZARD.TYPE_PAYMENT\"></span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"100\"><md-radio-group ng-model=\"vm.form.subscription\" required=\"\" layout=\"column\" layout-gt-xs=\"row\" flex=\"100\"><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"100\" flex-gt-xs=\"50\" ng-if=\"vm.enable_card_pay && vm.payment.days && (vm.first_module.package.data || (vm.package_current.subscription.data && vm.package_current.subscription.data.active))\"><md-radio-button ng-value=\"true\"><span translate=\"BUY_WIZARD.SUBSCRIPTION\"></span></md-radio-button></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"100\" flex-gt-xs=\"50\"><md-radio-button ng-value=\"false\"><span translate=\"BUY_WIZARD.ONE_TIME\"></span></md-radio-button></md-input-container></md-radio-group></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\" translate=\"BUY_WIZARD.PAYMENT_METHOD\"></span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"100\"><md-radio-group ng-model=\"vm.form.type\" required=\"\" layout=\"column\" layout-gt-xs=\"row\" flex=\"100\"><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"100\" flex-gt-xs=\"50\" ng-if=\"vm.enable_card_pay\"><md-radio-button ng-value=\"true\"><span translate=\"BUY_WIZARD.CARD\"></span></md-radio-button></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"100\" flex-gt-xs=\"50\" ng-if=\"!vm.form.subscription\"><md-radio-button ng-value=\"false\"><span>PayU</span></md-radio-button></md-input-container></md-radio-group></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || !vm.form.type\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\" translate=\"BUY_WIZARD.DATA\"></span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><md-input-container class=\"md-block\" flex=\"100\"><label><span translate=\"BUY_WIZARD.SELECT_CARD\"></span></label><md-select ng-model=\"vm.form.token\" name=\"token\" ng-if=\"!translate_loading\"><md-option ng-value=\"null\"><span translate=\"BUY_WIZARD.OTHER_CARD\"></span></md-option><md-option ng-value=\"card.value\" ng-repeat=\"card in vm.card_list\">{{card.cardNumberMasked}}</md-option></md-select></md-input-container><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.form.token == null\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label><span translate=\"BUY_WIZARD.CARD_NUMBER\"></span></label> <input name=\"card_number\" ng-model=\"vm.form.card_number\" required=\"\" ng-pattern=\"/^([0-9]{12,19})$/\"><div ng-messages=\"wizardStep3.card_number.$error\" ng-show=\"wizardStep3.card_number.$dirty\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.CARD_NUMBER\"></span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label><span translate=\"BUY_WIZARD.CARD_CVV2\"></span></label> <input name=\"card_cvv\" ng-model=\"vm.form.card_cvv\" required=\"\" ng-pattern=\"/^([0-9]{3})$/\"><div ng-messages=\"wizardStep3.card_cvv.$error\" ng-show=\"wizardStep3.card_cvv.$dirty\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.CARD_CVV2\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.form.token == null\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label><span translate=\"BUY_WIZARD.CARD_MONTH\"></span></label> <input name=\"card_exp_month\" ng-model=\"vm.form.card_exp_month\" required=\"\" ng-pattern=\"/^((0[1-9]{1})|(1[0-2]{1}))$/\"><div ng-messages=\"wizardStep3.card_exp_month.$error\" ng-show=\"wizardStep3.card_exp_month.$dirty\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.CARD_MONTH\"></span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label><span translate=\"BUY_WIZARD.CARD_YEAR\"></span></label> <input name=\"card_exp_year\" ng-model=\"vm.form.card_exp_year\" required=\"\" ng-pattern=\"/^([0-9]{4})$/\"><div ng-messages=\"wizardStep3.card_exp_year.$error\" ng-show=\"wizardStep3.card_exp_year.$dirty\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.CARD_YEAR\"></span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.form.token == null\"><md-input-container class=\"md-block\" flex=\"100\"><md-checkbox ng-model=\"vm.formWizard.accept\" name=\"other_contact_address\" required=\"\"><span translate=\"BUY_WIZARD.REGULATIONS_1\"></span> <a href=\"https://static.payu.com/sites/terms/files/REGULAMIN_SWIADCZENIA_USLUGI_PAYU.pdf\"><span translate=\"BUY_WIZARD.REGULATIONS_2\"></span></a> <span translate=\"BUY_WIZARD.REGULATIONS_3\"></span></md-checkbox></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">4</span> <span class=\"ms-form-wizard-step-text\" translate=\"BUY_WIZARD.SUMMARY\"></span></span></md-tab-label><md-tab-body><form name=\"wizardStep4\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" flex=\"100\"><div flex=\"100\" ng-if=\"vm.first_module.package.data\"><span translate=\"BUY_WIZARD.PACKAGE\"></span>: {{vm.first_module.package.data.name}}</div><div flex=\"100\" ng-if=\"!vm.first_module.package.data\"><span translate=\"BUY_WIZARD.MODULE\"></span>: {{vm.first_module.module.data.name}} <span ng-if=\"vm.first_module.module_mod.data.value != 1\">({{vm.first_module.module_mod.data.value}})</span></div><div flex=\"100\"><span translate=\"BUY_WIZARD.TYPE_PAYMENT\"></span>: <span translate=\"BUY_WIZARD.SUBSCRIPTION\" ng-if=\"vm.form.subscription\"></span> <span translate=\"BUY_WIZARD.ONE_TIME\" ng-if=\"!vm.form.subscription\"></span></div><div flex=\"100\"><span translate=\"BUY_WIZARD.PAYMENT_METHOD\"></span>: <span translate=\"BUY_WIZARD.CARD\" ng-if=\"vm.form.type\"></span><span ng-if=\"!vm.form.type\"><span>PayU</span></span></div><div flex=\"100\"><span translate=\"BUY_WIZARD.PRICE\"></span>: {{(vm.payment.price_total / 100).toFixed(2)}}{{vm.payment.currency }}<span ng-if=\"vm.form.subscription\">/</span><span translate=\"BUY_WIZARD.MONTH\" ng-if=\"vm.form.subscription\"></span></div></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep(2)\" ng-if=\"msWizard.selectedIndex == 3 && !vm.form.type\" ng-disabled=\"msWizard.isFirstStep()\"><span translate=\"OTHER.PREV\"></span></md-button><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-if=\"!(msWizard.selectedIndex == 3 && !vm.form.type)\" ng-disabled=\"msWizard.isFirstStep()\"><span translate=\"OTHER.PREV\"></span></md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep(2)\" ng-if=\"msWizard.selectedIndex == 1 && !vm.form.type\" ng-disabled=\"msWizard.currentStepInvalid()\"><span translate=\"OTHER.NEXT\"></span></md-button><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-if=\"!(msWizard.selectedIndex == 1 && !vm.form.type)\" ng-disabled=\"msWizard.currentStepInvalid()\"><span translate=\"OTHER.NEXT\"></span></md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"(wizardStep3.$invalid && vm.form.type) || vm.request_sending\"><span translate=\"BUY_WIZARD.BUY\"></span></md-button></div></ms-form-wizard></div></div></div></div>");
$templateCache.put("app/main/company/edit/edit.html","<div id=\"company-edit\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><a name=\"up\"></a><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"title\" translate=\"COMPANY_EDIT.TITLE\"></div></div></div><div class=\"content\" layout=\"column\"><md-tabs md-dynamic-height=\"\" md-selected=\"vm.tab_selected\"><md-tab><md-tab-label><span translate=\"COMPANY_EDIT.TAB1\"></span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/company/edit/tabs/tab1.html\'\"></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"COMPANY_EDIT.TAB2\"></span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/company/edit/tabs/tab2.html\'\"></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"COMPANY_EDIT.TAB3\"></span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/company/edit/tabs/tab3.html\'\"></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"COMPANY_EDIT.TAB10\"></span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/company/edit/tabs/tab10.html\'\"></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"COMPANY_EDIT.TAB4\"></span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/company/edit/tabs/tab4.html\'\"></div></md-tab-body></md-tab><md-tab ng-if=\"vm.user_role == \'owner\'\" ng-disabled=\"!vm.is_profile_completed\"><md-tab-label><span translate=\"COMPANY_EDIT.TAB11\"></span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/company/edit/tabs/tab11.html\'\"></div></md-tab-body></md-tab><md-tab ng-if=\"vm.user_role == \'owner\'\"><md-tab-label><span translate=\"COMPANY_EDIT.TAB13\"></span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/company/edit/tabs/tab13.html\'\"></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/company/my-list/my-list.html","<div id=\"company-my-list\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"title\" translate=\"COMPANY_MY_LIST.TITLE\"></div></div></div><div layout=\"column\" flex=\"\"><div class=\"board-selector\" layout=\"column\" layout-align=\"start center\" flex=\"\"><h1 translate=\"COMPANY_MY_LIST.TITLE_1\"></h1><div class=\"board-list\"><div layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div class=\"board-list-item rounded-element\" layout=\"column\" layout-align=\"center center\" ng-repeat=\"company in vm.companies\" ng-click=\"vm.selectCompany(company.id, company.enabled)\" ng-class=\"{\'disabled\': company.enabled == 0}\"><md-icon md-font-icon=\"icon-trello\" class=\"icon s64\"></md-icon><div class=\"board-name\"><b>{{company.name}}</b><br>NIP: {{company.vatin}}<br><span translate=\"COMPANY_MY_LIST.OWNER\"></span>: {{company.owner.data.first_name}} {{company.owner.data.last_name}}</div></div><a class=\"board-list-item rounded-element\" layout=\"column\" layout-align=\"center center\" href=\"/company/new\" ng-if=\"vm.num_owners < 1\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"icon s64\"></md-icon><div class=\"board-name\" translate=\"COMPANY_MY_LIST.ADD\"></div></a></div></div></div><div class=\"board-selector invitations\" layout=\"column\" layout-align=\"start center\" flex=\"\" ng-if=\"vm.invitations.length\"><h1 translate=\"COMPANY_MY_LIST.TITLE_2\"></h1><div class=\"board-list\"><div layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div class=\"board-list-item rounded-element\" layout=\"column\" layout-align=\"center center\" ng-repeat=\"invitation in vm.invitations\" ng-if=\"invitation.status == 0\"><md-icon md-font-icon=\"icon-trello\" class=\"icon s64\"></md-icon><div class=\"board-name\"><b>{{invitation.company.data.name}}</b><br>NIP: {{invitation.company.data.vatin}}<br><span translate=\"COMPANY_MY_LIST.OWNER\"></span>: {{invitation.company.data.owner.data.first_name}} {{invitation.company.data.owner.data.last_name}} <span translate=\"COMPANY_MY_LIST.EXPIRATION\"></span>: {{invitation.expiration_time}}</div><div class=\"invitation-accept\" ng-click=\"vm.accept(invitation.token)\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"icon s32\"></md-icon></div><div class=\"invitation-reject\" ng-click=\"vm.reject(invitation.token)\"><md-icon md-font-icon=\"icon-close-circle\" class=\"icon s32\"></md-icon></div></div></div></div></div></div></div>");
$templateCache.put("app/main/company/new/new.html","<div id=\"company-new\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"title\" translate=\"COMPANY_NEW.TITLE\"></div></div></div><div class=\"content\" layout=\"column\"><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container max-1000\" flex=\"\"><form name=\"newCompany\" novalidate=\"\" ng-submit=\"vm.create(false)\"><div layout-gt-sm=\"row\" ng-if=\"!vm.show_full\"><md-input-container class=\"md-block\" flex=\"100\"><label><span translate=\"COMPANY_NEW.NIP\"></span></label> <input ng-model=\"vm.form_full.vatin\" ng-pattern=\"/^((\\d{3}-\\d{3}-\\d{2}-\\d{2})|(\\d{3}-\\d{2}-\\d{2}-\\d{3})|([0-9]{10}))$/\" name=\"vatin\" required=\"\"><div ng-messages=\"newCompany.vatin.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.NIP\"></span></div></div></md-input-container></div><div flex=\"100\" layout-gt-sm=\"row\" ng-if=\"!vm.show_full && vm.request_sending\"><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float=\"\" ng-if=\"vm.show_full\" flex=\"100\"><label><span translate=\"COMPANY_NEW.NAME\"></span></label> <input ng-model=\"vm.form.name\" required=\"\" ng-maxlength=\"255\" name=\"name\" type=\"text\"><div ng-messages=\"newCompany.name.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"100\"><md-radio-group ng-model=\"vm.form.vat_payer\"><md-radio-button ng-value=\"true\"><span translate=\"COMPANY_NEW.VAT_PAYER_YES\"></span></md-radio-button><md-radio-button ng-value=\"false\"><span translate=\"COMPANY_NEW.VAT_PAYER_NO\"></span></md-radio-button></md-radio-group></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.form.vat_payer\"><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"50\" flex=\"100\"><label><span translate=\"COMPANY_NEW.VAT_REASON\"></span></label><md-select ng-model=\"vm.form.vat_release_reason_id\" name=\"vat_release_reason_id\" required=\"\" ng-if=\"!translate_loading\"><md-option ng-value=\"reason.id\" ng-repeat=\"reason in vm.vat_release_reasons\">{{reason.description}}</md-option></md-select><div ng-messages=\"newCompany.vat_release_reason_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"50\" flex=\"100\" ng-if=\"vm.vat_release_reasons[vm.form.vat_release_reason_id].slug == \'legal_basis\'\"><label><span translate=\"COMPANY_NEW.VAT_REASON_OTHER\"></span></label> <textarea ng-model=\"vm.form.vat_release_reason_note\" ng-maxlength=\"1000\" name=\"vat_release_reason_note\" required=\"\"></textarea><div ng-messages=\"newCompany.vat_release_reason_note.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_1000\"></span></div></div></md-input-container></div><div ng-if=\"!vm.show_full\" layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"COMPANY_NEW.GET_GUS\" ng-click=\"vm.getGus()\" ng-disabled=\"newCompany.$invalid || newCompany.$pristine || vm.request_sending\" translate=\"COMPANY_NEW.GET_GUS\" translate-attr-aria-label=\"COMPANY_NEW.GET_GUS\"></md-button><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"COMPANY_NEW.SKIP\" ng-click=\"vm.skip()\" translate=\"COMPANY_NEW.SKIP\" translate-attr-aria-label=\"COMPANY_NEW.SKIP\"></md-button></div><div ng-if=\"vm.show_full\" layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"CREATE\" ng-if=\"vm.show_full\" ng-disabled=\"newCompany.$invalid || newCompany.$pristine || vm.request_sending\" translate=\"OTHER.CREATE\" translate-attr-aria-label=\"OTHER.CREATE\"></md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/company/payment-back/payment-back.html","<div id=\"company-new\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"title\" translate=\"PAYMENT_BACK.TITLE\"></div></div></div><div class=\"content\" layout=\"column\"><md-icon md-font-icon=\"icon-cash-100 icon icon-flat s120\"></md-icon><div layout=\"row\"><div translate=\"PAYMENT_BACK.CONTENT\" class=\"font-size-20\"></div></div><div layout=\"row\" layout-align=\"center center\" class=\"mt-20\"><a class=\"md-raised md-button md-default-theme md-accent\" ng-href=\"/company/edit\"><span translate=\"OTHER.GO_BACK\"></span></a></div></div></div>");
$templateCache.put("app/main/contractors/form/content.html","<div class=\"form-title\" translate=\"CONTRACTORS_FORM.GENERAL_DATA\"></div><md-radio-group ng-model=\"vm.form.company\"><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"50\" flex-gt-xs=\"25\"><md-radio-button ng-value=\"true\" class=\"md-primary\"><span translate=\"CONTRACTORS_FORM.COMPANY\"></span></md-radio-button></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"25\"><md-radio-button ng-value=\"false\" class=\"md-primary\"><span translate=\"CONTRACTORS_FORM.NATURAL_PERSON\"></span></md-radio-button></md-input-container><div layout=\"row\" flex-gt-xs=\"50\"></div></div></md-radio-group><div layout-gt-sm=\"row\" ng-if=\"!vm.show_full\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex=\"100\"><label><span translate=\"CONTRACTORS_FORM.NIP\"></span></label> <input ng-model=\"vm.form.vatin\" ng-pattern=\"/^((\\d{3}-\\d{3}-\\d{2}-\\d{2})|(\\d{3}-\\d{2}-\\d{2}-\\d{3})|([0-9]{10}))$/\" name=\"vatin\" ng-required=\"vm.form.company\"><div ng-messages=\"formContractor.vatin.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.NIP\"></span></div></div></md-input-container><md-input-container class=\"md-block mt-10\" layout-align=\"end center\" flex-gt-sm=\"\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"CONTRACTORS_FORM.GET_GUS\" ng-click=\"vm.getGus()\" ng-disabled=\"formContractor.$invalid || (formContractor.$pristine && !vm.copy_nip) || vm.request_sending\" translate=\"CONTRACTORS_FORM.GET_GUS\" translate-attr-aria-label=\"CONTRACTORS_FORM.GET_GUS\"></md-button><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"CONTRACTORS_FORM.SKIP\" ng-click=\"vm.skip()\" translate=\"CONTRACTORS_FORM.SKIP\" translate-attr-aria-label=\"CONTRACTORS_FORM.SKIP\"></md-button></md-input-container></div><div flex=\"100\" layout-gt-sm=\"row\" ng-if=\"!vm.show_full && vm.request_sending\"><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear></div><div ng-if=\"vm.show_full\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label><span ng-if=\"vm.form.company\" translate=\"CONTRACTORS_FORM.COMPANY_NAME\"></span> <span ng-if=\"!vm.form.company\" translate=\"CONTRACTORS_FORM.COMPANY_NAME_2\"></span></label> <input ng-model=\"vm.form.name\" required=\"\" ng-maxlength=\"255\" name=\"name\"><div ng-messages=\"formContractor.name.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex=\"100\"><label><span translate=\"CONTRACTORS_FORM.NIP_PREFIX\"></span></label><md-select ng-model=\"vm.form.country_vatin_prefix_id\" name=\"country_vatin_prefix_id\" ng-if=\"!translate_loading\" ng-change=\"vm.checkErrors(\'vatin\')\"><md-option ng-value=\"null\"><span translate=\"CONTRACTORS_FORM.NIP_EMPTY\"></span></md-option><md-option ng-value=\"country.id\" ng-repeat=\"country in vm.countries\">{{country.key}} ({{country.name}})</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex=\"100\" ng-if=\"!vm.form.country_vatin_prefix_id || vm.pl_id == vm.form.country_vatin_prefix_id\"><label><span translate=\"CONTRACTORS_FORM.NIP\"></span></label> <input ng-model=\"vm.form.vatin\" ng-pattern=\"/^((\\d{3}-\\d{3}-\\d{2}-\\d{2})|(\\d{3}-\\d{2}-\\d{2}-\\d{3})|([0-9]{10}))$/\" name=\"vatin\" ng-required=\"vm.form.company\" id=\"nip-contractor\"><div ng-messages=\"formContractor.vatin.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.NIP\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex=\"100\" ng-if=\"vm.form.country_vatin_prefix_id && vm.pl_id != vm.form.country_vatin_prefix_id\"><label><span translate=\"CONTRACTORS_FORM.NIP\"></span></label> <input ng-model=\"vm.form.vatin\" name=\"vatin\" ng-required=\"vm.form.company\"><div ng-messages=\"formContractor.vatin.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex=\"100\"><label><span translate=\"CONTRACTORS_FORM.EMAIL\"></span></label> <input ng-model=\"vm.form.email\" ng-maxlength=\"255\" name=\"email\" type=\"email\"><div ng-messages=\"formContractor.email.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"email\"><span translate=\"ERRORS.FORM.EMAIL\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.PHONE\"></span></label> <input ng-model=\"vm.form.phone\" minlength=\"9\" ng-maxlength=\"15\" name=\"phone\"><div ng-messages=\"formContractor.phone.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.PHONE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.PHONE\"></span></div></div></md-input-container></div><div class=\"form-title\" translate=\"CONTRACTORS_FORM.MAIN_ADDRESS\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.COUNTRY\"></span></label><md-select ng-model=\"vm.form.main_address_country\" name=\"main_address_country\" ng-if=\"!translate_loading\" ng-change=\"vm.checkErrors(\'main_address_zip_code\')\"><md-option ng-value=\"country.name | uppercase\" ng-repeat=\"country in vm.countries\">{{country.name}}</md-option></md-select><div ng-messages=\"formContractor.main_address_country.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.STREET\"></span></label> <input ng-model=\"vm.form.main_address_street\" ng-minlength=\"4\" name=\"main_address_street\" required=\"\" ng-maxlength=\"255\"><div ng-messages=\"formContractor.main_address_street.$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_4\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.NUMBER\"></span></label> <input ng-model=\"vm.form.main_address_number\" name=\"main_address_number\" required=\"\" ng-maxlength=\"31\"><div ng-messages=\"formContractor.main_address_number.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_31\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.form.main_address_country == \'POLSKA\'\"><label><span translate=\"CONTRACTORS_FORM.ZIP_CODE\"></span></label> <input ng-model=\"vm.form.main_address_zip_code\" name=\"main_address_zip_code\" required=\"\" ng-pattern=\"/^[0-9]{2}-[0-9]{3}$/\" maxlength=\"6\" zip-code=\"\"><div ng-messages=\"formContractor.main_address_zip_code.$error\" role=\"alert\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\" class=\"my-message\"><span translate=\"ERRORS.FORM.POST_CODE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.form.main_address_country != \'POLSKA\'\"><label><span translate=\"CONTRACTORS_FORM.ZIP_CODE\"></span></label> <input ng-model=\"vm.form.main_address_zip_code\" name=\"main_address_zip_code\" required=\"\" maxlength=\"255\"><div ng-messages=\"formContractor.main_address_zip_code.$error\" role=\"alert\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.CITY\"></span></label> <input ng-model=\"vm.form.main_address_city\" name=\"main_address_city\" required=\"\" ng-minlength=\"2\" ng-maxlength=\"63\"><div ng-messages=\"formContractor.main_address_city.$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_2\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_63\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.edit\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"50\"><md-checkbox ng-model=\"vm.other_contact_address\" name=\"other_contact_address\"><span translate=\"CONTRACTORS_FORM.OTHER_CONTACT_ADDRESS\"></span></md-checkbox></md-input-container></div><div class=\"form-title\" translate=\"CONTRACTORS_FORM.CONTACT_ADDRESS\" ng-if=\"vm.other_contact_address\"></div><div layout-gt-sm=\"row\" ng-if=\"vm.other_contact_address\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.COUNTRY\"></span></label><md-select ng-model=\"vm.form.contact_address_country\" name=\"contact_address_country\" ng-if=\"!translate_loading\" ng-change=\"vm.checkErrors(\'contact_address_zip_code\')\"><md-option ng-value=\"country.name | uppercase\" ng-repeat=\"country in vm.countries\">{{country.name}}</md-option></md-select><div ng-messages=\"formContractor.contact_address_country.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.other_contact_address\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.STREET\"></span></label> <input ng-model=\"vm.form.contact_address_street\" ng-minlength=\"4\" name=\"contact_address_street\" required=\"\" ng-maxlength=\"255\"><div ng-messages=\"formContractor.contact_address_street.$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_4\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.NUMBER\"></span></label> <input ng-model=\"vm.form.contact_address_number\" name=\"contact_address_number\" required=\"\" ng-maxlength=\"31\"><div ng-messages=\"formContractor.contact_address_number.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_31\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.other_contact_address\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.form.contact_address_country == \'POLSKA\'\"><label><span translate=\"CONTRACTORS_FORM.ZIP_CODE\"></span></label> <input ng-model=\"vm.form.contact_address_zip_code\" name=\"contact_address_zip_code\" required=\"\" ng-pattern=\"/^[0-9]{2}-[0-9]{3}$/\" maxlength=\"6\" zip-code=\"\"><div ng-messages=\"formContractor.contact_address_zip_code.$error\" role=\"alert\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\" class=\"my-message\"><span translate=\"ERRORS.FORM.POST_CODE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.form.contact_address_country != \'POLSKA\'\"><label><span translate=\"CONTRACTORS_FORM.ZIP_CODE\"></span></label> <input ng-model=\"vm.form.contact_address_zip_code\" name=\"contact_address_zip_code\" required=\"\" maxlength=\"255\"><div ng-messages=\"formContractor.contact_address_zip_code.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.CITY\"></span></label> <input ng-model=\"vm.form.contact_address_city\" name=\"contact_address_city\" required=\"\" ng-minlength=\"2\" ng-maxlength=\"63\"><div ng-messages=\"formContractor.contact_address_city.$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_2\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_63\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"end none\" ng-if=\"vm.other_contact_address\"><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.copyToContact()\" translate=\"CONTRACTORS_FORM.ADDRESS_COPY\">COPY</md-button></div><div layout-gt-sm=\"row\" ng-if=\"!vm.edit && vm.addresses_delivery_enabled\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"50\"><md-checkbox ng-model=\"vm.other_delivery_address\" name=\"other_delivery_address\"><span translate=\"CONTRACTORS_FORM.OTHER_DELIVERY_ADDRESS\"></span></md-checkbox></md-input-container></div><div ng-if=\"vm.addresses_delivery_enabled && vm.other_delivery_address\" class=\"form-title\" translate=\"CONTRACTORS_FORM.DELIVERY_ADDRESS\"></div><div ng-if=\"vm.addresses_delivery_enabled && vm.other_delivery_address\" ng-repeat=\"(key, value) in vm.form.addresses\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.COUNTRY\"></span></label><md-select ng-model=\"vm.form.addresses[$index].country\" name=\"addresses_{{$index}}_country\" ng-if=\"!translate_loading\" ng-change=\"vm.checkErrors(\'addresses_\'+$index+\'_zip_code\')\"><md-option ng-value=\"country.name | uppercase\" ng-repeat=\"country in vm.countries\">{{country.name}}</md-option></md-select><div ng-messages=\"formContractor[\'addresses_\'+$index+\'_country\'].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.STREET\"></span></label> <input ng-model=\"vm.form.addresses[$index].street\" ng-minlength=\"4\" name=\"addresses_{{$index}}_street\" required=\"\" ng-maxlength=\"255\"><div ng-messages=\"formContractor[\'addresses_\'+$index+\'_street\'].$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_4\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.NUMBER\"></span></label> <input ng-model=\"vm.form.addresses[$index].number\" name=\"addresses_{{$index}}_number\" required=\"\" ng-maxlength=\"31\"><div ng-messages=\"formContractor[\'addresses_\'+$index+\'_number\'].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_31\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.form.addresses[$index].country == \'POLSKA\'\"><label><span translate=\"CONTRACTORS_FORM.ZIP_CODE\"></span></label> <input ng-model=\"vm.form.addresses[$index].zip_code\" name=\"addresses_{{$index}}_zip_code\" required=\"\" ng-pattern=\"/^[0-9]{2}-[0-9]{3}$/\" maxlength=\"6\" zip-code=\"\"><div ng-messages=\"formContractor[\'addresses_\'+$index+\'_zip_code\'].$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\" class=\"my-message\"><span translate=\"ERRORS.FORM.POST_CODE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.form.addresses[$index].country != \'POLSKA\'\"><label><span translate=\"CONTRACTORS_FORM.ZIP_CODE\"></span></label> <input ng-model=\"vm.form.addresses[$index].zip_code\" name=\"addresses_{{$index}}_zip_code\" required=\"\" maxlength=\"255\"><div ng-messages=\"formContractor[\'addresses_\'+$index+\'_zip_code\'].$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.CITY\"></span></label> <input ng-model=\"vm.form.addresses[$index].city\" name=\"addresses_{{$index}}_city\" required=\"\" ng-minlength=\"2\" ng-maxlength=\"63\"><div ng-messages=\"formContractor[\'addresses_\'+$index+\'_city\'].$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_2\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_63\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"50\"><md-checkbox ng-model=\"vm.form.addresses[$index].default\" name=\"addresses_{{$index}}_default\" ng-change=\"vm.changeDefaultDeliver($index)\"><span translate=\"CONTRACTORS_FORM.DELIVERY_ADDRESS_DEFAULT\"></span></md-checkbox></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"end none\" ng-if=\"key == 0\"><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.copyContactToDeliver()\" translate=\"CONTRACTORS_FORM.CONTACT_COPY\">COPY</md-button><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.copyMainToDeliver()\" translate=\"CONTRACTORS_FORM.ADDRESS_COPY\">COPY</md-button></div></div><div ng-if=\"vm.addresses_delivery_enabled && vm.other_delivery_address\" layout-gt-sm=\"row\" layout-align=\"end none\"><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.delDeliveryAddress()\" aria-label=\"\" translate=\"INFO.DELETE_LAST\" ng-disabled=\"vm.form.addresses.length == 1\">DELETE</md-button><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.addDeliveryAddress()\" aria-label=\"\" translate=\"INFO.ADD_NEXT\" ng-disabled=\"vm.form.addresses.length == 4\">ADD</md-button></div><div class=\"form-title\" translate=\"CONTRACTORS_FORM.DEFAULT_SETTINGS\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.TERM\"></span></label><md-select ng-model=\"vm.term\" name=\"term\" ng-if=\"!translate_loading\"><md-option ng-value=\"null\"><span translate=\"CONTRACTORS_FORM.DEFAULT\"></span></md-option><md-option value=\"7\">7 <span translate=\"CONTRACTORS_FORM.DAYS\"></span></md-option><md-option value=\"14\">14 <span translate=\"CONTRACTORS_FORM.DAYS\"></span></md-option><md-option value=\"30\">30 <span translate=\"CONTRACTORS_FORM.DAYS\"></span></md-option><md-option value=\"90\">90 <span translate=\"CONTRACTORS_FORM.DAYS\"></span></md-option><md-option value=\"d\"><span translate=\"CONTRACTORS_FORM.DAYS\"></span></md-option></md-select><div ng-messages=\"formContractor.term.$error\" role=\"alert\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.DAYS\"></span></label> <input pattern=\"\\d+\" ng-model=\"vm.days\" name=\"days\" ng-required=\"vm.term==\'d\'\" ng-disabled=\"vm.term!=\'d\'\"><div ng-messages=\"formContractor.days.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.NUMBER\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CONTRACTORS_FORM.METHOD\"></span></label><md-select ng-model=\"vm.form.default_payment_method_id\" name=\"default_payment_method_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"null\"><span translate=\"CONTRACTORS_FORM.DEFAULT\"></span></md-option><md-option ng-value=\"method.id\" ng-repeat=\"method in vm.methods\">{{method.name}}</md-option></md-select><div ng-messages=\"formContractor.default_payment_method_id.$error\" role=\"alert\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/contractors/form/form.html","<div id=\"contractors-form\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\" flex=\"100\"><div layout=\"row\"><div ng-if=\"!vm.edit\" class=\"title\" translate=\"CONTRACTORS_FORM.TITLE_ADD\" flex=\"70\"></div><div ng-if=\"vm.edit\" class=\"title\" translate=\"CONTRACTORS_FORM.TITLE_EDIT\" flex=\"70\"></div><div flex=\"30\" layout=\"row\" layout-align=\"end center\"><md-button href=\"/contractors/list\" class=\"md-raised\" aria-label=\"Go Back\" translate=\"OTHER.GO_BACK\" translate-attr-aria-label=\"OTHER.GO_BACK\">Go Back</md-button></div></div></div></div><div class=\"content\" layout=\"column\"><a name=\"up\"></a><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><form id=\"formContractor\" name=\"formContractor\" novalidate=\"\" ng-submit=\"vm.send(false, false)\"><div ng-include=\"\'app/main/contractors/form/content.html\'\"></div><div layout=\"row\" layout-align=\"end none\" ng-if=\"vm.show_full\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-click=\"vm.send(false, true)\" ng-disabled=\"formContractor.$invalid || formContractor.$pristine || vm.request_sending\" translate=\"CONTRACTORS_FORM.SAVE_AND_INVOICE\" translate-attr-aria-label=\"CONTRACTORS_FORM.SAVE_AND_INVOICE\"></md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-disabled=\"formContractor.$invalid || formContractor.$pristine || vm.request_sending\" translate=\"OTHER.SAVE\" translate-attr-aria-label=\"OTHER.SAVE\"></md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/contractors/form/modal.html","<md-dialog id=\"contractors-form-dialog\" aria-label=\"METHOD\" style=\"overflow: hidden;\"><form id=\"formContractor\" name=\"formContractor\" novalidate=\"\" ng-submit=\"vm.send(true, false)\"><md-toolbar class=\"md-accent md-hue-2\"><div ng-if=\"!vm.edit\" class=\"title\" translate=\"CONTRACTORS_FORM.TITLE_ADD\" flex=\"70\"></div><div ng-if=\"vm.edit\" class=\"title\" translate=\"CONTRACTORS_FORM.TITLE_EDIT\" flex=\"70\"></div></md-toolbar><md-dialog-content ms-scroll=\"\"><a name=\"up\"></a><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper min-1000\"><div ng-include=\"\'app/main/contractors/form/content.html\'\"></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.show_full\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-disabled=\"formContractor.$invalid || (formContractor.$pristine && !vm.copy_nip) || vm.request_sending\" translate=\"OTHER.SAVE\" translate-attr-aria-label=\"OTHER.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/contractors/list/list.html","<div id=\"contractors-list\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"title\" translate=\"CONTRACTORS_LIST.TITLE\"></div></div></div><div class=\"content\" layout=\"column\"><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><form novalidate=\"\" ng-submit=\"vm.getContractors()\"><div layout=\"row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"50\"><label><span translate=\"CONTRACTORS_LIST.SEARCH\"></span></label> <input ng-model=\"vm.query.search\" type=\"search\" name=\"search\"></md-input-container><div layout=\"row\" layout-align=\"start center\" flex-gt-xs=\"25\"><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.getContractors()\"><span translate=\"CONTRACTORS_LIST.SEARCH\"></span></md-button></div><div layout=\"row\" layout-align=\"end center\" flex-gt-xs=\"25\" ng-if=\"!vm.is_tax_office\"><a class=\"md-raised md-button md-default-theme md-accent\" ng-href=\"/contractors/form/new\"><span translate=\"CONTRACTORS_LIST.ADD\"></span></a></div></div></form><div ng-if=\"vm.pagination.total\" class=\"table-wrapper\"><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"CONTRACTORS_LIST.CONTRACTOR\"></span></th><th md-column=\"\"><span translate=\"CONTRACTORS_LIST.NIP\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"CONTRACTORS_LIST.CREATED\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"CONTRACTORS_LIST.PAID\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"CONTRACTORS_LIST.AFTER\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\">Akcje</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"contractor in vm.contractors\"><td md-cell=\"\">{{ vm.pagination | no:$index }}</td><td md-cell=\"\"><div>{{ contractor.name }}</div><div>{{ contractor.main_address_street }} {{ contractor.main_address_number }}, {{ contractor.main_address_zip_code }} {{ contractor.main_address_city }}</div></td><td md-cell=\"\">{{contractor.vatin_prefix.data.key}}{{ contractor.vatin }}</td><td md-cell=\"\">{{ contractor.payments_all | numFormat}}zł</td><td md-cell=\"\">{{ contractor.payments_paid | numFormat}}zł</td><td md-cell=\"\">{{ contractor.payments_paid_late | numFormat}}zł</td><td md-cell=\"\"><md-menu ng-if=\"!vm.is_tax_office\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.invoice_add(contractor.id)\" aria-label=\"Edit\"><span translate=\"CONTRACTORS_LIST.INVOICE_ADD\"></span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.edit(contractor.id)\" aria-label=\"Edit\"><span translate=\"OTHER.EDIT\"></span></md-button></md-menu-item><md-menu-item ng-if=\"contractor.is_used != true\"><md-button ng-click=\"vm.deleteContractor(contractor.id)\" aria-label=\"Delete\"><span translate=\"OTHER.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{vm.table_translate}}\" md-limit=\"vm.query.limit\" md-page=\"vm.query.page\" md-total=\"{{vm.pagination.total}}\" md-on-paginate=\"vm.getContractors\" md-page-select=\"\"></md-table-pagination></div><div layout=\"row\" ng-if=\"vm.pagination.total == 0\" translate=\"OTHER.NO_RECORDS\" class=\"text-center\"></div></div></div></div></div>");
$templateCache.put("app/main/errors/403/error-403.html","<div id=\"errors-page\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR403.CODE\"></div><div class=\"message\" translate=\"ERROR403.MESSAGE\"></div><a class=\"report-link md-accent-color\" ng-click=\"vm.back()\" translate=\"ERROR403.BACK\"></a></div></div>");
$templateCache.put("app/main/errors/404/error-404.html","<div id=\"errors-page\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR404.CODE\"></div><div class=\"message\" translate=\"ERROR404.MESSAGE\"></div><a class=\"report-link md-accent-color\" ng-click=\"vm.back()\" translate=\"ERROR404.BACK\"></a></div></div>");
$templateCache.put("app/main/errors/500/error-500.html","<div id=\"errors-page\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\"></div><div class=\"message\" translate=\"ERROR500.MESSAGE\"></div><a class=\"report-link md-accent-color\" ng-click=\"vm.back()\" translate=\"ERROR500.BACK\"></a></div></div>");
$templateCache.put("app/main/invoices/add-payment/add-payment.html","<md-dialog aria-label=\"METHOD\"><div id=\"add-edit-user-dialog\"><form id=\"addPyment\" name=\"addPyment\"><div layout-gt-sm=\"row\"><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div></div><div class=\"mb-20\"><span ng-if=\"!vm.edit\" translate=\"INVOICES_LIST.PAYMENTS.ADD\" class=\"font-size-16\"></span></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_LIST.PAYMENTS.AMOUNT\"></span></label> <input ng-model=\"vm.form.amount\" name=\"amount\" required=\"\" type=\"number\" step=\"0.01\" min=\"0\" max=\"{{vm.max_payment}}\"><div ng-messages=\"addPyment.amount.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"number\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"max\"><span translate=\"ERRORS.FORM.MAX_AMOUNT\"></span></div><div ng-message=\"step\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div></div></md-input-container></div><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"INVOICES_LIST.PAYMENTS.PAYMENT_METHOD\"></span></label><md-select ng-model=\"vm.form.payment_method_id\" required=\"\" name=\"payment_method_id\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"method.id\" ng-repeat=\"method in vm.payment_methods\">{{method.name}}</md-option></md-select><div ng-messages=\"addPyment.payment_method_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><div layout-gt-sm=\"row\" layout-align=\"end none\"><md-button ng-if=\"!vm.edit\" type=\"button\" class=\"md-raised md-accent\" aria-label=\"CANCEL\" translate=\"OTHER.CANCEL\" ng-click=\"vm.hide()\" translate-attr-aria-label=\"OTHER.CANCEL\"></md-button><md-button ng-if=\"!vm.edit\" type=\"button\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-disabled=\"addPyment.$invalid || vm.request_sending\" translate=\"OTHER.SAVE\" ng-click=\"vm.create()\" translate-attr-aria-label=\"OTHER.SAVE\"></md-button></div></form></div></md-dialog>");
$templateCache.put("app/main/invoices/form/form.html","<div id=\"invoice-form\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\" flex=\"100\"><div layout=\"row\"><div class=\"title\" flex=\"70\"><span translate=\"INVOICES_FORM.TITLE_ADD\"></span>&nbsp;{{vm.title}}</div><div flex=\"30\" layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"!vm.for_contractor\" href=\"/invoices/list\" class=\"md-raised\" aria-label=\"Go Back\" translate=\"OTHER.GO_BACK\" translate-attr-aria-label=\"OTHER.GO_BACK\">Go Back</md-button><md-button ng-if=\"vm.for_contractor\" href=\"/contractors/list\" class=\"md-raised\" aria-label=\"Go Back\" translate=\"OTHER.GO_BACK\" translate-attr-aria-label=\"OTHER.GO_BACK\">Go Back</md-button></div></div></div></div><div class=\"content\" layout=\"column\"><a name=\"up\"></a><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000 max-1000\"><form id=\"formInvoice\" name=\"formInvoice\" novalidate=\"\" ng-submit=\"vm.send()\"><div class=\"form-title\" translate=\"INVOICES_FORM.GENERAL\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.ISSUE_DATE\"></span></label> <input ng-model=\"vm.form.issue_date\" name=\"issue_date\" moment-picker=\"vm.form.issue_date\" format=\"YYYY-MM-DD\" start-view=\"decade\" locale=\"pl\"><div ng-messages=\"formInvoice.issue_date.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.SALE_DATE\"></span></label> <input ng-model=\"vm.form.sale_date\" name=\"sale_date\" moment-picker=\"vm.form.sale_date\" format=\"YYYY-MM-DD\" start-view=\"decade\" locale=\"pl\" ng-disabled=\"vm.is_extra_item\"><div ng-messages=\"formInvoice.sale_date.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.type == \'currency\' || vm.type == \'currency_reverse_charge\'\"><label><span translate=\"INVOICES_FORM.CURRENCY\"></span></label><md-select ng-model=\"vm.form.currency\" required=\"\" name=\"currency\" ng-if=\"!translate_loading\"><md-option ng-value=\"currency.code\" ng-repeat=\"currency in vm.currencies\">{{currency.code}} - {{ currency.name }}</md-option></md-select><div ng-messages=\"formInvoice.currency.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.type != \'margin\' && vm.type != \'margin_proforma\' && vm.type != \'reverse_charge\' && vm.type != \'currency_reverse_charge\' && vat_payer\"><label><span translate=\"INVOICES_FORM.COUNT_TAX\"></span></label><md-select ng-model=\"vm.form.gross_counted\" required=\"\" name=\"gross_counted\" ng-if=\"!translate_loading\" ng-disabled=\"vm.is_extra_item\"><md-option ng-value=\"0\"><span translate=\"INVOICES_FORM.FROM_NET\"></span></md-option><md-option ng-value=\"1\"><span translate=\"INVOICES_FORM.FROM_GROSS\"></span></md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.type == \'margin\' || vm.type == \'margin_proforma\'\"><label><span translate=\"INVOICES_FORM.MARGIN_PROCEDURES\"></span></label><md-select ng-model=\"vm.form.invoice_margin_procedure_id\" required=\"\" name=\"invoice_margin_procedure_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"procedure.id\" ng-repeat=\"procedure in vm.margin_procedures\">{{procedure.description}}</md-option></md-select><div ng-messages=\"formInvoice.invoice_margin_procedure_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.type == \'reverse_charge\' || vm.type == \'currency_reverse_charge\'\"><label><span translate=\"INVOICES_FORM.REVERSE_CHANGES\"></span></label><md-select ng-model=\"vm.form.invoice_reverse_charge_id\" required=\"\" name=\"invoice_reverse_charge_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"type.id\" ng-repeat=\"type in vm.reverse_changes\">{{type.description}}</md-option></md-select><div ng-messages=\"formInvoice.invoice_reverse_charge_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.registries.length > 1\"><label><span translate=\"INVOICES_FORM.REGISTER\"></span></label><md-select ng-model=\"vm.form.invoice_registry_id\" required=\"\" name=\"invoice_registry_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"register.id\" ng-repeat=\"register in vm.registries\">{{register.prefix}}<span ng-if=\"register.prefix != \'\'\">/</span>{{vm.invoice_formats[register.invoice_format_id].name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.registries.length < 2\"></md-input-container></div><div class=\"form-title\" translate=\"INVOICES_FORM.CLIENT\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block autocomplete-container\" flex-gt-sm=\"50\"><label><span translate=\"OTHER.NAME\"></span></label><md-autocomplete autocomplete-required=\"\" md-input-name=\"contractor\" ng-model-options=\"{debounce:200}\" md-selected-item=\"vm.contractor\" md-search-text=\"vm.search_text_contractor\" md-items=\"item in vm.searchContractor(vm.search_text_contractor)\" md-item-text=\"item.name\" ng-click=\"vm.selectedAutocompleteContractor(\'contractor\')\" placeholder=\"{{ \'INVOICES_FORM.SEARCH_CLIENT\' | translate }}\"><md-item-template><span md-highlight-text=\"vm.search_text_contractor\">{{item.name}}</span></md-item-template><md-not-found><span translate=\"OTHER.NOT_FOUND\"></span> <a ng-click=\"vm.addNewContractor()\" translate=\"OTHER.ADD_NEW_1\"></a></md-not-found></md-autocomplete><div ng-messages=\"formInvoice.contractor.$error\"><div ng-message=\"selectedItem\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><div ng-if=\"vm.contractor.id\" layout-gt-sm=\"row\" layout-wrap=\"\" class=\"mb-20 ml-30\">{{vm.contractor.name}}<br><div layout=\"row\" flex=\"100\">{{ vm.contractor.main_address_street }} {{ vm.contractor.main_address_number }}, {{ vm.contractor.main_address_zip_code }} {{ vm.contractor.main_address_city }}</div><div layout=\"row\" flex=\"100\"><span translate=\"INVOICES_FORM.VATIN\"></span>: {{vm.contractor.vatin_prefix.data.key}}{{vm.contractor.vatin}}</div><div ng-if=\"vm.contractor.id && vm.contractor.vatin && vm.contractor.vatin.length\"><md-button ng-click=\"vm.checkClientData()\" type=\"button\" ng-disabled=\"vm.loading_gus\" class=\"ml-0\">{{ \'INVOICES_FORM.CHECK_CLIENT_DATA\' | translate }}</md-button><md-progress-circular ng-if=\"vm.loading_gus\" md-mode=\"indeterminate\" md-diameter=\"24\" class=\"m-10 md-accent\"></md-progress-circular><div ng-if=\"vm.contractor.gus_diff && !vm.loading_gus\"><div class=\"mb-10 red-800-fg\">{{ \'INVOICES_FORM.GUS_DIFFERENT\' | translate }}:</div><div>{{ vm.contractor.gus_data.name }}<br>{{ vm.contractor.gus_data.main_address_street }} {{ vm.contractor.gus_data.main_address_number }}, {{ vm.contractor.gus_data.main_address_zip_code }} {{ vm.contractor.gus_data.main_address_city }}</div><md-button v-if=\"!vm.contractor.updated\" ng-click=\"vm.updateClientData($event)\" type=\"button\" class=\"md-raised md-accent ml-0 mt-10\">{{ \'INVOICES_FORM.UPDATE\' | translate }}</md-button></div><div ng-if=\"vm.contractor.gus_ok && !vm.loading_gus\" class=\"green-800-fg\">{{ \'INVOICES_FORM.GUS_OK\' | translate }}!</div></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container ng-if=\"vm.addresses_delivery_enabled\" class=\"md-block\" flex-gt-sm=\"\" flex=\"50\"><md-checkbox ng-model=\"vm.form.default_delivery\" name=\"default_delivery\" class=\"\"><span translate=\"INVOICES_FORM.DELIVERY_ADDRESS_OTHER\"></span></md-checkbox></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.addresses_delivery_enabled && vm.form.default_delivery\"><md-input-container class=\"md-block autocomplete-container\" flex-gt-sm=\"50\"><label><span translate=\"OTHER.NAME\"></span></label><md-autocomplete autocomplete-required=\"\" md-input-name=\"delivery_contractor\" ng-model-options=\"{debounce:200}\" md-selected-item=\"vm.delivery_contractor\" md-search-text=\"vm.search_text_delivery_contractor\" md-items=\"item in vm.searchContractor(vm.search_text_delivery_contractor)\" md-item-text=\"item.name\" md-selected-item-change=\"vm.changeContractorDelivery()\" ng-click=\"vm.selectedAutocompleteContractor(\'contractor_delivery\')\"><md-item-template><span md-highlight-text=\"vm.search_text_delivery_contractor\">{{item.name}}</span></md-item-template><md-not-found><span translate=\"OTHER.NOT_FOUND\"></span> <a ng-click=\"vm.addNewContractor()\" translate=\"OTHER.ADD_NEW_1\"></a></md-not-found></md-autocomplete><div ng-messages=\"formInvoice.delivery_contractor.$error\"><div ng-message=\"selectedItem\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.delivery_contractor && vm.delivery_contractor.addresses.data\"><label><span translate=\"INVOICES_FORM.DELIVERY_ADDRESS\"></span></label><md-select ng-model=\"vm.form.delivery_address_id\" required=\"\" name=\"delivery_address_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"address.id\" ng-repeat=\"address in vm.delivery_contractor.addresses.data\">{{address.name}}</md-option></md-select><div ng-messages=\"formInvoice.delivery_address_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div class=\"form-title\" translate=\"INVOICES_FORM.PRODUCTS\"></div><div layout=\"row\"><div class=\"table-wrapper table-products\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\" hide-xs=\"\" hide-sm=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\" width=\"40%\"><span translate=\"INVOICES_FORM.PRODUCT\"></span></th><th md-column=\"\" width=\"10%\"><span translate=\"INVOICES_FORM.QUANTITY\"></span></th><th md-column=\"\" width=\"10%\"><span translate=\"INVOICES_FORM.UNIT\"></span></th><th md-column=\"\" width=\"10%\" ng-if=\"!vm.form.gross_counted\">{{ \'INVOICES_FORM.PRICE_NET\' | translate }} ({{ vm.form.currency || \'zł\' }})</th><th md-column=\"\" width=\"10%\" ng-if=\"!vm.form.gross_counted\">{{ \'INVOICES_FORM.PRICE_NET_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</th><th md-column=\"\" width=\"10%\" ng-if=\"vm.form.gross_counted\"><span ng-if=\"vat_payer\">{{ \'INVOICES_FORM.PRICE_GROSS\' | translate }} ({{ vm.form.currency || \'zł\' }})</span> <span ng-if=\"!vat_payer\">{{ \'INVOICES_FORM.PRICE\' | translate }} ({{ vm.form.currency || \'zł\' }})</span></th><th md-column=\"\" width=\"10%\" ng-if=\"vm.form.gross_counted\"><span ng-if=\"vat_payer\">{{ \'INVOICES_FORM.PRICE_GROSS_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</span> <span ng-if=\"!vat_payer\">{{ \'INVOICES_FORM.PRICE_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</span></th><th md-column=\"\" width=\"10%\" ng-if=\"vat_payer\"><span translate=\"INVOICES_FORM.TAX\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\">Akcje</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.form.items track by $index\"><td md-cell=\"\">{{ ($index + 1) }}</td><td md-cell=\"\"><div class=\"short-services\" hide-sm=\"\" hide-xs=\"\" layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><span ng-repeat=\"product in vm.products_short_list\" ng-click=\"item.current_service = product\" class=\"service\">{{product.name}}</span></div><md-input-container class=\"md-block autocomplete-container\" flex=\"100\"><label hide-gt-sm=\"\"><span translate=\"INVOICES_FORM.PRODUCT\"></span></label><md-autocomplete autocomplete-required=\"\" ng-disabled=\"vm.is_extra_item\" md-input-name=\"company_service_id_{{$index}}\" ng-model-options=\"{debounce:200}\" md-selected-item=\"item.current_service\" md-search-text=\"item.search_text\" md-items=\"item in vm.searchProducts(item.search_text)\" md-item-text=\"item.name\" ng-click=\"vm.selectedAutocompleteProduct($index)\" placeholder=\"{{ \'INVOICES_FORM.SEARCH_PRODUCT\' | translate }}\"><md-item-template><span md-highlight-text=\"item.search_text\">{{item.name}}</span></md-item-template><md-not-found><span translate=\"OTHER.NOT_FOUND\"></span> <a ng-click=\"vm.addNewProduct()\" translate=\"OTHER.ADD_NEW_4\"></a></md-not-found></md-autocomplete><div ng-messages=\"formInvoice[\'company_service_id_\'+$index].$error\"><div ng-message=\"selectedItem\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block input-style\" flex=\"100\" ng-if=\"item.custom_name_enable\"><input ng-model=\"item.custom_name\" name=\"custom_name_{{$index}}\" required=\"\" ng-maxlength=\"255\" placeholder=\"{{ \'INVOICES_FORM.ENTER_DESCRIPTION\' | translate }}\"><div ng-messages=\"formInvoice[\'custom_name_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><div class=\"custom-name-checkbox\" ng-if=\"vm.custom_name_products_enable\"><a ng-if=\"!item.custom_name_enable\" ng-click=\"item.custom_name_enable=true\" translate=\"INVOICES_FORM.CUSTOM_NAME_ENABLE\"></a> <a ng-if=\"item.custom_name_enable\" ng-click=\"vm.clearCustomName(item)\" translate=\"INVOICES_FORM.CUSTOM_NAME_DISABLE\"></a></div></td><td md-cell=\"\"><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\"><label hide-gt-sm=\"\"><span translate=\"INVOICES_FORM.QUANTITY\"></span></label> <input ng-model=\"item.quantity\" name=\"quantity_{{$index}}\" required=\"\" type=\"number\" step=\"{{item.service_unit.decimal ? 0.001 : 1}}\" min=\"1\" ng-disabled=\"vm.is_extra_item\"><div ng-messages=\"formInvoice[\'quantity_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"number\"><span translate=\"ERRORS.FORM.NUMBER\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.NUMBER\"></span></div><div ng-message=\"step\"><span ng-if=\"!item.service_unit.decimal\" translate=\"ERRORS.FORM.INTEGER\"></span> <span ng-if=\"item.service_unit.decimal\" translate=\"ERRORS.FORM.NUMBER_3_DP\"></span></div></div></md-input-container></td><td md-cell=\"\"><md-input-container class=\"md-block select-style\" flex-gt-sm=\"\"><label hide-gt-sm=\"\"><span translate=\"INVOICES_FORM.UNIT\"></span></label><md-select ng-model=\"item.service_unit_id\" required=\"\" name=\"service_unit_id_{{$index}}\" ng-disabled=\"vm.is_extra_item\"><md-option ng-value=\"unit.id\" ng-repeat=\"unit in vm.units\" ng-if=\"unit.id\">{{unit.slug}}</md-option></md-select><div ng-messages=\"formInvoice[\'service_unit_id_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></td><td md-cell=\"\"><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\" ng-if=\"!vm.form.gross_counted\"><label hide-gt-sm=\"\">{{ \'INVOICES_FORM.PRICE_NET\' | translate }} ({{ vm.form.currency || \'zł\' }})</label> <input ng-model=\"item.price_net\" name=\"price_net_{{$index}}\" required=\"\" type=\"number\" step=\"0.01\" min=\"0.01\" ng-disabled=\"vm.is_extra_item\"><div ng-messages=\"formInvoice[\'price_net_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"number\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"step\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div></div></md-input-container><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\" ng-if=\"vm.form.gross_counted\"><label hide-gt-sm=\"\"><span ng-if=\"vat_payer\">{{ \'INVOICES_FORM.PRICE_GROSS\' | translate }} ({{ vm.form.currency || \'zł\' }})</span> <span ng-if=\"!vat_payer\">{{ \'INVOICES_FORM.PRICE\' | translate }} ({{ vm.form.currency || \'zł\' }})</span></label> <input ng-model=\"item.price_gross\" name=\"price_gross_{{$index}}\" required=\"\" type=\"number\" step=\"0.01\" min=\"0.01\" ng-disabled=\"vm.is_extra_item\"><div ng-messages=\"formInvoice[\'price_gross_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"number\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"step\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div></div></md-input-container></td><td md-cell=\"\"><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\" ng-if=\"!vm.form.gross_counted\"><label hide-gt-sm=\"\">{{ \'INVOICES_FORM.PRICE_NET_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</label> <input ng-model=\"item.price_net_sum\" required=\"\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\" ng-if=\"vm.form.gross_counted\"><label hide-gt-sm=\"\"><span ng-if=\"vat_payer\">{{ \'INVOICES_FORM.PRICE_GROSS_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</span> <span ng-if=\"!vat_payer\">{{ \'INVOICES_FORM.PRICE_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</span></label> <input ng-model=\"item.price_gross_sum\" required=\"\" ng-disabled=\"true\"></md-input-container></td><td md-cell=\"\" ng-if=\"vat_payer\"><md-input-container class=\"md-block select-style\" flex-gt-sm=\"\"><label hide-gt-sm=\"\"><span translate=\"INVOICES_FORM.TAX\"></span></label><md-select ng-model=\"item.vat_rate_id\" required=\"\" name=\"vat_rate_id_{{$index}}\" ng-disabled=\"vm.is_extra_item || vm.type == \'margin\' || vm.type == \'reverse_charge\' || vm.type == \'currency_reverse_charge\'\"><md-option ng-value=\"tax.id\" ng-repeat=\"tax in vm.taxes\">{{tax.name}}</md-option></md-select><div ng-messages=\"formInvoice[\'vat_rate_id\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></td><td md-cell=\"\"><md-button class=\"md-icon-button md-warn\" ng-click=\"vm.deleteProduct($index)\" ng-if=\"vm.form.items.length > 1\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div></div><div layout-gt-sm=\"row\" layout-align=\"end none\" ng-if=\"!vm.is_extra_item\"><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.addProduct()\" translate=\"INVOICES_FORM.ADD_PRODUCT\">ADD</md-button></div><div class=\"form-title\" translate=\"INVOICES_FORM.SUMMARY\"></div><div layout-gt-sm=\"row\" ng-if=\"!vm.is_extra_item\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-checkbox ng-model=\"vm.special_payment\" name=\"special_payment\" ng-change=\"vm.changeSpecialPayment()\"><span translate=\"INVOICES_FORM.PARTIAL_PAYMENT\"></span></md-checkbox></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.special_payment\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.TERM\"></span></label> <input ng-model=\"vm.today\" moment-picker=\"vm.today\" format=\"YYYY-MM-DD\" start-view=\"year\" locale=\"pl\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.AMOUNT\"></span></label> <input ng-model=\"vm.form.special_payment.amount\" name=\"partial_amount\" required=\"\" type=\"number\" step=\"0.01\" min=\"0.01\" max=\"{{(vm.form.price_gross - 0.01)}}\"><div ng-messages=\"formInvoice.partial_amount.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"number\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"max\"><span translate=\"ERRORS.FORM.MAX_AMOUNT\"></span></div><div ng-message=\"step\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.PAYMENT_METHOD\"></span></label><md-select ng-model=\"vm.form.special_payment.payment_method_id\" required=\"\" name=\"partials_payment_method_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"payment_method.id\" ng-repeat=\"payment_method in vm.payment_methods\" ng-disabled=\"payment_method.id == vm.form.payment_method_id\" ng-if=\"payment_method.slug == \'gotowka\' || payment_method.slug == \'karta\'\">{{payment_method.name}}</md-option></md-select><div ng-messages=\"formInvoice.partials_payment_method_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.TERM\"></span></label> <input ng-model=\"vm.payment_date\" name=\"payment_date\" moment-picker=\"vm.payment_date\" format=\"YYYY-MM-DD\" start-view=\"year\" locale=\"pl\" min-date=\"vm.start_callendar\" max-date=\"vm.stop_callendar\" ng-disabled=\"vm.is_extra_item || vm.disabled_payment_date\"><div ng-messages=\"formInvoice.payment_date.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.special_payment\"><label><span translate=\"INVOICES_FORM.AMOUNT\"></span></label> <input ng-value=\"vm.round(vm.form.price_gross - vm.form.special_payment.amount)\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.PAYMENT_METHOD\"></span></label><md-select ng-model=\"vm.form.payment_method_id\" required=\"\" name=\"payment_method_id\" ng-if=\"!translate_loading\" ng-disabled=\"vm.is_extra_item\"><md-option ng-value=\"payment_method.id\" ng-repeat=\"payment_method in vm.payment_methods\" ng-disabled=\"payment_method.id == vm.form.special_payment.payment_method_id\">{{payment_method.name}}</md-option></md-select><div ng-messages=\"formInvoice.payment_method_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.company.bank_accounts.data.length > 1 && vm.form.payment_method_id == 2\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.BANK_ACCOUNT\"></span></label><md-select ng-model=\"vm.form.bank_account_id\" required=\"\" name=\"bank_account\" ng-if=\"!translate_loading\"><md-option ng-value=\"bank_account.id\" ng-repeat=\"bank_account in vm.company.bank_accounts.data\">{{bank_account.bank_name}}</md-option></md-select><div ng-messages=\"formInvoice.bank_account.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.type === \'vat\' || vm.type === \'reverse_charge\' || vm.type === \'currency\' || vm.type === \'currency_reverse_charge\' || vm.type === \'margin\' || vm.type === \'margin_proforma\'\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"50\"><label>{{ \'INVOICES_FORM.GTU_PRODUCT\' | translate }}</label><md-select ng-model=\"vm.form.gtu\" name=\"gtu\" ng-if=\"!translate_loading\" multiple=\"true\" md-selected-text=\"vm.getGtuProductLabel()\"><md-option ng-value=\"gtu.id\" ng-repeat=\"gtu in vm.gtu_product_items\"><div class=\"md-option-title\">{{gtu.name}}</div><div class=\"md-option-desc\">{{gtu.description}}</div></md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"50\"><label>{{ \'INVOICES_FORM.GTU_PROCEDURE\' | translate }}</label><md-select ng-model=\"vm.form.gtu\" name=\"gtu\" ng-if=\"!translate_loading\" multiple=\"true\" md-selected-text=\"vm.getGtuProcedureLabel()\"><md-option ng-value=\"gtu.id\" ng-repeat=\"gtu in vm.gtu_procedure_items\"><div class=\"md-option-title\">{{gtu.name}}</div><div class=\"md-option-desc\">{{gtu.description}}</div></md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.is_extra_item\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-checkbox ng-model=\"vm.show_description\"><span translate=\"INVOICES_FORM.DESCRIPTION\"></span></md-checkbox></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.show_description\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.DESCRIPTION\"></span></label> <textarea ng-model=\"vm.form.description\" ng-maxlength=\"1000\" name=\"description\"></textarea></md-input-container></div><div layout-gt-sm=\"row\" class=\"mb-30 ml-30\"><div class=\"table-wrapper width-auto\" ng-if=\"vm.form.taxes.length && vat_payer\" flex-gt-sm=\"\"><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\"><span translate=\"INVOICES_FORM.TAX\"></span></th><th md-column=\"\" md-numeric=\"\">{{ \'INVOICES_FORM.PRICE_NET_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</th><th md-column=\"\" md-numeric=\"\">{{ \'INVOICES_FORM.PRICE_GROSS_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"tax in vm.form.taxes\"><td md-cell=\"\">{{vm.taxes[tax.vat_rate_id].name}}</td><td md-cell=\"\">{{ tax.price_net.toFixed(2) | numFormat}} {{ vm.form.currency || \'zł\' }}</td><td md-cell=\"\">{{ tax.price_gross.toFixed(2) | numFormat}} {{ vm.form.currency || \'zł\' }}</td></tr></tbody></table></md-table-container></div><div layout-gt-sm=\"row\" layout-wrap=\"\" flex-gt-sm=\"\" class=\"p-20 font-size-18\"><div layout=\"row\" flex=\"100\" layout-align=\"end center\"><div class=\"block\"><span ng-if=\"vat_payer\"><span translate=\"INVOICES_FORM.PRICE_NET_SUMMARY\"></span>: <b>&nbsp;{{vm.form.price_net.toFixed(2) | numFormat}} {{ vm.form.currency || \'zł\' }}</b><br></span> <span ng-if=\"vat_payer\"><span translate=\"INVOICES_FORM.PRICE_GROSS_SUMMARY\"></span>: <b>&nbsp;{{vm.form.price_gross.toFixed(2) | numFormat}} {{ vm.form.currency || \'zł\' }}</b></span> <span ng-if=\"!vat_payer\"><span translate=\"INVOICES_FORM.PRICE_SUMMARY\"></span>: <b>&nbsp;{{vm.form.price_gross.toFixed(2) | numFormat}} {{ vm.form.currency || \'zł\' }}</b></span></div></div></div></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><span class=\"require\">*</span> <span translate=\"INFO.REQUIRE_INFO\"></span></md-input-container></div><div layout=\"row\" layout-align=\"end none\"><md-button ng-if=\"!vm.for_contractor\" href=\"/invoices/list\" class=\"md-raised\" aria-label=\"Go Back\" translate=\"OTHER.GO_BACK\" translate-attr-aria-label=\"OTHER.GO_BACK\">Go Back</md-button><md-button ng-if=\"vm.for_contractor\" href=\"/contractors/list\" class=\"md-raised\" aria-label=\"Go Back\" translate=\"OTHER.GO_BACK\" translate-attr-aria-label=\"OTHER.GO_BACK\">Go Back</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"formInvoice.$invalid || (formInvoice.$pristine && !vm.copy_invoice) || vm.request_sending\" translate=\"INVOICES_FORM.SAVE\" translate-attr-aria-label=\"INVOICES_FORM.SAVE\"></md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/invoices/form-correction/form-correction.html","<div id=\"invoice-form\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\" flex=\"100\"><div layout=\"row\"><div class=\"title\" translate=\"INVOICES_FORM_CORRECTION.TITLE_ADD\" flex=\"70\"></div><div flex=\"30\" layout=\"row\" layout-align=\"end center\"><md-button href=\"/invoices/list\" class=\"md-raised\" aria-label=\"Go Back\" translate=\"OTHER.GO_BACK\" translate-attr-aria-label=\"OTHER.GO_BACK\">Go Back</md-button></div></div></div></div><div class=\"content\" layout=\"column\"><a name=\"up\"></a><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000 max-1000\"><form id=\"formCorrectionInvoice\" name=\"formCorrectionInvoice\" novalidate=\"\" ng-submit=\"vm.send()\"><div class=\"form-title\" translate=\"INVOICES_FORM_CORRECTION.TYPE\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM_CORRECTION.TYPE\"></span></label><md-select ng-model=\"vm.form.correction_type\" required=\"\" name=\"correction_type\" ng-if=\"!translate_loading\" ng-disabled=\"vm.form.correction_type != \'\'\"><md-option ng-value=\"type.slug\" ng-repeat=\"type in vm.correction_types\">{{type.description}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"></md-input-container></div><div ng-if=\"vm.form.correction_type != \'\'\"><div class=\"form-title\" translate=\"INVOICES_FORM_CORRECTION.GENERAL\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM_CORRECTION.ISSUE_DATE\"></span></label> <input ng-model=\"vm.form.issue_date\" name=\"issue_date\" moment-picker=\"vm.form.issue_date\" format=\"YYYY-MM-DD\" start-view=\"decade\" locale=\"pl\"><div ng-messages=\"formCorrectionInvoice.issue_date.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM_CORRECTION.SALE_DATE\"></span></label> <input ng-model=\"vm.form.sale_date\" name=\"sale_date\" moment-picker=\"vm.form.sale_date\" format=\"YYYY-MM-DD\" start-view=\"decade\" locale=\"pl\"><div ng-messages=\"formCorrectionInvoice.sale_date.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.type == \'currency_correction\' || vm.type == \'currency_reverse_charge_correction\'\"><label><span translate=\"INVOICES_FORM_CORRECTION.CURRENCY\"></span></label><md-select ng-model=\"vm.form.currency\" required=\"\" name=\"currency\" ng-if=\"!translate_loading\" ng-disabled=\"true\"><md-option ng-value=\"vm.form.currency\">{{ vm.form.currency }}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.type != \'margin_correction\' && vm.type != \'reverse_charge_correction\' && vm.type != \'currency_reverse_charge_correction\' && vat_payer\"><label><span translate=\"INVOICES_FORM_CORRECTION.COUNT_TAX\"></span></label><md-select ng-model=\"vm.form.gross_counted\" required=\"\" name=\"gross_counted\" ng-if=\"!translate_loading\" ng-disabled=\"true\"><md-option ng-value=\"0\"><span translate=\"INVOICES_FORM_CORRECTION.FROM_NET\"></span></md-option><md-option ng-value=\"1\"><span translate=\"INVOICES_FORM_CORRECTION.FROM_GROSS\"></span></md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.type == \'margin_correction\'\"><label><span translate=\"INVOICES_FORM_CORRECTION.MARGIN_PROCEDURES\"></span></label><md-select ng-model=\"vm.form.invoice_margin_procedure_id\" required=\"\" name=\"invoice_margin_procedure_id\" ng-if=\"!translate_loading\" ng-disabled=\"true\"><md-option ng-value=\"procedure.id\" ng-repeat=\"procedure in vm.margin_procedures\">{{procedure.description}}</md-option></md-select><div ng-messages=\"formInvoice.invoice_margin_procedure_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div class=\"form-title\" translate=\"INVOICES_FORM_CORRECTION.CLIENT\"></div><div layout-gt-sm=\"row\" layout-wrap=\"\" ng-if=\"vm.contractor.id\" class=\"mb-30 ml-30\">{{vm.contractor.name}}<br><div layout=\"row\" flex=\"100\">{{ vm.contractor.main_address_street }} {{ vm.contractor.main_address_number }}, {{ vm.contractor.main_address_zip_code }} {{ vm.contractor.main_address_city }}</div><div layout=\"row\" flex=\"100\"><span translate=\"INVOICES_FORM_CORRECTION.VATIN\"></span>: {{vm.contractor.vatin}}</div></div><div class=\"form-title\" translate=\"INVOICES_FORM_CORRECTION.PRODUCTS\"></div><div layout=\"row\"><div class=\"table-wrapper table-products\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\" hide-xs=\"\" hide-sm=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\" width=\"40%\"><span translate=\"INVOICES_FORM_CORRECTION.PRODUCT\"></span></th><th md-column=\"\" width=\"10%\"><span translate=\"INVOICES_FORM_CORRECTION.QUANTITY\"></span></th><th md-column=\"\" width=\"10%\"><span translate=\"INVOICES_FORM_CORRECTION.UNIT\"></span></th><th md-column=\"\" width=\"10%\" ng-if=\"!vm.form.gross_counted\">{{ \'INVOICES_FORM_CORRECTION.PRICE_NET\' | translate }} ({{ vm.form.currency || \'zł\' }})</th><th md-column=\"\" width=\"10%\" ng-if=\"!vm.form.gross_counted\">{{ \'INVOICES_FORM_CORRECTION.PRICE_NET_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</th><th md-column=\"\" width=\"10%\" ng-if=\"vm.form.gross_counted\"><span ng-if=\"vat_payer\">{{ \'INVOICES_FORM_CORRECTION.PRICE_GROSS\' | translate }} ({{ vm.form.currency || \'zł\' }})</span> <span ng-if=\"!vat_payer\">{{ \'INVOICES_FORM_CORRECTION.PRICE\' | translate }} ({{ vm.form.currency || \'zł\' }})</span></th><th md-column=\"\" width=\"10%\" ng-if=\"vm.form.gross_counted\"><span ng-if=\"vat_payer\">{{ \'INVOICES_FORM_CORRECTION.PRICE_GROSS_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</span> <span ng-if=\"!vat_payer\">{{ \'INVOICES_FORM_CORRECTION.PRICE_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</span></th><th md-column=\"\" width=\"10%\" ng-if=\"vat_payer\"><span translate=\"INVOICES_FORM_CORRECTION.TAX\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\">Akcje</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.form.items\"><td md-cell=\"\">{{ ($index + 1) }}</td><td md-cell=\"\"><md-input-container class=\"md-block autocomplete-container\" flex-gt-sm=\"\"><label hide-gt-sm=\"\"><span translate=\"INVOICES_FORM_CORRECTION.PRODUCT\"></span></label><md-autocomplete autocomplete-required=\"\" ng-disabled=\"!item.new_obj\" ng-if=\"!item.new_obj\" md-input-name=\"company_service_id_{{$index}}\" ng-model-options=\"{debounce:200}\" md-selected-item=\"item.current_service\" md-search-text=\"item.search_text\" md-items=\"item in vm.searchProducts(item.search_text)\" md-item-text=\"item.name\"><md-item-template><span md-highlight-text=\"item.search_text\">{{item.name}}</span></md-item-template><md-not-found><span translate=\"OTHER.NOT_FOUND\"></span></md-not-found></md-autocomplete><div ng-messages=\"formCorrectionInvoice[\'company_service_id_\'+$index].$error\"><div ng-message=\"selectedItem\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block input-style\" flex=\"100\" ng-if=\"item.custom_name_enable && vm.custom_name_products_enable\"><input ng-model=\"item.custom_name\" name=\"custom_name_{{$index}}\" required=\"\" ng-maxlength=\"255\" ng-disabled=\"!item.new_obj\" placeholder=\"{{ \'INVOICES_FORM_CORRECTION.ENTER_DESCRIPTION\' | translate }}\"><div ng-messages=\"formCorrectionInvoice[\'custom_name_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><div ng-if=\"item.custom_name_enable && !item.new_obj\"><span translate=\"INVOICES_FORM_CORRECTION.CUSTOM_NAME\"></span> {{item.custom_name}}</div></td><td md-cell=\"\"><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\" ng-if=\"!item.new_obj || vm.form.correction_type != \'quantity\'\"><label hide-gt-sm=\"\"><span translate=\"INVOICES_FORM_CORRECTION.QUANTITY\"></span></label> <input ng-model=\"item.quantity\" name=\"quantity_{{$index}}\" type=\"number\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\" ng-if=\"item.new_obj && vm.form.correction_type == \'quantity\'\"><label hide-gt-sm=\"\"><span translate=\"INVOICES_FORM_CORRECTION.QUANTITY\"></span></label> <input ng-model=\"item.quantity\" name=\"quantity_{{$index}}\" required=\"\" type=\"number\" step=\"{{item.service_unit.decimal ? 0.001 : 1}}\" min=\"{{(-1 * vm.form.items[$index-1].quantity)}}\" max=\"{{item.service_unit.decimal ? -0.001 : -1}}\"><div ng-messages=\"formCorrectionInvoice[\'quantity_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"number\"><span translate=\"ERRORS.FORM.NUMBER_NEGATIVE\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.NUMBER_TOO_SMALL\"></span></div><div ng-message=\"max\"><span ng-if=\"!item.service_unit.decimal\" translate=\"ERRORS.FORM.MAX_M1\"></span> <span ng-if=\"item.service_unit.decimal\" translate=\"ERRORS.FORM.MAX_M001\"></span></div><div ng-message=\"step\"><span ng-if=\"!item.service_unit.decimal\" translate=\"ERRORS.FORM.INTEGER_NEGATIVE\"></span> <span ng-if=\"item.service_unit.decimal\" translate=\"ERRORS.FORM.NUMBER_NEGATIVE_3_DP\"></span></div></div></md-input-container></td><td md-cell=\"\"><md-input-container class=\"md-block select-style\" flex-gt-sm=\"\"><label hide-gt-sm=\"\"><span translate=\"INVOICES_FORM_CORRECTION.UNIT\"></span></label><md-select ng-model=\"item.service_unit_id\" required=\"\" name=\"service_unit_id_{{$index}}\" ng-disabled=\"true\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"unit.id\" ng-repeat=\"unit in vm.units\" ng-if=\"unit.id\">{{unit.slug}}</md-option></md-select><div ng-messages=\"formCorrectionInvoice[\'service_unit_id_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></td><td md-cell=\"\"><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\" ng-if=\"!vm.form.gross_counted\"><label hide-gt-sm=\"\">{{ \'INVOICES_FORM_CORRECTION.PRICE_NET\' | translate }} ({{ vm.form.currency || \'zł\' }})</label> <input ng-model=\"item.price_net\" name=\"price_net_{{$index}}\" required=\"\" type=\"number\" step=\"0.01\" min=\"0.01\" ng-disabled=\"!item.new_obj || vm.form.correction_type != \'price\'\"><div ng-messages=\"formCorrectionInvoice[\'price_net_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"number\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"step\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div></div></md-input-container><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\" ng-if=\"vm.form.gross_counted\"><label hide-gt-sm=\"\"><span ng-if=\"vat_payer\">{{ \'INVOICES_FORM_CORRECTION.PRICE_GROSS\' | translate }} ({{ vm.form.currency || \'zł\' }})</span> <span ng-if=\"!vat_payer\">{{ \'INVOICES_FORM_CORRECTION.PRICE\' | translate }} ({{ vm.form.currency || \'zł\' }})</span></label> <input ng-model=\"item.price_gross\" name=\"price_gross_{{$index}}\" required=\"\" type=\"number\" step=\"0.01\" min=\"0.01\" ng-disabled=\"!item.new_obj || vm.form.correction_type != \'price\'\"><div ng-messages=\"formCorrectionInvoice[\'price_gross_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"number\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"step\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div></div></md-input-container></td><td md-cell=\"\"><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\" ng-if=\"!vm.form.gross_counted\"><label hide-gt-sm=\"\">{{ \'INVOICES_FORM_CORRECTION.PRICE_NET_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</label> <input ng-model=\"item.price_net_sum\" required=\"\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\" ng-if=\"vm.form.gross_counted\"><label hide-gt-sm=\"\"><span ng-if=\"vat_payer\">{{ \'INVOICES_FORM_CORRECTION.PRICE_GROSS_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</span> <span ng-if=\"!vat_payer\">{{ \'INVOICES_FORM_CORRECTION.PRICE_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</span></label> <input ng-model=\"item.price_gross_sum\" required=\"\" ng-disabled=\"true\"></md-input-container></td><td md-cell=\"\" ng-if=\"vat_payer\"><md-input-container class=\"md-block select-style\" flex-gt-sm=\"\"><label hide-gt-sm=\"\"><span translate=\"INVOICES_FORM_CORRECTION.TAX\"></span></label><md-select ng-model=\"item.vat_rate_id\" required=\"\" name=\"vat_rate_id_{{$index}}\" ng-disabled=\"!item.new_obj || vm.form.correction_type != \'tax\'\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"tax.id\" ng-repeat=\"tax in vm.taxes\">{{tax.name}}</md-option></md-select><div ng-messages=\"formCorrectionInvoice[\'vat_rate_id\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></td><td md-cell=\"\"><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.addProductCorrection($index)\" ng-if=\"!item.new_obj && !item.is_correction\" translate=\"INVOICES_FORM_CORRECTION.ADD_CORRECTION\">ADD</md-button><md-button class=\"md-icon-button md-warn\" ng-click=\"vm.deleteProductCorrection($index)\" ng-if=\"vm.form.items.length > 1 && item.new_obj\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div></div><div class=\"form-title\" translate=\"INVOICES_FORM_CORRECTION.SUMMARY\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM_CORRECTION.TERM\"></span></label> <input ng-model=\"vm.payment_date\" name=\"payment_date\" moment-picker=\"vm.payment_date\" format=\"YYYY-MM-DD\" start-view=\"year\" locale=\"pl\" min-date=\"vm.form.issue_date\" max-date=\"vm.stop_callendar\" ng-disabled=\"vm.disabled_payment_date\"><div ng-messages=\"formCorrectionInvoice.payment_date.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM_CORRECTION.PAYMENT_METHOD\"></span></label><md-select ng-model=\"vm.form.payment_method_id\" required=\"\" name=\"payment_method_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"payment_method.id\" ng-repeat=\"payment_method in vm.payment_methods\">{{payment_method.name}}</md-option></md-select><div ng-messages=\"formCorrectionInvoice.payment_method_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.company.bank_accounts.data.length > 1 && vm.form.payment_method_id == 2\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM_CORRECTION.BANK_ACCOUNT\"></span></label><md-select ng-model=\"vm.form.bank_account_id\" required=\"\" name=\"bank_account\" ng-if=\"!translate_loading\"><md-option ng-value=\"bank_account.id\" ng-repeat=\"bank_account in vm.company.bank_accounts.data\">{{bank_account.bank_name}}</md-option></md-select><div ng-messages=\"formInvoice.bank_account.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.is_extra_item\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-checkbox ng-model=\"vm.show_description\"><span translate=\"INVOICES_FORM_CORRECTION.DESCRIPTION\"></span></md-checkbox></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.show_description\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM_CORRECTION.DESCRIPTION\"></span></label> <textarea ng-model=\"vm.form.description\" ng-maxlength=\"1000\" name=\"description\"></textarea></md-input-container></div><div layout-gt-sm=\"row\" class=\"mb-30 ml-30\"><div class=\"table-wrapper width-auto\" ng-if=\"vm.form.taxes.length && vat_payer\" flex-gt-sm=\"\"><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\"><span translate=\"INVOICES_FORM_CORRECTION.TAX\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"INVOICES_FORM_CORRECTION.PRICE_NET_SUM\"></span></th><th md-column=\"\" md-numeric=\"\"><span>{{ \'INVOICES_FORM_CORRECTION.PRICE_GROSS_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"tax in vm.form.taxes\"><td md-cell=\"\">{{vm.taxes[tax.vat_rate_id].name}}</td><td md-cell=\"\">{{ tax.price_net.toFixed(2) | numFormat}} {{ vm.form.currency || \'zł\' }}</td><td md-cell=\"\">{{ tax.price_gross.toFixed(2) | numFormat}} {{ vm.form.currency || \'zł\' }}</td></tr></tbody></table></md-table-container></div><div layout-gt-sm=\"row\" layout-wrap=\"\" flex-gt-sm=\"\" class=\"p-20 font-size-18\"><div layout=\"row\" flex=\"100\" layout-align=\"end center\"><div class=\"block\"><span ng-if=\"vat_payer\"><span translate=\"INVOICES_FORM_CORRECTION.PRICE_NET_SUMMARY\"></span>: <b>&nbsp;{{vm.form.price_net.toFixed(2) | numFormat}} {{ vm.form.currency || \'zł\' }}</b><br></span> <span ng-if=\"vat_payer\"><span translate=\"INVOICES_FORM_CORRECTION.PRICE_GROSS_SUMMARY\"></span>: <b>&nbsp;{{vm.form.price_gross.toFixed(2) | numFormat}} {{ vm.form.currency || \'zł\' }}</b></span> <span ng-if=\"!vat_payer\"><span translate=\"INVOICES_FORM_CORRECTION.PRICE_SUMMARY\"></span>: <b>&nbsp;{{vm.form.price_gross.toFixed(2) | numFormat}} {{ vm.form.currency || \'zł\' }}</b></span></div></div></div></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><span class=\"require\">*</span> <span translate=\"INFO.REQUIRE_INFO\"></span></md-input-container></div><div layout=\"row\" layout-align=\"end none\"><md-button href=\"/invoices/list\" class=\"md-raised\" aria-label=\"Go Back\" translate=\"OTHER.GO_BACK\" translate-attr-aria-label=\"OTHER.GO_BACK\">Go Back</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"formCorrectionInvoice.$invalid || (formCorrectionInvoice.$pristine && vm.form.correction_type != \'quantity\') || vm.request_sending\" translate=\"INVOICES_FORM_CORRECTION.SAVE\" translate-attr-aria-label=\"INVOICES_FORM_CORRECTION.SAVE\"></md-button></div></div></form></div></div></div></div>");
$templateCache.put("app/main/invoices/form-edit/form-edit.html","<div id=\"invoice-form\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\" flex=\"100\"><div layout=\"row\"><div class=\"title\" flex=\"70\"><span translate=\"INVOICES_FORM.TITLE_EDIT\"></span>: {{vm.title}}</div><div flex=\"30\" layout=\"row\" layout-align=\"end center\"><md-button href=\"/invoices/list\" class=\"md-raised\" aria-label=\"Go Back\" translate=\"OTHER.GO_BACK\" translate-attr-aria-label=\"OTHER.GO_BACK\">Go Back</md-button></div></div></div></div><div class=\"content\" layout=\"column\"><a name=\"up\"></a><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000 max-1000\"><form id=\"formInvoice\" name=\"formInvoice\" novalidate=\"\" ng-submit=\"vm.send()\"><div class=\"form-title\" translate=\"INVOICES_FORM.GENERAL\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.ISSUE_DATE\"></span></label> <input ng-model=\"vm.form.issue_date\" name=\"issue_date\" moment-picker=\"vm.form.issue_date\" format=\"YYYY-MM-DD\" start-view=\"decade\" locale=\"pl\"><div ng-messages=\"formInvoice.issue_date.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.SALE_DATE\"></span></label> <input ng-model=\"vm.form.sale_date\" name=\"sale_date\" moment-picker=\"vm.form.sale_date\" format=\"YYYY-MM-DD\" start-view=\"decade\" locale=\"pl\" ng-disabled=\"vm.is_extra_item\"><div ng-messages=\"formInvoice.sale_date.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.type == \'currency\' || vm.type == \'currency_reverse_charge\'\"><label><span translate=\"INVOICES_FORM.CURRENCY\"></span></label><md-select ng-model=\"vm.form.currency\" required=\"\" name=\"currency\" ng-if=\"!translate_loading\"><md-option ng-value=\"currency.code\" ng-repeat=\"currency in vm.currencies\">{{currency.code}} - {{ currency.name }}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.type != \'margin\' && vm.type != \'reverse_charge\' && vm.type != \'currency_reverse_charge\' && vat_payer\"><label><span translate=\"INVOICES_FORM.COUNT_TAX\"></span></label><md-select ng-model=\"vm.form.gross_counted\" required=\"\" name=\"gross_counted\" ng-if=\"!translate_loading\" ng-disabled=\"true\"><md-option ng-value=\"0\"><span translate=\"INVOICES_FORM.FROM_NET\"></span></md-option><md-option ng-value=\"1\"><span translate=\"INVOICES_FORM.FROM_GROSS\"></span></md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.type == \'margin\' || vm.type == \'margin_proforma\' || vm.type == \'margin_correction\'\"><label><span translate=\"INVOICES_FORM.MARGIN_PROCEDURES\"></span></label><md-select ng-model=\"vm.form.invoice_margin_procedure_id\" required=\"\" name=\"invoice_margin_procedure_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"procedure.id\" ng-repeat=\"procedure in vm.margin_procedures\">{{procedure.description}}</md-option></md-select><div ng-messages=\"formInvoice.invoice_margin_procedure_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.type == \'reverse_charge\' || vm.type == \'currency_reverse_charge\'\"><label><span translate=\"INVOICES_FORM.REVERSE_CHANGES\"></span></label><md-select ng-model=\"vm.form.invoice_reverse_charge_id\" required=\"\" name=\"invoice_reverse_charge_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"type.id\" ng-repeat=\"type in vm.reverse_changes\">{{type.description}}</md-option></md-select><div ng-messages=\"formInvoice.invoice_reverse_charge_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.registries.length > 1\"><label><span translate=\"INVOICES_FORM.REGISTER\"></span></label><md-select ng-model=\"vm.form.invoice_registry_id\" required=\"\" name=\"invoice_registry_id\" ng-if=\"!translate_loading\" ng-disabled=\"true\"><md-option ng-value=\"register.id\" ng-repeat=\"register in vm.registries\">{{register.prefix}}<span ng-if=\"register.prefix != \'\'\">/</span>{{vm.invoice_formats[register.invoice_format_id].name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.registries.length < 2\"></md-input-container></div><div class=\"form-title\" translate=\"INVOICES_FORM.CLIENT\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block autocomplete-container\" flex-gt-sm=\"50\"><label><span translate=\"OTHER.NAME\"></span></label><md-autocomplete autocomplete-required=\"\" md-input-name=\"contractor\" ng-model-options=\"{debounce:200}\" md-selected-item=\"vm.contractor\" md-search-text=\"vm.search_text_contractor\" md-items=\"item in vm.searchContractor(vm.search_text_contractor)\" md-item-text=\"item.name\" ng-click=\"vm.selectedAutocompleteContractor(\'contractor\')\" placeholder=\"{{ \'INVOICES_FORM.SEARCH_CLIENT\' | translate }}\"><md-item-template><span md-highlight-text=\"vm.search_text_contractor\">{{item.name}}</span></md-item-template><md-not-found><span translate=\"OTHER.NOT_FOUND\"></span> <a ng-click=\"vm.addNewContractor()\" translate=\"OTHER.ADD_NEW_1\"></a></md-not-found></md-autocomplete><div ng-messages=\"formInvoice.contractor.$error\"><div ng-message=\"selectedItem\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><div layout-gt-sm=\"row\" layout-wrap=\"\" ng-if=\"vm.contractor.id\" class=\"mb-30 ml-30\">{{vm.contractor.name}}<br><div layout=\"row\" flex=\"100\">{{ vm.contractor.main_address_street }} {{ vm.contractor.main_address_number }}, {{ vm.contractor.main_address_zip_code }} {{ vm.contractor.main_address_city }}</div><div layout=\"row\" flex=\"100\"><span translate=\"INVOICES_FORM.VATIN\"></span>: {{vm.contractor.vatin_prefix.data.key}}{{vm.contractor.vatin}}</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container ng-if=\"vm.addresses_delivery_enabled\" class=\"md-block\" flex-gt-sm=\"\" flex=\"50\"><md-checkbox ng-model=\"vm.form.default_delivery\" name=\"default_delivery\"><span translate=\"INVOICES_FORM.DELIVERY_ADDRESS_OTHER\"></span></md-checkbox></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.addresses_delivery_enabled && vm.form.default_delivery\"><md-input-container class=\"md-block autocomplete-container\" flex-gt-sm=\"50\"><label><span translate=\"OTHER.NAME\"></span></label><md-autocomplete autocomplete-required=\"\" md-input-name=\"delivery_contractor\" ng-model-options=\"{debounce:200}\" md-selected-item=\"vm.delivery_contractor\" md-search-text=\"vm.search_text_delivery_contractor\" md-items=\"item in vm.searchContractor(vm.search_text_delivery_contractor)\" md-item-text=\"item.name\" md-selected-item-change=\"vm.changeContractorDelivery()\" ng-click=\"vm.selectedAutocompleteContractor(\'contractor_delivery\')\"><md-item-template><span md-highlight-text=\"vm.search_text_delivery_contractor\">{{item.name}}</span></md-item-template><md-not-found><span translate=\"OTHER.NOT_FOUND\"></span> <a ng-click=\"vm.addNewContractor()\" translate=\"OTHER.ADD_NEW_1\"></a></md-not-found></md-autocomplete><div ng-messages=\"formInvoice.delivery_contractor.$error\"><div ng-message=\"selectedItem\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.delivery_contractor && vm.delivery_contractor.addresses.data\"><label><span translate=\"INVOICES_FORM.DELIVERY_ADDRESS\"></span></label><md-select ng-model=\"vm.form.delivery_address_id\" required=\"\" name=\"delivery_address_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"address.id\" ng-repeat=\"address in vm.delivery_contractor.addresses.data\">{{address.name}}</md-option></md-select><div ng-messages=\"formInvoice.delivery_address_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div class=\"form-title\" translate=\"INVOICES_FORM.PRODUCTS\"></div><div layout=\"row\"><div class=\"table-wrapper table-products\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\" hide-xs=\"\" hide-sm=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\" width=\"40%\"><span translate=\"INVOICES_FORM.PRODUCT\"></span></th><th md-column=\"\" width=\"10%\"><span translate=\"INVOICES_FORM.QUANTITY\"></span></th><th md-column=\"\" width=\"10%\"><span translate=\"INVOICES_FORM.UNIT\"></span></th><th md-column=\"\" width=\"10%\" ng-if=\"!vm.form.gross_counted\">{{ \'INVOICES_FORM.PRICE_NET\' | translate }} ({{ vm.form.currency || \'zł\' }})</th><th md-column=\"\" width=\"10%\" ng-if=\"!vm.form.gross_counted\">{{ \'INVOICES_FORM.PRICE_NET_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</th><th md-column=\"\" width=\"10%\" ng-if=\"vm.form.gross_counted\"><span ng-if=\"vat_payer\">{{ \'INVOICES_FORM.PRICE_GROSS\' | translate }} ({{ vm.form.currency || \'zł\' }})</span> <span ng-if=\"!vat_payer\">{{ \'INVOICES_FORM.PRICE\' | translate }} ({{ vm.form.currency || \'zł\' }})</span></th><th md-column=\"\" width=\"10%\" ng-if=\"vm.form.gross_counted\"><span ng-if=\"vat_payer\">{{ \'INVOICES_FORM.PRICE_GROSS_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</span> <span ng-if=\"!vat_payer\">{{ \'INVOICES_FORM.PRICE_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</span></th><th md-column=\"\" width=\"10%\" ng-if=\"vat_payer\"><span translate=\"INVOICES_FORM.TAX\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\">Akcje</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.form.items\"><td md-cell=\"\">{{ ($index + 1) }}</td><td md-cell=\"\"><div class=\"short-services\" hide-sm=\"\" hide-xs=\"\" layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><span ng-repeat=\"product in vm.products_short_list\" ng-click=\"item.current_service = product\" class=\"service\">{{product.name}}</span></div><md-input-container class=\"md-block autocomplete-container\" flex-gt-sm=\"\"><label hide-gt-sm=\"\"><span translate=\"INVOICES_FORM.PRODUCT\"></span></label><md-autocomplete autocomplete-required=\"\" ng-disabled=\"vm.is_extra_item\" md-input-name=\"company_service_id_{{$index}}\" ng-model-options=\"{debounce:200}\" md-selected-item=\"item.current_service\" md-search-text=\"item.search_text\" md-items=\"item in vm.searchProducts(item.search_text)\" md-item-text=\"item.name\" ng-click=\"vm.selectedAutocompleteProduct($index)\" placeholder=\"{{ \'INVOICES_FORM.SEARCH_PRODUCT\' | translate }}\"><md-item-template><span md-highlight-text=\"item.search_text\">{{item.name}}</span></md-item-template><md-not-found><span translate=\"OTHER.NOT_FOUND\"></span> <a ng-click=\"vm.addNewProduct()\" translate=\"OTHER.ADD_NEW_4\"></a></md-not-found></md-autocomplete><div ng-messages=\"formInvoice[\'company_service_id_\'+$index].$error\"><div ng-message=\"selectedItem\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block input-style\" flex=\"100\" ng-if=\"item.custom_name_enable && vm.custom_name_products_enable\"><input ng-model=\"item.custom_name\" name=\"custom_name_{{$index}}\" required=\"\" ng-maxlength=\"255\" placeholder=\"{{ \'INVOICES_FORM.ENTER_DESCRIPTION\' | translate }}\"><div ng-messages=\"formInvoice[\'custom_name_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><div class=\"custom-name-checkbox\" ng-if=\"vm.custom_name_products_enable\"><a ng-if=\"!item.custom_name_enable\" ng-click=\"item.custom_name_enable=true\" translate=\"INVOICES_FORM.CUSTOM_NAME_ENABLE\"></a> <a ng-if=\"item.custom_name_enable\" ng-click=\"vm.clearCustomName(item)\" translate=\"INVOICES_FORM.CUSTOM_NAME_DISABLE\"></a></div></td><td md-cell=\"\"><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\"><label hide-gt-sm=\"\"><span translate=\"INVOICES_FORM.QUANTITY\"></span></label> <input ng-model=\"item.quantity\" name=\"quantity_{{$index}}\" required=\"\" type=\"number\" step=\"{{item.service_unit.decimal ? 0.001 : 1}}\" min=\"1\" ng-disabled=\"vm.is_extra_item\"><div ng-messages=\"formInvoice[\'quantity_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"number\"><span translate=\"ERRORS.FORM.NUMBER\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.NUMBER\"></span></div><div ng-message=\"step\"><span ng-if=\"!item.service_unit.decimal\" translate=\"ERRORS.FORM.INTEGER\"></span> <span ng-if=\"item.service_unit.decimal\" translate=\"ERRORS.FORM.NUMBER_3_DP\"></span></div></div></md-input-container></td><td md-cell=\"\"><md-input-container class=\"md-block select-style\" flex-gt-sm=\"\"><label hide-gt-sm=\"\"><span translate=\"INVOICES_FORM.UNIT\"></span></label><md-select ng-model=\"item.service_unit_id\" required=\"\" name=\"service_unit_id_{{$index}}\" ng-disabled=\"vm.is_extra_item\"><md-option ng-value=\"unit.id\" ng-repeat=\"unit in vm.units\" ng-if=\"unit.id\">{{unit.slug}}</md-option></md-select><div ng-messages=\"formInvoice[\'service_unit_id_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></td><td md-cell=\"\"><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\" ng-if=\"!vm.form.gross_counted\"><label hide-gt-sm=\"\">{{ \'INVOICES_FORM.PRICE_NET\' | translate }} ({{ vm.form.currency || \'zł\' }})</label> <input ng-model=\"item.price_net\" name=\"price_net_{{$index}}\" required=\"\" type=\"number\" step=\"0.01\" min=\"0.01\" ng-disabled=\"vm.is_extra_item\"><div ng-messages=\"formInvoice[\'price_net_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"number\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"step\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div></div></md-input-container><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\" ng-if=\"vm.form.gross_counted\"><label hide-gt-sm=\"\"><span ng-if=\"vat_payer\">{{ \'INVOICES_FORM.PRICE_GROSS\' | translate }} ({{ vm.form.currency || \'zł\' }})</span> <span ng-if=\"!vat_payer\">{{ \'INVOICES_FORM.PRICE\' | translate }} ({{ vm.form.currency || \'zł\' }})</span></label> <input ng-model=\"item.price_gross\" name=\"price_gross_{{$index}}\" required=\"\" type=\"number\" step=\"0.01\" min=\"0.01\" ng-disabled=\"vm.is_extra_item\"><div ng-messages=\"formInvoice[\'price_gross_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"number\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"step\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div></div></md-input-container></td><td md-cell=\"\"><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\" ng-if=\"!vm.form.gross_counted\"><label hide-gt-sm=\"\">{{ \'INVOICES_FORM.PRICE_NET_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</label> <input ng-model=\"item.price_net_sum\" required=\"\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block input-style\" flex-gt-sm=\"\" ng-if=\"vm.form.gross_counted\"><label hide-gt-sm=\"\"><span ng-if=\"vat_payer\">{{ \'INVOICES_FORM.PRICE_GROSS_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</span> <span ng-if=\"!vat_payer\">{{ \'INVOICES_FORM.PRICE_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</span></label> <input ng-model=\"item.price_gross_sum\" required=\"\" ng-disabled=\"true\"></md-input-container></td><td md-cell=\"\" ng-if=\"vat_payer\"><md-input-container class=\"md-block select-style\" flex-gt-sm=\"\"><label hide-gt-sm=\"\"><span translate=\"INVOICES_FORM.TAX\"></span></label><md-select ng-model=\"item.vat_rate_id\" required=\"\" name=\"vat_rate_id_{{$index}}\" ng-disabled=\"vm.is_extra_item || vm.type == \'margin\' || vm.type == \'reverse_charge\' || vm.type == \'currency_reverse_charge\'\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"tax.id\" ng-repeat=\"tax in vm.taxes\">{{tax.name}}</md-option></md-select><div ng-messages=\"formInvoice[\'vat_rate_id_\'+$index].$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></td><td md-cell=\"\"><md-button class=\"md-icon-button md-warn\" ng-click=\"vm.deleteProduct($index)\" ng-if=\"vm.form.items.length > 1\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div></div><div layout-gt-sm=\"row\" layout-align=\"end none\" ng-if=\"!vm.is_extra_item\"><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.addProduct()\" translate=\"INVOICES_FORM.ADD_PRODUCT\">ADD</md-button></div><div class=\"form-title\" translate=\"INVOICES_FORM.SUMMARY\"></div><div layout-gt-sm=\"row\" ng-if=\"!vm.is_extra_item\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-checkbox ng-model=\"vm.special_payment\" name=\"special_payment\" ng-change=\"vm.changeSpecialPayment()\"><span translate=\"INVOICES_FORM.PARTIAL_PAYMENT\"></span></md-checkbox></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.special_payment\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.TERM\"></span></label> <input ng-model=\"vm.today\" moment-picker=\"vm.today\" format=\"YYYY-MM-DD\" start-view=\"year\" locale=\"pl\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.AMOUNT\"></span></label> <input ng-model=\"vm.form.special_payment.amount\" name=\"partial_amount\" required=\"\" type=\"number\" step=\"0.01\" min=\"0.01\" max=\"{{(vm.form.price_gross - 0.01)}}\"><div ng-messages=\"formInvoice.partial_amount.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"number\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"max\"><span translate=\"ERRORS.FORM.MAX_AMOUNT\"></span></div><div ng-message=\"step\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.PAYMENT_METHOD\"></span></label><md-select ng-model=\"vm.form.special_payment.payment_method_id\" required=\"\" name=\"partials_payment_method_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"payment_method.id\" ng-repeat=\"payment_method in vm.payment_methods\" ng-disabled=\"payment_method.id == vm.form.payment_method_id\" ng-if=\"payment_method.slug == \'gotowka\' || payment_method.slug == \'karta\'\">{{payment_method.name}}</md-option></md-select><div ng-messages=\"formInvoice.partials_payment_method_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.TERM\"></span></label> <input ng-model=\"vm.payment_date\" name=\"payment_date\" moment-picker=\"vm.payment_date\" format=\"YYYY-MM-DD\" start-view=\"year\" locale=\"pl\" min-date=\"vm.start_callendar\" max-date=\"vm.stop_callendar\" ng-disabled=\"vm.is_extra_item || vm.disabled_payment_date\"><div ng-messages=\"formInvoice.payment_date.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.special_payment\"><label><span translate=\"INVOICES_FORM.AMOUNT\"></span></label> <input ng-value=\"vm.round(vm.form.price_gross - vm.form.special_payment.amount)\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.PAYMENT_METHOD\"></span></label><md-select ng-model=\"vm.form.payment_method_id\" required=\"\" name=\"payment_method_id\" ng-if=\"!translate_loading\" ng-disabled=\"vm.is_extra_item\"><md-option ng-value=\"payment_method.id\" ng-repeat=\"payment_method in vm.payment_methods\" ng-disabled=\"payment_method.id == vm.form.special_payment.payment_method_id\">{{payment_method.name}}</md-option></md-select><div ng-messages=\"formInvoice.payment_method_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.company.bank_accounts.data.length > 1 && vm.form.payment_method_id == 2\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.BANK_ACCOUNT\"></span></label><md-select ng-model=\"vm.form.bank_account_id\" required=\"\" name=\"bank_account\" ng-if=\"!translate_loading\"><md-option ng-value=\"bank_account.id\" ng-repeat=\"bank_account in vm.company.bank_accounts.data\">{{bank_account.bank_name}}</md-option></md-select><div ng-messages=\"formInvoice.bank_account.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.type === \'vat\' || vm.type === \'reverse_charge\' || vm.type === \'currency\' || vm.type === \'currency_reverse_charge\' || vm.type === \'margin\' || vm.type === \'margin_proforma\'\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"50\"><label>{{ \'INVOICES_FORM.GTU_PRODUCT\' | translate }}</label><md-select ng-model=\"vm.form.gtu\" name=\"gtu\" ng-if=\"!translate_loading\" multiple=\"true\" md-selected-text=\"vm.getGtuProductLabel()\"><md-option ng-value=\"gtu.id\" ng-repeat=\"gtu in vm.gtu_product_items\"><div class=\"md-option-title\">{{gtu.name}}</div><div class=\"md-option-desc\">{{gtu.description}}</div></md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"50\"><label>{{ \'INVOICES_FORM.GTU_PROCEDURE\' | translate }}</label><md-select ng-model=\"vm.form.gtu\" name=\"gtu\" ng-if=\"!translate_loading\" multiple=\"true\" md-selected-text=\"vm.getGtuProcedureLabel()\"><md-option ng-value=\"gtu.id\" ng-repeat=\"gtu in vm.gtu_procedure_items\"><div class=\"md-option-title\">{{gtu.name}}</div><div class=\"md-option-desc\">{{gtu.description}}</div></md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.is_extra_item\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-checkbox ng-model=\"vm.show_description\"><span translate=\"INVOICES_FORM.DESCRIPTION\"></span></md-checkbox></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.show_description\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"INVOICES_FORM.DESCRIPTION\"></span></label> <textarea ng-model=\"vm.form.description\" ng-maxlength=\"1000\" name=\"description\"></textarea></md-input-container></div><div layout-gt-sm=\"row\" class=\"mb-30 ml-30\"><div class=\"table-wrapper width-auto\" ng-if=\"vm.form.taxes.length && vat_payer\" flex-gt-sm=\"\"><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-numeric=\"\"><span translate=\"INVOICES_FORM.TAX\"></span></th><th md-column=\"\" md-numeric=\"\">{{ \'INVOICES_FORM.PRICE_NET_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</th><th md-column=\"\" md-numeric=\"\">{{ \'INVOICES_FORM.PRICE_GROSS_SUM\' | translate }} ({{ vm.form.currency || \'zł\' }})</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"tax in vm.form.taxes\"><td md-cell=\"\">{{vm.taxes[tax.vat_rate_id].name}}</td><td md-cell=\"\">{{ tax.price_net.toFixed(2) | numFormat }} {{ vm.form.currency || \'zł\' }}</td><td md-cell=\"\">{{ tax.price_gross.toFixed(2) | numFormat }} {{ vm.form.currency || \'zł\' }}</td></tr></tbody></table></md-table-container></div><div layout-gt-sm=\"row\" layout-wrap=\"\" flex-gt-sm=\"\" class=\"p-20 font-size-18\"><div layout=\"row\" flex=\"100\" layout-align=\"end center\"><div class=\"block\"><span ng-if=\"vat_payer\"><span translate=\"INVOICES_FORM.PRICE_NET_SUMMARY\"></span>: <b>&nbsp;{{vm.form.price_net.toFixed(2) | numFormat}} {{ vm.form.currency || \'zł\' }}</b><br></span> <span ng-if=\"vat_payer\"><span translate=\"INVOICES_FORM.PRICE_GROSS_SUMMARY\"></span>: <b>&nbsp;{{vm.form.price_gross.toFixed(2) | numFormat}} {{ vm.form.currency || \'zł\' }}</b></span> <span ng-if=\"!vat_payer\"><span translate=\"INVOICES_FORM.PRICE_SUMMARY\"></span>: <b>&nbsp;{{vm.form.price_gross.toFixed(2) | numFormat}} {{ vm.form.currency || \'zł\' }}</b></span></div></div></div></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><span class=\"require\">*</span> <span translate=\"INFO.REQUIRE_INFO\"></span></md-input-container></div><div layout=\"row\" layout-align=\"end none\"><md-button href=\"/invoices/list\" class=\"md-raised\" aria-label=\"Go Back\" translate=\"OTHER.GO_BACK\" translate-attr-aria-label=\"OTHER.GO_BACK\">Go Back</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"formInvoice.$invalid || vm.request_sending\" translate=\"INVOICES_FORM.SAVE\" translate-attr-aria-label=\"INVOICES_FORM.SAVE\"></md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/invoices/list/list.html","<div id=\"invoices-list\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"title\" translate=\"INVOICES_LIST.TITLE\"></div></div></div><div class=\"content\" layout=\"column\"><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><div class=\"add-invoice-options\" layout=\"row\" layout-wrap=\"\" ng-if=\"!vm.is_tax_office\"><div class=\"mr-20\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.goTo(\'form/new/type/vat\')\"><span ng-if=\"vat_payer\" translate=\"INVOICES_LIST.ADD_INVOICE_VAT\"></span> <span ng-if=\"!vat_payer\" translate=\"INVOICES_LIST.ADD_INVOICE_NOVAT\"></span></md-button></div><md-input-container class=\"md-block\" flex-gt-xs=\"33\" flex-gt-md=\"25\" flex=\"100\"><md-select class=\"md-block\" ng-model=\"vm.type\" ng-change=\"vm.selectAdd()\" ng-if=\"!translate_loading && !vm.is_loading\" md-container-class=\"select--full-height\"><md-option ng-value=\"null\"><span translate=\"INVOICES_LIST.ADD_OTHER\"></span></md-option><md-option ng-value=\"\'proforma\'\"><span translate=\"INVOICES_LIST.ADD_INVOICE_PROFORMA\"></span></md-option><md-option ng-value=\"\'margin\'\" ng-if=\"vat_payer\"><span translate=\"INVOICES_LIST.ADD_INVOICE_MARGIN\"></span></md-option><md-option ng-value=\"\'reverse_charge\'\" ng-if=\"vat_payer\"><span translate=\"INVOICES_LIST.ADD_INVOICE_REVERSE\"></span></md-option><md-option ng-value=\"\'currency\'\"><span translate=\"INVOICES_LIST.ADD_INVOICE_CURRENCY\"></span></md-option><md-option ng-value=\"\'currency_reverse_charge\'\"><span translate=\"INVOICES_LIST.ADD_INVOICE_CURRENCY_REVERSE\"></span></md-option><md-option ng-value=\"\'margin_proforma\'\"><span translate=\"INVOICES_LIST.ADD_INVOICE_MARGIN_PROFORMA\"></span></md-option></md-select></md-input-container></div><div class=\"filtering-label\" translate=\"INVOICES_LIST.SEARCH_INVOICES\">Search invoices:</div><div layout=\"column\" class=\"filter-options\"><div layout=\"row\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label><span translate=\"INVOICES_LIST.STATUS_NAME\"></span></label><md-select ng-model=\"vm.query.status\" required=\"\" name=\"status\" ng-if=\"!translate_loading\"><md-option ng-value=\"filter.slug\" ng-repeat=\"filter in vm.filters\"><span translate=\"INVOICES_LIST.STATUS.{{filter.slug}}\"></span></md-option></md-select></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label><span translate=\"OTHER.FROM\"></span></label> <input ng-model=\"vm.query.date_start\" name=\"date_start\" moment-picker=\"vm.query.date_start\" format=\"YYYY-MM-DD\" start-view=\"year\" locale=\"pl\" autocomplete=\"off\" input-clear=\"\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex=\"33\"><label><span translate=\"OTHER.TO\"></span></label> <input ng-model=\"vm.query.date_end\" name=\"date_end\" moment-picker=\"vm.query.date_end\" format=\"YYYY-MM-DD\" start-view=\"year\" locale=\"pl\" autocomplete=\"off\" input-clear=\"\"></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-autocomplete class=\"md-block no-errors-spacer\" flex-gt-md=\"25\" flex-gt-xs=\"50\" flex=\"100\" md-input-name=\"contractor\" ng-model-options=\"{debounce:200}\" md-selected-item=\"vm.contractor\" md-search-text=\"vm.search_text\" md-items=\"item in vm.searchContractor(vm.search_text)\" md-floating-label=\"{{\'INVOICES_LIST.CONTRACTOR\' | translate}}\" md-item-text=\"item.name\" md-clear-button=\"true\"><md-item-template><span md-highlight-text=\"vm.search_text\">{{item.name}}</span></md-item-template><md-not-found><span translate=\"OTHER.NOT_FOUND\"></span></md-not-found></md-autocomplete><md-input-container class=\"md-block no-errors-spacer\" flex-gt-md=\"25\" flex-gt-xs=\"50\" flex=\"100\"><label><span translate=\"INVOICES_LIST.NUMBER\"></span></label> <input ng-model=\"vm.query.number\" name=\"number\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex-gt-md=\"25\" flex-gt-xs=\"50\" flex=\"100\"><label><span translate=\"INVOICES_LIST.CURRENCY\"></span></label><md-select class=\"md-block\" ng-model=\"vm.query.currency\" ng-if=\"!translate_loading && !vm.is_loading\"><md-option ng-value=\"null\"><span translate=\"OTHER.ALL\"></span></md-option><md-option ng-value=\"currency.code\" ng-repeat=\"currency in vm.currencies\">{{ currency.code }} - {{ currency.name }}</md-option></md-select></md-input-container><div layout=\"row\" layout-align=\"end start\" flex-gt-md=\"25\" flex-gt-xs=\"50\" flex=\"100\"><md-input-container class=\"md-block no-errors-spacer\" flex=\"100\"><label><span translate=\"INVOICES_LIST.REGISTER\"></span></label><md-select class=\"md-block\" ng-model=\"vm.query.invoice_registry_id\" ng-if=\"!translate_loading && !vm.is_loading\"><md-option ng-value=\"null\"><span translate=\"OTHER.ALL\"></span></md-option><md-option ng-value=\"register.id\" ng-repeat=\"register in vm.registries\">{{register.prefix}}<span ng-if=\"register.prefix != \'\'\">/</span>{{vm.invoice_formats[register.invoice_format_id].name}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" layout-wrap=\"\"><div layout=\"row\" layout-align=\"start start\" flex=\"100\" flex-gt-xs=\"50\"><div class=\"mt-8 mh-10\"><md-checkbox ng-model=\"vm.save_filters\" ng-click=\"vm.saveFilters()\"><span translate=\"INVOICES_LIST.SAVE_FILTERS\"></span></md-checkbox></div><md-button class=\"md-button mb-15 mt-0\" ng-click=\"vm.resetFilters()\"><span translate=\"INVOICES_LIST.RESET_FILTERS\"></span></md-button></div><div layout=\"row\" layout-align=\"end start\" flex=\"100\" flex-gt-xs=\"50\"><md-button class=\"md-raised md-button md-default-theme md-accent mb-15 mt-0\" ng-click=\"vm.filterInvoices()\"><span translate=\"INVOICES_LIST.SEARCH\"></span></md-button></div></div></div><div layout=\"row\" layout-align=\"end center\" layout-wrap=\"\"><div layout=\"row\" flex-xs=\"100\"><md-button class=\"md-raised md-button\" ng-click=\"vm.pdfAll()\"><md-icon md-font-icon=\"icon-format-list-numbers icon icon-flat s20\"></md-icon><span translate=\"INVOICES_LIST.PDF_LIST\"></span></md-button></div><div layout=\"row\" flex-xs=\"100\"><md-button class=\"md-raised md-button\" ng-click=\"vm.archiveAll()\" flex-xs=\"100\"><md-icon md-font-icon=\"icon-download icon icon-flat s20\"></md-icon><span translate=\"INVOICES_LIST.INVOICES_ARCHIVE\"></span></md-button></div><div layout=\"row\" flex-xs=\"100\"><md-button class=\"md-button\" ng-click=\"vm.invoicesZips($event)\" flex-xs=\"100\"><md-icon md-font-icon=\"icon-archive icon icon-flat s20\"></md-icon><span translate=\"INVOICES_LIST.INVOICES_ZIPS\"></span></md-button></div></div><div ng-if=\"vm.pagination.total\" class=\"table-wrapper mt-20\"><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.query.sort\" md-on-reorder=\"vm.getInvoices\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"id\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"INVOICES_LIST.NUMBER\"></span></th><th md-column=\"\" md-order-by=\"issue_date\" class=\"\">{{ \'INVOICES_LIST.ISSUE_DATE_1\' | translate }}<br>{{ \'INVOICES_LIST.ISSUE_DATE_2\' | translate }}</th><th md-column=\"\"><span translate=\"INVOICES_LIST.CONTRACTOR\"></span></th><th md-column=\"\"><span translate=\"INVOICES_LIST.TYPE\"></span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"price_net\" ng-if=\"vat_payer\"><span translate=\"INVOICES_LIST.PRICE_NET_SUM\"></span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"price_gross\" ng-if=\"vat_payer\"><span translate=\"INVOICES_LIST.PRICE_GROSS_SUM\"></span></th><th md-column=\"\" md-numeric=\"\" md-order-by=\"price_gross\" ng-if=\"!vat_payer\"><span translate=\"INVOICES_LIST.PRICE_SUM\"></span></th><th md-column=\"\"><span translate=\"INVOICES_LIST.CURRENCY\"></span></th><th md-column=\"\">{{ \'INVOICES_LIST.TERM_1\' | translate }}<br>{{ \'INVOICES_LIST.TERM_2\' | translate }}</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"invoice in vm.invoices\"><td md-cell=\"\">{{ vm.pagination | no:$index }}</td><td md-cell=\"\" class=\"no-wrap\" ng-class=\"{\'line-through\': invoice.deleted_at != null}\">{{ invoice.number }}</td><td md-cell=\"\" class=\"no-wrap\">{{ invoice.issue_date }}</td><td md-cell=\"\">{{ invoice.invoice_contractor.data.name | limitTo:50 }}{{ invoice.invoice_contractor.data.name.length > 50 ? \'...\' : \'\' }}</td><td md-cell=\"\">{{ vm.types[invoice.invoice_type_id].no_vat_description }}</td><td md-cell=\"\" ng-if=\"vat_payer\">{{ invoice.price_net.toFixed(2) | numFormat }}</td><td md-cell=\"\">{{ invoice.price_gross.toFixed(2) | numFormat }}</td><td md-cell=\"\">{{ invoice.currency }}</td><td md-cell=\"\" class=\"no-wrap\">{{ vm.moment(invoice.issue_date).add(invoice.payment_term_days, \'days\').format(\'YYYY-MM-DD\') }}</td><td md-cell=\"\"><span ng-if=\"invoice.deleted_at != null\" translate=\"INVOICES_LIST.CANCELED\"></span><md-menu ng-if=\"invoice.deleted_at == null\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.pdf(invoice.id, 0)\" aria-label=\"pdf\"><span translate=\"INVOICES_LIST.PDF\"></span></md-button></md-menu-item><md-menu-item ng-if=\"invoice.invoice_type_id != vm.id_type_proforma\"><md-button ng-click=\"vm.pdf(invoice.id, 1)\" aria-label=\"duplicate\"><span translate=\"INVOICES_LIST.DUPLICATE\"></span></md-button></md-menu-item><md-menu-item ng-if=\"!vm.isCorrection(invoice.invoice_type_id) && invoice.invoice_type_id != vm.id_type_proforma && !invoice.invoices.data.length && !vm.is_tax_office\"><md-button ng-click=\"vm.goTo(\'form-correction/\' + invoice.id)\" aria-label=\"correction\"><span translate=\"INVOICES_LIST.CORRECTION\"></span></md-button></md-menu-item><md-menu-item ng-if=\"!invoice.paid_at && invoice.invoice_type_id != vm.id_type_proforma && !vm.is_tax_office\"><md-button ng-click=\"vm.paymentsAdd(invoice.id, invoice.payment_left, invoice.payment_method_id)\" aria-label=\"paymentsAdd\"><span translate=\"INVOICES_LIST.PAYMENTS_ADD\"></span></md-button></md-menu-item><md-menu-item ng-if=\"invoice.payment_left != invoice.price_gross && invoice.invoice_type_id != vm.id_type_proforma\"><md-button ng-click=\"vm.payments(invoice.id)\" aria-label=\"payments\"><span translate=\"INVOICES_LIST.PAYMENTS_LIST\"></span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.mail(invoice)\" aria-label=\"Email\"><span translate=\"INVOICES_LIST.MAIL\"></span></md-button></md-menu-item><md-menu-item ng-if=\"!vm.isCorrection(invoice.invoice_type_id) && !vm.is_tax_office\"><md-button ng-click=\"vm.goTo(\'form/new/invoice/\' + invoice.id)\" aria-label=\"New\"><span translate=\"INVOICES_LIST.NEW\"></span></md-button></md-menu-item><md-menu-item ng-if=\"invoice.is_editable && !vm.is_tax_office\"><md-button ng-click=\"vm.goTo(\'form/edit/\' + invoice.id)\" aria-label=\"Edit\"><span translate=\"OTHER.EDIT\"></span></md-button></md-menu-item><md-menu-item ng-if=\"(vm.isCorrection(invoice.invoice_type_id) || !invoice.invoices.data.length) && !vm.is_tax_office\"><md-button ng-click=\"vm.cancel(invoice.id)\" aria-label=\"Cancel\"><span translate=\"INVOICES_LIST.CANCEL_INVOICE\"></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{vm.table_translate}}\" md-limit=\"vm.query.limit\" md-page=\"vm.query.page\" md-total=\"{{vm.pagination.total}}\" md-on-paginate=\"vm.onPaginationChanged\" md-page-select=\"\"></md-table-pagination></div><div layout=\"row\" ng-if=\"vm.pagination.total == 0\" translate=\"OTHER.NO_RECORDS\" class=\"text-center\"></div><div class=\"bold mb-5 font-size-18\" translate=\"INVOICES_LIST.SUM\"></div><div layout=\"row\" layout-wrap=\"\"><div ng-repeat=\"report in vm.reports\" class=\"font-size-16 mr-20 mb-10\"><div class=\"bold\">{{ \'INVOICES_LIST.CURRENCY\' | translate }}: {{report.currency}}</div><div><span translate=\"INVOICES_LIST.SUM_GROSS\"></span>: {{report.price_gross_sum.toFixed(2) | numFormat}} {{report.currency}}</div><div><span translate=\"INVOICES_LIST.SUM_NET\"></span>: {{report.price_net_sum.toFixed(2) | numFormat}} {{report.currency}}</div><div><span translate=\"INVOICES_LIST.VAT_SUM\"></span>: {{report.vat_sum_sum.toFixed(2) | numFormat}} {{report.currency}}</div><div><span translate=\"INVOICES_LIST.SUM_PAYMENT_LEFT\"></span>: {{report.payment_left_sum.toFixed(2) | numFormat}} {{report.currency}}</div></div></div></div></div></div></div>");
$templateCache.put("app/main/invoices/payments/payments.html","<md-dialog aria-label=\"METHOD\"><div id=\"invoice-payments-dialog\"><div class=\"table-wrapper\"><md-table-container ng-if=\"vm.items.length\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"INVOICES_LIST.PAYMENTS.AMOUNT\"></span></th><th md-column=\"\"><span translate=\"INVOICES_LIST.PAYMENTS.PAYMENT_METHOD\"></span></th><th md-column=\"\"><span translate=\"INVOICES_LIST.PAYMENTS.DATE\"></span></th><th md-column=\"\" ng-if=\"!vm.is_tax_office\"><span translate=\"OTHER.ACTION\"></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.items\"><td md-cell=\"\">{{ ($index + 1) }}</td><td md-cell=\"\">{{ item.amount.toFixed(2) | numFormat}}zł</td><td md-cell=\"\">{{ vm.payment_methods[item.payment_method_id].name }}</td><td md-cell=\"\">{{ item.created_at }}</td><td md-cell=\"\"><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.removePayment(item.id)\" translate=\"INVOICES_LIST.PAYMENTS.DELETE\" ng-if=\"!vm.is_tax_office && !item.special_partial_payment\">DELETE</md-button></td></tr></tbody></table></md-table-container><div ng-if=\"!vm.items.length\" translate=\"OTHER.NO_RECORDS\"></div></div></div></md-dialog>");
$templateCache.put("app/main/invoices/success_save/success_save.html","<md-dialog aria-label=\"METHOD\"><div id=\"invoice-success-save-dialog\" class=\"text-center\"><div class=\"title\"><span ng-if=\"vm.page==\'new\' || vm.page==\'new-correction\'\" translate=\"INVOICES_SUCCESS_SAVE.CREATED\"></span> <span ng-if=\"vm.page==\'edit\'\" translate=\"INVOICES_SUCCESS_SAVE.UPDATED\"></span> <span ng-if=\"!vm.page\" translate=\"INVOICES_SUCCESS_SAVE.INVOICE\"></span> {{vm.invoice.number}}</div><div ng-if=\"!vm.form_email_anabled\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"PDF\" ng-click=\"vm.pdf()\" translate=\"INVOICES_SUCCESS_SAVE.PDF\" translate-attr-aria-label=\"INVOICES_SUCCESS_SAVE.PDF\"></md-button><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"EMAIL\" ng-click=\"vm.form_email_anabled = true\" translate=\"INVOICES_SUCCESS_SAVE.MAIL\" translate-attr-aria-label=\"INVOICES_SUCCESS_SAVE.MAIL\"></md-button></div><div ng-if=\"!vm.form_email_anabled\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"edit\" ng-click=\"vm.edit()\" ng-disabled=\"vm.page == \'new-correction\'\" translate=\"OTHER.EDIT\" translate-attr-aria-label=\"OTHER.EDIT\"></md-button><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"add new\" ng-click=\"vm.add_new()\" translate=\"INVOICES_SUCCESS_SAVE.NEW\" translate-attr-aria-label=\"INVOICES_SUCCESS_SAVE.NEW\" ng-disabled=\"vm.page == \'new-correction\'\"></md-button><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"copy\" ng-click=\"vm.copy()\" translate=\"INVOICES_SUCCESS_SAVE.COPY\" translate-attr-aria-label=\"INVOICES_SUCCESS_SAVE.COPY\"></md-button><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"list\" ng-click=\"vm.list()\" translate=\"INVOICES_SUCCESS_SAVE.LIST\" translate-attr-aria-label=\"INVOICES_SUCCESS_SAVE.LIST\"></md-button></div><form ng-if=\"vm.form_email_anabled\" id=\"sendInvoiceEmail\" name=\"sendInvoiceEmail\"><div layout-gt-sm=\"row\"><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div></div><div layout-gt-sm=\"row\" class=\"text-left\"><md-input-container class=\"md-block\" flex=\"100\"><label><span translate=\"INVOICES_SUCCESS_SAVE.EMAIL\"></span></label> <input ng-model=\"vm.form.email\" required=\"\" ng-maxlength=\"255\" name=\"email\" type=\"email\"><div ng-messages=\"sendInvoiceEmail.email.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"email\"><span translate=\"ERRORS.FORM.EMAIL\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"end none\"><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"CANCEL\" translate=\"OTHER.CANCEL\" ng-click=\"vm.cancelForm()\" translate-attr-aria-label=\"OTHER.CANCEL\"></md-button><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-disabled=\"sendInvoiceEmail.$invalid || vm.request_sending\" translate=\"INVOICES_SUCCESS_SAVE.MAIL\" ng-click=\"vm.email()\" translate-attr-aria-label=\"INVOICES_SUCCESS_SAVE.MAIL\"></md-button></div></form></div></md-dialog>");
$templateCache.put("app/main/online-sales/invoices/invoices.html","<md-dialog aria-label=\"METHOD\"><div id=\"online-sales-invoices-dialog\"><div class=\"table-wrapper\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"ONLINE_SALES_LIST.NUMBER\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\"></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"invoice in vm.invoices\"><td md-cell=\"\">{{ ($index + 1) }}</td><td md-cell=\"\">{{ invoice.number }}</td><td md-cell=\"\"><md-button class=\"md-raised md-accent md-button md-default-theme\" ng-click=\"vm.pdf(invoice.id, 0)\"><span translate=\"ONLINE_SALES_LIST.PDF\"></span></md-button><md-button class=\"md-raised md-accent md-button md-default-theme\" ng-click=\"vm.pdf(invoice.id, 0)\"><span translate=\"ONLINE_SALES_LIST.PDF_DUPLICATE\"></span></md-button></td></tr></tbody></table></md-table-container></div></div></md-dialog>");
$templateCache.put("app/main/online-sales/items/items.html","<md-dialog aria-label=\"METHOD\"><div id=\"online-sales-items-dialog\"><div class=\"table-wrapper\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"OTHER.NAME\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"ONLINE_SALES_LIST.QUANTITY\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"ONLINE_SALES_LIST.PRICE_NET\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"ONLINE_SALES_LIST.PRICE_GROSS\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"ONLINE_SALES_LIST.VAT_SUM\"></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.items\"><td md-cell=\"\">{{ ($index + 1) }}</td><td md-cell=\"\">{{ item.name }}</td><td md-cell=\"\">{{ item.quantity }}</td><td md-cell=\"\">{{ item.price_net_sum.toFixed(2) | numFormat }}zł</td><td md-cell=\"\">{{ item.price_gross_sum.toFixed(2) | numFormat }}zł</td><td md-cell=\"\">{{ item.vat_sum.toFixed(2) | numFormat }}zł</td></tr></tbody></table></md-table-container></div></div></md-dialog>");
$templateCache.put("app/main/online-sales/list/list.html","<div id=\"online-sales-list\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"title\" translate=\"ONLINE_SALES_LIST.TITLE\"></div></div></div><div class=\"content\" layout=\"column\"><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div ng-if=\"vm.pagination.total == 0\" class=\"info\"><span translate=\"ONLINE_SALES_LIST.INFO\"></span>&nbsp;<a href=\"http://fvonline.pl\">kontakt@fvonline.pl</a></div><div layout=\"row\" ng-if=\"vm.pagination.total != 0\"><div class=\"form-wrapper rounded-container min-1000\"><div layout=\"row\"><md-input-container class=\"md-block no-errors-spacer\" flex-gt-xs=\"33\"><label><span translate=\"OTHER.FROM\"></span></label> <input ng-model=\"vm.query.date_start\" name=\"date_start\" moment-picker=\"vm.query.date_start\" format=\"YYYY-MM-DD\" start-view=\"decade\" locale=\"pl\" input-clear=\"\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex-gt-xs=\"33\"><label><span translate=\"OTHER.TO\"></span></label> <input ng-model=\"vm.query.date_end\" name=\"date_end\" moment-picker=\"vm.query.date_end\" format=\"YYYY-MM-DD\" start-view=\"decade\" locale=\"pl\" input-clear=\"\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex-gt-xs=\"33\"><label><span translate=\"ONLINE_SALES_LIST.TRANSACTION_NUMBER\"></span></label> <input ng-model=\"vm.query.transaction_number\" name=\"transaction_number\"></md-input-container></div><div layout=\"row\" layout-wrap=\"\"><md-input-container class=\"md-block no-errors-spacer\" flex-gt-sm=\"33\" flex=\"50\"><label><span translate=\"ONLINE_SALES_LIST.NUMBER\"></span></label> <input ng-model=\"vm.query.number\" name=\"number\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex-gt-sm=\"33\" flex=\"50\"><label><span translate=\"ONLINE_SALES_LIST.EMAIL\"></span></label> <input ng-model=\"vm.query.email\" name=\"email\"></md-input-container><div layout=\"row\" layout-align=\"start center\" flex-gt-sm=\"33\" flex=\"100\"><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.getOnlineSales()\"><span translate=\"ONLINE_SALES_LIST.SEARCH\"></span></md-button><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.pdf()\"><span translate=\"ONLINE_SALES_LIST.GENERATE_PDF\"></span></md-button></div></div><div ng-if=\"vm.pagination.total > 0\" class=\"table-wrapper\"><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.query.sort\" md-on-reorder=\"vm.getOnlineSales\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"ONLINE_SALES_LIST.NUMBER\"></span></th><th md-column=\"\"><span translate=\"ONLINE_SALES_LIST.TRANSACTION_NUMBER\"></span></th><th md-column=\"\"><span translate=\"ONLINE_SALES_LIST.EMAIL\"></span></th><th md-column=\"\"><span translate=\"ONLINE_SALES_LIST.CREATED\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"ONLINE_SALES_LIST.PRICE_NET\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"ONLINE_SALES_LIST.PRICE_GROSS\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"ONLINE_SALES_LIST.VAT_SUM\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\">Akcje</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"sale in vm.online_sales\"><td md-cell=\"\">{{ vm.pagination | no:$index }}</td><td md-cell=\"\">{{ sale.number }}</td><td md-cell=\"\">{{ sale.transaction_number }}</td><td md-cell=\"\">{{ sale.email }}</td><td md-cell=\"\">{{ sale.sale_date }}</td><td md-cell=\"\">{{ sale.price_net.toFixed(2) | numFormat }}zł</td><td md-cell=\"\">{{ sale.price_gross.toFixed(2) | numFormat }}zł</td><td md-cell=\"\">{{ sale.vat_sum.toFixed(2) | numFormat }}zł</td><td md-cell=\"\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.details(sale.id)\" aria-label=\"Show\"><span translate=\"OTHER.DETAILS\"></span></md-button></md-menu-item><md-menu-item ng-if=\"sale.invoices.data.length\"><md-button ng-click=\"vm.invoices($index)\"><span translate=\"ONLINE_SALES_LIST.INVOICES\"></span></md-button></md-menu-item><md-menu-item ng-if=\"!sale.invoices.data.length && !vm.is_tax_office\"><md-button ng-click=\"vm.invoice(sale.id)\" aria-label=\"Edit\"><span translate=\"ONLINE_SALES_LIST.GENERATE_INVOICE\"></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{vm.table_translate}}\" md-limit=\"vm.query.limit\" md-page=\"vm.query.page\" md-total=\"{{vm.pagination.total}}\" md-on-paginate=\"vm.getOnlineSales\" md-page-select=\"\"></md-table-pagination></div><div layout=\"row\" ng-if=\"vm.pagination.total == 0\" translate=\"OTHER.NO_RECORDS\" class=\"text-center\"></div><div class=\"font-size-16 mt-20\"><div class=\"bold\" translate=\"ONLINE_SALES_LIST.SUM\"></div><div><span translate=\"ONLINE_SALES_LIST.SUM_GROSS\"></span>: {{vm.reports.price_gross_report.toFixed(2) | numFormat}}zł</div><div><span translate=\"ONLINE_SALES_LIST.SUM_NET\"></span>: {{vm.reports.price_net_report.toFixed(2) | numFormat}}zł</div><div><span translate=\"ONLINE_SALES_LIST.VAT_SUM\"></span>: {{vm.reports.vat_sum_report.toFixed(2) | numFormat}}zł</div></div></div></div></div></div>");
$templateCache.put("app/main/pages/cookie/cookie.html","<div id=\"cookie\" class=\"flex-scrollable guest-layout\" layout=\"column\" ms-scroll=\"\"><div id=\"cookie-wrapper\" class=\"guest-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"cookie-form\" class=\"rounded-container guest-form\"><logo-sqr></logo-sqr><div class=\"title\" translate=\"COOKIE.TITLE\"></div><div class=\"text-left\"><p>Niniejszy dokument stanowi integralną część regulaminu i dotyczy wyłącznie przeglądania zawartości Strony http://fvonline.pl/ oraz faktury.fvonline.pl</p><br><b>Czym są Pliki Cookies?</b><p class=\"text-justify\">Pliki Cookies - są to krótkie pliki tekstowe stanowiące dane informatyczne, służące do przeglądania zawartości Portalu, które przechowywane są na urządzeniu ostatecznym (np. komputerze) Użytkownika. Pliki Cookies, którymi posługuje się http://fvonline.pl/ oraz faktury.fvonline.pl nie służą do zbierania danych osobowych Użytkowników. Użytkownik ma możliwość podjęcia decyzji o stosowaniu Plików Cookies na swoim Urządzeniu. Dodatkowo Portal informuje, że ruch na stronie jest monitorowany przez statystyki Google Analytics co ma na celu gromadzenie danych o sposobie korzystania i popularności Portalu. Korzystając ze stron Portalu, Użytkownik zgadza się na analizowanie jego danych przez Google Analytics w opisanych w tym punkcie celu.</p><br><b>Rodzaje i cel korzystania przez http://fvonline.pl/ z Plików Cookies</b><ol><li>Ze względu na czas przez jaki cookie będzie umieszczone w urządzeniu końcowym użytkownika:<ol type=\"a\"><li><b>Cookies tymczasowe (session cookies)</b> - cookie umieszczone na czas korzystania z przeglądarki (sesji), usuwane w momencie zamykania przeglądarki</li><li><b>Cookies stałe (persistent cookie)</b> - pozostaje w urządzeniu użytkownika na określony czas lub bez okresu ważności w zależności od ustawień witryny</li></ol></li><li>Ze względu na pochodzenie – administratora serwisu, który zarządza cookies:<ol type=\"a\"><li><b>Cookie własne (first party cookie)</b> - cookie umieszczone przez Fvonline.pl</li><li><b>Cookie zewnętrzne (third-party cookie)</b> - cookie umieszczone przez zewnętrzne podmioty</li></ol></li><li>Ze względu na cel jakiemu służą:<ol type=\"a\"><li><b>Konfiguracji serwisu</b> - umożliwiają ustawienia funkcji i usług w serwisie</li><li><b>Bezpieczeństwo i niezawodność serwisu</b> - weryfikacja autentyczności oraz optymalizację wydajności serwisu</li><li><b>Uwierzytelnianie</b> - informują o zalogowaniu użytkownika do Serwisu</li><li><b>Procesy</b> - umożliwiają zapisywanie informacji w czasie trwania sesji</li><li><b>Procesy</b> - umożliwiają sprawne działanie samej witryny oraz dostępnych na niej funkcji</li><li><b>Reklamy</b> - dostosowanie reklam do profilu użytkownika</li><li><b>Lokalizacja</b> - dostosowanie wyświetlanych informacji do lokalizacji użytkownika</li></ol></li></ol><br><b>Usuwanie plików „cookies”</b><p class=\"text-justify\">Standardowo oprogramowanie służące do przeglądania stron internetowych domyślnie dopuszcza umieszczanie plików „cookies” na urządzeniu końcowym. Ustawienia te mogą zostać zmienione w taki sposób, aby blokować automatyczną obsługę plików „cookies” w ustawieniach przeglądarki internetowej bądź informować o ich każdorazowym przesłaniu na urządzenie użytkownika. Szczegółowe informacje o możliwości i sposobach obsługi plików „cookies” dostępne są w ustawieniach oprogramowania (przeglądarki internetowej). Ograniczenie stosowania plików „cookies”, może wpłynąć na niektóre funkcjonalności dostępne na stronie internetowej.</p></div></div></div><footer ng-include=\"\'app/layouts/footer.html\'\"></footer></div>");
$templateCache.put("app/main/pages/gdpr_info/gdpr_info.html","<md-dialog class=\"gdpr-info-dialog\"><md-toolbar class=\"md-accent md-hue-2\" layout=\"row\" layout-align=\"space-between center\"><div class=\"ph-24\" translate=\"GDPR_INFO.TITLE\"></div></md-toolbar><md-dialog-content><div class=\"content\"><p class=\"mt-0\">25 maja 2018 roku weszło w życie rozporządzenie RODO. W związku z tym chcielibyśmy poinformować Cię o przetwarzaniu Twoich danych osobowych oraz zasadach, na jakich będzie się to odbywało. Poniżej znajdziesz podstawowe informacje na ten temat.Szanujemy Twoją prywatność i kiedy wyrazisz zgodę to zakres naszych uprawnień pozostanie taki jak przed 25 maja. Nie zwiększy się. Twoje dane są u nas bezpieczne, a zgodę możesz wycofać w każdej chwili na podstronie <a ng-click=\"vm.goToPrivacyPolicy()\">polityki prywatności</a>.</p><h3>Kto będzie administratorem Twoich danych?</h3><p>To będzie DevPark sp.z o.o. ul. Wspólna 15/1, Komorniki. Tam będziesz mógł zgłaszać pytania, uwagi i zastrzeżenia.</p><h3>Jakie dane przetwarzamy i w jakim celu?</h3><p>Nie znamy twojego imienia i nazwiska, nie wiemy gdzie mieszkasz i co robisz. To się nie zmienia. Przetwarzamy tylko te dane, które podajesz lub pozostawiasz w ramach korzystania serwisu. Są to dane niezbędne do założenia konta oraz dane, które pozostawiasz w ramach poruszania się po naszych stronach, które zostawiasz w plikach cookies. Pozwalają ci się one zalogować w serwisie, a dodatkowo umożliwiają nam personalizację treści i reklam oraz analizowania ruchu na stronach. Dostęp do tych informacji z naszej strony mają także podmioty powiązane oraz nasi zaufani partnerzy, którzy wykorzystują je do personalizowania treści i reklam.</p><h3>Czy jeśli się nie zgodzę to znikną reklamy?</h3><p>Gdyby nie reklamy nasz serwis nie mógłby zapewniać ci tyle radości co dzień - nad serwisem pracuje codziennie wiele osób. Twórcy RODO zajmuję się tylko danymi osobowymi, toteż mimo sprzeciwu ilość reklam będzie wciąż podobna, ale nie będą one już dopasowane do Ciebie.</p><h3>Jakie masz prawa w stosunku do Twoich danych?</h3><p>Masz między innymi prawo do żądania dostępu do tych danych, sprostowania, usunięcia lub ograniczenia ich przetwarzania. Możesz także wycofać zgodę na przetwarzanie danych osobowych, zgłosić sprzeciw oraz skorzystać z innych praw wymienionych szczegółowo w <a ng-click=\"vm.goToPrivacyPolicy()\">polityce prywatności</a>.</p><p>Dlatego też proszę, zaznacz przycisk \"OK, przejdź do serwisu\", jeżeli zgadzasz się na przetwarzanie Twoich danych osobowych zbieranych w ramach korzystania przez ciebie z naszego serwisu, w tym w wersji \"desktop\", jak i \"mobile\", a także zbieranych w tzw. plikach cookies przez nas i naszych Zaufanych Partnerów, w celach marketingowych. Swoją zgodę możesz w dowolnym momencie wycofać na stronie <a ng-click=\"vm.goToPrivacyPolicy()\">polityki prywatności</a>.</p></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.hide()\"><span translate=\"GDPR_INFO.HIDE\"></span></md-button><md-button ng-click=\"vm.accept()\" class=\"md-raised md-accent\"><span translate=\"GDPR_INFO.ACCEPT\"></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pages/invite_tax_office/invite_tax_office.html","<md-dialog aria-label=\"METHOD\"><div id=\"invite-tax-office-dialog\"><h1>Twój księgowy</h1><p>Nie musisz więcej przesyłać do swojego księgowego faktur oraz innych dokumentów, które przechowujesz w programie. Zaproś księgowego do Twojej firmy a będzie miał dostęp do wszystkich Twoich dokumentów.</p><div layout=\"row\" layout-align=\"end none\"><md-button class=\"md-raised md-accent md-button md-default-theme\" ng-click=\"vm.goToInvite()\">Zaproś księgowego</md-button></div></div></md-dialog>");
$templateCache.put("app/main/pages/language_webbrowser/language_webbrowser.html","<md-dialog aria-label=\"METHOD\"><div id=\"language_webbrowser-dialog\"><h1 translate=\"LANGUAGE_WEBBROWSER.TITLE\"></h1><p><span translate=\"LANGUAGE_WEBBROWSER.CONTENT\"></span></p></div></md-dialog>");
$templateCache.put("app/main/pages/new-version/new-version.html","<md-dialog aria-label=\"METHOD\"><div id=\"new-version-dialog\"><p ng-if=\"vm.name != \'\'\"><span translate=\"NEW_VERSION.TITLE\"></span>, {{vm.name}}</p><p ng-if=\"vm.name == \'\'\"><span translate=\"NEW_VERSION.TITLE\"></span></p><p><span translate=\"NEW_VERSION.CONTENT\"></span></p><p><a translate=\"NEW_VERSION.REFRESH\" ng-click=\"vm.refresh()\"></a></p></div></md-dialog>");
$templateCache.put("app/main/pages/package-alert/package-alert.html","<md-dialog aria-label=\"METHOD\"><div id=\"package-alert-dialog\"><h1>Przejdź na pakiet premium</h1><p>Ta funkcjonalność jest dostepna tylko w pakiecie Premium.</p><div layout=\"row\" layout-align=\"end none\"><md-button class=\"md-raised md-accent md-button md-default-theme\" ng-click=\"vm.goPremium()\">Przejdź na pakiet Premium</md-button></div></div></md-dialog>");
$templateCache.put("app/main/pages/privacy-policy/privacy-policy.html","<div id=\"privacy-policy\" class=\"flex-scrollable guest-layout\" layout=\"column\" ms-scroll=\"\"><div id=\"privacy-policy-wrapper\" class=\"guest-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"privacy-policy-form\" class=\"rounded-container guest-form\"><logo-sqr></logo-sqr><div class=\"title\" translate=\"PRIVACY_POLICY.TITLE\"></div><div class=\"text-justify\"><p>1. Polityka Prywatności obowiązuje wszystkie osoby odwiedzające Serwis. Zastrzegamy sobie prawo do wprowadzenia ewentualnych zmian w opublikowanej polityce prywatności.</p><p>2. W ramach świadczonych usług, Serwis może zbierać i przetwarzać dane niezbędne do świadczenia swoich usług związanych z charakterem działalności i wynikających z dostępnych funkcji aplikacji. Oświadczamy, że używamy plików cookies, które pozwalają na identyfikację użytkownika aby tym samym umożliwić i usprawnić korzystania z naszej aplikacji. W każdej chwili możesz zmodyfikować ustawienia w przeglądarce internetowej tym samym uniemożliwić zapisywanie plików cookies. Fvonline.pl zapewnia, że zapisywanie na komputerze użytkownika bądź każdej innej osoby odwiedzającej nasz serwis plików cookies nie powoduje zmian konfiguracyjnych w komputerze i oprogramowaniu.</p><p>3. Fvonline.pl oświadcza, że gromadzi informacje o osobach odwiedzających naszą stronę wyłącznie na swoje potrzeby, a udostępnianie tychże informacji osobom trzecim możliwe jest tylko, gdy:<br>- wymagają tego przepisy prawa;<br>- w celu świadczenia usług lecz po uzyskaniu stosownej zgody od użytkownika;</p><p>4. Zastrzegamy sobie prawo do sporządzania statystyk charakteryzujących populację użytkowników Fvonline.pl bądź innych osób odwiedzających serwis w celu wykorzystania danych do nawiązywanej współpracy z potencjalnymi Klientami/ partnerami firmy.</p></div></div></div><footer ng-include=\"\'app/layouts/footer.html\'\"></footer></div>");
$templateCache.put("app/main/products/form/content.html","<div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"OTHER.NAME\"></span></label> <input ng-model=\"vm.form.name\" required=\"\" ng-maxlength=\"100\" name=\"name\"><div ng-messages=\"formProduct.name.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_100\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"PRODUCTS_FORM.TYPE\"></span></label><md-select ng-model=\"vm.form.type\" required=\"\" name=\"type\" ng-if=\"!translate_loading\"><md-option ng-value=\"\'article\'\"><span translate=\"PRODUCTS_FORM.TYPE_1\"></span></md-option><md-option ng-value=\"\'service\'\"><span translate=\"PRODUCTS_FORM.TYPE_2\"></span></md-option></md-select><div ng-messages=\"formProduct.type.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span ng-if=\"vm.root_scope.vat_payer\" translate=\"PRODUCTS_FORM.PRICE_NET\"></span> <span ng-if=\"!vm.root_scope.vat_payer\" translate=\"PRODUCTS_FORM.PRICE\"></span></label> <input ng-model=\"vm.form.price_net\" type=\"number\" step=\"0.01\" min=\"0.01\" name=\"price_net\" ng-change=\"vm.changePrice()\"><div ng-messages=\"formProduct.price_net.$error\"><div ng-message=\"number\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div><div ng-message=\"step\"><span translate=\"ERRORS.FORM.NUMBER_2_DP\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.root_scope.vat_payer\"><label><span translate=\"PRODUCTS_FORM.TAX\"></span></label><md-select ng-model=\"vm.form.vat_rate_id\" required=\"\" name=\"vat_rate_id\" ng-if=\"!translate_loading\" ng-change=\"vm.changePrice()\"><md-option ng-value=\"tax.id\" ng-repeat=\"tax in vm.taxes\" ng-if=\"tax.id\">{{tax.name}}</md-option></md-select><div ng-messages=\"formProduct.vat_rate_id.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"PRODUCTS_FORM.UNIT\"></span></label><md-select ng-model=\"vm.form.service_unit_id\" required=\"\" name=\"service_unit_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"unit.id\" ng-repeat=\"unit in vm.units\" ng-if=\"unit.id\">{{unit.slug}}</md-option></md-select><div ng-messages=\"formProduct.service_unit_id.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"PRODUCTS_FORM.PKWIU\"></span></label> <input ng-model=\"vm.form.pkwiu\" ng-maxlength=\"20\" name=\"pkwiu\"><div ng-messages=\"formProduct.pkwiu.$error\"><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_20\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"PRODUCTS_FORM.DESCRIPTION\"></span></label> <textarea ng-model=\"vm.form.description\" ng-maxlength=\"1000\" name=\"description\"></textarea><div ng-messages=\"formProduct.description.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_1000\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-checkbox ng-model=\"vm.form.print_on_invoice\" name=\"print_on_invoice\"><span translate=\"PRODUCTS_FORM.PRINT\"></span></md-checkbox></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><span class=\"require\">*</span> <span translate=\"INFO.REQUIRE_INFO\"></span></md-input-container></div><div layout=\"row\" layout-align=\"end none\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-disabled=\"formProduct.$invalid || formProduct.$pristine || vm.request_sending\" translate=\"OTHER.SAVE\" translate-attr-aria-label=\"OTHER.SAVE\"></md-button></div>");
$templateCache.put("app/main/products/form/form.html","<div id=\"products-form\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\" flex=\"100\"><div layout=\"row\"><div ng-if=\"!vm.edit\" class=\"title\" translate=\"PRODUCTS_FORM.TITLE_ADD\" flex=\"70\"></div><div ng-if=\"vm.edit\" class=\"title\" translate=\"PRODUCTS_FORM.TITLE_EDIT\" flex=\"70\"></div><div flex=\"30\" layout=\"row\" layout-align=\"end center\"><md-button href=\"/products/list\" class=\"md-raised\" aria-label=\"Go Back\" translate=\"OTHER.GO_BACK\" translate-attr-aria-label=\"OTHER.GO_BACK\">Go Back</md-button></div></div></div></div><div class=\"content\" layout=\"column\"><a name=\"up\"></a><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><form id=\"formProduct\" name=\"formProduct\" novalidate=\"\" ng-submit=\"vm.send(false)\"><div ng-include=\"\'app/main/products/form/content.html\'\"></div></form></div></div></div></div>");
$templateCache.put("app/main/products/form/modal.html","<md-dialog aria-label=\"METHOD\"><div id=\"products-form-dialog\"><div ng-if=\"!vm.edit\" class=\"title\" translate=\"PRODUCTS_FORM.TITLE_ADD\" flex=\"70\"></div><div ng-if=\"vm.edit\" class=\"title\" translate=\"PRODUCTS_FORM.TITLE_EDIT\" flex=\"70\"></div><div class=\"content\" layout=\"column\"><a name=\"up\"></a><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><form id=\"formProduct\" name=\"formProduct\" novalidate=\"\" ng-submit=\"vm.send(true)\"><div ng-include=\"\'app/main/products/form/content.html\'\"></div></form></div></div></div></div></md-dialog>");
$templateCache.put("app/main/products/list/list.html","<div id=\"contractors-list\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"title\" translate=\"PRODUCTS_LIST.TITLE\"></div></div></div><div class=\"content\" layout=\"column\"><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><form novalidate=\"\" ng-submit=\"vm.getProducts()\"><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block no-errors-spacer\" flex-gt-xs=\"50\"><label><span translate=\"PRODUCTS_LIST.SEARCH\"></span></label> <input ng-model=\"vm.query.name\" type=\"search\" name=\"search\"></md-input-container><div layout=\"row\" layout-align=\"start center\" flex-gt-xs=\"25\"><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.getProducts()\"><span translate=\"PRODUCTS_LIST.SEARCH\"></span></md-button></div><div layout=\"row\" layout-align=\"end center\" flex-gt-xs=\"25\" ng-if=\"!vm.is_tax_office\"><a class=\"md-raised md-button md-default-theme md-accent\" ng-href=\"/products/form/new\"><span translate=\"PRODUCTS_LIST.ADD\"></span></a></div></div></form><div ng-if=\"vm.pagination.total\" class=\"table-wrapper\"><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"OTHER.NAME\"></span></th><th md-column=\"\"><span translate=\"PRODUCTS_LIST.UNIT\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"vat_payer\"><span translate=\"PRODUCTS_LIST.TAX\"></span></th><th md-column=\"\"><span translate=\"PRODUCTS_LIST.PKWIU\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\">Akcje</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"product in vm.products\"><td md-cell=\"\">{{ vm.pagination | no:$index }}</td><td md-cell=\"\">{{ product.name }}</td><td md-cell=\"\">{{ product.service_unit.data.slug }}</td><td md-cell=\"\" ng-if=\"vat_payer\">{{ vm.taxs[product.vat_rate_id].name }}</td><td md-cell=\"\">{{ product.pkwiu }}</td><td md-cell=\"\"><a class=\"md-raised md-accent md-button md-default-theme\" ng-href=\"/products/form/edit/{{product.id}}\" ng-if=\"!product.is_used && !vm.is_tax_office\"><span translate=\"OTHER.EDIT\"></span></a></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{vm.table_translate}}\" md-limit=\"vm.query.limit\" md-page=\"vm.query.page\" md-total=\"{{vm.pagination.total}}\" md-on-paginate=\"vm.getProducts\" md-page-select=\"\"></md-table-pagination></div><div layout=\"row\" ng-if=\"vm.pagination.total == 0\" translate=\"OTHER.NO_RECORDS\" class=\"text-center\"></div></div></div></div></div>");
$templateCache.put("app/main/projects/form/form.html","<div id=\"projects-form\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\" flex=\"100\"><div layout=\"row\"><div ng-if=\"!vm.edit\" class=\"title\" translate=\"PROJECTS_FORM.TITLE_ADD\" flex=\"70\"></div><div ng-if=\"vm.edit\" class=\"title\" translate=\"PROJECTS_FORM.TITLE_EDIT\" flex=\"70\"></div><div flex=\"30\" layout=\"row\" layout-align=\"end center\"><md-button href=\"/projects/list\" class=\"md-raised\" aria-label=\"Go Back\" translate=\"OTHER.GO_BACK\" translate-attr-aria-label=\"OTHER.GO_BACK\">Go Back</md-button></div></div></div></div><div class=\"content\" layout=\"column\"><a name=\"up\"></a><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><form id=\"formProject\" name=\"formProject\" novalidate=\"\" ng-submit=\"vm.send()\"><div class=\"form-title\" translate=\"PROJECTS_FORM.GENERAL_DATA\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex=\"100\"><label><span translate=\"OTHER.NAME\"></span></label> <input ng-model=\"vm.form.name\" required=\"\" name=\"name\" ng-change=\"vm.generateShort()\"><div ng-messages=\"formProject.name.$error\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.NIP\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"PROJECTS_FORM.SHORT_NAME\"></span></label> <input ng-model=\"vm.form.short_name\" required=\"\" ng-maxlength=\"100\" name=\"short_name\"><div ng-messages=\"formProject.short_name.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_100\"></span></div></div></md-input-container></div><div class=\"form-title\" translate=\"PROJECTS_FORM.USERS_DATA\"></div><div layout-gt-sm=\"row\" ng-repeat=\"role in vm.roles\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"ROLES.{{ role.name }}\"></span></label><md-contact-chips ng-model=\"vm.form_users[role.id]\" md-contacts=\"vm.searchUser($query)\" md-contact-name=\"name\" md-contact-image=\"avatar\" md-contact-email=\"email\"></md-contact-chips></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><span class=\"require\">*</span> <span translate=\"INFO.REQUIRE_INFO\"></span></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"end none\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-disabled=\"formProject.$invalid || formProject.$pristine || vm.request_sending\" translate=\"OTHER.SAVE\" translate-attr-aria-label=\"OTHER.SAVE\"></md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/projects/list/list.html","<div id=\"projects-list\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"title\" translate=\"PROJECTS_LIST.TITLE\"></div></div></div><div class=\"content\" layout=\"column\"><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><div layout=\"row\" ng-if=\"vm.role == \'owner\' || vm.role == \'admin\'\"><md-input-container class=\"md-block\" flex-gt-xs=\"33\"><label><span translate=\"PROJECTS_LIST.STATUS\"></span></label><md-select ng-model=\"vm.query.status\" required=\"\" name=\"status\" ng-if=\"!translate_loading\" ng-change=\"vm.getProjects()\"><md-option ng-value=\"\'all\'\"><span translate=\"OTHER.ALL\"></span></md-option><md-option ng-value=\"\'closed\'\"><span translate=\"PROJECTS_LIST.CLOSED\"></span></md-option><md-option ng-value=\"\'opened\'\"><span translate=\"PROJECTS_LIST.OPENED\"></span></md-option></md-select></md-input-container><md-input-container layout=\"row\" layout-align=\"end center\" flex-gt-xs=\"66\"><a class=\"md-raised md-button md-default-theme md-accent\" ng-href=\"/projects/form/new\"><span translate=\"PROJECTS_LIST.ADD\"></span></a></md-input-container></div><div ng-if=\"vm.pagination.total\" class=\"table-wrapper\"><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"OTHER.NAME\"></span></th><th md-column=\"\"><span translate=\"PROJECTS_LIST.SHORT_NAME\"></span></th><th md-column=\"\"><span translate=\"PROJECTS_LIST.STATUS\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\">Akcje</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"project in vm.projects\"><td md-cell=\"\">{{ vm.pagination | no:$index }}</td><td md-cell=\"\"><a ng-click=\"vm.show(project.id)\">{{ project.name }}</a></td><td md-cell=\"\">{{ project.short_name }}</td><td md-cell=\"\"><span ng-if=\"project.closed_at\" translate=\"PROJECTS_LIST.CLOSED\"></span> <span ng-if=\"!project.closed_at\" translate=\"PROJECTS_LIST.OPENED\"></span></td><td md-cell=\"\"><md-menu ng-if=\"vm.role == \'owner\' || vm.role == \'admin\'\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.show(project.id)\" aria-label=\"Show\"><span translate=\"OTHER.SHOW\"></span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.edit(project.id)\"><span translate=\"OTHER.EDIT\"></span></md-button></md-menu-item><md-menu-item ng-if=\"project.closed_at\"><md-button ng-click=\"vm.openProjects(project.id)\"><span translate=\"PROJECTS_LIST.OPEN\"></span></md-button></md-menu-item><md-menu-item ng-if=\"!project.closed_at\"><md-button ng-click=\"vm.closeProjects(project.id)\"><span translate=\"OTHER.CLOSE\"></span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteProjects(project.id)\"><span translate=\"OTHER.DELETE\"></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{vm.table_translate}}\" md-limit=\"vm.query.limit\" md-page=\"vm.query.page\" md-total=\"{{vm.pagination.total}}\" md-on-paginate=\"vm.getProjects\" md-page-select=\"\"></md-table-pagination></div><div layout=\"row\" ng-if=\"vm.pagination.total == 0\" translate=\"OTHER.NO_RECORDS\" class=\"text-center\"></div></div></div></div></div>");
$templateCache.put("app/main/projects/show/show.html","<div id=\"projects-show\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"title\"><span translate=\"PROJECTS_SHOW.TITLE\"></span> - {{vm.project.name}}</div></div></div><div class=\"content\" layout=\"column\"><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><div class=\"form-title\" translate=\"PROJECTS_SHOW.USERS\"></div><md-list class=\"fixedRows\"><md-list-item class=\"md-2-line contact-item\" ng-repeat=\"user in vm.users\"><img ng-src=\"assets/images/avatars/profile.jpg\" class=\"md-avatar\" alt=\"\"><div class=\"md-list-item-text compact\"><h3>{{user.user.data.first_name}} {{user.user.data.last_name}}</h3><p translate=\"ROLES.{{user.role.data.name}}\"></p></div></md-list-item></md-list></div></div></div></div>");
$templateCache.put("app/main/receipts/crete-invoice/crete-invoice.html","<md-dialog aria-label=\"METHOD\" ng-cloak=\"\"><div id=\"crete-invoice-dialog\"><form id=\"createInvoice\" name=\"createInvoice\"><div layout-gt-sm=\"row\"><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div></div><div class=\"mb-20\"><span translate=\"RECEIPTS_LIST.RECEIPT_TITLE\" class=\"font-size-16\"></span></div><div layout-gt-sm=\"row\" ng-repeat=\"search_text_receipt in vm.search_text_receipt track by $index\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"RECEIPTS_LIST.RECEIPT\"></span></label><md-autocomplete md-input-name=\"receipt_id_{{$index}}\" ng-model-options=\"{debounce:200}\" md-selected-item=\"vm.selected_item[$index]\" md-search-text=\"search_text_receipt\" md-items=\"item in vm.searchReceipt(search_text_receipt)\" md-item-text=\"item.number\"><md-item-template><span md-highlight-text=\"search_text_receipt\">{{item.number}}</span></md-item-template><md-not-found><span translate=\"OTHER.NOT_FOUND\"></span></md-not-found></md-autocomplete></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"end none\"><md-button type=\"button\" class=\"md-raised md-accent\" translate=\"INFO.ADD_NEXT\" ng-click=\"vm.add()\" translate-attr-aria-label=\"INFO.ADD_NEXT\"></md-button><md-button type=\"button\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-disabled=\"createInvoice.$invalid || vm.request_sending\" translate=\"OTHER.SAVE\" ng-click=\"vm.create()\" translate-attr-aria-label=\"OTHER.SAVE\"></md-button></div></form></div></md-dialog>");
$templateCache.put("app/main/receipts/invoices/invoices.html","<md-dialog aria-label=\"METHOD\"><div id=\"receipts-invoices-dialog\"><div class=\"table-wrapper\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"RECEIPTS_LIST.NUMBER\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\"></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"invoice in vm.invoices\"><td md-cell=\"\">{{ ($index + 1) }}</td><td md-cell=\"\">{{ invoice.number }}</td><td md-cell=\"\"><md-button class=\"md-raised md-accent md-button md-default-theme\" ng-click=\"vm.pdf(invoice.id, 0)\"><span translate=\"RECEIPTS_LIST.PDF\"></span></md-button><md-button class=\"md-raised md-accent md-button md-default-theme\" ng-click=\"vm.pdf(invoice.id, 0)\"><span translate=\"RECEIPTS_LIST.PDF_DUPLICATE\"></span></md-button></td></tr></tbody></table></md-table-container></div></div></md-dialog>");
$templateCache.put("app/main/receipts/items/items.html","<md-dialog aria-label=\"METHOD\"><div id=\"receipts-items-dialog\"><div class=\"table-wrapper\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"OTHER.NAME\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"RECEIPTS_LIST.QUANTITY\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"RECEIPTS_LIST.PRICE_NET\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"RECEIPTS_LIST.PRICE_GROSS\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"RECEIPTS_LIST.VAT_SUM\"></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.items\"><td md-cell=\"\">{{ ($index + 1) }}</td><td md-cell=\"\">{{ item.name }}</td><td md-cell=\"\">{{ item.quantity | numFormat}}</td><td md-cell=\"\">{{ item.price_net_sum.toFixed(2) | numFormat}}zł</td><td md-cell=\"\">{{ item.price_gross_sum.toFixed(2) | numFormat}}zł</td><td md-cell=\"\">{{ item.vat_sum.toFixed(2) | numFormat}}zł</td></tr></tbody></table></md-table-container></div></div></md-dialog>");
$templateCache.put("app/main/receipts/list/list.html","<div id=\"contractors-list\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"title\" translate=\"RECEIPTS_LIST.TITLE\"></div></div></div><div class=\"content\" layout=\"column\"><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-xs=\"33\"><label><span translate=\"OTHER.FROM\"></span></label> <input ng-model=\"vm.query.date_start\" name=\"date_start\" moment-picker=\"vm.query.date_start\" format=\"YYYY-MM-DD\" start-view=\"decade\" locale=\"pl\" input-clear=\"\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"33\"><label><span translate=\"OTHER.TO\"></span></label> <input ng-model=\"vm.query.date_end\" name=\"date_end\" moment-picker=\"vm.query.date_end\" format=\"YYYY-MM-DD\" start-view=\"decade\" locale=\"pl\" input-clear=\"\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"33\"><label><span translate=\"RECEIPTS_LIST.PAYMENTS_METHOD\"></span></label><md-select ng-model=\"vm.query.payment_method_id\" required=\"\" name=\"payment_method_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"payments_method.id\" ng-repeat=\"payments_method in vm.payments_method2\">{{payments_method.name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-xs=\"33\"><label><span translate=\"RECEIPTS_LIST.TRANSACTION_NUMBER\"></span></label> <input ng-model=\"vm.query.transaction_number\" name=\"transaction_number\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"33\"><label><span translate=\"RECEIPTS_LIST.NUMBER\"></span></label> <input ng-model=\"vm.query.number\" name=\"number\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"33\"><label><span translate=\"RECEIPTS_LIST.USERS\"></span></label><md-select ng-model=\"vm.query.user_id\" required=\"\" name=\"user_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"user.id\" ng-repeat=\"user in vm.users\">{{user.first_name}} {{user.last_name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div layout=\"row\" layout-align=\"end center\" flex=\"100\"><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.report()\"><span translate=\"RECEIPTS_LIST.GENERATE_REPORT\"></span></md-button><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.pdf()\"><span translate=\"RECEIPTS_LIST.GENERATE_PDF\"></span></md-button><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.receiptsModal()\" ng-if=\"!vm.is_tax_office\"><span translate=\"RECEIPTS_LIST.CREATE_INVOICE\"></span></md-button><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.getReceipts()\"><span translate=\"RECEIPTS_LIST.SEARCH\"></span></md-button></div></div><div ng-if=\"vm.pagination.total\" class=\"table-wrapper\"><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"RECEIPTS_LIST.NUMBER\"></span></th><th md-column=\"\"><span translate=\"RECEIPTS_LIST.TRANSACTION_NUMBER\"></span></th><th md-column=\"\"><span translate=\"RECEIPTS_LIST.CREATED\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"RECEIPTS_LIST.PRICE_NET\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"RECEIPTS_LIST.PRICE_GROSS\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"RECEIPTS_LIST.VAT_SUM\"></span></th><th md-column=\"\"><span translate=\"RECEIPTS_LIST.METHOD\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\">Akcje</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"receipt in vm.receipts\"><td md-cell=\"\">{{ vm.pagination | no:$index }}</td><td md-cell=\"\">{{ receipt.number }}</td><td md-cell=\"\">{{ receipt.transaction_number }}</td><td md-cell=\"\">{{ receipt.sale_date }}</td><td md-cell=\"\">{{ receipt.price_net.toFixed(2) | numFormat}}zł</td><td md-cell=\"\">{{ receipt.price_gross.toFixed(2) | numFormat}}zł</td><td md-cell=\"\">{{ receipt.vat_sum.toFixed(2) | numFormat}}zł</td><td md-cell=\"\">{{ vm.payments_method[receipt.payment_method_id].name }}</td><td md-cell=\"\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.details(receipt.id)\"><span translate=\"OTHER.DETAILS\"></span></md-button></md-menu-item><md-menu-item ng-if=\"receipt.invoices.data.length\"><md-button ng-click=\"vm.invoices($index)\"><span translate=\"RECEIPTS_LIST.INVOICES\"></span></md-button></md-menu-item><md-menu-item ng-if=\"!receipt.invoices.data.length && !vm.is_tax_office\"><md-button ng-click=\"vm.invoice(receipt.id)\"><span translate=\"RECEIPTS_LIST.GENERATE_INVOICE\"></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{vm.table_translate}}\" md-limit=\"vm.query.limit\" md-page=\"vm.query.page\" md-total=\"{{vm.pagination.total}}\" md-on-paginate=\"vm.getReceipts\" md-page-select=\"\"></md-table-pagination></div><div layout=\"row\" ng-if=\"vm.pagination.total == 0\" translate=\"OTHER.NO_RECORDS\" class=\"text-center\"></div><div class=\"font-size-16\"><div class=\"bold\" translate=\"RECEIPTS_LIST.SUM\"></div><div><span translate=\"RECEIPTS_LIST.SUM_GROSS\"></span>: {{vm.reports.price_gross_report.toFixed(2) | numFormat}}zł</div><div><span translate=\"RECEIPTS_LIST.SUM_NET\"></span>: {{vm.reports.price_net_report.toFixed(2) | numFormat}}zł</div><div><span translate=\"RECEIPTS_LIST.VAT_SUM\"></span>: {{vm.reports.vat_sum_report.toFixed(2) | numFormat}}zł</div></div></div></div></div></div>");
$templateCache.put("app/main/registry-sales/items/items.html","<md-dialog aria-label=\"METHOD\"><div id=\"registry-online-sales-items-dialog\"><div class=\"table-wrapper\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"OTHER.NAME\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.QUANTITY\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.PRICE_NET\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.PRICE_GROSS\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.VAT_SUM\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!vat_payer\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.PRICE\"></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.items\"><td md-cell=\"\">{{ ($index + 1) }}</td><td md-cell=\"\">{{ item.name }}</td><td md-cell=\"\">{{ item.quantity | numFormat}}</td><td md-cell=\"\" ng-if=\"vat_payer\">{{ item.price_net_sum | numFormat}}zł</td><td md-cell=\"\">{{ item.price_gross_sum | numFormat}}zł</td><td md-cell=\"\" ng-if=\"vat_payer\">{{ item.vat_sum | numFormat}}zł</td></tr></tbody></table></md-table-container></div></div></md-dialog>");
$templateCache.put("app/main/registry-sales/items-receipts/items.html","<md-dialog aria-label=\"METHOD\"><div id=\"receipts-tab3-items-dialog\"><div class=\"table-wrapper\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"OTHER.NAME\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.QUANTITY\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.PRICE_NET\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.PRICE_GROSS\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.VAT_SUM\"></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.items\"><td md-cell=\"\">{{ ($index + 1) }}</td><td md-cell=\"\">{{ item.name }}</td><td md-cell=\"\">{{ item.quantity | numFormat}}</td><td md-cell=\"\">{{ item.price_net_sum.toFixed(2) | numFormat}}zł</td><td md-cell=\"\">{{ item.price_gross_sum.toFixed(2) | numFormat}}zł</td><td md-cell=\"\">{{ item.vat_sum.toFixed(2) | numFormat}}zł</td></tr></tbody></table></md-table-container></div></div></md-dialog>");
$templateCache.put("app/main/registry-sales/jpk-fa/jpk-fa.html","<md-dialog aria-label=\"METHOD\"><div id=\"jpk-fa-dialog\"><form id=\"JpkFa\" name=\"JpkFa\"><div class=\"mb-20\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.JPK_FA\" class=\"font-size-16\"></span></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label><span translate=\"OTHER.FROM\"></span></label> <input ng-model=\"vm.form.start_date\" name=\"start_date\" required=\"\" moment-picker=\"vm.form.start_date\" format=\"YYYY-MM-DD\" start-view=\"decade\" locale=\"pl\" input-clear=\"\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label><span translate=\"OTHER.TO\"></span></label> <input ng-model=\"vm.form.end_date\" name=\"end_date\" required=\"\" moment-picker=\"vm.form.end_date\" format=\"YYYY-MM-DD\" start-view=\"decade\" locale=\"pl\" input-clear=\"\"></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"end none\"><md-button ng-if=\"!vm.edit\" type=\"button\" class=\"md-raised md-accent\" aria-label=\"CANCEL\" translate=\"OTHER.CANCEL\" ng-click=\"vm.hide()\" translate-attr-aria-label=\"OTHER.CANCEL\"></md-button><md-button ng-if=\"!vm.edit\" type=\"button\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-disabled=\"JpkFa.$invalid || vm.request_sending\" translate=\"REGISTRY_SALES.INVOICES_LIST.JPK_FA\" ng-click=\"vm.generate()\" translate-attr-aria-label=\"OTHER.SAVE\"></md-button></div></form></div></md-dialog>");
$templateCache.put("app/main/registry-sales/list/list.html","<div id=\"registry-sales\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"title\" translate=\"REGISTRY_SALES.TITLE\"></div></div></div><div class=\"content\" layout=\"column\"><md-tabs md-dynamic-height=\"\"><md-tab><md-tab-label><span translate=\"REGISTRY_SALES.TAB1\"></span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/registry-sales/list/tab/tab1.html\'\"></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"REGISTRY_SALES.TAB2\"></span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/registry-sales/list/tab/tab2.html\'\"></div></md-tab-body></md-tab><md-tab ng-if=\"vm.receipts_active == \'1\'\"><md-tab-label><span translate=\"REGISTRY_SALES.TAB3\"></span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/registry-sales/list/tab/tab3.html\'\"></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/tokens/form/form.html","<div id=\"contractors-form\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\" flex=\"100\"><div layout=\"row\"><div class=\"title\" translate=\"TOKENS_FORM.TITLE_ADD\" flex=\"70\"></div><div flex=\"30\" layout=\"row\" layout-align=\"end center\"><md-button href=\"/users/tokens/{{vm.form.user_id}}\" class=\"md-raised\" aria-label=\"Go Back\" translate=\"OTHER.GO_BACK\" translate-attr-aria-label=\"OTHER.GO_BACK\">Go Back</md-button></div></div></div></div><div class=\"content\" layout=\"column\"><a name=\"up\"></a><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><form id=\"formToken\" name=\"formToken\" novalidate=\"\" ng-submit=\"vm.send()\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"TOKENS_FORM.ROLE\"></span></label><md-select ng-model=\"vm.form.role_id\" required=\"\" name=\"role_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"role.id\" ng-repeat=\"role in vm.roles\"><span translate=\"TOKENS_FORM.ROLES.{{role.name.replace(\'api.\', \'\')}}\"></span></md-option></md-select><div ng-messages=\"formToken.vat_rate_id.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"TOKENS_FORM.DOMAIN\"></span></label> <input ng-model=\"vm.form.domain\" name=\"domain\"><div ng-messages=\"formToken.domain.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"TOKENS_FORM.IP_FROM\"></span></label> <input ng-model=\"vm.form.ip_from\" name=\"ip_from\" ng-pattern=\"/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/\"><div ng-messages=\"formToken.ip_from.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.IP\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"TOKENS_FORM.IP_TO\"></span></label> <input ng-model=\"vm.form.ip_to\" name=\"ip_to\" ng-pattern=\"/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/\"><div ng-messages=\"formToken.ip_from.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.IP\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"TOKENS_FORM.TTL\"></span></label> <input ng-model=\"vm.form.ttl\" required=\"\" name=\"ttl\" min=\"1\" max=\"1440\" type=\"number\"><div ng-messages=\"formToken.ttl.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.NUM_MIN_1\"></span></div><div ng-message=\"max\"><span translate=\"ERRORS.FORM.NUM_MIN_1440\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><span class=\"require\">*</span> <span translate=\"INFO.REQUIRE_INFO\"></span></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"end none\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-disabled=\"formToken.$invalid || formToken.$pristine || vm.request_sending\" translate=\"OTHER.SAVE\" translate-attr-aria-label=\"OTHER.SAVE\"></md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/tokens/list/list.html","<div id=\"tokens-list\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\" flex=\"100\"><div layout=\"row\"><div class=\"title\" translate=\"TOKENS_LIST.TITLE\" flex=\"70\"></div><div flex=\"30\" layout=\"row\" layout-align=\"end center\"><md-button href=\"/company/edit\" class=\"md-raised\" aria-label=\"Go Back\" translate=\"OTHER.GO_BACK\" translate-attr-aria-label=\"OTHER.GO_BACK\">Go Back</md-button></div></div></div></div><div class=\"content\" layout=\"column\"><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><div layout=\"row\"><div layout=\"row\" layout-align=\"start center\" flex-gt-xs=\"50\"><a class=\"md-raised md-button md-default-theme md-accent\" ng-href=\"/users/tokens/form/{{vm.id}}\"><span translate=\"TOKENS_LIST.ADD\"></span></a></div></div><div ng-if=\"vm.tokens.length != 0\" class=\"table-wrapper\"><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"TOKENS_LIST.TOKEN\"></span></th><th md-column=\"\"><span translate=\"TOKENS_LIST.DOMAIN\"></span></th><th md-column=\"\"><span translate=\"TOKENS_LIST.IP_FROM\"></span></th><th md-column=\"\"><span translate=\"TOKENS_LIST.IP_TO\"></span></th><th md-column=\"\"><span translate=\"TOKENS_LIST.TTL\"></span></th><th md-column=\"\"><span translate=\"TOKENS_LIST.ROLE\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\">Akcje</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"token in vm.tokens\"><td md-cell=\"\">{{ ($index + 1) }}</td><td md-cell=\"\" style=\"max-width:200px; word-wrap: break-word\">{{ token.api_token }}</td><td md-cell=\"\">{{ token.domain}}</td><td md-cell=\"\">{{ token.ip_from}}</td><td md-cell=\"\">{{ token.ip_to}}</td><td md-cell=\"\">{{ token.ttl}}</td><td md-cell=\"\"><span translate=\"TOKENS_LIST.ROLES.{{token.role.data.name.replace(\'api.\', \'\')}}\"></span></td><td md-cell=\"\"><md-button class=\"md-raised md-button md-default-theme md-warn\" ng-click=\"vm.deleteTokens(token.id)\"><span translate=\"OTHER.DELETE\"></span></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{vm.table_translate}}\" md-limit=\"vm.query.limit\" md-page=\"vm.query.page\" md-total=\"{{vm.pagination.total}}\" md-on-paginate=\"vm.getTokens\" md-page-select=\"\"></md-table-pagination></div><div layout=\"row\" ng-if=\"vm.tokens.length == 0\" translate=\"OTHER.NO_RECORDS\" class=\"text-center\"></div></div></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div ng-if=\"vm.logo == \'\'\" class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\" ng-click=\"vm.redirectToDashboard()\">F</span> <span class=\"logo-text\" ng-click=\"vm.redirectToDashboard()\">{{page_title}}</span></div><div ng-if=\"vm.logo != \'\'\" class=\"logo\" layout=\"row\" layout-align=\"start center\"><div class=\"logo-logo-image-2\" style=\'background-image: url(\"/assets/logos/{{vm.logo}}/logo_sqr.jpg\")\' ng-click=\"vm.redirectToDashboard()\"></div><div class=\"logo-text-2\" style=\'background-image: url(\"/assets/logos/{{vm.logo}}/logo.png\")\' ng-click=\"vm.redirectToDashboard()\"></div></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide=\"\" show-gt-sm=\"\" ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span></md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img ng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div ng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div class=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" ng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" ng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" ng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" md-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item class=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div ng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div class=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" ng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\"><h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div class=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4><span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" aria-label=\"Call\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon md-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></div></md-toolbar><md-content flex=\"\" layout-paddings=\"\" ms-scroll=\"\" id=\"chat-dialog\"><div layout=\"row\" ng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img ng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex=\"\"><div class=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content><form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea ng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex=\"\" ng-model=\"vm.replyMessage\" placeholder=\"Type and hit enter to send message\" translate=\"\" translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\"></textarea><md-button class=\"md-fab md-icon-button\" type=\"submit\" aria-label=\"Send message\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader><md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">{{page_title}}</span></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><div class=\"toolbar-separator\"></div><ms-search-bar></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs=\"\">John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"logout()\"><span translate=\"TOOLBAR.LOGOUT\" id=\"logout\"></span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"navigation-toggle\" hide-gt-sm=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">{{page_title}}</span></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><ms-search-bar></ms-search-bar><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs=\"\">John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"logout()\"><span translate=\"TOOLBAR.LOGOUT\" id=\"logout\"></span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm=\"\" aria-label=\"Toggle navigation\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div id=\"global-company-name\" class=\"project-menu\" hide-xs=\"\" ng-if=\"is_fv && current_company_nip\"><div class=\"user-button md-button md-default-theme md-ink-ripple no-hover\" layout=\"column\" layout-align=\"center center\"><div><span translate=\"TOOLBAR.COMPANY\"></span></div><div><span>NIP:</span> {{current_company_nip}}</div></div></div><div id=\"global-company-invitation-tax-office\" class=\"project-menu\" ng-if=\"is_fv && show_tax_office_button\"><div class=\"user-button md-button md-default-theme md-ink-ripple\" ng-click=\"inviteTaxOffice()\" layout=\"column\" layout-align=\"center center\"><div translate=\"TOOLBAR.TAX_OFFICE_INVITATION_1\"></div><div translate=\"TOOLBAR.TAX_OFFICE_INVITATION_2\"></div></div></div><div id=\"global-company-plan\" class=\"project-menu\" ng-if=\"is_fv && packageName\" ng-class=\"{\'has-border-left\': !show_tax_office_button}\"><div class=\"user-button md-button md-default-theme md-ink-ripple no-hover\" layout=\"column\" layout-align=\"center center\"><div><span translate=\"TOOLBAR.CURRENT_PACKAGE\"></span> {{packageName | firstLetterUpper}}</div><div><a ng-if=\"!packageExpires && button_change_packet\" class=\"md-raised md-accent md-button md-default-theme\" translate=\"TOOLBAR.CHANGE_PACKAGE\" href=\"/company/edit?package=premium\"></a> <span ng-if=\"packageExpires\" translate=\"TOOLBAR.EXPIRES\"></span> {{packageExpires}}</div></div></div><div class=\"project-menu\" id=\"info-menu\" ng-if=\"show_projects_buttons\"><md-button class=\"user-button\" aria-label=\"Info\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><md-icon md-font-icon=\"icon-information-outline\" class=\"icon s30\"></md-icon></div><span class=\"username\" hide-xs=\"\" hide-sm=\"\" translate=\"TOOLBAR.INFO\"></span></div></md-button></div><div class=\"project-menu\" id=\"stories-menu\" ng-if=\"show_projects_buttons\"><md-button class=\"user-button\" aria-label=\"Stories\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><md-icon md-font-icon=\"icon-star\" class=\"icon s30\"></md-icon></div><span class=\"username\" hide-xs=\"\" hide-sm=\"\" translate=\"TOOLBAR.STORIES\"></span></div></md-button></div><md-menu-bar class=\"project-menu\" id=\"agile-menu\" ng-if=\"show_projects_buttons\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"Agile\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><md-icon md-font-icon=\"icon-layers\" class=\"icon s30\"></md-icon></div><span class=\"username\" hide-xs=\"\" hide-sm=\"\" translate=\"TOOLBAR.AGILE\"></span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\" hide-sm=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-button ng-href=\"\"><span translate=\"TOOLBAR.BACKLOG\"></span></md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-button ng-href=\"\"><span translate=\"TOOLBAR.HISTORY\"></span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"project-menu\" id=\"knowledge-menu\" ng-if=\"show_projects_buttons\"><md-button class=\"user-button\" aria-label=\"Knowledge\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><md-icon md-font-icon=\"icon-book-open\" class=\"icon s30\"></md-icon></div><span class=\"username\" hide-xs=\"\" hide-sm=\"\" translate=\"TOOLBAR.KNOWLEDGE\"></span></div></md-button></div><div class=\"project-menu\" id=\"files-menu\" ng-if=\"show_projects_buttons\"><md-button class=\"user-button\" aria-label=\"Files\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s30\"></md-icon></div><span class=\"username\" hide-xs=\"\" hide-sm=\"\" translate=\"TOOLBAR.FILES\"></span></div></md-button></div><div class=\"toolbar-separator\"></div><md-progress-circular id=\"toolbar-progress\" class=\"md-accent\" ng-if=\"$root.loadingProgress\" md-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div ng-if=\"!is_fv\" layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div><span class=\"username\" hide-xs=\"\" hide-sm=\"\" hide-md=\"\">{{ vm.currentUser.first_name + \' \' + vm.currentUser.last_name }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\" hide-sm=\"\"></md-icon></div><div ng-if=\"is_fv\" layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"></div><span class=\"username\">{{ vm.currentUser.first_name + \' \' + vm.currentUser.last_name }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\" hide-sm=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ng-if=\"show_companies_list\"><md-icon md-font-icon=\"icon-tile-four\" class=\"icon\"></md-icon><md-button ng-href=\"/company/my-list/open\"><span translate=\"NAV.COMPANY.MY_LIST\"></span></md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-pencil\" class=\"icon\"></md-icon><md-button ng-href=\"/user-edit\"><span translate=\"TOOLBAR.EDIT\"></span></md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"logout()\"><span translate=\"TOOLBAR.LOGOUT\" id=\"logout\"></span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-menu-bar id=\"informations-menu\" ng-if=\"is_fv\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\"><div layout=\"row\" layout-align=\"space-between center\"><span class=\"username\" translate=\"TOOLBAR.INFO\">INFO</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\" hide-sm=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-button ng-href=\"https://fvonline.pl/regulamin\" target=\"_blank\"><span translate=\"LAYOUT.REGULATIONS\"></span></md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-button ng-href=\"/page/privacy-policy\"><span translate=\"LAYOUT.PRIVACY_POLICY\"></span></md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-button ng-href=\"/page/cookie\"><span translate=\"LAYOUT.COOKIE\"></span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul class=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-horizontal-nested.html\"><div ms-navigation-horizontal-item layout=\"row\"> <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\" ng-class=\"{\'active md-accent-bg\': vm.isActive}\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </div> <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-class=\"{\'active md-accent-bg\': vm.isActive}\" ng-if=\"node.uisref && node.title\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren\"> <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-nested.html\"><div ms-navigation-item layout=\"row\"> <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </div> <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active\" ng-if=\"node.uisref && node.title\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren\"> <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/main/calendar/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"Set Availability\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"CALENDAR.SET_AVAILABILITY\">Set Availability</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"errors-wrapper\"><div class=\"error text-center\" ng-repeat=\"error in vm.errors track by $index\">{{ error }}</div></div><md-dialog-content ms-scroll=\"\"><div class=\"md-block\"><label>{{ vm.moment(vm.dialogData.day).format(\'D MMMM YYYY dddd\') }}</label></div><md-list class=\"availability\"><md-list-item><md-switch class=\"md-checked ng-touched ng-valid\" ng-model=\"vm.switch\" role=\"checkbox\" tabindex=\"0\" aria-checked=\"true\" aria-invalid=\"false\" aria-label=\"Offline/Online\" translate=\"\" translate-attr-aria-label=\"CALENDAR.AVAILABILITY\" ng-change=\"vm.switchAction()\"></md-switch><p translate=\"CALENDAR.AVAILABILITY\">Offline/Online</p></md-list-item></md-list><section layout=\"row\" class=\"date-row zmd-hierarchical-display show-hide-transition\" ng-show=\"vm.switch\"><div class=\"md-block\"><label translate=\"CALENDAR.AVAILABILITY_HOURS\">Availability hours</label></div><div class=\"md-block\"><div layout=\"row\" class=\"date-row\" ng-repeat=\"event in vm.events track by $index\"><input type=\"hidden\" ng-model=\"event.day\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CALENDAR.START_TIME\"></span></label> <input ng-model=\"event.time_start\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CALENDAR.END_TIME\"></span></label> <input ng-model=\"event.time_stop\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CALENDAR.DESCRIPTION\"></span></label> <input ng-model=\"event.description\" ng-maxlength=\"100\" name=\"description\"></md-input-container><md-input-container class=\"md-block\" flex=\"\" ng-if=\"vm.templateCounter.length + vm.events.length > 1\"><md-button class=\"md-fab md-mini md-warn\" ng-click=\"vm.removeEvent($index)\">X</md-button></md-input-container><input type=\"hidden\" ng-model=\"event.available\"> <input type=\"hidden\" ng-model=\"event.description\"></div><div layout=\"row\" class=\"date-row\" ng-repeat=\"n in vm.templateCounter track by $index\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CALENDAR.START_TIME\"></span></label> <input ng-model=\"vm.newEvents[n].time_start\" ng-change=\"vm.setOnlineEvent(n)\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CALENDAR.END_TIME\"></span></label> <input ng-model=\"vm.newEvents[n].time_stop\" ng-change=\"vm.setOnlineEvent(n)\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CALENDAR.DESCRIPTION\"></span></label> <input ng-model=\"vm.newEvents[n].description\" ng-maxlength=\"100\" name=\"description\"></md-input-container><md-input-container class=\"md-block\" flex=\"\" ng-if=\"vm.templateCounter.length + vm.events.length > 1\"><md-button class=\"md-fab md-mini md-warn\" ng-click=\"vm.removeNewEvent($index)\">X</md-button></md-input-container></div><md-button aria-label=\"+ Add Another Time Period\" translate=\"CALENDAR.ADD_TIME_PERIOD\" translate-attr-aria-label=\"CALENDAR.ADD_TIME_PERIOD\" class=\"md-accent md-raised\" ng-if=\"vm.dialogData.type != \'edit\'\" ng-click=\"vm.incTemplate()\">+ Add Another Time Period</md-button></div></section><div layout-gt-sm=\"row\" ng-if=\"! vm.switch\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex=\"100\"><label><span translate=\"CALENDAR.OFFLINE_REASON\"></span></label><md-select ng-model=\"vm.def_desc\" ng-change=\"vm.setOfflineEvent()\" ng-if=\"!translate_loading\" flex=\"\"><md-option ng-value=\"\'\'\"></md-option><md-option ng-value=\"null\"><span translate=\"CALENDAR.REASON.other\"></span></md-option><md-option ng-repeat=\"opt in vm.reasons\" value=\"{{opt}}\"><span translate=\"CALENDAR.REASON.{{opt}}\"></span></md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"CALENDAR.CUSTOM_REASON\"></span></label> <input ng-model=\"vm.custom_desc\" ng-if=\"vm.def_desc === null\" ng-maxlength=\"100\" name=\"def_desc\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" translate=\"CALENDAR.SAVE\" translate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button class=\"md-icon-button\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"CALENDAR.DELETE\" ng-click=\"vm.clearForm()\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"CALENDAR.DELETE\">Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/cash-operations/list/tab/tab1.html","<div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><div layout=\"row\" layout-wrap=\"\"><md-input-container class=\"md-block no-errors-spacer\" flex-gt-sm=\"20\" flex=\"25\"><label><span translate=\"CASH_OPERATIONS_LIST.DATE\"></span></label> <input ng-model=\"vm.tab1.query.date\" name=\"date\" moment-picker=\"vm.tab1.query.date\" format=\"YYYY-MM-DD\" start-view=\"decade\" locale=\"pl\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex-gt-sm=\"30\" flex=\"35\"><label><span translate=\"CASH_OPERATIONS_LIST.USER\"></span></label><md-select ng-model=\"vm.tab1.query.user_id\" required=\"\" name=\"user_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"user.id\" ng-repeat=\"user in vm.users\">{{user.first_name}} {{user.last_name}}</md-option></md-select></md-input-container><div layout=\"row\" layout-align=\"start center\" flex-gt-sm=\"15\" flex=\"25\"><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.getCashOperations()\"><span translate=\"CASH_OPERATIONS_LIST.SEARCH\"></span></md-button></div><div layout=\"row\" layout-align=\"start center\" layout-align-gt-sm=\"end center\" flex-gt-sm=\"35\" flex=\"100\"><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.pdf()\"><span translate=\"CASH_OPERATIONS_LIST.GENERATE_PDF\"></span></md-button><a class=\"md-raised md-button md-default-theme md-accent\" ng-href=\"/cash-operations/form/new/cashless/0\" ng-if=\"!vm.is_tax_office\"><span translate=\"CASH_OPERATIONS_LIST.ADD\"></span></a></div></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><md-checkbox ng-model=\"vm.tab1.query.balanced_tmp\" ng-change=\"vm.getCashOperations()\"><span translate=\"CASH_OPERATIONS_LIST.BALANCE\"></span></md-checkbox></md-input-container></div><div ng-if=\"vm.tab1.pagination.total\" class=\"table-wrapper\"><md-table-container><table md-table=\"\" md-progress=\"vm.tab1.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"CASH_OPERATIONS_LIST.RECEIPT_NUMBER\"></span></th><th md-column=\"\"><span translate=\"CASH_OPERATIONS_LIST.RECEIPT_NUMBER_TRANSACTION\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"CASH_OPERATIONS_LIST.AMOUNT\"></span></th><th md-column=\"\"><span translate=\"CASH_OPERATIONS_LIST.DIRECTION\"></span></th><th md-column=\"\"><span translate=\"CASH_OPERATIONS_LIST.DESCRIPTION\"></span></th><th md-column=\"\"><span translate=\"CASH_OPERATIONS_LIST.CREATED\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\">Akcje</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"operation in vm.tab1.cash_operations\"><td md-cell=\"\">{{ vm.tab1.pagination | no:$index }}</td><td md-cell=\"\">{{ operation.receipt.data ? operation.receipt.data.number : \'\' }} {{ operation.invoice.data ? operation.invoice.data.number : \'\' }}</td><td md-cell=\"\">{{ operation.receipt.data ? operation.receipt.data.transaction_number : \'\' }}</td><td md-cell=\"\">{{ operation.amount.toFixed(2) | numFormat }}zł</td><td md-cell=\"\"><span translate=\"CASH_OPERATIONS_LIST.DIRECTION_LIST.{{operation.direction}}\"></span></td><td md-cell=\"\">{{operation.description}}</td><td md-cell=\"\">{{ operation.flow_date }}</td><td md-cell=\"\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.pdf(operation.id)\" aria-label=\"Edit\"><span translate=\"CASH_OPERATIONS_LIST.GENERATE_PDF\"></span></md-button></md-menu-item><md-menu-item ng-if=\"vm.tab1.edit_access && !vm.is_tax_office\"><md-button ng-click=\"vm.changeTo(operation.id, 1)\" aria-label=\"Change\"><span translate=\"CASH_OPERATIONS_LIST.CHANGE_2\"></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{vm.tab1.table_translate}}\" md-limit=\"vm.tab1.query.limit\" md-page=\"vm.tab1.query.page\" md-total=\"{{vm.tab1.pagination.total}}\" md-on-paginate=\"vm.getCashOperations\" md-page-select=\"\"></md-table-pagination></div><div layout=\"row\" ng-if=\"vm.tab1.pagination.total == 0\" translate=\"OTHER.NO_RECORDS\" class=\"text-center\"></div><div class=\"font-size-16 mt-10\"><div class=\"bold\" translate=\"CASH_OPERATIONS_LIST.SUM\"></div><div><span translate=\"CASH_OPERATIONS_LIST.CASH_START\"></span>: {{vm.tab1.reports.cash_initial_sum.toFixed(2) | numFormat }}zł</div><div><span translate=\"CASH_OPERATIONS_LIST.CASH_STOP\"></span>: {{vm.tab1.reports.cash_final_sum.toFixed(2) | numFormat }}zł</div><div><span translate=\"CASH_OPERATIONS_LIST.CASH_RELEASED\"></span>: {{vm.tab1.reports.cash_out_sum.toFixed(2) | numFormat }}zł</div><div><span translate=\"CASH_OPERATIONS_LIST.CASH_TOOK\"></span>: {{vm.tab1.reports.cash_in_sum.toFixed(2) | numFormat }}zł</div><div><span translate=\"CASH_OPERATIONS_LIST.CALC\"></span>: {{vm.tab1.reports.calc_final_sum.toFixed(2) | numFormat }}zł</div></div></div></div>");
$templateCache.put("app/main/cash-operations/list/tab/tab2.html","<div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><div layout=\"row\" layout-wrap=\"\"><md-input-container class=\"md-block no-errors-spacer\" flex-gt-sm=\"20\" flex=\"25\"><label><span translate=\"CASH_OPERATIONS_LIST.DATE\"></span></label> <input ng-model=\"vm.tab2.query.date\" name=\"date\" moment-picker=\"vm.tab2.query.date\" format=\"YYYY-MM-DD\" start-view=\"decade\" locale=\"pl\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex-gt-sm=\"30\" flex=\"35\"><label><span translate=\"CASH_OPERATIONS_LIST.USER\"></span></label><md-select ng-model=\"vm.tab2.query.user_id\" required=\"\" name=\"user_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"user.id\" ng-repeat=\"user in vm.users\">{{user.first_name}} {{user.last_name}}</md-option></md-select></md-input-container><div layout=\"row\" layout-align=\"start center\" flex-gt-sm=\"15\" flex=\"25\"><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.getNonCashOperations()\"><span translate=\"CASH_OPERATIONS_LIST.SEARCH\"></span></md-button></div><div layout=\"row\" layout-align=\"start center\" layout-align-gt-sm=\"end center\" flex-gt-sm=\"35\" flex=\"100\"><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.nonCashPdf()\"><span translate=\"CASH_OPERATIONS_LIST.GENERATE_PDF\"></span></md-button><a class=\"md-raised md-button md-default-theme md-accent\" ng-href=\"/cash-operations/form/new/cashless/1\" ng-if=\"!vm.is_tax_office\"><span translate=\"CASH_OPERATIONS_LIST.ADD\"></span></a></div></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"\"><md-checkbox ng-model=\"vm.tab2.query.balanced_tmp\" ng-change=\"vm.getNonCashOperations()\"><span translate=\"CASH_OPERATIONS_LIST.BALANCE\"></span></md-checkbox></md-input-container></div><div ng-if=\"vm.tab2.pagination.total\" class=\"table-wrapper\"><md-table-container><table md-table=\"\" md-progress=\"vm.tab2.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"CASH_OPERATIONS_LIST.RECEIPT_NUMBER\"></span></th><th md-column=\"\"><span translate=\"CASH_OPERATIONS_LIST.RECEIPT_NUMBER_TRANSACTION\"></span></th><th md-column=\"\" md-numeric=\"\"><span translate=\"CASH_OPERATIONS_LIST.AMOUNT\"></span></th><th md-column=\"\"><span translate=\"CASH_OPERATIONS_LIST.DIRECTION\"></span></th><th md-column=\"\"><span translate=\"CASH_OPERATIONS_LIST.DESCRIPTION\"></span></th><th md-column=\"\"><span translate=\"CASH_OPERATIONS_LIST.CREATED\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\">Akcje</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"operation in vm.tab2.cash_operations\"><td md-cell=\"\">{{ vm.tab2.pagination | no:$index }}</td><td md-cell=\"\">{{ operation.receipt.data ? operation.receipt.data.number : \'\' }} {{ operation.invoice.data ? operation.invoice.data.number : \'\' }}</td><td md-cell=\"\">{{ operation.receipt.data ? operation.receipt.data.transaction_number : \'\' }}</td><td md-cell=\"\">{{ operation.amount.toFixed(2) | numFormat }}zł</td><td md-cell=\"\"><span translate=\"CASH_OPERATIONS_LIST.DIRECTION_LIST.{{operation.direction}}\"></span></td><td md-cell=\"\">{{operation.description}}</td><td md-cell=\"\">{{ operation.flow_date }}</td><td md-cell=\"\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.nonCashPdf(operation.id)\" aria-label=\"Edit\"><span translate=\"CASH_OPERATIONS_LIST.GENERATE_PDF\"></span></md-button></md-menu-item><md-menu-item ng-if=\"vm.tab2.edit_access && !vm.is_tax_office\"><md-button ng-click=\"vm.changeTo(operation.id, 0)\" aria-label=\"Change\"><span translate=\"CASH_OPERATIONS_LIST.CHANGE_1\"></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{vm.tab2.table_translate}}\" md-limit=\"vm.tab2.query.limit\" md-page=\"vm.tab2.query.page\" md-total=\"{{vm.tab2.pagination.total}}\" md-on-paginate=\"vm.getNonCashOperations\" md-page-select=\"\"></md-table-pagination></div><div layout=\"row\" ng-if=\"vm.tab2.pagination.total == 0\" translate=\"OTHER.NO_RECORDS\" class=\"text-center\"></div><div class=\"font-size-16 mt-10\"><div class=\"bold\" translate=\"CASH_OPERATIONS_LIST.SUM\"></div><div><span translate=\"CASH_OPERATIONS_LIST.CASH_START\"></span>: {{vm.tab2.reports.cash_initial_sum.toFixed(2) | numFormat }}zł</div><div><span translate=\"CASH_OPERATIONS_LIST.CASH_STOP\"></span>: {{vm.tab2.reports.cash_final_sum.toFixed(2) | numFormat }}zł</div><div><span translate=\"CASH_OPERATIONS_LIST.CASH_RELEASED\"></span>: {{vm.tab2.reports.cash_out_sum.toFixed(2) | numFormat }}zł</div><div><span translate=\"CASH_OPERATIONS_LIST.CASH_TOOK\"></span>: {{vm.tab2.reports.cash_in_sum.toFixed(2) | numFormat }}zł</div><div><span translate=\"CASH_OPERATIONS_LIST.CALC\"></span>: {{vm.tab2.reports.calc_final_sum.toFixed(2) | numFormat }}zł</div></div></div></div>");
$templateCache.put("app/main/company/edit/add-edit-user/add-edit-user.html","<md-dialog aria-label=\"METHOD\"><div id=\"add-edit-user-dialog\"><form id=\"addEditUser\" name=\"addEditUser\"><div layout-gt-sm=\"row\"><div class=\"alert-error\" ng-if=\"vm.msg_error\">{{ vm.msg_error }}</div><div class=\"alert-success\" ng-if=\"vm.msg_success\">{{ vm.msg_success }}</div></div><div class=\"mb-20\"><span ng-if=\"vm.edit\" translate=\"COMPANY_EDIT.USER.UPDATE\" class=\"font-size-16\"></span> <span ng-if=\"!vm.edit\" translate=\"COMPANY_EDIT.USER.ADD\" class=\"font-size-16\"></span></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label><span translate=\"COMPANY_EDIT.USER.EMAIL\"></span></label> <input ng-model=\"vm.form.email\" required=\"\" ng-maxlength=\"255\" name=\"email\" type=\"email\" ng-disabled=\"vm.edit\"><div ng-messages=\"addEditUser.email.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"email\"><span translate=\"ERRORS.FORM.EMAIL\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label><span translate=\"COMPANY_EDIT.USER.NAME\"></span></label> <input ng-model=\"vm.form.first_name\" required=\"\" ng-maxlength=\"100\" name=\"first_name\"><div ng-messages=\"addEditUser.first_name.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_100\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"\"><label><span translate=\"COMPANY_EDIT.USER.SURNAME\"></span></label> <input ng-model=\"vm.form.last_name\" required=\"\" ng-maxlength=\"100\" name=\"last_name\"><div ng-messages=\"addEditUser.last_name.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_100\"></span></div></div></md-input-container></div><md-input-container class=\"md-block\" md-no-float=\"\"><label><span translate=\"COMPANY_EDIT.USER.ROLE\"></span></label><md-select ng-model=\"vm.form.role_id\" required=\"\" name=\"role_id\" ng-disabled=\"vm.edit\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"role.id\" ng-repeat=\"role in vm.roles\" ng-if=\"role.name.indexOf(\'api.\') == -1 && role.name != \'owner\'\"><span translate=\"ROLES.{{role.name}}\"></span></md-option></md-select><div ng-messages=\"addEditUser.role_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><div layout-gt-sm=\"row\" ng-if=\"vm.create_user\"><md-input-container class=\"md-block\" flex=\"\"><label><span translate=\"COMPANY_EDIT.USER.PASSWORD\"></span></label> <input type=\"password\" ng-model=\"vm.form.password\" ng-required=\"!vm.edit\" pattern=\".{6,}\" name=\"password\" id=\"password\"><div ng-messages=\"addEditUser.password.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.PASSWORD\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.create_user\"><md-input-container class=\"md-block\" flex=\"\"><label><span translate=\"COMPANY_EDIT.USER.PASSWORD_CONFIRM\"></span></label> <input type=\"password\" ng-model=\"vm.form.password_confirmation\" ng-required=\"!vm.edit\" ms-confirm=\"password\" name=\"password_confirmation\"><div ng-messages=\"addEditUser.password_confirmation.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"confirm\"><span translate=\"ERRORS.FORM.CONFIRM\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"end none\"><md-button ng-if=\"!vm.edit\" type=\"button\" class=\"md-raised md-accent\" aria-label=\"CANCEL\" translate=\"OTHER.CANCEL\" ng-click=\"vm.hide()\" translate-attr-aria-label=\"OTHER.CANCEL\"></md-button><md-button ng-if=\"!vm.edit\" type=\"button\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-disabled=\"addEditUser.$invalid || vm.request_sending\" translate=\"OTHER.ADD\" ng-click=\"vm.create()\" translate-attr-aria-label=\"OTHER.ADD\"></md-button><md-button ng-if=\"vm.edit\" type=\"button\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-disabled=\"addEditUser.$invalid || vm.request_sending\" translate=\"OTHER.SAVE\" ng-click=\"vm.update()\" translate-attr-aria-label=\"OTHER.SAVE\"></md-button></div></form></div></md-dialog>");
$templateCache.put("app/main/company/edit/tabs/tab1.html","<div class=\"alert-success\" ng-if=\"vm.tab1.msg_success\">{{ vm.tab1.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.tab1.msg_error\">{{ vm.tab1.msg_error }}</div><div layout=\"row\"><div id=\"company-edit-tab-1\" class=\"form-wrapper rounded-container max-1000\" flex=\"\"><form id=\"editCompanyTab1\" name=\"vm.tab1.scope_form\" novalidate=\"\" ng-submit=\"vm.sendTab1()\"><div class=\"form-title\" translate=\"COMPANY_EDIT.GENERAL_DATA\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.NAME\"></span></label> <input ng-model=\"vm.tab1.form.name\" required=\"\" ng-maxlength=\"255\" name=\"name\"><div ng-messages=\"vm.tab1.scope_form.name.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex=\"100\"><label><span translate=\"COMPANY_EDIT.NIP_PREFIX\"></span></label><md-select ng-model=\"vm.tab1.form.country_vatin_prefix_id\" name=\"country_vatin_prefix_id\" ng-if=\"!translate_loading\" ng-change=\"vm.checkErrors(\'vatin\')\"><md-option ng-value=\"null\"><span translate=\"COMPANY_EDIT.NIP_EMPTY\"></span></md-option><md-option ng-value=\"country.id\" ng-repeat=\"country in vm.tab1.countries\">{{country.key}} ({{country.name}})</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex=\"100\" ng-if=\"!vm.tab1.form.country_vatin_prefix_id || vm.tab1.pl_id == vm.tab1.form.country_vatin_prefix_id\"><label><span translate=\"COMPANY_EDIT.NIP\"></span></label> <input ng-model=\"vm.tab1.form.vatin\" required=\"\" ng-pattern=\"/^((\\d{3}-\\d{3}-\\d{2}-\\d{2})|(\\d{3}-\\d{2}-\\d{2}-\\d{3})|([0-9]{10}))$/\" name=\"vatin\"><div ng-messages=\"vm.tab1.scope_form.vatin.$error\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.NIP\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex=\"100\" ng-if=\"vm.tab1.form.country_vatin_prefix_id && vm.tab1.pl_id != vm.tab1.form.country_vatin_prefix_id\"><label><span translate=\"COMPANY_EDIT.NIP\"></span></label> <input ng-model=\"vm.tab1.form.vatin\" required=\"\" name=\"vatin\"><div ng-messages=\"vm.tab1.scope_form.vatin.$error\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.NIP\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex=\"100\"><label><span translate=\"COMPANY_EDIT.EMAIL\"></span></label> <input ng-model=\"vm.tab1.form.email\" required=\"\" ng-maxlength=\"255\" name=\"email\" type=\"email\"><div ng-messages=\"vm.tab1.scope_form.email.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"email\"><span translate=\"ERRORS.FORM.EMAIL\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.PHONE\"></span></label> <input ng-model=\"vm.tab1.form.phone\" required=\"\" minlength=\"9\" ng-maxlength=\"15\" name=\"phone\"><div ng-messages=\"vm.tab1.scope_form.phone.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.PHONE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.PHONE\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-button id=\"file-upload-button\" type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.addLogo()\" translate=\"COMPANY_EDIT.PHOTO\" translate-attr-aria-label=\"COMPANY_EDIT.PHOTO\" aria-label=\"photo\"></md-button><img ng-if=\"vm.tab1.logotype != \'\'\" id=\"input-file-img\" src=\"{{vm.tab1.logotype}}\"> <input id=\"file-to-upload\" type=\"file\" fileread=\"vm.tab1.logotype\" file-model=\"vm.tab1.form.logotype\" style=\"display:none;\" accept=\"image/*\" aria-label=\"photo\" name=\"logo\"><div class=\"inline-block pl-10\" ng-if=\"vm.tab1.logotype != \'\' && vm.tab1.logotype_loaded\"><md-checkbox ng-model=\"vm.tab1.form.remove_logotype\"><span translate=\"COMPANY_EDIT.REMOVE_LOGO\"></span></md-checkbox></div><div class=\"font-size-12 grey-600-fg mt-10 ml-10\">Max 10MB; MIN 50px/50px; MAX 1920px/1080px</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.WWW\"></span></label> <input ng-model=\"vm.tab1.form.website\" name=\"website\" type=\"text\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"\"><md-radio-group ng-model=\"vm.tab1.form.vat_payer\"><md-radio-button ng-value=\"true\" ng-disabled=\"!vm.tab1.vat_settings_is_editable\"><span translate=\"COMPANY_EDIT.VAT_PAYER_YES\"></span></md-radio-button><md-radio-button ng-value=\"false\" ng-disabled=\"!vm.tab1.vat_settings_is_editable\"><span translate=\"COMPANY_EDIT.VAT_PAYER_NO\"></span></md-radio-button></md-radio-group></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.BDO_NUMBER\"></span></label> <input ng-model=\"vm.tab1.form.bdo\" name=\"bdo\" ng-pattern=\"/^[0-9]{9}$/\"><div ng-messages=\"vm.tab1.scope_form.bdo.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\" class=\"my-message\"><span translate=\"ERRORS.FORM.BDO\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.tab1.form.vat_payer\"><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"50\" flex=\"100\"><label><span translate=\"COMPANY_EDIT.VAT_REASON\"></span></label><md-select ng-model=\"vm.tab1.form.vat_release_reason_id\" name=\"vat_release_reason_id\" required=\"\" ng-if=\"!translate_loading\"><md-option ng-value=\"reason.id\" ng-repeat=\"reason in vm.tab1.vat_release_reasons\">{{reason.description}}</md-option></md-select><div ng-messages=\"newCompany.vat_release_reason_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\" flex-gt-sm=\"50\" flex=\"100\" ng-if=\"vm.tab1.vat_release_reasons[vm.tab1.form.vat_release_reason_id].slug == \'legal_basis\'\"><label><span translate=\"COMPANY_EDIT.VAT_REASON_OTHER\"></span></label> <textarea ng-model=\"vm.tab1.form.vat_release_reason_note\" ng-maxlength=\"1000\" name=\"vat_release_reason_note\" required=\"\"></textarea><div ng-messages=\"newCompany.vat_release_reason_note.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_1000\"></span></div></div></md-input-container></div><div class=\"form-title\" translate=\"COMPANY_EDIT.MAIN_ADDRESS\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.COUNTRY\"></span></label><md-select ng-model=\"vm.tab1.form.main_address_country\" name=\"main_address_country\" ng-if=\"!translate_loading\" ng-change=\"vm.checkErrors(\'main_address_zip_code\')\"><md-option ng-value=\"country.name | uppercase\" ng-repeat=\"country in vm.tab1.countries\">{{country.name}}</md-option></md-select><div ng-messages=\"vm.tab1.scope_form.main_address_country.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.STREET\"></span></label> <input ng-model=\"vm.tab1.form.main_address_street\" ng-minlength=\"4\" name=\"main_address_street\" required=\"\" ng-maxlength=\"255\"><div ng-messages=\"vm.tab1.scope_form.main_address_street.$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_4\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.NUMBER\"></span></label> <input ng-model=\"vm.tab1.form.main_address_number\" name=\"main_address_number\" required=\"\" ng-maxlength=\"255\"><div ng-messages=\"vm.tab1.scope_form.main_address_number.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.tab1.form.main_address_country == \'POLSKA\'\"><label><span translate=\"COMPANY_EDIT.ZIP_CODE\"></span></label> <input ng-model=\"vm.tab1.form.main_address_zip_code\" name=\"main_address_zip_code\" required=\"\" ng-pattern=\"/^[0-9]{2}-[0-9]{3}$/\" maxlength=\"6\" zip-code=\"\"><div ng-messages=\"vm.tab1.scope_form.main_address_zip_code.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\" class=\"my-message\"><span translate=\"ERRORS.FORM.POST_CODE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.tab1.form.main_address_country != \'POLSKA\'\"><label><span translate=\"COMPANY_EDIT.ZIP_CODE\"></span></label> <input ng-model=\"vm.tab1.form.main_address_zip_code\" name=\"main_address_zip_code\" required=\"\" maxlength=\"255\"><div ng-messages=\"vm.tab1.scope_form.main_address_zip_code.$error\" role=\"alert\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.CITY\"></span></label> <input ng-model=\"vm.tab1.form.main_address_city\" name=\"main_address_city\" required=\"\" ng-minlength=\"2\" ng-maxlength=\"255\"><div ng-messages=\"vm.tab1.scope_form.main_address_city.$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_2\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"!vm.tab1.edit\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" flex=\"50\"><md-checkbox ng-model=\"vm.tab1.other_contact_address\" name=\"other_contact_address\"><span translate=\"COMPANY_EDIT.OTHER_CONTACT_ADDRESS\"></span></md-checkbox></md-input-container></div><div class=\"form-title\" translate=\"COMPANY_EDIT.CONTACT_ADDRESS\" ng-if=\"vm.tab1.other_contact_address\"></div><div layout-gt-sm=\"row\" ng-if=\"vm.tab1.other_contact_address\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.COUNTRY\"></span></label><md-select ng-model=\"vm.tab1.form.contact_address_country\" name=\"contact_address_country\" ng-if=\"!translate_loading\" ng-change=\"vm.checkErrors(\'contact_address_zip_code\')\"><md-option ng-value=\"country.name | uppercase\" ng-repeat=\"country in vm.tab1.countries\">{{country.name}}</md-option></md-select><div ng-messages=\"vm.tab1.scope_form.contact_address_country.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.tab1.other_contact_address\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.STREET\"></span></label> <input ng-model=\"vm.tab1.form.contact_address_street\" ng-minlength=\"4\" name=\"contact_address_street\" required=\"\" ng-maxlength=\"255\"><div ng-messages=\"vm.tab1.scope_form.contact_address_street.$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_4\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.NUMBER\"></span></label> <input ng-model=\"vm.tab1.form.contact_address_number\" name=\"contact_address_number\" required=\"\" ng-maxlength=\"255\"><div ng-messages=\"vm.tab1.scope_form.contact_address_number.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" ng-if=\"vm.tab1.other_contact_address\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.tab1.form.contact_address_country == \'POLSKA\'\"><label><span translate=\"COMPANY_EDIT.ZIP_CODE\"></span></label> <input ng-model=\"vm.tab1.form.contact_address_zip_code\" name=\"contact_address_zip_code\" required=\"\" ng-pattern=\"/^[0-9]{2}-[0-9]{3}$/\" maxlength=\"6\" zip-code=\"\"><div ng-messages=\"vm.tab1.scope_form.contact_address_zip_code.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\" class=\"my-message\"><span translate=\"ERRORS.FORM.POST_CODE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.tab1.form.contact_address_country != \'POLSKA\'\"><label><span translate=\"COMPANY_EDIT.ZIP_CODE\"></span></label> <input ng-model=\"vm.tab1.form.contact_address_zip_code\" name=\"contact_address_zip_code\" required=\"\" maxlength=\"255\"><div ng-messages=\"vm.tab1.scope_form.contact_address_zip_code.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.CITY\"></span></label> <input ng-model=\"vm.tab1.form.contact_address_city\" name=\"contact_address_city\" required=\"\" ng-minlength=\"2\" ng-maxlength=\"255\"><div ng-messages=\"vm.tab1.scope_form.contact_address_city.$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_2\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"end none\" ng-if=\"vm.tab1.other_contact_address && !vm.tab1.first\"><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.copyToContact()\" translate=\"COMPANY_EDIT.ADDRESS_COPY\">COPY</md-button></div><div class=\"form-title\" translate=\"COMPANY_EDIT.BANK\"></div><div flex=\"100\" layout-gt-sm=\"row\" layout-align=\"center start\" class=\"bank-account-row\" ng-repeat=\"(key, value) in vm.tab1.form.bank_accounts\"><md-input-container class=\"md-block\" flex-gt-sm=\"40\" flex=\"100\"><label><span translate=\"COMPANY_EDIT.BANK_ACCOUNT\"></span></label> <input ng-model=\"vm.tab1.form.bank_accounts[$index].number\" name=\"bank_accounts_{{$index}}_number\" required=\"\"><div ng-messages=\"vm.tab1.scope_form.bank_accounts[$index].number.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.BANK_NAME\"></span></label> <input ng-model=\"vm.tab1.form.bank_accounts[$index].bank_name\" ng-maxlength=\"100\" name=\"bank_accounts_{{$index}}_bank_name\" required=\"\"><div ng-messages=\"vm.tab1.scope_form.bank_accounts[$index].bank_name.$error\"><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_100\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-button ng-if=\"!vm.tab1.form.bank_accounts[$index].swift && !vm.tab1.form.bank_accounts[$index].add_swift\" class=\"md-raised mt-15\" type=\"button\" ng-click=\"vm.tab1.form.bank_accounts[$index].add_swift = true\">{{ \'COMPANY_EDIT.ADD_SWIFT\' | translate }}</md-button><md-input-container class=\"md-block\" flex-gt-sm=\"\" ng-if=\"vm.tab1.form.bank_accounts[$index].swift || vm.tab1.form.bank_accounts[$index].add_swift\"><label><span translate=\"COMPANY_EDIT.SWIFT\"></span></label> <input ng-model=\"vm.tab1.form.bank_accounts[$index].swift\" name=\"bank_accounts_{{$index}}_swift\"></md-input-container><md-button ng-if=\"vm.tab1.form.bank_accounts[$index].default\" disabled=\"\" type=\"button\" class=\"md-raised md-accent mt-15\" translate=\"COMPANY_EDIT.CURRENT_DEFAULT\">DEFAULT</md-button><md-button ng-if=\"!vm.tab1.form.bank_accounts[$index].default\" ng-click=\"vm.changeDefaultBankAccount($index)\" type=\"button\" class=\"md-raised md-default mt-15\" ng-disabled=\"!vm.tab1.form.bank_accounts[$index].number.length || !vm.tab1.form.bank_accounts[$index].bank_name.length\" translate=\"COMPANY_EDIT.DEFAULT\">SET AS DEFAULT</md-button></div><div layout-gt-sm=\"row\" layout-align=\"end none\"><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.addBankAccount()\" aria-label=\"\" translate=\"INFO.ADD_NEXT\">ADD</md-button><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.deleteBankAccount()\" aria-label=\"\" translate=\"INFO.DELETE_LAST\" ng-disabled=\"vm.tab1.form.bank_accounts.length == 1\">DELETE</md-button></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><span class=\"require\">*</span> <span translate=\"INFO.REQUIRE_INFO\"></span></md-input-container></div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.tab1.progress}}\"></md-progress-linear><div layout=\"row\" layout-align=\"end none\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-disabled=\"vm.tab1.scope_form.$invalid || vm.request_sending\" translate=\"OTHER.SAVE\" translate-attr-aria-label=\"OTHER.SAVE\"></md-button></div></form></div></div>");
$templateCache.put("app/main/company/edit/tabs/tab10.html","<div class=\"alert-success\" ng-if=\"vm.tab10.msg_success\">{{ vm.tab10.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.tab10.msg_error\">{{ vm.tab10.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container max-1000\" flex=\"\"><form id=\"editCompanyTab10\" name=\"vm.tab10.scope_form\" novalidate=\"\" ng-submit=\"vm.sendTab10()\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.TAX_OFFICES\"></span></label><md-select ng-model=\"vm.tab10.form.tax_office_id\" name=\"tax_office_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"office.id\" ng-repeat=\"office in vm.tab10.tax_offices\">{{office.name}}</md-option></md-select><div ng-messages=\"vm.tab10.scope_form.tax_office_id.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"50\" flex=\"100\"><label><span translate=\"COMPANY_EDIT.REGON\"></span></label> <input ng-model=\"vm.tab10.form.regon\" required=\"\" ng-pattern=\"/^(([0-9]{9})|([0-9]{14}))$/\" name=\"regon\"><div ng-messages=\"vm.tab10.scope_form.regon.$error\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.REGON\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.STATE\"></span></label> <input ng-model=\"vm.tab10.form.state\" name=\"state\" required=\"\" ng-minlength=\"2\" ng-maxlength=\"255\"><div ng-messages=\"vm.tab10.scope_form.state.$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_2\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.COUNTY\"></span></label> <input ng-model=\"vm.tab10.form.county\" name=\"county\" required=\"\" ng-minlength=\"2\" ng-maxlength=\"255\"><div ng-messages=\"vm.tab10.scope_form.county.$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_2\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.COMMUNITY\"></span></label> <input ng-model=\"vm.tab10.form.community\" name=\"community\" required=\"\" ng-minlength=\"2\" ng-maxlength=\"255\"><div ng-messages=\"vm.tab10.scope_form.community.$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_2\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.CITY\"></span></label> <input ng-model=\"vm.tab10.form.city\" name=\"city\" required=\"\" ng-minlength=\"2\" ng-maxlength=\"255\"><div ng-messages=\"vm.tab10.scope_form.city.$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_2\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"33\"><label><span translate=\"COMPANY_EDIT.STREET_2\"></span></label> <input ng-model=\"vm.tab10.form.street\" name=\"street\" required=\"\" ng-minlength=\"2\" ng-maxlength=\"255\"><div ng-messages=\"vm.tab10.street.city.$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_2\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"33\"><label><span translate=\"COMPANY_EDIT.BUILDING_NUMBER\"></span></label> <input ng-model=\"vm.tab10.form.building_number\" name=\"building_number\" ng-maxlength=\"255\"><div ng-messages=\"vm.tab10.scope_form.building_number.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"33\"><label><span translate=\"COMPANY_EDIT.FLAT_NUMBER\"></span></label> <input ng-model=\"vm.tab10.form.flat_number\" name=\"flat_number\" ng-maxlength=\"255\"><div ng-messages=\"vm.tab10.scope_form.flat_number.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.ZIP_CODE\"></span></label> <input ng-model=\"vm.tab10.form.zip_code\" name=\"zip_code\" required=\"\" ng-pattern=\"/^[0-9]{2}-[0-9]{3}$/\" maxlength=\"6\" zip-code=\"\"><div ng-messages=\"vm.tab10.scope_form.zip_code.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\" class=\"my-message\"><span translate=\"ERRORS.FORM.POST_CODE\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.POSTAL\"></span></label> <input ng-model=\"vm.tab10.form.postal\" name=\"postal\" required=\"\" ng-minlength=\"2\" ng-maxlength=\"255\"><div ng-messages=\"vm.tab10.scope_form.postal.$error\"><div ng-message=\"minlength\"><span translate=\"ERRORS.FORM.MIN_2\"></span></div><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"maxlength\"><span translate=\"ERRORS.FORM.MAX_255\"></span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><span class=\"require\">*</span> <span translate=\"INFO.REQUIRE_INFO\"></span></md-input-container></div><div layout=\"row\" layout-align=\"end none\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-disabled=\"vm.tab10.scope_form.$invalid || vm.request_sending\" translate=\"OTHER.SAVE\" translate-attr-aria-label=\"OTHER.SAVE\"></md-button></div></form></div></div>");
$templateCache.put("app/main/company/edit/tabs/tab11.html","<div class=\"alert-success\" ng-if=\"vm.tab11.msg_success\">{{ vm.tab11.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.tab11.msg_error\">{{ vm.tab11.msg_error }}</div><div layout=\"row\"><div id=\"company-edit-tab-11\" class=\"form-wrapper rounded-container max-1000\" flex=\"\"><div><div class=\"collapse\"><div class=\"collapse-header \'md-white-fg md-accent-bg\" ng-click=\"vm.tab11.togglePackage(vm.tab11.packages_current, true)\" flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"collapse-header__title\" flex=\"\" layout=\"row\" layout-align=\"flex-start center\"><div><md-icon class=\"md-font material-icons icon icon-menu-down\" ng-class=\"{\'icon-menu-down\': vm.tab11.packages_current.togglePackage, \'icon-menu-right\': !vm.tab11.packages_current.togglePackage }\"></md-icon></div><div>{{ vm.tab11.packages_current.name}}<div class=\"status\" translate=\"COMPANY_EDIT.PACKAGES.ACTIVE\"></div></div></div><div class=\"collapse-header__description text-right\"><div ng-if=\"vm.tab11.packages_current.modules.data[0].company_module.data.expiration_date\"><span ng-if=\"vm.tab11.packages_current.subscription.data && vm.tab11.packages_current.subscription.data.active\"><span translate=\"COMPANY_EDIT.PACKAGES.RENEW_SUBSCRIPTION\"></span> {{vm.tab11.packages_current.modules.data[0].company_module.data.expiration_date}}</span> <span ng-if=\"!vm.tab11.packages_current.subscription.data || !vm.tab11.packages_current.subscription.data.active\"><span translate=\"COMPANY_EDIT.PACKAGES.EXPIRES\"></span> {{vm.tab11.packages_current.modules.data[0].company_module.data.expiration_date}}</span></div><div ng-if=\"vm.tab11.packages_current.price <= 0 && !vm.tab11.packages_current.modules.data[0].company_module.data.expiration_date\" translate=\"COMPANY_EDIT.PACKAGES.FREE\"></div><div ng-if=\"vm.tab11.packages_current.price > 0\"><span class=\"price\">{{(vm.tab11.packages_current.price / 100).toFixed(2) }}</span> {{vm.tab11.currency}}<span ng-if=\"vm.tab11.packages_current.subscription.data && vm.tab11.packages_current.subscription.data.active\">/<span ng-if=\"vm.tab11.packages_current.days == 30\" translate=\"COMPANY_EDIT.PACKAGES.MONTH_SHORT\"></span><span ng-if=\"vm.tab11.packages_current.days == 365\" translate=\"COMPANY_EDIT.PACKAGES.YEAR\"></span></span></div></div></div><div class=\"collapse-body\" ng-if=\"vm.tab11.packages_current.togglePackage\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr class=\"module-header\" md-row=\"\"><th md-column=\"\" class=\"status\"><span translate=\"COMPANY_EDIT.PACKAGES.STATUS\"></span></th><th md-column=\"\"><span translate=\"OTHER.NAME\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\"></span></th></tr></thead><tbody md-body=\"\"><tr class=\"module-row\" md-row=\"\" ng-repeat=\"module in vm.tab11.packages_current.modules.data\" ng-if=\"module.visible\"><td class=\"status\" md-cell=\"\"><md-icon class=\"icon icon-checkbox-marked-outline green-500-fg\" ng-if=\"[\'0\', \'\', 0].indexOf(module.company_module.data.value) == -1\"><md-tooltip><span translate=\"COMPANY_EDIT.PACKAGES.STATUS_LIST.ACTIVE\"></span></md-tooltip></md-icon><md-icon ng-if=\"[\'0\', \'\', 0].indexOf(module.company_module.data.value) > -1\" class=\"icon icon-checkbox-blank-outline grey-300-fg\"><md-tooltip><span translate=\"COMPANY_EDIT.PACKAGES.STATUS_LIST.INACTIVE\"></span></md-tooltip></md-icon></td><td class=\"name\" md-cell=\"\"><span translate=\"COMPANY_EDIT.PACKAGES.MODULES_LIST.{{vm.tab11.replaceModuleSlug(module.slug)}}\"></span></td><td class=\"action\" md-cell=\"\"><div flex=\"\" layout=\"row\" layout-align=\"end center\" ng-if=\"module.mods_count > 1\"><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\"><label><span translate=\"COMPANY_EDIT.PACKAGES.VALUE\"></span></label><md-select ng-model=\"vm.tab11.getModule(module).selected_mod\" ng-change=\"vm.tab11.calculate(vm.tab11.packages_current)\"><md-option ng-value=\"mod.id\" ng-repeat=\"mod in vm.tab11.getMods(module)\" ng-if=\"!mod.test\"><span ng-if=\"mod.value == \'\'\" translate=\"COMPANY_EDIT.PACKAGES.DISABLED\"></span> <span ng-if=\"mod.value != \'\'\">{{mod.value}}</span> ({{(vm.tab11.getPriceChangeModule(module, mod.id) / 100).toFixed(2)}}{{vm.tab11.currency}} <span translate=\"COMPANY_EDIT.PACKAGES.WITH_VAT\"></span>)</md-option></md-select></md-input-container><md-button class=\"md-raised md-accent md-button\" ng-click=\"vm.tab11.changeModule(vm.tab11.getModule(module))\" ng-disabled=\"!vm.tab11.canChangeModule(vm.tab11.getModule(module)) || vm.tab11.packages_current.price <= 0\" ng-if=\"!vm.tab11.packages_current.subscription.data || !vm.tab11.packages_current.subscription.data.active\"><span translate=\"COMPANY_EDIT.PACKAGES.BUY\"></span></md-button></div></td></tr></tbody></table></md-table-container><div flex=\"\" layout-gt-sm=\"row\" layout-align=\"end center\" ng-if=\"vm.tab11.packages_current.modules_list\"><div ng-if=\"vm.tab11.canRenew(vm.tab11.packages_current, 30) || vm.tab11.canRenew(vm.tab11.packages_current, 365)\" flex=\"\" layout=\"row\" layout-align=\"end center\"><div class=\"font-size-20 mr-10\">{{(vm.tab11.packages_current.current_price / 100).toFixed(2)}} {{vm.tab11.currency}} <span translate=\"COMPANY_EDIT.PACKAGES.WITH_VAT\"></span></div><md-input-container class=\"md-block min-width-100\" md-no-float=\"\" flex=\"\"><label><span translate=\"COMPANY_EDIT.PACKAGES.TIME\"></span></label><md-select ng-model=\"vm.tab11.packages_current.selected_days\" ng-change=\"vm.tab11.calculate(vm.tab11.packages_current)\"><md-option ng-value=\"30\" ng-if=\"vm.tab11.canRenew(vm.tab11.packages_current, 30)\"><span translate=\"COMPANY_EDIT.PACKAGES.MONTH\"></span></md-option><md-option ng-value=\"365\" ng-if=\"vm.tab11.canRenew(vm.tab11.packages_current, 365)\"><span translate=\"COMPANY_EDIT.PACKAGES.YEAR\"></span></md-option></md-select></md-input-container><md-button class=\"md-raised md-accent md-button\" ng-click=\"vm.tab11.renewPackage(vm.tab11.packages_current)\"><span translate=\"COMPANY_EDIT.PACKAGES.RENEW\"></span></md-button></div><md-button class=\"md-raised md-accent md-button\" ng-click=\"vm.tab11.changePackage(vm.tab11.packages_current)\" ng-if=\"vm.tab11.canChange(vm.tab11.packages_current)\"><span translate=\"COMPANY_EDIT.PACKAGES.CHANGE_PACKAGE\"></span></md-button><md-button ng-if=\"vm.tab11.packages_current.subscription.data && vm.tab11.packages_current.subscription.data.active\" class=\"md-raised md-accent md-button\" ng-click=\"vm.tab11.cancelSubscription(vm.tab11.packages_current.subscription.data.id, vm.tab11.packages_current)\"><span translate=\"COMPANY_EDIT.PACKAGES.CANCEL_SUBSCRIPTION\"></span></md-button></div></div></div><div class=\"collapse\" ng-repeat=\"(index, package) in vm.tab11.packages\" ng-if=\"package.id != vm.tab11.packages_current.id\"><div class=\"collapse-header md-accent-fg md-white-bg\" ng-click=\"vm.tab11.togglePackage(package, true)\" flex=\"\" layout=\"row\" layout-align=\"space-between center\"><div class=\"collapse-header__title\" flex=\"\" layout=\"row\" layout-align=\"flex-start center\"><div><md-icon class=\"md-font material-icons icon icon-menu-down\" ng-class=\"{\'icon-menu-down\': package.togglePackage, \'icon-menu-right\': !package.togglePackage }\"></md-icon></div><div>{{ package.name}}</div></div><div class=\"collapse-header__description\"><div ng-if=\"package.price <= 0\" translate=\"COMPANY_EDIT.PACKAGES.FREE\"></div><div ng-if=\"package.price > 0\"><span class=\"price\">{{(package.price / 100).toFixed(2) }}</span> {{vm.tab11.currency}}/<span translate=\"COMPANY_EDIT.PACKAGES.MONTH_SHORT\"></span></div></div></div><div class=\"collapse-body\" ng-if=\"package.togglePackage\"><md-table-container ng-if=\"package.modules_list.length > 0\"><table md-table=\"\"><thead md-head=\"\"><tr class=\"module-header\" md-row=\"\"><th md-column=\"\" class=\"status\"><span translate=\"COMPANY_EDIT.PACKAGES.STATUS\"></span></th><th md-column=\"\"><span translate=\"OTHER.NAME\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\"></span></th></tr></thead><tbody md-body=\"\"><tr class=\"module-row\" md-row=\"\" ng-repeat=\"module in package.modules_list\" ng-if=\"module.visible\"><td class=\"status\" md-cell=\"\"><md-icon class=\"icon icon-checkbox-marked-outline green-500-fg\" ng-if=\"vm.tab11.isActiveInOtherPackage(module) && !vm.tab11.isFreeMod(module)\"><md-tooltip><span translate=\"COMPANY_EDIT.PACKAGES.STATUS_LIST.ACTIVE\"></span></md-tooltip></md-icon><md-icon class=\"icon icon-checkbox-marked-outline green-500-fg\" ng-if=\"!module.mods.data[0].error && package.price > 0 && !vm.tab11.isFreeMod(module)\"><md-tooltip><span translate=\"COMPANY_EDIT.PACKAGES.STATUS_LIST.AVAILABLE\"></span></md-tooltip></md-icon><md-icon ng-if=\"vm.tab11.isInactiveInOtherPackage(module) && package.price <= 0 || vm.tab11.isFreeMod(module)\" class=\"icon icon-checkbox-blank-outline grey-300-fg\"><md-tooltip><span translate=\"COMPANY_EDIT.PACKAGES.STATUS_LIST.INACTIVE\"></span></md-tooltip></md-icon><md-icon ng-if=\"module.mods.data[module.mods.data.length - 1].error == \'unavailable_value\'\" class=\"icon icon-block-helper red-500-fg\"><md-tooltip><span translate=\"COMPANY_EDIT.PACKAGES.STATUS_LIST.UNAVAILABLE\"></span></md-tooltip></md-icon><md-icon ng-if=\"module.mods.data[0].error == \'waiting_for_payment\'\" class=\"icon icon-clock orange-500-fg\"><md-tooltip><span translate=\"COMPANY_EDIT.PACKAGES.STATUS_LIST.WAITING\"></span></md-tooltip></md-icon></td><td class=\"name\" md-cell=\"\"><span translate=\"COMPANY_EDIT.PACKAGES.MODULES_LIST.{{vm.tab11.replaceModuleSlug(module.slug)}}\"></span></td><td class=\"action\" md-cell=\"\"><div flex=\"\" layout=\"row\" layout-align=\"end center\" ng-if=\"vm.tab11.getCountMods(module) > 1\"><md-input-container class=\"md-block\" md-no-float=\"\" flex=\"\"><label><span translate=\"COMPANY_EDIT.PACKAGES.VALUE\"></span></label><md-select ng-model=\"module.selected_mod\" ng-change=\"vm.tab11.calculate(package)\"><md-option ng-value=\"mod.id\" ng-repeat=\"mod in module.mods.data\" ng-if=\"!mod.test\"><span ng-if=\"mod.value == \'\'\" translate=\"COMPANY_EDIT.PACKAGES.DISABLED\"></span> <span ng-if=\"mod.value != \'\'\">{{mod.value}}</span> ({{(vm.tab11.getPriceChangeModule(module, mod.id) / 100).toFixed(2)}}{{vm.tab11.currency}} <span translate=\"COMPANY_EDIT.PACKAGES.WITH_VAT\"></span>)</md-option></md-select></md-input-container></div></td></tr></tbody></table></md-table-container><div flex=\"\" layout-gt-sm=\"row\" ng-if=\"package.modules_list\"><div flex=\"30\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.tab11.canTest(package)\"><md-button class=\"md-raised md-accent md-button\" ng-click=\"vm.tab11.testPackage(package)\"><span translate=\"COMPANY_EDIT.PACKAGES.TRIAL\"></span></md-button></div><div flex=\"\" layout=\"row\" layout-align=\"end center\" ng-if=\"package.price > 0\"><div ng-if=\"vm.tab11.canRenew(package, 30) || vm.tab11.canRenew(package, 365)\" flex=\"\" layout=\"row\" layout-align=\"end center\"><div class=\"font-size-20 mr-10\">{{(package.current_price / 100).toFixed(2)}} {{vm.tab11.currency}} <span translate=\"COMPANY_EDIT.PACKAGES.WITH_VAT\"></span></div><md-input-container class=\"md-block min-width-100\" md-no-float=\"\" flex=\"\"><label><span translate=\"COMPANY_EDIT.PACKAGES.TIME\"></span></label><md-select ng-model=\"package.selected_days\" ng-change=\"vm.tab11.calculate(package)\"><md-option ng-value=\"30\" ng-if=\"vm.tab11.canRenew(package, 30)\"><span translate=\"COMPANY_EDIT.PACKAGES.MONTH\"></span></md-option><md-option ng-value=\"365\" ng-if=\"vm.tab11.canRenew(package, 365)\"><span translate=\"COMPANY_EDIT.PACKAGES.YEAR\"></span></md-option></md-select></md-input-container><md-button class=\"md-raised md-accent md-button\" ng-click=\"vm.tab11.renewPackage(package)\"><span translate=\"COMPANY_EDIT.PACKAGES.BUY\"></span></md-button></div><md-button class=\"md-raised md-accent md-button\" ng-click=\"vm.tab11.changePackage(package)\" ng-if=\"vm.tab11.canChange(package)\"><span translate=\"COMPANY_EDIT.PACKAGES.CHANGE_PACKAGE\"></span></md-button></div></div></div></div></div></div></div>");
$templateCache.put("app/main/company/edit/tabs/tab12.html","<div class=\"alert-success\" ng-if=\"vm.tab12.msg_success\">{{ vm.tab12.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.tab12.msg_error\">{{ vm.tab12.msg_error }}</div><div layout=\"row\"><div id=\"company-edit-tab-12\" class=\"form-wrapper rounded-container max-1000\" flex=\"\"><md-tabs md-dynamic-height=\"\"><md-tab><md-tab-label>Paczki</md-tab-label><md-tab-body><div><div class=\"collapse\"><div class=\"collapse-header\" ng-click=\"vm.tab12[0] = !vm.tab12[0]\">Podstawowy 0zł</div><div class=\"collapse-body\" ng-if=\"vm.tab12[0]\"><div class=\"font-size-16\">Dokumenty sprzedażowe:<md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\" ng-disabled=\"true\"><span>10 - 0zł</span></md-button></div><div class=\"font-size-16\">Klienci:<md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\" ng-disabled=\"true\"><span>bez limitu - 0zł</span></md-button></div><div class=\"font-size-16\">Produkty, usługi, towary:<md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\" ng-disabled=\"true\"><span>bez limitu - 0zł</span></md-button></div><div class=\"font-size-16\">Firmy w ramach jednego konta:<md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\" ng-disabled=\"true\"><span>bez limitu - 0zł</span></md-button></div><div layout=\"row\" layout-align=\"end\"><div class=\"sum\">Suma 0zł/miesiąc</div><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"\" ng-disabled=\"true\"><span>Wybieram pakiet</span></md-button></div></div></div><div class=\"collapse\"><div class=\"collapse-header\" ng-click=\"vm.tab12[1] = !vm.tab12[1]\">Premium 10zł/miesiąc</div><div class=\"collapse-body\" ng-if=\"vm.tab12[1]\"><div class=\"font-size-16\">Dokumenty sprzedażowe:<md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\" ng-disabled=\"true\"><span>bez limitu - 0zł</span></md-button></div><div class=\"font-size-16\">Klienci:<md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\" ng-disabled=\"true\"><span>bez limitu - 0zł</span></md-button></div><div class=\"font-size-16\">Produkty, usługi, towary:<md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\" ng-disabled=\"true\"><span>bez limitu - 0zł</span></md-button></div><div class=\"font-size-16\">Firmy w ramach jednego konta:<md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\" ng-disabled=\"true\"><span>bez limitu - 0zł</span></md-button></div><div class=\"font-size-16\">Użytkownicy:<md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\" ng-disabled=\"true\"><span>10 - 0zł</span></md-button><md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\"><span>50 - 10zł</span></md-button><md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\"><span>bez limitu - 50zł</span></md-button></div><div class=\"font-size-16\">Pobieranie danych z GUS</div><div class=\"font-size-16\">Uprawnienia dla użytkowników</div><div layout=\"row\" layout-align=\"end\"><div class=\"sum\">Suma 30zł/miesiąc</div><md-input-container><label>Okres</label><md-select class=\"md-block\" ng-model=\"vm.tab12.days\" ng-change=\"\" ng-if=\"!translate_loading && !vm.is_loading\"><md-option ng-value=\"30\">Misiąc</md-option><md-option ng-value=\"365\">Rok</md-option></md-select></md-input-container><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"\"><span>Wybieram pakiet</span></md-button></div></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label>moduły</md-tab-label><md-tab-body><div class=\"tab-body\"><div class=\"font-size-16\">Jakieś coś tam:<md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\" ng-disabled=\"true\"><span>bez limitu - 10zł</span></md-button></div><div class=\"font-size-16\">Integracje:<md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\" ng-disabled=\"true\"><span>hubstaff - 0zł</span></md-button><md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\"><span>upwork - 10zł</span></md-button><md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\"><span>upwork + hubstaff - 50zł</span></md-button></div><div class=\"font-size-16\">Moduł xx<md-button class=\"md-raised md-button md-default-theme md-accent bt-min\" ng-click=\"\" ng-disabled=\"true\"><span>bez limitu - 10zł/miesiąc</span></md-button><span class=\"waiting\">Oczekiwanie na płatność</span></div></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/company/edit/tabs/tab13.html","<div class=\"alert-success\" ng-if=\"vm.tab13.msg_success\">{{ vm.tab13.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.tab13.msg_error\">{{ vm.tab13.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container max-1000\" flex=\"\"><form novalidate=\"\" ng-submit=\"\"><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"50\"><md-select class=\"md-block\" ng-model=\"vm.tab13.status\" ng-change=\"vm.tab13.getPayments()\" ng-if=\"!translate_loading && !vm.is_loading\"><md-option ng-value=\"null\"><span translate=\"COMPANY_EDIT.PAYMENTS.STATUS_LIST.ALL\"></span></md-option><md-option ng-value=\"\'NEW\'\"><span translate=\"COMPANY_EDIT.PAYMENTS.STATUS_LIST.NEW\"></span></md-option><md-option ng-value=\"\'PENDING\'\"><span translate=\"COMPANY_EDIT.PAYMENTS.STATUS_LIST.PENDING\"></span></md-option><md-option ng-value=\"\'COMPLETED\'\"><span translate=\"COMPANY_EDIT.PAYMENTS.STATUS_LIST.COMPLETED\"></span></md-option><md-option ng-value=\"\'CANCELED\'\"><span translate=\"COMPANY_EDIT.PAYMENTS.STATUS_LIST.CANCELED\"></span></md-option><md-option ng-value=\"\'REJECTED\'\"><span translate=\"COMPANY_EDIT.PAYMENTS.STATUS_LIST.REJECTED\"></span></md-option></md-select></md-input-container></div></form><div ng-if=\"vm.tab13.payments.length\" class=\"table-wrapper\"><md-table-container><table md-table=\"\" md-progress=\"vm.tab13.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"COMPANY_EDIT.PAYMENTS.NUMBER\"></span></th><th md-column=\"\"><span translate=\"COMPANY_EDIT.PAYMENTS.CREATED\"></span></th><th md-column=\"\"><span translate=\"COMPANY_EDIT.PAYMENTS.TOTAL_PRICE\"></span></th><th md-column=\"\"><span translate=\"COMPANY_EDIT.PAYMENTS.VAT\"></span></th><th md-column=\"\"><span translate=\"COMPANY_EDIT.PAYMENTS.STATUS\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\">Akcje</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"payment in vm.tab13.payments\"><td md-cell=\"\">{{ ($index + 1) }}</td><td md-cell=\"\">{{ payment.id }}</td><td md-cell=\"\">{{ payment.created_at }}</td><td md-cell=\"\">{{ (payment.price_total / 100).toFixed(2) }}{{ payment.currency }}</td><td md-cell=\"\">{{ (payment.vat / 100).toFixed(2) }}{{ payment.currency }}</td><td md-cell=\"\"><span translate=\"COMPANY_EDIT.PAYMENTS.STATUS_LIST.{{ payment.status }}\"></span></td><td md-cell=\"\"><md-button class=\"md-raised md-warn md-button md-default-theme\" ng-click=\"vm.tab13.cancel(payment.id)\" ng-if=\"payment.status != \'COMPLETED\' && payment.status != \'CANCELED\' && payment.status != \'BEFORE_START\'\"><span translate=\"OTHER.CANCEL\"></span></md-button><md-button class=\"md-raised md-accent md-button md-default-theme\" ng-click=\"vm.tab13.again(payment.transaction_id)\" ng-if=\"payment.status == \'CANCELED\' || payment.status == \'REJECTED\'\"><span translate=\"COMPANY_EDIT.PAYMENTS.RETRY\"></span></md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{vm.tab13.table_translate}}\" md-limit=\"vm.tab13.query.limit\" md-page=\"vm.tab13.query.page\" md-total=\"{{vm.tab13.pagination.total}}\" md-on-paginate=\"vm.getPayments\" md-page-select=\"\"></md-table-pagination></div><div ng-if=\"vm.tab13.payments.length == 0\" translate=\"OTHER.NO_RECORDS\" class=\"text-center\"></div></div></div>");
$templateCache.put("app/main/company/edit/tabs/tab2.html","<div class=\"alert-success\" ng-if=\"vm.tab2.msg_success\">{{ vm.tab2.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.tab2.msg_error\">{{ vm.tab2.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container max-1000\" flex=\"\"><div class=\"form-title\" translate=\"COMPANY_EDIT.METHOD_LIST\"></div><div layout-gt-sm=\"row\"><md-table-container><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.NAME\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\"></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"method in vm.tab2.methods\"><td md-cell=\"\">{{method.name}}</td><td md-cell=\"\"><md-button class=\"md-raised md-accent md-button md-default-theme\" ng-click=\"vm.setDefaultMethod(method.id)\" ng-if=\"method.id != vm.tab2.default\"><span translate=\"COMPANY_EDIT.DEFAULT\"></span></md-button><div ng-if=\"method.id == vm.tab2.default\" class=\"success pl-10\" translate=\"COMPANY_EDIT.CURRENT_DEFAULT\"></div></td></tr></tbody></table></md-table-container></div></div></div>");
$templateCache.put("app/main/company/edit/tabs/tab3.html","<div class=\"alert-success\" ng-if=\"vm.tab3.msg_success\">{{ vm.tab3.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.tab3.msg_error\">{{ vm.tab3.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container max-1000\" flex=\"\"><form id=\"editCompanyTab3\" name=\"editCompanyTab3\" novalidate=\"\" ng-submit=\"vm.sendTab3()\"><div class=\"form-title\" translate=\"COMPANY_EDIT.TERM\"></div><md-radio-group ng-model=\"vm.tab3.term_days\" layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-radio-button ng-value=\"7\">7 <span translate=\"COMPANY_EDIT.DAYS\"></span></md-radio-button></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-radio-button ng-value=\"14\">14 <span translate=\"COMPANY_EDIT.DAYS\"></span></md-radio-button></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-radio-button ng-value=\"30\">30 <span translate=\"COMPANY_EDIT.DAYS\"></span></md-radio-button></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><md-radio-button ng-value=\"90\">90 <span translate=\"COMPANY_EDIT.DAYS\"></span></md-radio-button></md-input-container><div class=\"md-block\" flex-gt-sm=\"\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"20\"><md-radio-button ng-value=\"\'d\'\"></md-radio-button></md-input-container><md-input-container class=\"md-block\" flex=\"80\"><label><span translate=\"COMPANY_EDIT.OTHER\"></span></label> <input pattern=\"\\d+\" ng-model=\"vm.tab3.term_custom\" name=\"term_custom\" ng-required=\"vm.tab3.term_days==\'d\'\" ng-disabled=\"vm.tab3.term_days!=\'d\'\"><div ng-messages=\"editCompanyTab3.term_custom.$error\"><div ng-message=\"required\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"pattern\"><span translate=\"ERRORS.FORM.NUMBER\"></span></div></div></md-input-container></div></md-radio-group><div class=\"form-title\" translate=\"COMPANY_EDIT.NUMBERING_TITLE\"></div><div ng-repeat=\"(registries_key, registries) in vm.tab3.invoice_registries\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.PREFIX\"></span></label> <input ng-model=\"vm.tab3.invoice_registries[registries_key].prefix\" name=\"invoice_registries_{{registries_key}}_prefix\" ng-pattern=\"/^[a-zA-Z0-9_\\-ąęśćźżółńĄĘŚĆŹŻÓŁŃ]*$/\" ng-disabled=\"vm.tab3.invoice_registries[registries_key].is_used\" maxlength=\"10\"><div ng-messages=\"editCompanyTab3[\'invoice_registries_\'+registries_key+\'_prefix\'].$error\" role=\"alert\"><div ng-message=\"pattern\" class=\"my-message\"><span translate=\"ERRORS.FORM.PREFIX\"></span></div><div ng-message=\"maxlength\" class=\"my-message\"><span translate=\"ERRORS.FORM.MAX_10\"></span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.NUMBERING\"></span></label><md-select ng-model=\"vm.tab3.invoice_registries[registries_key].invoice_format_id\" required=\"\" name=\"invoice_registries_{{registries_key}}_invoice_format_id\" ng-if=\"!translate_loading\" ng-disabled=\"vm.tab3.invoice_registries[registries_key].is_used\" ng-change=\"vm.changeNumbering(registries_key)\"><md-option ng-value=\"type.id\" ng-repeat=\"type in vm.tab3.invoice_formats_2\">{{type.name}}</md-option></md-select><div ng-messages=\"editCompanyTab3[\'invoice_registries_\'+registries_key+\'_invoice_format_id\'].$error\" role=\"alert\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div></div></md-input-container><div class=\"md-block mt-25 mh-5\" flex-gt-sm=\"\"><span translate=\"COMPANY_EDIT.EXAMPLE\"></span>: <span>{{vm.tab3.invoice_registries[registries_key].prefix}}<span ng-if=\"vm.tab3.invoice_registries[registries_key].prefix != \'\'\">/</span>{{vm.tab3.invoice_formats[vm.tab3.invoice_registries[registries_key].invoice_format_id].example}}</span></div><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.START_NUMBER\"></span></label> <input ng-model=\"vm.tab3.invoice_registries[registries_key].start_number\" name=\"invoice_registries_{{registries_key}}_start_number\" ng-disabled=\"vm.tab3.invoice_registries[registries_key].is_used || vm.tab3.year_registry_id != vm.tab3.invoice_registries[registries_key].invoice_format_id\" type=\"number\" step=\"1\" min=\"1\"><div ng-messages=\"editCompanyTab3[\'invoice_registries_\'+registries_key+\'_start_number\'].$error\"><div ng-message=\"required\" class=\"my-message\"><span translate=\"ERRORS.FORM.REQUIRE\"></span></div><div ng-message=\"number\"><span translate=\"ERRORS.FORM.INTEGER\"></span></div><div ng-message=\"min\"><span translate=\"ERRORS.FORM.INTEGER\"></span></div><div ng-message=\"step\"><span translate=\"ERRORS.FORM.INTEGER\"></span></div></div></md-input-container></div><div class=\"border-bottom\" layout-gt-sm=\"row\" ng-if=\"vm.tab3.invoice_registries.length > 1\"><md-input-container class=\"md-block no-errors-spacer mt-5\" flex-gt-sm=\"\"><md-checkbox ng-model=\"vm.tab3.invoice_registries[registries_key].default\" name=\"invoice_registries_{{registries_key}}_default\" ng-change=\"vm.changeDefaultRegister($index)\"><span translate=\"COMPANY_EDIT.DEFAULT\"></span></md-checkbox></md-input-container><md-input-container class=\"md-block no-errors-spacer mt-0\" flex-gt-sm=\"\" layout-gt-sm=\"row\" layout-align=\"end none\"><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.delRegister(registries_key)\" aria-label=\"\" translate=\"OTHER.DELETE\" ng-disabled=\"vm.tab3.invoice_registries[registries_key].is_used\">DELETE</md-button></md-input-container></div></div><div layout-gt-sm=\"row\" layout-align=\"end none\"><md-button type=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.addRegister()\" aria-label=\"\" translate=\"COMPANY_EDIT.ADD_NEX_NUMBERING\" ng-disabled=\"vm.tab3.invoice_registries.length == 9\">ADD</md-button></div><div class=\"form-title\" translate=\"COMPANY_EDIT.COUNT_TAX\" ng-if=\"vm.tab1.form.vat_payer\"></div><div layout-gt-sm=\"row\" ng-if=\"vm.tab1.form.vat_payer\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label><span translate=\"COMPANY_EDIT.COUNT_TAX2\"></span></label><md-select ng-model=\"vm.tab3.form.default_invoice_gross_counted\" required=\"\" name=\"default_invoice_gross_counted\" ng-if=\"!translate_loading\" ng-disabled=\"!vm.tab3.vat_settings_is_editable\"><md-option ng-value=\"0\"><span translate=\"COMPANY_EDIT.FROM_NET\"></span></md-option><md-option ng-value=\"1\"><span translate=\"COMPANY_EDIT.FROM_GROSS\"></span></md-option></md-select></md-input-container><div class=\"md-block line-70\" flex-gt-sm=\"\"></div></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><span class=\"require\">*</span> <span translate=\"INFO.REQUIRE_INFO\"></span></md-input-container></div><div layout=\"row\" layout-align=\"end none\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SEND\" ng-disabled=\"editCompanyTab3.$invalid || vm.request_sending\" translate=\"OTHER.SAVE\" translate-attr-aria-label=\"OTHER.SAVE\"></md-button></div></form></div></div>");
$templateCache.put("app/main/company/edit/tabs/tab4.html","<div class=\"alert-success\" ng-if=\"vm.tab4.msg_success\">{{ vm.tab4.msg_success }}</div><div class=\"alert-error\" ng-if=\"vm.tab4.msg_error\">{{ vm.tab4.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container max-1000\" flex=\"\"><div layout=\"row\" layout-align=\"end none\"><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.newUser()\"><span translate=\"COMPANY_EDIT.USER.NEW\"></span></md-button></div><div ng-if=\"vm.tab4.users.length\" class=\"table-wrapper\"><md-table-container><table md-table=\"\" md-progress=\"vm.tab4.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"COMPANY_EDIT.USER.NAME\"></span></th><th md-column=\"\"><span translate=\"COMPANY_EDIT.USER.SURNAME\"></span></th><th md-column=\"\"><span translate=\"COMPANY_EDIT.USER.ROLE\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\">Akcje</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"user in vm.tab4.users\"><td md-cell=\"\">{{ ($index + 1) }}</td><td md-cell=\"\">{{ user.first_name }}</td><td md-cell=\"\">{{ user.last_name }}</td><td md-cell=\"\"><span translate=\"ROLES.{{ vm.tab4.roles[user.company_role_id].name }}\"></span></td><td md-cell=\"\"><a class=\"md-raised md-accent md-button md-default-theme\" href=\"/users/tokens/{{user.id}}\"><span translate=\"COMPANY_EDIT.USER.TOKENS\"></span></a><md-button class=\"md-raised md-accent md-button md-default-theme\" ng-click=\"vm.editUser($index)\" ng-if=\"vm.user.role == \'system_admin\'\"><span translate=\"OTHER.EDIT\"></span></md-button><md-button class=\"md-raised md-button md-default-theme md-warn\" ng-click=\"vm.deleteUser(user.id)\" ng-if=\"vm.tab4.roles[user.company_role_id].name != \'owner\'\"><span translate=\"OTHER.DELETE\"></span></md-button></td></tr></tbody></table></md-table-container></div><div ng-if=\"vm.tab4.users.length == 0\" translate=\"OTHER.NO_RECORDS\" class=\"text-center\"></div></div></div>");
$templateCache.put("app/main/invoices/form/profile-alert/profile-alert.html","<md-dialog aria-label=\"METHOD\"><div id=\"profile-alert-dialog\"><h1 translate=\"INVOICES_FORM.PROFILE_ALERT.NO_DATA\"></h1><p translate=\"INVOICES_FORM.PROFILE_ALERT.INFO\"></p><div layout=\"row\" layout-align=\"end none\"><md-button class=\"md-raised md-accent md-button md-default-theme\" ng-click=\"vm.goEdit()\" translate=\"INVOICES_FORM.PROFILE_ALERT.EDIT\"></md-button></div></div></md-dialog>");
$templateCache.put("app/main/invoices/list/zip_download_dialog/zip_download_dialog.html","<md-dialog class=\"invoices-zip-download-dialog\"><md-dialog-content><div class=\"content text-center\"><div class=\"table-wrapper mt-20\"><md-table-container><table md-table=\"\" md-progress=\"vm.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"id\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\" width=\"90%\"><span translate=\"INVOICES_ZIP_DOWNLOAD_DIALOG.NAME\"></span></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"package in vm.packages\" ng-if=\"vm.packages.length\"><td md-cell=\"\">{{ vm.pagination | no:$index }}</td><td md-cell=\"\">{{ package.file_name }}</td><td md-cell=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.downloadPackage(package.id)\"><md-icon md-font-icon=\"icon-download\"><md-tooltip><span translate=\"INVOICES_ZIP_DOWNLOAD_DIALOG.DOWNLOAD\"></span></md-tooltip></md-icon></md-button></td></tr><tr md-row=\"\" ng-if=\"!vm.packages.length && !vm.loading\" class=\"grey-200-bg\"><td md-cell=\"\" colspan=\"3\"><div class=\"text-center pt-20\"><span class=\"grey-600-fg\" translate=\"INVOICES_ZIP_DOWNLOAD_DIALOG.NO_PACKAGES\"></span><br><md-button ng-click=\"vm.getPackages()\" translate=\"INVOICES_ZIP_DOWNLOAD_DIALOG.REFRESH\"></md-button></div></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{vm.table_translate}}\" md-limit=\"vm.query.limit\" md-page=\"vm.query.page\" md-total=\"{{vm.pagination.total}}\" md-on-paginate=\"vm.getPackages\" md-page-select=\"\"></md-table-pagination></div><p class=\"info\" translate=\"INVOICES_ZIP_DOWNLOAD_DIALOG.DOWNLOAD_AVAILABLE_BY_DAYS\"></p></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.hide()\" class=\"md-raised md-accent\"><span translate=\"OTHER.CLOSE\"></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoices/list/zip_pending_dialog/zip_pending_dialog.html","<md-dialog class=\"invoices-zip-dialog\"><md-dialog-content><div class=\"content text-center\"><md-icon md-font-icon=\"icon-check-circle\" class=\"icon icon-flat s64 green-600-fg\"></md-icon><p><span translate=\"INVOICES_ZIP_PENDING_DIALOG.INFO\"></span><br><span translate=\"INVOICES_ZIP_PENDING_DIALOG.ACTION_INFO\"></span></p></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.hide()\"><span translate=\"OTHER.CLOSE\"></span></md-button><md-button ng-click=\"vm.accept()\" class=\"md-raised md-accent\"><span translate=\"INVOICES_ZIP_PENDING_DIALOG.INVOICES_ZIPS\"></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/registry-sales/list/tab/tab1.html","<div class=\"alert-error\" ng-if=\"vm.tab1.msg_error\">{{ vm.tab1.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><div layout=\"row\"><div layout=\"row\" layout-align=\"start center\" flex=\"100\"><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.tab1.pdfInvoices()\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.GENERATE_PDF\"></span></md-button><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.tab1.csvInvoices()\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.GENERATE_CSV\"></span></md-button><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.tab1.jpkFa()\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.JPK_FA\"></span></md-button><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.tab1.downloadSales()\" ng-if=\"vm.download_sales\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.DOWNLOAD_SALE\"></span></md-button></div></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.INVOICES_LIST.MONTH\"></span></label><md-select ng-model=\"vm.tab1.query.month\"><md-option ng-value=\"n\" ng-repeat=\"n in range(1, 12)\"><span translate=\"MONTHS.{{n}}\"></span></md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.INVOICES_LIST.YEAR\"></span></label><md-select ng-model=\"vm.tab1.query.year\"><md-option ng-value=\"n\" ng-repeat=\"n in range_r(2016, vm.current_year)\">{{n}}</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.tab1.currencies && vm.tab1.currencies.length\" class=\"md-block\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.INVOICES_LIST.CURRENCY\"></span></label><md-select ng-model=\"vm.tab1.query.currency\"><md-option ng-value=\"null\">{{ \'REGISTRY_SALES.INVOICES_LIST.ALL\' | translate }}</md-option><md-option ng-value=\"currency.code\" ng-repeat=\"currency in vm.tab1.currencies\">{{currency.code}} - {{currency.name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.INVOICES_LIST.VAT_SUM\"></span></label><md-select ng-model=\"vm.tab1.query.vat_rate_id\" name=\"vat_rate_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"null\"><span translate=\"OTHER.ALL\"></span></md-option><md-option ng-value=\"tax.id\" ng-repeat=\"tax in vm.tab1.taxes\">{{tax.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.INVOICES_LIST.TYPE\"></span></label><md-select ng-model=\"vm.tab1.query.invoice_type_id\" name=\"invoice_type_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"null\"><span translate=\"OTHER.ALL\"></span></md-option><md-option ng-value=\"type.id\" ng-repeat=\"type in vm.tab1.invoice_types\">{{type.description}}</md-option></md-select></md-input-container><div layout=\"row\" layout-align=\"start center\" flex-gt-xs=\"33\"><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.tab1.getInvoices()\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.SEARCH\"></span></md-button></div></div><div ng-if=\"vm.tab1.pagination.total\" class=\"table-wrapper\"><md-table-container><table md-table=\"\" md-progress=\"vm.tab1.promise\"><thead md-head=\"\" md-order=\"vm.tab1.query.sort\" md-on-reorder=\"vm.tab1.getOnlineSales\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.DATE\"></span></th><th md-column=\"\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.DATE_SALE\"></span></th><th md-column=\"\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.NUMBER\"></span></th><th md-column=\"\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.CONTRACTOR\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.VAT\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.PRICE_NET\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.VAT_SUM\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.PRICE_GROSS\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!vat_payer\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.PRICE\"></span></th><th md-column=\"\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.CURRENCY\"></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"invoice in vm.tab1.invoices\"><td md-cell=\"\">{{ vm.tab1.pagination | no:$index }}</td><td md-cell=\"\">{{ invoice.issue_date }}</td><td md-cell=\"\">{{ invoice.sale_date }}</td><td md-cell=\"\">{{ invoice.number }}</td><td md-cell=\"\">{{ invoice.name }}</td><td md-cell=\"\" ng-if=\"vat_payer\"><div class=\"m-10 no-wrap\" ng-repeat=\"tax in invoice.taxes.data\">{{tax.vat_rate_name}}</div></td><td md-cell=\"\" ng-if=\"vat_payer\"><div class=\"m-10 no-wrap\" ng-repeat=\"tax in invoice.taxes.data\">{{tax.price_net.toFixed(2) | numFormat}}</div></td><td md-cell=\"\" ng-if=\"vat_payer\"><div class=\"m-10 no-wrap\" ng-repeat=\"tax in invoice.taxes.data\">{{tax.vat_sum.toFixed(2) | numFormat}}</div></td><td md-cell=\"\"><div class=\"m-10 no-wrap\" ng-repeat=\"tax in invoice.taxes.data\">{{tax.price_gross.toFixed(2) | numFormat}}</div></td><td md-cell=\"\">{{ invoice.currency }}</td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{vm.tab1.table_translate}}\" md-limit=\"vm.tab1.query.limit\" md-page=\"vm.tab1.query.page\" md-total=\"{{vm.tab1.pagination.total}}\" md-on-paginate=\"vm.tab1.getInvoices\" md-page-select=\"\"></md-table-pagination></div><div layout=\"row\" ng-if=\"vm.tab1.pagination.total == 0\" translate=\"OTHER.NO_RECORDS\" class=\"text-center\"></div><div class=\"font-size-16 mt-10\"><div class=\"bold\" translate=\"REGISTRY_SALES.INVOICES_LIST.SUMMARY\"></div><div ng-if=\"!vat_payer\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.SUM\"></span>: {{vm.tab1.reports.price_gross.toFixed(2) | numFormat}}zł</div><div ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.SUM_GROSS\"></span>: {{vm.tab1.reports.price_gross.toFixed(2) | numFormat}}zł</div><div ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.SUM_NET\"></span>: {{vm.tab1.reports.price_net.toFixed(2) | numFormat}}zł</div><div ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.INVOICES_LIST.VAT_SUM\"></span>: {{vm.tab1.reports.vat_sum.toFixed(2) | numFormat}}zł</div></div></div></div>");
$templateCache.put("app/main/registry-sales/list/tab/tab2.html","<div class=\"alert-error\" ng-if=\"vm.tab2.msg_error\">{{ vm.tab2.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><div layout=\"row\"><div layout=\"row\" layout-align=\"start center\" flex=\"100\"><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.tab2.pdfOnlineSales()\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.GENERATE_PDF\"></span></md-button></div></div><div layout=\"row\"><md-input-container class=\"md-block no-errors-spacer\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.MONTH\"></span></label><md-select ng-model=\"vm.tab2.query.month\"><md-option ng-value=\"n\" ng-repeat=\"n in range(1, 12)\"><span translate=\"MONTHS.{{n}}\"></span></md-option></md-select></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.YEAR\"></span></label><md-select ng-model=\"vm.tab2.query.year\"><md-option ng-value=\"n\" ng-repeat=\"n in range_r(2016, vm.current_year)\">{{n}}</md-option></md-select></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.TRANSACTION_NUMBER\"></span></label> <input ng-model=\"vm.tab2.query.transaction_number\" name=\"transaction_number\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block no-errors-spacer\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.NUMBER\"></span></label> <input ng-model=\"vm.tab2.query.number\" name=\"number\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.EMAIL\"></span></label> <input ng-model=\"vm.tab2.query.email\" name=\"email\"></md-input-container><div layout=\"row\" layout-align=\"start center\" flex-gt-xs=\"33\"><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.tab2.getOnlineSales()\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.SEARCH\"></span></md-button></div></div><div ng-if=\"vm.tab2.pagination.total\" class=\"table-wrapper\"><md-table-container><table md-table=\"\" md-progress=\"vm.tab2.promise\"><thead md-head=\"\" md-order=\"vm.tab2.query.sort\" md-on-reorder=\"vm.tab2.getOnlineSales\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.NUMBER\"></span></th><th md-column=\"\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.TRANSACTION_NUMBER\"></span></th><th md-column=\"\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.EMAIL\"></span></th><th md-column=\"\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.CREATED\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.PRICE_NET\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.PRICE_GROSS\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.VAT_SUM\"></span></th>th md-column md-numeric ng-if=\"!vat_payer\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.PRICE\"></span><th md-column=\"\"><span translate=\"OTHER.ACTION\">Akcje</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"sale in vm.tab2.online_sales\"><td md-cell=\"\">{{ vm.tab2.pagination | no:$index }}</td><td md-cell=\"\">{{ sale.number }}</td><td md-cell=\"\">{{ sale.transaction_number }}</td><td md-cell=\"\">{{ sale.email }}</td><td md-cell=\"\">{{ sale.sale_date }}</td><td md-cell=\"\" ng-if=\"vat_payer\">{{ sale.price_net.toFixed(2) | numFormat}}zł</td><td md-cell=\"\">{{ sale.price_gross.toFixed(2) | numFormat}}zł</td><td md-cell=\"\" ng-if=\"vat_payer\">{{ sale.vat_sum.toFixed(2) | numFormat}}zł</td><td md-cell=\"\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.tab2.detailsOnlineSales(sale.id)\" aria-label=\"Show\"><span translate=\"OTHER.DETAILS\"></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{vm.tab2.table_translate}}\" md-limit=\"vm.tab2.query.limit\" md-page=\"vm.tab2.query.page\" md-total=\"{{vm.tab2.pagination.total}}\" md-on-paginate=\"vm.tab2.getOnlineSales\" md-page-select=\"\"></md-table-pagination></div><div layout=\"row\" ng-if=\"vm.tab2.pagination.total == 0\" translate=\"OTHER.NO_RECORDS\" class=\"text-center\"></div><div class=\"font-size-16 mt-10\"><div class=\"bold\" translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.SUMMARY\"></div><div ng-if=\"!vat_payer\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.SUM\"></span>: {{vm.tab2.reports.price_gross_report.toFixed(2) | numFormat}}zł</div><div ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.SUM_GROSS\"></span>: {{vm.tab2.reports.price_gross_report.toFixed(2) | numFormat}}zł</div><div ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.SUM_NET\"></span>: {{vm.tab2.reports.price_net_report.toFixed(2) | numFormat}}zł</div><div ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.ONLINE_SALES_LIST.VAT_SUM\"></span>: {{vm.tab2.reports.vat_sum_report.toFixed(2) | numFormat}}zł</div></div></div></div>");
$templateCache.put("app/main/registry-sales/list/tab/tab3.html","<div class=\"alert-error\" ng-if=\"vm.tab3.msg_error\">{{ vm.tab3.msg_error }}</div><div layout=\"row\"><div class=\"form-wrapper rounded-container min-1000\"><div layout=\"row\"><md-input-container class=\"md-block no-errors-spacer\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.MONTH\"></span></label><md-select ng-model=\"vm.tab3.query.month\"><md-option ng-value=\"n\" ng-repeat=\"n in range(1, 12)\"><span translate=\"MONTHS.{{n}}\"></span></md-option></md-select></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.YEAR\"></span></label><md-select ng-model=\"vm.tab3.query.year\"><md-option ng-value=\"n\" ng-repeat=\"n in range_r(2016, vm.current_year)\">{{n}}</md-option></md-select></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.PAYMENTS_METHOD\"></span></label><md-select ng-model=\"vm.tab3.query.payment_method_id\" required=\"\" name=\"payment_method_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"payments_method.id\" ng-repeat=\"payments_method in vm.tab3.payments_method2\">{{payments_method.name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block no-errors-spacer\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.TRANSACTION_NUMBER\"></span></label> <input ng-model=\"vm.tab3.query.transaction_number\" name=\"transaction_number\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.NUMBER\"></span></label> <input ng-model=\"vm.tab3.query.number\" name=\"number\"></md-input-container><md-input-container class=\"md-block no-errors-spacer\" flex-gt-xs=\"33\"><label><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.USERS\"></span></label><md-select ng-model=\"vm.tab3.query.user_id\" required=\"\" name=\"user_id\" ng-if=\"!translate_loading\"><md-option ng-value=\"null\"></md-option><md-option ng-value=\"user.id\" ng-repeat=\"user in vm.tab3.users\">{{user.first_name}} {{user.last_name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><div layout=\"row\" layout-align=\"end center\" flex=\"100\"><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.tab3.pdfReceipts()\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.GENERATE_PDF\"></span></md-button><md-button class=\"md-raised md-button md-default-theme md-accent\" ng-click=\"vm.tab3.getReceipts()\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.SEARCH\"></span></md-button></div></div><div ng-if=\"vm.tab3.pagination.total\" class=\"table-wrapper\"><md-table-container><table md-table=\"\" md-progress=\"vm.tab3.promise\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"><span translate=\"OTHER.No\">Lp.</span></th><th md-column=\"\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.NUMBER\"></span></th><th md-column=\"\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.TRANSACTION_NUMBER\"></span></th><th md-column=\"\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.CREATED\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.PRICE_NET\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.PRICE_GROSS\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.VAT_SUM\"></span></th><th md-column=\"\" md-numeric=\"\" ng-if=\"!vat_payer\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.PRICE_GROSS\"></span></th><th md-column=\"\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.METHOD\"></span></th><th md-column=\"\"><span translate=\"OTHER.ACTION\">Akcje</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"receipt in vm.tab3.receipts\"><td md-cell=\"\">{{ vm.tab3.pagination | no:$index }}</td><td md-cell=\"\">{{ receipt.number }}</td><td md-cell=\"\">{{ receipt.transaction_number }}</td><td md-cell=\"\">{{ receipt.sale_date }}</td><td md-cell=\"\" ng-if=\"vat_payer\">{{ receipt.price_net.toFixed(2) | numFormat}}zł</td><td md-cell=\"\">{{ receipt.price_gross.toFixed(2) | numFormat}}zł</td><td md-cell=\"\" ng-if=\"vat_payer\">{{ receipt.vat_sum.toFixed(2) | numFormat}}zł</td><td md-cell=\"\">{{ vm.tab3.payments_method[receipt.payment_method_id].name }}</td><td md-cell=\"\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.tab3.detailsReceipts(receipt.id)\"><span translate=\"OTHER.DETAILS\"></span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{vm.tab3.table_translate}}\" md-limit=\"vm.tab3.query.limit\" md-page=\"vm.tab3.query.page\" md-total=\"{{vm.tab3.pagination.total}}\" md-on-paginate=\"vm.tab3.getReceipts\" md-page-select=\"\"></md-table-pagination></div><div layout=\"row\" ng-if=\"vm.tab3.pagination.total == 0\" translate=\"OTHER.NO_RECORDS\" class=\"text-center\"></div><div class=\"font-size-16\"><div class=\"bold\" translate=\"REGISTRY_SALES.RECEIPTS_LIST.SUMMARY\"></div><div ng-if=\"!vat_payer\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.SUM\"></span>: {{vm.tab3.reports.price_gross_report.toFixed(2) | numFormat}}zł</div><div ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.SUM_GROSS\"></span>: {{vm.tab3.reports.price_gross_report.toFixed(2) | numFormat}}zł</div><div ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.SUM_NET\"></span>: {{vm.tab3.reports.price_net_report.toFixed(2) | numFormat}}zł</div><div ng-if=\"vat_payer\"><span translate=\"REGISTRY_SALES.RECEIPTS_LIST.VAT_SUM\"></span>: {{vm.tab3.reports.vat_sum_report.toFixed(2) | numFormat}}zł</div></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\"><div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div class=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button class=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" layout-align=\"space-between\" layout-fill=\"\" flex=\"\"><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" ng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" aria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/agile/backlog/dialogs/task/task-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label translate=\"BACKLOG.TITLE\">Title</label> <input name=\"title\" ng-model=\"vm.task.title\" required=\"\"><div ng-messages=\"taskForm.title.$error\" ng-show=\"taskForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BACKLOG.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><div class=\"tags\"><label translate=\"BACKLOG.TAGS\">Tags</label><md-chips ng-model=\"vm.task.tags\" md-transform-chip=\"vm.newTag($chip)\"><md-chip-template><span ng-if=\"$chip.color\" class=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> <span>{{$chip.label}}</span></md-chip-template></md-chips></div><div layout-sm=\"column\" layout=\"row\"><div flex=\"\" class=\"date-container\"><label translate=\"BACKLOG.START_DATE\">Start Date</label><md-datepicker flex=\"\" ng-model=\"vm.task.startDate\" md-placeholder=\"Start Date\"></md-datepicker></div><div flex=\"\" class=\"date-container\"><label translate=\"BACKLOG.DUE_DATE\">Due Date</label><md-datepicker flex=\"\" ng-model=\"vm.task.dueDate\" md-placeholder=\"Due Date\"></md-datepicker></div></div><div class=\"notes\"><label translate=\"BACKLOG.NOTES\">Notes</label><text-angular ng-model=\"vm.task.notes\"></text-angular></div><div class=\"attachment-list\"><div class=\"attachment\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"filename\">attachment-2.doc</span> <span class=\"size\">(12 Kb)</span></div><md-button class=\"md-icon-button\"><md-icon md-font-icon=\"icon-close\" aria-label=\"delete attachment\" class=\"s16\"></md-icon></md-button></div><div class=\"attachment\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"filename\">attachment-1.jpg</span> <span class=\"size\">(350 Kb)</span></div><md-button class=\"md-icon-button\" aria-label=\"Delete attachment\" translate=\"\" translate-attr-aria-label=\"BACKLOG.DELETE_ATTACHMENT\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newTask\" ng-click=\"vm.saveTask()\" class=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"SAVE\" translate=\"BACKLOG.SAVE\" translate-attr-aria-label=\"BACKLOG.SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newTask\" ng-click=\"vm.addNewTask()\" class=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Add Task\" translate=\"BACKLOG.ADD_TASK\" translate-attr-aria-label=\"BACKLOG.ADD_TASK\">ADD TASK</md-button><md-button class=\"md-icon-button\" aria-label=\"Attach file\" translate=\"\" translate-attr-aria-label=\"BACKLOG.ATTACH_FILE\"><md-icon md-font-icon=\"icon-paperclip\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Insert picture\" translate=\"\" translate-attr-aria-label=\"BACKLOG.INSERT_PICTURE\"><md-icon md-font-icon=\"icon-file-image-box\"></md-icon></md-button></div><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteTask($event)\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"BACKLOG.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"BACKLOG.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/agile/backlog/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"BACKLOG.TO_DO\">To-Do</span></div><md-select class=\"project-selection simplified\" ng-model=\"vm.selectedProject\" placeholder=\"Select Project\"><md-option ng-repeat=\"(project, title) in vm.projects\" value=\"{{project}}\">{{title}}</md-option></md-select></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"add-task-button\"><md-button class=\"md-accent md-raised\" ng-click=\"vm.openTaskDialog($event)\" aria-label=\"ADD TASK\" translate=\"BACKLOG.ADD_TASK\" translate-attr-aria-label=\"BACKLOG.ADD_TASK\">ADD TASK</md-button></div><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"All Tasks\" translate=\"\" translate-attr-aria-label=\"BACKLOG.ALL_TASKS\" ng-class=\"{\'selected\':vm.showAllTasks}\" ng-click=\"vm.resetFilters()\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"BACKLOG.ALL_TASKS\">All Tasks</span></div></md-button><div class=\"item subheader\" translate=\"BACKLOG.FILTERS\">Filters</div><md-button class=\"item\" aria-label=\"Starred\" translate=\"\" translate-attr-aria-label=\"BACKLOG.STARRED\" ng-click=\"vm.toggleFilterWithEmpty(\'starred\')\" ng-class=\"{\'selected\':vm.taskFilters.starred}\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><span class=\"title\" translate=\"BACKLOG.STARRED\">Starred</span></md-button><md-button class=\"item\" aria-label=\"Priority\" translate=\"\" translate-attr-aria-label=\"BACKLOG.PRIORITY\" ng-click=\"vm.toggleFilterWithEmpty(\'important\')\" ng-class=\"{\'selected\':vm.taskFilters.important}\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span class=\"title\" translate=\"BACKLOG.PRIORITY\">Priority</span></md-button><md-button class=\"item\" aria-label=\"Scheduled\" translate=\"\" translate-attr-aria-label=\"BACKLOG.SCHEDULED\" ng-click=\"vm.toggleFilterWithEmpty(\'dueDate\')\" ng-class=\"{\'selected\':vm.taskFilters.dueDate}\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><span class=\"title\" translate=\"BACKLOG.SCHEDULED\">Scheduled</span></md-button><md-button class=\"item\" aria-label=\"Today\" translate=\"\" translate-attr-aria-label=\"BACKLOG.TODAY\" ng-click=\"vm.toggleFilterWithEmpty(\'startDate\')\" ng-class=\"{\'selected\':vm.taskFilters.startDate}\"><md-icon md-font-icon=\"icon-calendar-today\" class=\"s16\"></md-icon><span class=\"title\" translate=\"BACKLOG.TODAY\">Today</span></md-button><md-button class=\"item\" aria-label=\"Done\" translate=\"\" translate-attr-aria-label=\"BACKLOG.DONE\" ng-click=\"vm.toggleFilterWithEmpty(\'completed\')\" ng-class=\"{\'selected\':vm.taskFilters.completed}\"><md-icon md-font-icon=\"icon-check\" class=\"s16\"></md-icon><span class=\"title\" translate=\"BACKLOG.DONE\">Done</span></md-button><md-button class=\"item\" aria-label=\"Deleted\" translate=\"\" translate-attr-aria-label=\"BACKLOG.DELETED\" ng-click=\"vm.toggleFilter(\'deleted\')\" ng-class=\"{\'selected\':vm.taskFilters.deleted}\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><span class=\"title\" translate=\"BACKLOG.DELETED\">Deleted</span></md-button><div class=\"item subheader\" translate=\"BACKLOG.TAGS\">Tags</div><md-button class=\"tag item\" aria-label=\"tag {{tag.label}}\" ng-repeat=\"tag in vm.tags\" ng-click=\"vm.toggleTagFilter(tag)\" ng-class=\"{\'selected\':vm.isTagFilterExists(tag)}\"><md-icon md-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : tag.color}\"></md-icon><span class=\"title\">{{tag.label}}</span></md-button></div></md-content>");
$templateCache.put("app/main/agile/backlog/views/list/list-view.html","<div class=\"sprint md-whiteframe-4dp\" layout=\"column\"><div class=\"sprint-handle\" ng-click=\"vm.preventDefault($event)\" flex=\"\"><md-icon md-font-icon=\"icon-drag-horizontal\" class=\"icon\"></md-icon><div class=\"title\">Sprint 1</div></div><div class=\"backlog-items\" flex=\"\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.tasks.sprint_1\" ng-class=\"{\'sortable\': vm.taskOrder === \'\'}\"><div class=\"backlog-item\" md-ink-ripple=\"\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.openTaskDialog($event, task)\" ng-repeat=\"task in vm.tasks.sprint_1| orderBy:vm.taskOrder:vm.taskOrderDescending track by $index\" ng-class=\"{\'starred\': task.starred, \'selected\': task.selected, \'completed\': task.completed}\"><div class=\"handle\" ng-click=\"vm.preventDefault($event)\"><md-icon md-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon></div><div layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"info\" flex=\"\"><div class=\"code\">{{task.code}} <span class=\"title\" flex=\"\">{{task.title}}</span></div><div class=\"notes\">{{task.notes}}</div></div></div></div></div></div><div class=\"sprint md-whiteframe-4dp\" layout=\"column\"><div class=\"sprint-handle\" ng-click=\"vm.preventDefault($event)\" flex=\"\"><md-icon md-font-icon=\"icon-drag-horizontal\" class=\"icon\"></md-icon><div class=\"title\">Sprint 2</div></div><div class=\"backlog-items\" flex=\"\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.tasks.sprint_2\" ng-class=\"{\'sortable\': vm.taskOrder === \'\'}\"><div class=\"backlog-item\" md-ink-ripple=\"\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.openTaskDialog($event, task)\" ng-repeat=\"task in vm.tasks.sprint_2| orderBy:vm.taskOrder:vm.taskOrderDescending track by $index\" ng-class=\"{\'starred\': task.starred, \'selected\': task.selected, \'completed\': task.completed}\"><div class=\"handle\" ng-click=\"vm.preventDefault($event)\"><md-icon md-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon></div><div layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"info\" flex=\"\"><div class=\"code\">{{task.code}} <span class=\"title\" flex=\"\">{{task.title}}</span></div><div class=\"notes\">{{task.notes}}</div></div></div></div></div></div><div class=\"sprint-backlog md-whiteframe-4dp\" layout=\"column\"><div class=\"sprint-handle\" ng-click=\"vm.preventDefault($event)\" flex=\"\"><div class=\"title\">Backlog</div></div><div class=\"backlog-items\" flex=\"\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.tasks.backlog\" ng-class=\"{\'sortable\': vm.taskOrder === \'\'}\"><div class=\"backlog-item\" md-ink-ripple=\"\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.openTaskDialog($event, task)\" ng-repeat=\"task in vm.tasks.backlog| orderBy:vm.taskOrder:vm.taskOrderDescending track by $index\" ng-class=\"{\'starred\': task.starred, \'selected\': task.selected, \'completed\': task.completed}\"><div class=\"handle\" ng-click=\"vm.preventDefault($event)\"><md-icon md-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon></div><div layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"info\" flex=\"\"><div class=\"code\">{{task.code}} <span class=\"title\" flex=\"\">{{task.title}}</span></div><div class=\"notes\">{{task.notes}}</div></div></div></div></div></div>");
$templateCache.put("app/main/agile/scrumboard/dialogs/card/card-dialog.html","<md-dialog class=\"card-dialog\" aria-label=\"Card Dialog\"><md-toolbar class=\"md-accent\" ng-class=\"\'md-\' + vm.board.settings.color + \'-bg\'\"><div class=\"md-toolbar-tools\"><div class=\"due-date\"><div ng-if=\"!vm.card.due\" moment-picker=\"vm.card.due\" format=\"x\" min-view=\"year\" max-view=\"hour\" start-view=\"month\"><md-button class=\"md-icon-button\" aria-label=\"Due date\" translate=\"\" translate-attr-aria-label=\"SB.DUE_DATE\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-calendar\"></md-icon></md-button></div></div><md-menu ng-if=\"vm.card.due\" md-offset=\"0 48\" class=\"remove-due-date\"><md-button class=\"md-icon-button\" aria-label=\"Members\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-calendar\"></md-icon></md-button><md-menu-content class=\"remove-due-date-menu-content\" width=\"4\" ms-scroll=\"\"><md-menu-item><md-button ng-click=\"vm.card.due = \'\'\" aria-label=\"remove due date\" translate-attr-aria-label=\"SB.REMOVE_DUE_DATE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"SB.REMOVE_DUE_DATE\">Remove Due Date</span></md-button></md-menu-item></md-menu-content></md-menu><md-menu md-offset=\"0 48\" class=\"labels\"><md-button class=\"md-icon-button\" aria-label=\"Label\" translate=\"\" translate-attr-aria-label=\"SB.LABEL\" ng-click=\"vm.labelTabIndex = 0; $mdMenu.open($event)\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-label-outline\"></md-icon></md-button><md-menu-content class=\"labels-menu-content\" width=\"4\" ms-scroll=\"\"><md-tabs md-selected=\"vm.labelTabIndex\" md-dynamic-height=\"\"><md-tab><md-tab-body><md-menu-item><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Search labels...\" type=\"text\" ng-model=\"vm.labelSearchText\" autocomplete=\"off\" translate-attr-palceholder=\"SB.SEARCH_LABELS\"></md-input-container></md-menu-item><md-menu-item class=\"label\" ng-repeat=\"label in vm.labels| filter: vm.filterLabel\"><md-button class=\"label-toggle-button\" md-prevent-menu-close=\"\" ng-class=\"\'md-\' + label.color + \'-bg\'\" ng-click=\"vm.toggleInArray(label.id, vm.card.idLabels)\" aria-label=\"Toggle Label\" translate=\"\" translate-attr-aria-label=\"SB.TOGGLE_LABEL\"><div layout=\"row\" layout-align=\"space-between center\"><span>{{label.name}}</span> <i ng-if=\"vm.exists(label.id, vm.card.idLabels)\" class=\"icon-check s16\"></i></div></md-button><md-button class=\"md-icon-button label-edit-button\" md-prevent-menu-close=\"\" ng-click=\"vm.editLabelId = label.id; vm.labelTabIndex = 2\" aria-label=\"Edit Label\" translate=\"\" translate-attr-aria-label=\"SB.EDIT_LABEL\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button class=\"add-label-button\" md-prevent-menu-close=\"\" ng-click=\"vm.labelTabIndex = 1\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span translate=\"SB.ADD_NEW_LABEL\">Add new label</span></md-button></md-menu-item></md-tab-body></md-tab><md-tab><md-tab-body><div class=\"add-label-tab-content\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close=\"\" ng-click=\"vm.labelTabIndex = 0\" aria-label=\"Back\" translate=\"\" translate-attr-aria-label=\"SB.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span flex=\"\" translate=\"SB.CREATE_LABEL\">Create Label</span></div><div class=\"content\" layout=\"column\" layout-align=\"start stretch\"><form ng-submit=\"vm.addNewLabel(); vm.labelTabIndex = 0\" layout=\"column\"><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.newLabelName\" translate=\"\" translate-attr-placeholder=\"SB.LABEL_NAME\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" layout-wrap=\"\"><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" aria-label=\"{{palette}}\"> <i class=\"icon-check s18\" ng-if=\"vm.newLabelColor === palette\"></i></label></div><md-button type=\"submit\" md-prevent-menu-close=\"\" class=\"create-button md-accent md-raised\" aria-label=\"Create\" translate=\"\" translate-attr-aria-label=\"SB.CREATE\"><span translate=\"SB.CREATE\">Create</span></md-button></form></div></div></md-tab-body></md-tab><md-tab><md-tab-body><div class=\"edit-label-tab-content\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close=\"\" ng-click=\"vm.labelTabIndex = 0\" aria-label=\"back\" translate=\"\" translate-attr-aria-label=\"SB.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span flex=\"\" translate=\"SB.EDIT_LABEL\">Edit Label</span></div><div class=\"content\" layout=\"column\" layout-align=\"start stretch\"><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.board.labels.getById(vm.editLabelId).name\" translate=\"\" translate-attr-placeholder=\"SB.LABEL_NAME\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" layout-wrap=\"\"><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.board.labels.getById(vm.editLabelId).color\" ng-value=\"palette\" aria-label=\"{{palette}}\"> <i ng-if=\"vm.board.labels.getById(vm.editLabelId).color === palette\" class=\"icon-check s18\"></i></label></div><div layout=\"row\" layout-align=\"end center\" flex=\"\"><md-button class=\"remove-button md-icon-button\" type=\"submit\" md-prevent-menu-close=\"\" ng-click=\"vm.removeLabel(); vm.labelTabIndex = 0\" aria-label=\"remove\" translate=\"\" translate-attr-aria-label=\"SB.REMOVE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div></md-tab-body></md-tab></md-tabs></md-menu-content></md-menu><md-menu md-offset=\"0 48\" class=\"members\"><md-button class=\"md-icon-button\" aria-label=\"Members\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-account-multiple\"></md-icon></md-button><md-menu-content class=\"members-menu-content\" width=\"4\" ms-scroll=\"\"><md-menu-item><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Search members...\" autocomplete=\"off\" type=\"text\" ng-model=\"vm.memberSearchText\" translate=\"\" translate-attr-placeholder=\"SB.SEARCH_MEMBERS\"></md-input-container></md-menu-item><md-menu-item class=\"member\" ng-repeat=\"member in vm.members| filter: vm.filterMember\"><md-button ng-click=\"vm.toggleInArray(member.id, vm.card.idMembers)\" md-prevent-menu-close=\"\" aria-label=\"toggle member\" translate=\"\" translate-attr-aria-label=\"SB.TOGGLE_MEMBER\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><img alt=\"{{ member.name}}\" ng-src=\"{{ member.avatar}}\" class=\"avatar\"><p class=\"member-name\">{{ member.name}}</p></div><i class=\"icon-check s16\" ng-if=\"vm.exists(member.id, vm.card.idMembers)\"></i></div></md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-click=\"\" aria-label=\"Attachment\" translate=\"\" translate-attr-aria-label=\"SB.ATTACHMENT\"><md-icon md-font-icon=\"icon-attachment\"></md-icon></md-button><md-menu md-offset=\"0 48px\" class=\"checklist\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"checklist\" translate=\"\" translate-attr-aria-label=\"SB.CHECKLIST\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-menu-content class=\"checklist-menu-content\" width=\"4\"><form ng-submit=\"vm.createCheckList()\" layout=\"column\" layout-align=\"start end\"><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Checklist Title\" autocomplete=\"off\" type=\"text\" ng-model=\"vm.newCheckListTitle\" translate=\"\" translate-attr-placeholder=\"SB.CHECKLIST_TITLE\"></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Add Checklist\" translate=\"\" translate-attr-aria-label=\"SB.ADD_CHECKLIST\"><span translate=\"SB.ADD_CHECKLIST\">Add Checklist</span></md-button></form></md-menu-content></md-menu><md-menu md-offset=\"0 48px\" class=\"subscribe\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Subscribe\" translate=\"\" translate-attr-aria-label=\"SB.SUBSCRIBE\"><md-icon md-menu-origin=\"\" ng-if=\"vm.card.subscribed\" md-font-icon=\"icon-eye\"></md-icon><md-icon md-menu-origin=\"\" ng-if=\"!vm.card.subscribed\" md-font-icon=\"icon-eye-off\"></md-icon></md-button><md-menu-content class=\"subscribe-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.card.subscribed = !vm.card.subscribed\" aria-label=\"Subscribed\" translate=\"\" translate-attr-aria-label=\"SB.SUBSCRIBED\"><span ng-if=\"!vm.card.subscribed\" translate=\"SB.SUBSCRIBE\">Subscribe</span> <span ng-if=\"vm.card.subscribed\" translate=\"SB.UNSUBSCRIBE\">Unsubscribe</span></md-button></md-menu-item></md-menu-content></md-menu><md-menu md-offset=\"0 48px\" class=\"options\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Options\" translate=\"\" translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.removeCard()\" aria-label=\"Remove Card\" translate=\"\" translate-attr-aria-label=\"SB.REMOVE_CARD\"><md-icon md-font-icon=\"icon-delete\" md-menu-align-target=\"\"></md-icon><span translate=\"SB.REMOVE_CARD\">Remove Card</span></md-button></md-menu-item></md-menu-content></md-menu><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close Dialog\" translate=\"\" translate-attr-aria-label=\"SB.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout=\"row\" layout-align=\"space-between start\"><div layout=\"row\" layout-align=\"start start\"><div layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.card.subscribed\" class=\"card-subscribe s18\" md-font-icon=\"icon-eye\"></md-icon><div class=\"card-name\"><span>{{vm.card.code}}</span></div></div><div class=\"card-breadcrumb\" layout=\"row\" layout-align=\"start center\"><span>{{vm.board.name}}</span> <i class=\"icon-menu-right\"></i> <span>{{vm.getCardList().name}}</span></div></div><div ng-if=\"vm.card.due\" class=\"due-date\" layout=\"row\" layout-align=\"start center\"><div class=\"picker day-picker\" moment-picker=\"vm.card.due\" format=\"x\" min-view=\"year\" max-view=\"month\" start-view=\"month\"><div layout=\"row\" layout-align=\"start center\"><i class=\"s18 icon icon-calendar\"></i> <span>{{vm.card.due| date:\'mediumDate\'}}</span></div></div><div class=\"picker hour-picker\" moment-picker=\"vm.card.due\" format=\"x\" min-view=\"day\" max-view=\"hour\" start-view=\"day\"><div layout=\"row\" layout-align=\"start center\"><i class=\"s18 icon icon-clock\"></i> <span>{{vm.card.due| date:\'shortTime\'}}</span></div></div><div class=\"remove-due-date\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.card.due = \'\'\"><i class=\"s16 icon icon-close\"></i></div></div></div><div class=\"sections\" layout=\"row\"><div layout=\"column\" flex=\"80\"><div class=\"description\"><md-input-container class=\"md-block\"><label translate=\"SB.NAME\">Name</label> <textarea ng-model=\"vm.card.name\" columns=\"1\" md-maxlength=\"150\" rows=\"5\"></textarea></md-input-container></div><div class=\"description\"><md-input-container class=\"md-block\"><label translate=\"SB.DESCRIPTION\">Description</label> <textarea ng-model=\"vm.card.description\" columns=\"1\" md-maxlength=\"150\" rows=\"5\"></textarea></md-input-container></div><div ng-if=\"vm.card.attachments[0]\" class=\"section\"><div class=\"attachments\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"section-title\" translate=\"SB.ATTACHMENTS\">Attachments</span></div><div class=\"section-content\"><div class=\"attachment\" ng-repeat=\"item in vm.card.attachments\" ng-switch=\"item.type\"><div class=\"attachment-preview md-whiteframe-2dp\" ng-style=\"{\'background-image\': \'url({{item.src}})\'}\"><span class=\"attachment-time\">{{item.time}}</span></div></div><md-button class=\"add-attachment-button\" aria-label=\"add attachment\"><div layout=\"row\" layout-align=\"start center\"><i class=\"icon-plus s20\"></i> <span translate=\"SB.ADD_AN_ATTACHMENT\">Add an attachment</span></div></md-button></div></div></div></div><div layout=\"column\" id=\"additional-info\"><div ng-if=\"vm.card.idLabels[0] || vm.card.idMembers[0]\" class=\"section\"><div ng-if=\"vm.card.idLabels[0]\" flex=\"\" class=\"labels\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-label-outline s18\"></i> <span class=\"section-title\" translate=\"SB.LABELS\">Labels</span></div><div class=\"section-content\"><md-chips class=\"label-chips\" ng-model=\"vm.card.idLabels\" md-autocomplete-snap=\"\" md-require-match=\"true\" md-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedLabel\" md-search-text=\"vm.searchLabelText\" md-items=\"label in vm.labelQuerySearch(vm.searchLabelText)\" md-item-text=\"label.name\" placeholder=\"Search for a label\"><span md-highlight-text=\"vm.searchLabelText\">{{label.name}}</span></md-autocomplete><md-chip-template class=\"label-chip\" ng-class=\"\'md-\' + vm.board.labels.getById($chip).color + \'-bg\'\"><span>{{vm.board.labels.getById($chip).name}}</span></md-chip-template><button md-chip-remove=\"\" class=\"md-primary\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div></div><div ng-if=\"vm.card.idMembers[0]\" flex=\"\" class=\"members\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-account-multiple s18\"></i> <span class=\"section-title\" translate=\"SB.MEMBERS\">Members</span></div><div class=\"section-content\"><md-chips class=\"member-chips\" ng-model=\"vm.card.idMembers\" md-autocomplete-snap=\"\" md-require-match=\"true\" md-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedMember\" md-search-text=\"vm.searchText\" md-items=\"member in vm.memberQuerySearch(vm.searchText)\" md-item-text=\"member.name\" placeholder=\"Search for a member\"><span md-highlight-text=\"vm.searchText\">{{member.name}}</span></md-autocomplete><md-chip-template class=\"member-chip\"><img class=\"member-chip-avatar\" ng-src=\"{{vm.board.members.getById($chip).avatar}}\"><md-tooltip>{{vm.board.members.getById($chip).name}}</md-tooltip></md-chip-template><button md-chip-remove=\"\" class=\"md-primary\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div></div><div ng-if=\"vm.card.checklists\" class=\"section\" ng-repeat=\"checklist in vm.card.checklists\"><div class=\"checklist\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked s18\"></i> <span flex=\"\" class=\"section-title\" editable-text=\"checklist.name\">{{checklist.name}}</span><md-menu md-position-mode=\"target-right target\" class=\"options\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"options\" translate=\"\" translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.removeChecklist(checklist)\" aria-label=\"Remove Checklist\" translate=\"\" translate-attr-aria-label=\"SB.REMOVE_CHECKLIST\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"SB.REMOVE_CHECKLIST\">Remove Checklist</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"section-content\"><div class=\"checklist-progress\" layout=\"row\" layout-align=\"start center\"><span class=\"checklist-progress-value\">{{checklist.checkItemsChecked}} / {{checklist.checkItems.length}}</span><md-progress-linear class=\"md-accent checklist-progressbar\" md-mode=\"determinate\" value=\"{{100 * checklist.checkItemsChecked / checklist.checkItems.length}}\"></md-progress-linear></div><div class=\"check-items\"><div class=\"check-item\" ng-repeat=\"checkItem in checklist.checkItems\"><md-checkbox ng-model=\"checkItem.checked\" ng-change=\"vm.updateCheckedCount(checklist)\" aria-label=\"{{checkItem.name}}\">{{checkItem.name}}</md-checkbox></div></div><form name=\"newCheckItemForm\" class=\"new-check-item-form\" ng-submit=\"vm.addCheckItem(vm[checklist.id].newCheckItem, checklist); vm[checklist.id].newCheckItem = \'\'\" layout=\"row\" layout-align=\"start center\"><md-input-container class=\"no-errors-spacer\" flex=\"\"><label layout=\"row\" layout-align=\"center\"><i class=\"icon-plus s18\"></i> <span translate=\"SB.ADD_AN_ITEM\">Add an item</span></label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm[checklist.id].newCheckItem\"></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Add\" translate=\"\" translate-attr-aria-label=\"SB.ADD\"><span translate=\"SB.ADD\">Add</span></md-button></form></div></div></div></div></div></div><div class=\"sections\"><div class=\"section\"><div class=\"comments\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\"></i> <span class=\"section-title\" translate=\"SB.COMMENTS\">Comments</span></div><div class=\"section-content\"><form name=\"cardCommentForm\" ng-submit=\"vm.addNewComment(vm.newCommentText); vm.newCommentText = \'\'\" class=\"comment new-comment\" layout=\"column\" layout-align=\"start\" no-validate=\"\"><div layout=\"row\"><img class=\"comment-member-avatar\" src=\"assets/images/avatars/profile.jpg\"><md-input-container flex=\"\" md-no-float=\"\"><textarea ms-scroll=\"\" placeholder=\"Write a comment..\" ng-model=\"vm.newCommentText\" required=\"\" translate=\"\" translate-attr-placeholder=\"SB.WRITE_A_COMMENT\"></textarea></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" class=\"md-raised md-accent\" ng-disabled=\"cardCommentForm.$invalid || cardCommentForm.$pristine\" aria-label=\"Add\"><span translate=\"SB.ADD\">Add</span></md-button></div></form><div class=\"comment\" layout=\"row\" ng-repeat=\"comment in vm.card.comments\"><img class=\"comment-member-avatar\" ng-src=\"{{vm.board.members.getById(comment.idMember).avatar}}\"><div layout=\"column\"><div class=\"comment-member-name\">{{vm.board.members.getById(comment.idMember).name}}</div><div class=\"comment-bubble\">{{comment.message}}</div><div class=\"comment-time secondary-text\">{{comment.time}}</div></div></div></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/agile/scrumboard/sidenavs/preview/preview-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\' + vm.board.settings.color + \'-bg\'\"><div class=\"md-toolbar-tools\"><span flex=\"\" class=\"menu-title\">{{vm.previewCard.code}}</span></div></md-toolbar><md-content ms-scroll=\"\"><div layout=\"row\" layout-align=\"space-between start\"><div ng-if=\"vm.previewCard.due\" class=\"due-date\" layout=\"row\" layout-align=\"start center\"><div class=\"picker day-picker\" moment-picker=\"vm.previewCard.due\" format=\"x\" min-view=\"year\" max-view=\"month\" start-view=\"month\"><div layout=\"row\" layout-align=\"start center\"><i class=\"s18 icon icon-calendar\"></i> <span>{{vm.previewCard.due| date:\'mediumDate\'}}</span></div></div><div class=\"picker hour-picker\" moment-picker=\"vm.previewCard.due\" format=\"x\" min-view=\"day\" max-view=\"hour\" start-view=\"day\"><div layout=\"row\" layout-align=\"start center\"><i class=\"s18 icon icon-clock\"></i> <span>{{vm.previewCard.due| date:\'shortTime\'}}</span></div></div><div class=\"remove-due-date\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.previewCard.due = \'\'\"><i class=\"s16 icon icon-close\"></i></div></div></div><md-divider></md-divider><div class=\"sections\" layout=\"column\"><div layout=\"column\"><div class=\"description\"><md-input-container class=\"md-block\"><label translate=\"SB.NAME\">Name</label> <textarea ng-model=\"vm.previewCard.name\" columns=\"1\" md-maxlength=\"150\" rows=\"5\"></textarea></md-input-container></div><div class=\"description\"><md-input-container class=\"md-block\"><label translate=\"SB.DESCRIPTION\">Description</label> <textarea ng-model=\"vm.previewCard.description\" columns=\"1\" md-maxlength=\"150\" rows=\"5\"></textarea></md-input-container></div><div ng-if=\"vm.previewCard.attachments[0]\" class=\"section\"><div class=\"attachments\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"section-title\" translate=\"SB.ATTACHMENTS\">Attachments</span></div><div class=\"section-content\"><div class=\"attachment\" ng-repeat=\"item in vm.previewCard.attachments\" ng-switch=\"item.type\"><div class=\"attachment-preview md-whiteframe-2dp\" ng-style=\"{\'background-image\': \'url({{item.src}})\'}\"><span class=\"attachment-time\">{{item.time}}</span></div></div><md-button class=\"add-attachment-button\" aria-label=\"add attachment\"><div layout=\"row\" layout-align=\"start center\"><i class=\"icon-plus s20\"></i> <span translate=\"SB.ADD_AN_ATTACHMENT\">Add an attachment</span></div></md-button></div></div></div></div><md-divider></md-divider><div layout=\"column\" id=\"additional-info\"><div ng-if=\"vm.previewCard.idLabels[0] || vm.previewCard.idMembers[0]\" class=\"section\"><div ng-if=\"vm.previewCard.idLabels[0]\" flex=\"\" class=\"labels\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-label-outline s18\"></i> <span class=\"section-title\" translate=\"SB.LABELS\">Labels</span></div><div class=\"section-content\"><md-chips class=\"label-chips\" ng-model=\"vm.previewCard.idLabels\" md-autocomplete-snap=\"\" md-require-match=\"true\" md-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedLabel\" md-search-text=\"vm.searchLabelText\" md-items=\"label in vm.labelQuerySearch(vm.searchLabelText)\" md-item-text=\"label.name\" placeholder=\"Search for a label\"><span md-highlight-text=\"vm.searchLabelText\">{{label.name}}</span></md-autocomplete><md-chip-template class=\"label-chip\" ng-class=\"\'md-\' + vm.board.labels.getById($chip).color + \'-bg\'\"><span>{{vm.board.labels.getById($chip).name}}</span></md-chip-template><button md-chip-remove=\"\" class=\"md-primary\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div></div><div ng-if=\"vm.previewCard.idMembers[0]\" flex=\"\" class=\"members\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-account-multiple s18\"></i> <span class=\"section-title\" translate=\"SB.MEMBERS\">Members</span></div><div class=\"section-content\"><md-chips class=\"member-chips\" ng-model=\"vm.previewCard.idMembers\" md-autocomplete-snap=\"\" md-require-match=\"true\" md-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedMember\" md-search-text=\"vm.searchText\" md-items=\"member in vm.memberQuerySearch(vm.searchText)\" md-item-text=\"member.name\" placeholder=\"Search for a member\"><span md-highlight-text=\"vm.searchText\">{{member.name}}</span></md-autocomplete><md-chip-template class=\"member-chip\"><img class=\"member-chip-avatar\" ng-src=\"{{vm.board.members.getById($chip).avatar}}\"><md-tooltip>{{vm.board.members.getById($chip).name}}</md-tooltip></md-chip-template><button md-chip-remove=\"\" class=\"md-primary\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div></div><md-divider></md-divider><div ng-if=\"vm.previewCard.checklists\" class=\"section\" ng-repeat=\"checklist in vm.previewCard.checklists\"><div class=\"checklist\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked s18\"></i> <span flex=\"\" class=\"section-title\" editable-text=\"checklist.name\">{{checklist.name}}</span><md-menu md-position-mode=\"target-right target\" class=\"options\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"options\" translate=\"\" translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.removeChecklist(checklist)\" aria-label=\"Remove Checklist\" translate=\"\" translate-attr-aria-label=\"SB.REMOVE_CHECKLIST\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span translate=\"SB.REMOVE_CHECKLIST\">Remove Checklist</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"section-content\"><div class=\"checklist-progress\" layout=\"row\" layout-align=\"start center\"><span class=\"checklist-progress-value\">{{checklist.checkItemsChecked}} / {{checklist.checkItems.length}}</span><md-progress-linear class=\"md-accent checklist-progressbar\" md-mode=\"determinate\" value=\"{{100 * checklist.checkItemsChecked / checklist.checkItems.length}}\"></md-progress-linear></div><div class=\"check-items\"><div class=\"check-item\" ng-repeat=\"checkItem in checklist.checkItems\"><md-checkbox ng-model=\"checkItem.checked\" ng-change=\"vm.updateCheckedCount(checklist)\" aria-label=\"{{checkItem.name}}\">{{checkItem.name}}</md-checkbox></div></div><form name=\"newCheckItemForm\" class=\"new-check-item-form\" ng-submit=\"vm.addCheckItem(vm[checklist.id].newCheckItem, checklist); vm[checklist.id].newCheckItem = \'\'\" layout=\"row\" layout-align=\"start center\"><md-input-container class=\"no-errors-spacer\" flex=\"\"><label layout=\"row\" layout-align=\"center\"><i class=\"icon-plus s18\"></i> <span translate=\"SB.ADD_AN_ITEM\">Add an item</span></label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm[checklist.id].newCheckItem\"></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Add\" translate=\"\" translate-attr-aria-label=\"SB.ADD\"><span translate=\"SB.ADD\">Add</span></md-button></form></div></div></div></div></div></div><div class=\"sections\"><div class=\"section\"><div class=\"comments\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\"></i> <span class=\"section-title\" translate=\"SB.COMMENTS\">Comments</span></div><div class=\"section-content\"><form name=\"cardCommentForm\" ng-submit=\"vm.addNewComment(vm.newCommentText); vm.newCommentText = \'\'\" class=\"comment new-comment\" layout=\"column\" layout-align=\"start\" no-validate=\"\"><div layout=\"row\"><img class=\"comment-member-avatar\" src=\"assets/images/avatars/profile.jpg\"><md-input-container flex=\"\" md-no-float=\"\"><textarea ms-scroll=\"\" placeholder=\"Write a comment..\" ng-model=\"vm.newCommentText\" required=\"\" translate=\"\" translate-attr-placeholder=\"SB.WRITE_A_COMMENT\"></textarea></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" class=\"md-raised md-accent\" ng-disabled=\"cardCommentForm.$invalid || cardCommentForm.$pristine\" aria-label=\"Add\"><span translate=\"SB.ADD\">Add</span></md-button></div></form><div class=\"comment\" layout=\"row\" ng-repeat=\"comment in vm.previewCard.comments\"><img class=\"comment-member-avatar\" ng-src=\"{{vm.board.members.getById(comment.idMember).avatar}}\"><div layout=\"column\"><div class=\"comment-member-name\">{{vm.board.members.getById(comment.idMember).name}}</div><div class=\"comment-bubble\">{{comment.message}}</div><div class=\"comment-time secondary-text\">{{comment.time}}</div></div></div></div></div></div></div></md-content>");
$templateCache.put("app/main/agile/scrumboard/views/board/board-view.html","<div id=\"board\" ng-class=\"vm.board.settings.color+\'-100-bg\'\" ui-sortable=\"vm.sortableListOptions\" ng-model=\"vm.board.lists\" layout=\"row\"><div class=\"list-wrapper\" ng-repeat=\"list in vm.board.lists track by list.id\"><div class=\"list md-whiteframe-1dp\" layout=\"column\"><div class=\"list-header blue-grey-200-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"list-header-name\"><span editable-text=\"list.name\">{{list.name}}</span></div></div><div class=\"list-content\" ms-scroll=\"\"><div class=\"list-cards\" ui-sortable=\"vm.sortableCardOptions\" ng-model=\"list.idCards\"><div ng-if=\"cardId\" class=\"list-card md-whiteframe-3dp\" ng-repeat=\"cardId in list.idCards | filter: vm.cardFilter track by $index\"><div class=\"row\" layout=\"row\"><div class=\"list-card-code\" flex=\"\" ng-click=\"vm.openCardDialog($event, cardId)\">{{vm.board.cards.getById(cardId).code}}</div><div flex=\"30\" ng-if=\"vm.board.cards.getById(cardId).idMembers.length > 0\" class=\"list-card-members\"><div class=\"list-card-member\" ng-repeat=\"memberId in vm.board.cards.getById(cardId).idMembers\"><img class=\"list-card-member-avatar\" ng-src=\"{{vm.board.members.getById(memberId).avatar}}\"><md-tooltip><div class=\"name\">{{ vm.board.members.getById(memberId).name}}</div></md-tooltip></div></div><span ng-if=\"vm.board.cards.getById(cardId).checkItems\" class=\"badge check-items\" ng-class=\"{\'completed\': vm.board.cards.getById(cardId).checkItemsChecked === vm.board.cards.getById(cardId).checkItems}\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked-circle s16\"></i> <span>{{vm.board.cards.getById(cardId).checkItemsChecked}}</span> <span>/</span> <span>{{vm.board.cards.getById(cardId).checkItems}}</span></span></div><div class=\"click-preview\" ng-click=\"vm.previewCard(\'preview-sidenav\', $event, cardId)\"><div class=\"list-card-name\">{{vm.board.cards.getById(cardId).name}}</div><div class=\"list-card-details\"><div class=\"list-card-sort-handle\"><md-icon md-font-icon=\"icon-cursor-move\" class=\"icon s16\"></md-icon></div><div ng-if=\"vm.board.cards.getById(cardId).due || vm.board.cards.getById(cardId).checkItems\" class=\"list-card-badges\" layout=\"column\" layout-align=\"start center\"><span class=\"badge estimation\" ng-class=\"{\'overdue\': vm.isOverWorked(vm.board.cards.getById(cardId).remaining)}\" ng-if=\"vm.board.cards.getById(cardId).estimation\" layout=\"row\" layout-align=\"start center\" flex=\"100\"><i class=\"icon-clock s16\"></i> <span>{{vm.board.cards.getById(cardId).estimation}} / {{vm.board.cards.getById(cardId).remaining}}</span></span><span class=\"badge due-date\" ng-class=\"{\'overdue\': vm.isOverdue(vm.board.cards.getById(cardId).due)}\" ng-if=\"vm.board.cards.getById(cardId).due\" layout=\"row\" layout-align=\"start center\" flex=\"100\"><i class=\"icon-calendar s16\"></i> <span>{{vm.board.cards.getById(cardId).due | date:\'mediumDate\'}}</span></span></div></div><div class=\"list-card-footer\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span ng-if=\"vm.board.cards.getById(cardId).subscribed\" class=\"list-card-footer-item\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-eye s18\"></i></span><span ng-if=\"vm.board.cards.getById(cardId).description !== \'\'\" class=\"list-card-footer-item\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-document s18\"></i></span></div><div layout=\"row\" layout-align=\"end center\"><span class=\"list-card-footer-item\" ng-if=\"vm.board.cards.getById(cardId).attachments\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"value\">{{vm.board.cards.getById(cardId).attachments.length}}</span></span><span class=\"list-card-footer-item\" ng-if=\"vm.board.cards.getById(cardId).comments\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\"></i> <span class=\"value\">{{vm.board.cards.getById(cardId).comments.length}}</span></span></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/agile/scrumboard/views/boards/boards-view.html","<div id=\"boards\" class=\"md-accent-bg\" layout=\"column\" flex=\"\"><div id=\"board-selector\" layout=\"column\" layout-align=\"start center\" flex=\"\"><h1 translate=\"SB.SCRUMBOARD_APP\">Scrumboard App</h1><div class=\"board-list\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" ui-sref=\"app.scrumboard.boards.board({id:board.id, uri:board.uri})\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-trello\" class=\"icon s64\"></md-icon><div class=\"board-name\">{{board.name}}</div></div><div class=\"board-list-item add-new-board\" layout=\"column\" layout-align=\"center center\" ui-sref=\"app.scrumboard.boards.addBoard\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"icon s64\"></md-icon><div class=\"board-name\" translate=\"SB.ADD_NEW_BOARD\">Add new board</div></div></div></div></div>");}]);